import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A custom scalar that can be an integer or the string "Last". */
  IntOrLast: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: any;
};

export type AcademyData = {
  coursesCompleted?: Maybe<Scalars['Int']>;
  learningTracksCompleted?: Maybe<Scalars['Int']>;
  resourcesViewed?: Maybe<Scalars['Int']>;
  templatesDownloaded?: Maybe<Scalars['Int']>;
  topResources?: Maybe<Array<Maybe<TopResource>>>;
};

export type AcademyResource = {
  id: Scalars['String'];
  nonprofitTopic: Scalars['String'];
};

export type AccountInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  orgName: Scalars['String'];
  orgUuid?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<FunderOrgToUserRole>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ActiveOrgsByMonth = {
  activeMonth?: Maybe<Scalars['String']>;
  n?: Maybe<Scalars['Int']>;
};

export enum ActivityType {
  GroupCoaching = 'GROUP_COACHING',
  PeerToPeer = 'PEER_TO_PEER'
}

export type AddGoalInput = {
  category: GoalCategory;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  impactCategory?: InputMaybe<GoalImpactCategory>;
  isGoalSharedByFunder?: InputMaybe<Scalars['Boolean']>;
  isGoalSharedByNonprofit?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  reportedMetricGroupId?: InputMaybe<Scalars['Int']>;
  shareWithFunderOrgId?: InputMaybe<Scalars['Int']>;
  shareWithFunderOrgIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  templateLibraryId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type: GoalType;
};

export type AiBlocksUnion = AiCtaBlockType | AiImageBlockType | AiTextBlockType;

export type AiCoachingIntervention = {
  claimedAt?: Maybe<Scalars['DateTime']>;
  claimedBy?: Maybe<AiCoachingInterventionUser>;
  coachFeedback?: Maybe<Scalars['String']>;
  coachRating?: Maybe<AiCoachingRating>;
  createdAt?: Maybe<Scalars['DateTime']>;
  declineReason?: Maybe<Scalars['String']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  editedMessage?: Maybe<Scalars['String']>;
  emailedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  identifier?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  postedToFeedAt?: Maybe<Scalars['DateTime']>;
  shouldIntervene?: Maybe<Scalars['Boolean']>;
  status?: Maybe<AiCoachingInterventionStatus>;
  trigger?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<AiCoachingInterventionUser>;
  version?: Maybe<Scalars['String']>;
};

export enum AiCoachingInterventionStatus {
  Declined = 'DECLINED',
  Emailed = 'EMAILED',
  New = 'NEW',
  Posted = 'POSTED',
  PostedAndEmailed = 'POSTED_AND_EMAILED'
}

export type AiCoachingInterventionUser = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  funderOrgs?: Maybe<Array<Maybe<FunderOrgBasic>>>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  nonprofitOrgs?: Maybe<Array<Maybe<NonprofitOrgBasic>>>;
  platformPlan?: Maybe<PlatformPlan>;
};

export type AiCoachingInterventionsResponse = {
  interventions?: Maybe<Array<Maybe<AiCoachingIntervention>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum AiCoachingRating {
  Bad = 'BAD',
  Good = 'GOOD'
}

export type AiCtaBlockType = {
  buttonText?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type AiImageBlockType = {
  cloudinaryFileId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AiImpactDashboardSummary = {
  bulletpoints?: Maybe<Array<Maybe<Scalars['String']>>>;
  copy?: Maybe<Scalars['String']>;
  hasError?: Maybe<Scalars['Boolean']>;
};

export type AiResponse = {
  description?: Maybe<Scalars['String']>;
  hasError?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
};

export type AiStoriesResponse = {
  blocks?: Maybe<Array<AiBlocksUnion>>;
  hasError?: Maybe<Scalars['Boolean']>;
  isInappropriate?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Array<AssetType>>;
};

export enum AiStoryAudienceType {
  BoardMembers = 'BOARD_MEMBERS',
  Clients = 'CLIENTS',
  Donors = 'DONORS',
  Employees = 'EMPLOYEES',
  GeneralAudience = 'GENERAL_AUDIENCE',
  Grantmakers = 'GRANTMAKERS',
  Volunteers = 'VOLUNTEERS'
}

export enum AiStoryGoalType {
  ProvideUpdate = 'PROVIDE_UPDATE',
  RaiseFunds = 'RAISE_FUNDS',
  ShareGratitude = 'SHARE_GRATITUDE',
  SpreadAwareness = 'SPREAD_AWARENESS'
}

export type AiTextBlockType = {
  blocks?: Maybe<Array<Maybe<AiTextBlocksObjectType>>>;
  entityMap?: Maybe<Scalars['Json']>;
  type?: Maybe<Scalars['String']>;
};

export type AiTextBlocksObjectType = {
  data?: Maybe<Scalars['Json']>;
  depth?: Maybe<Scalars['Int']>;
  entityRanges?: Maybe<Scalars['Json']>;
  inlineStyleRanges?: Maybe<Scalars['Json']>;
  key?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Asset = {
  assetDetails?: Maybe<Scalars['Json']>;
  assetType: AssetType;
  createdAt: Scalars['DateTime'];
  createdUserId: Scalars['Int'];
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
  reusable: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  updatedUserId: Scalars['Int'];
};

export enum AssetType {
  Cta = 'CTA',
  Donation = 'DONATION',
  Image = 'IMAGE',
  ImageAndText = 'IMAGE_AND_TEXT',
  ProgressReport = 'PROGRESS_REPORT',
  Quote = 'QUOTE',
  Summary = 'SUMMARY',
  Text = 'TEXT',
  Title = 'TITLE',
  Video = 'VIDEO'
}

export type AssetUpsertInput = {
  assetDetails?: InputMaybe<Scalars['Json']>;
  assetType: AssetType;
  id?: InputMaybe<Scalars['Int']>;
  reusable: Scalars['Boolean'];
};

export type AssignGoalsToGoalGroupInput = {
  goalGroupId: Scalars['Int'];
  goalIds: Array<Scalars['Int']>;
};

export type Attachment = {
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  goal: Goal;
  id: Scalars['Int'];
  owner?: Maybe<User>;
  publicId: Scalars['String'];
  resourceType?: Maybe<Scalars['String']>;
  secureUrl: Scalars['String'];
};

export type AutoStoriesSettings = {
  autoStoriesEnabled: Scalars['Boolean'];
  lastScan?: Maybe<Scalars['DateTime']>;
  nonprofitOrgId: Scalars['Int'];
  notifyEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  socialUrls?: Maybe<Array<Maybe<SocialMediaUrlConfig>>>;
};

export type AutoStoriesSettingsInput = {
  enabled: Scalars['Boolean'];
  notifyEmails?: InputMaybe<Array<Scalars['String']>>;
  socialUrls?: InputMaybe<Array<SocialMediaUrlInput>>;
};

export type AutomatedGoal = {
  checklistItems?: Maybe<Array<Maybe<ChecklistItem>>>;
  goal?: Maybe<Goal>;
  objective?: Maybe<ReportedMetricGroup>;
  templateLibraryId?: Maybe<Scalars['Int']>;
};

export type BankAccount = {
  last4?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

export type Block = {
  asset: Asset;
  assetId: Scalars['Int'];
  assetType: AssetType;
  backgroundColor?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  storyId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BlockUpsertInput = {
  asset: AssetUpsertInput;
  assetType: AssetType;
  backgroundColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
};

export type BoxConfig = {
  boxId?: Maybe<Scalars['String']>;
  tokenData?: Maybe<TokenData>;
};

export enum BudgetRange {
  Budget_50KTo_99K = 'BUDGET_50K_TO_99K',
  Budget_100KTo_249K = 'BUDGET_100K_TO_249K',
  Budget_250KTo_499K = 'BUDGET_250K_TO_499K',
  Budget_500KTo_999k = 'BUDGET_500K_TO_999k',
  Budget_1000KTo_4999K = 'BUDGET_1000K_TO_4999K',
  Budget_5000KAndUp = 'BUDGET_5000K_AND_UP',
  BudgetLessThan_50K = 'BUDGET_LESS_THAN_50K',
  BudgetNone = 'BUDGET_NONE'
}

export type BulkFunderUserInput = {
  email: Scalars['String'];
  role: FunderOrgToUserRole;
};

export enum CalculationType {
  Cumulative = 'CUMULATIVE',
  Incremental = 'INCREMENTAL'
}

export type Campaign = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdUserId?: Maybe<Scalars['Int']>;
  donations?: Maybe<Array<Maybe<CampaignDonation>>>;
  draftGoalName?: Maybe<Scalars['String']>;
  draftObjectiveName?: Maybe<Scalars['String']>;
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  fundraisingTarget?: Maybe<Scalars['Int']>;
  hashedPortalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  initiativeGoalId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  portalId?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedUserId?: Maybe<Scalars['Int']>;
};

export type CampaignDonation = {
  amount: Scalars['Int'];
  campaignId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  disputed: Scalars['Boolean'];
  donorStripeAccountId: Scalars['String'];
  id: Scalars['String'];
  netAmount: Scalars['Int'];
  refunded: Scalars['Boolean'];
};

export type CampaignGating = {
  limit?: Maybe<Scalars['Int']>;
  limitCycle?: Maybe<Scalars['String']>;
  numberOfCampaignsUsed?: Maybe<Scalars['Int']>;
};

export type CampaignInput = {
  fundraisingTarget?: InputMaybe<Scalars['Int']>;
  goalName?: InputMaybe<Scalars['String']>;
  initiativeGoalId?: InputMaybe<Scalars['Int']>;
  objectiveId?: InputMaybe<Scalars['Int']>;
  objectiveName?: InputMaybe<Scalars['String']>;
  savingAsDraft?: InputMaybe<Scalars['Boolean']>;
};

export type Campaigns = {
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
};

export type Capabilities = {
  card_payments?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  transfers?: Maybe<Scalars['String']>;
};

export type CategoryActivity = {
  academyResourcesViewed: Scalars['Int'];
  goalCategory: Scalars['String'];
  goalsCreated: Scalars['Int'];
  tasksCompleted: Scalars['Int'];
};

export type Chart = {
  calculationType: CalculationType;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  seriesData: Array<Maybe<ChartSeriesData>>;
  target?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  unitOfMeasurement: Scalars['String'];
};

export type ChartCategory = {
  ChartDataPoint: Array<ChartDataPoint>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  chartId: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type ChartCategoryInput = {
  title: Scalars['String'];
};

export type ChartDataPoint = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  chartCategoryId: Scalars['Int'];
  chartId: Scalars['Int'];
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  value?: Maybe<Scalars['Float']>;
};

export type ChartDataPointInput = {
  chartCategoryId: Scalars['Int'];
  chartId: Scalars['Int'];
  date: Scalars['DateTime'];
  value?: InputMaybe<Scalars['Float']>;
};

export type ChartSeriesData = {
  data: Array<Maybe<ChartSeriesDataPoint>>;
  title: Scalars['String'];
};

export type ChartSeriesDataPoint = {
  x: Scalars['String'];
  y?: Maybe<Scalars['Float']>;
};

export type ChecklistItem = {
  checklistItemGroupId?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['String']>;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  lastUpdatedUser: User;
  linkText?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  resourceId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ChecklistItemAdditionalInformation = {
  goalId?: Maybe<Scalars['Int']>;
  goalType?: Maybe<Scalars['String']>;
  initiativeId?: Maybe<Scalars['Int']>;
  templateLibraryId?: Maybe<Scalars['Int']>;
};

export type ChecklistItemInput = {
  checklistItemGroupId?: InputMaybe<Scalars['Int']>;
  dueDate?: InputMaybe<Scalars['String']>;
  goalId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  linkText?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  resourceId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChecklistItemTemplate = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  frequency?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  linkText?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  numberOfOccurrences?: Maybe<Scalars['Int']>;
  recurrenceType?: Maybe<TaskRecurrenceType>;
  resourceId?: Maybe<Scalars['String']>;
  templateLibraryId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ChecklistItemTemplateInput = {
  archivedAt?: InputMaybe<Scalars['Boolean']>;
  displayOrder: Scalars['Int'];
  frequency?: InputMaybe<Scalars['Int']>;
  linkText?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  numberOfOccurrences?: InputMaybe<Scalars['Int']>;
  recurrenceType?: InputMaybe<TaskRecurrenceType>;
  resourceId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CheckoutInput = {
  cardToken?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  formationPlan?: InputMaybe<FormationPlan>;
  idempotencyKey: Scalars['String'];
  lastName: Scalars['String'];
  orgName: Scalars['String'];
  phone: Scalars['String'];
  platformPlan: PlatformPlan;
  promoCode?: InputMaybe<Scalars['String']>;
  promoId?: InputMaybe<Scalars['String']>;
  role: NonprofitOrgToUserRole;
  state: Scalars['String'];
};

export type CheckoutResponse = {
  email?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  setpasswordURL?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type CloudinaryAssets = {
  cloudinary_public_file_id?: Maybe<Scalars['String']>;
};

export type CloudinaryConfig = {
  cloudinaryId?: Maybe<Scalars['String']>;
};

export type CoachingData = {
  groupSessionsByMonth?: Maybe<Array<Maybe<CoachingSessionByMonth>>>;
  oneOnOneSessionsByMonth?: Maybe<Array<Maybe<CoachingSessionByMonth>>>;
  topCoachingTopics?: Maybe<Array<Maybe<TopCoachingTopic>>>;
  totalOneOnOneSessions?: Maybe<Scalars['Int']>;
};

export type CoachingSessionByMonth = {
  activeWeek?: Maybe<Scalars['String']>;
  n?: Maybe<Scalars['Int']>;
};

export type Cohort = {
  cohortMemberships?: Maybe<Array<Maybe<CohortMembership>>>;
  cohortOwnerships?: Maybe<Array<Maybe<CohortOwnership>>>;
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  memberRoles: Array<Scalars['String']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type CohortData = {
  cohortId?: Maybe<Scalars['String']>;
  cohortName?: Maybe<Scalars['String']>;
  cohortSize?: Maybe<Scalars['Int']>;
  nonprofits?: Maybe<Array<Maybe<NonprofitData>>>;
};

export type CohortMembership = {
  cohort?: Maybe<Cohort>;
  cohortId?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  nonprofitOrg?: Maybe<NonprofitOrg>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type CohortOwnership = {
  cohortId?: Maybe<Scalars['Int']>;
  funderOrg?: Maybe<FunderOrg>;
  funderOrgId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type CohortPaginatedResult = {
  cohorts?: Maybe<Array<Cohort>>;
  total: Scalars['Int'];
};

export type ColorTheme = {
  color: Scalars['String'];
  id: Scalars['Int'];
  isDefaultPalette: Scalars['Boolean'];
};

export type CommunityComment = {
  /** The body of the Comment */
  body?: Maybe<Scalars['String']>;
  /** The ID for the Event that the Comment is in */
  eventId?: Maybe<Scalars['String']>;
  /** Circle's ID for the Comment object */
  id: Scalars['Int'];
  /** The ID for the Post that the Comment is in */
  postId?: Maybe<Scalars['String']>;
  /** The ID for the Space that the Comment is in */
  spaceId: Scalars['String'];
  /** The direct URL for the Comment */
  url?: Maybe<Scalars['String']>;
};

export type CommunityCommentConnection = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges?: Maybe<Array<Maybe<CommunityCommentEdge>>>;
  /** Flattened list of CommunityComment type */
  nodes?: Maybe<Array<Maybe<CommunityComment>>>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type CommunityCommentEdge = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node?: Maybe<CommunityComment>;
};

export type CommunityCommenter = {
  /** URL for the commenter's avatar image */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Name of the commenter */
  name: Scalars['String'];
};

export type CommunityEvent = {
  /** The body of the event */
  body?: Maybe<Scalars['String']>;
  /** The end date of the community event */
  endsAt: Scalars['DateTime'];
  /** Circle's ID of the community event */
  id: Scalars['Int'];
  /** The name of the community event */
  name: Scalars['String'];
  /** The ID for the Space that the event is in */
  spaceId: Scalars['String'];
  /** The start date of the community event */
  startsAt: Scalars['DateTime'];
  /** The url of the community event. Returns null if the user does not have access to the event. */
  url?: Maybe<Scalars['String']>;
};

export enum CommunityEventsFilterOption {
  All = 'All',
  Completed = 'Completed',
  Upcoming = 'Upcoming'
}

export type CommunityGuidelines = {
  /** The current user has previously agreed to the community guidelines */
  isAgreed: Scalars['Boolean'];
};

export type CommunityPost = {
  /** The body of the Post */
  body?: Maybe<Scalars['String']>;
  /** Circle's ID for the Post object */
  id: Scalars['Int'];
  /** The title of the Post */
  name?: Maybe<Scalars['String']>;
  /** The ID for the Space that the Post is in */
  spaceId: Scalars['String'];
  /** The direct URL for the Post */
  url?: Maybe<Scalars['String']>;
};

export type CommunityPostConnection = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges?: Maybe<Array<Maybe<CommunityPostEdge>>>;
  /** Flattened list of CommunityPost type */
  nodes?: Maybe<Array<Maybe<CommunityPost>>>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type CommunityPostEdge = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node?: Maybe<CommunityPost>;
};

export type CommunityPoster = {
  /** URL for the poster's avatar image */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Name of the poster */
  name: Scalars['String'];
};

export type CommunityTopPost = {
  /** The post body */
  body: Scalars['String'];
  /** List of users who commented on the post */
  commenters: Array<CommunityCommenter>;
  /** Number of comments the post has received */
  commentsCount: Scalars['Int'];
  /** Circle's ID for the Post object */
  id: Scalars['Int'];
  /** Number of likes the post has received */
  likesCount: Scalars['Int'];
  /** The name of the Post */
  name: Scalars['String'];
  /** The date when the post was published */
  postDate: Scalars['String'];
  /** The direct URL for the Post */
  postLink: Scalars['String'];
  /** Information about the user who created the post */
  poster: CommunityPoster;
  /** Total engagement score (sum of likes and comments) */
  totalEngagement: Scalars['Int'];
};

export type CommunityTopPostsResponse = {
  /** The list of top community posts */
  posts: Array<CommunityTopPost>;
};

export type CommunityTrendingEvent = {
  /** Event details or description */
  body?: Maybe<Scalars['String']>;
  /** Circle's ID for the Event object */
  circleEventId?: Maybe<Scalars['Int']>;
  /** The end date and time of the Event */
  endsAt: Scalars['DateTime'];
  /** The type of the Event (e.g. P2P, Demo, Workshop, etc.) */
  eventType?: Maybe<Scalars['String']>;
  /** Circle's ID for the Event object */
  id: Scalars['Int'];
  /** The name of the Event */
  name: Scalars['String'];
  /** The number of confirmed RSVPs for the Event */
  rsvpCount: Scalars['Int'];
  /** The start date and time of the Event */
  startsAt: Scalars['DateTime'];
  /** Brief summary of the event */
  summary?: Maybe<Scalars['String']>;
  /** The URL for virtual attendance of the Event */
  virtualLocationUrl?: Maybe<Scalars['String']>;
};

export type ComplianceDocuments = {
  files?: Maybe<Array<Files>>;
  folderId?: Maybe<Scalars['String']>;
};

export type ConnectAccountBusinessProfile = {
  url?: InputMaybe<Scalars['String']>;
};

export type ConnectAccountMetadata = {
  business_profile?: InputMaybe<ConnectAccountBusinessProfile>;
  email?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<ConnectAccountSettings>;
};

export type ConnectAccountSettings = {
  branding?: InputMaybe<ConnectAccountSettingsBranding>;
};

export type ConnectAccountSettingsBranding = {
  icon?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  primary_color?: InputMaybe<Scalars['String']>;
  secondary_color?: InputMaybe<Scalars['String']>;
};

export type Contact = {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fileId: Scalars['Int'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CreateChartInput = {
  calculationType: CalculationType;
  chartCategories?: InputMaybe<Array<ChartCategoryInput>>;
  goalId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
  target?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  unitOfMeasurement?: InputMaybe<Scalars['String']>;
};

export type CreateChartsInput = {
  calculationType: CalculationType;
  chartCategories: Array<ChartCategoryInput>;
  goalIds: Array<Scalars['Int']>;
  target?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  unitOfMeasurement?: InputMaybe<Scalars['String']>;
};

export type CreateFeedItemInput = {
  activityEntityType: FeedEntityType;
  activityType: FeedActivityType;
  body: Scalars['String'];
  callToActionLink?: InputMaybe<Scalars['String']>;
  callToActionText?: InputMaybe<Scalars['String']>;
  category: FeedItemCategory;
  eventAt?: InputMaybe<Scalars['DateTime']>;
  parameters?: InputMaybe<Scalars['Json']>;
  title: Scalars['String'];
  type: FeedItemType;
  userId: Scalars['Int'];
};

export type CreateGoalGroupInput = {
  category: GoalCategory;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  isFunderAssigned: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  target?: InputMaybe<Scalars['Float']>;
  targetDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateOnboardingGoalResponse = {
  createdChecklistItems?: Maybe<Array<Maybe<ChecklistItem>>>;
  createdGoal?: Maybe<Goal>;
};

export type CreateOrUpdateManyResponse = {
  count?: Maybe<Scalars['Int']>;
};

export type CreateUserSurveysResponse = {
  userIds: Array<Scalars['Int']>;
};

export type CustomAmount = {
  amountInCents?: Maybe<Scalars['Int']>;
};

export type CustomAmountInput = {
  amountInCents: Scalars['Int'];
};

export enum DashboardActivityResourceType {
  Article = 'article',
  Course = 'course',
  LearningTrack = 'learning_track',
  Template = 'template'
}

export type DataVisualizationMetadata = {
  /** Business logic warnings (e.g., missing test data filters) */
  businessWarnings?: Maybe<Array<Scalars['String']>>;
  cacheHit: Scalars['Boolean'];
  /** Customer Success specific insights about the data */
  csInsights?: Maybe<Array<Scalars['String']>>;
  dataQualityScore: Scalars['Float'];
  executionTimeMs: Scalars['Int'];
  queryIntent: Scalars['String'];
  rowCount: Scalars['Int'];
  suggestedVisualization: Scalars['String'];
};

export type DataVisualizationResult = {
  /** The query results as JSON objects */
  data: Array<Maybe<Scalars['Json']>>;
  /** Error message if the query failed */
  error?: Maybe<Scalars['String']>;
  /** Enhanced metadata with CS insights */
  metadata?: Maybe<DataVisualizationMetadata>;
  /** The generated SQL query */
  sql: Scalars['String'];
};

export type DeleteGoalDimensionResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export enum DeleteRecurringTasksOption {
  All = 'ALL',
  Future = 'FUTURE'
}

export type Dimension = {
  GoalToDimension: Array<GoalToDimension>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isHidden: Scalars['Boolean'];
  lastUpdatedUser?: Maybe<User>;
  nonprofitOrg: NonprofitOrg;
  nonprofitOrgId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DonationBlockUpsertInput = {
  asset: AssetUpsertInput;
  assetType: AssetType;
  id?: InputMaybe<Scalars['Int']>;
};

export type DonationCheckoutSessionData = {
  billingPortalUrl?: Maybe<Scalars['String']>;
  chargedAmount?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  donationAmount?: Maybe<Scalars['Int']>;
  ein?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  feeAmount?: Maybe<Scalars['Int']>;
  feeCovered?: Maybe<Scalars['Boolean']>;
  interval?: Maybe<Scalars['String']>;
  nextBillingDate?: Maybe<Scalars['DateTime']>;
  orgAddress?: Maybe<Scalars['String']>;
  orgLegalName?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  statementDescriptor?: Maybe<Scalars['String']>;
};

export type DonationCheckoutUrl = {
  checkoutSessionUrl?: Maybe<Scalars['String']>;
};

export enum DonationInterval {
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME'
}

export type DonationMetadata = {
  anonymousDonation: Scalars['String'];
  campaignId?: InputMaybe<Scalars['String']>;
  donor?: InputMaybe<Scalars['String']>;
  donorEmail: Scalars['String'];
  donorFirstName?: InputMaybe<Scalars['String']>;
  donorLastName?: InputMaybe<Scalars['String']>;
  honoree?: InputMaybe<Scalars['String']>;
  honoreeEmail?: InputMaybe<Scalars['String']>;
  honoreeFirstName?: InputMaybe<Scalars['String']>;
  honoreeLastName?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['String']>;
  logoCloudinaryFileId?: InputMaybe<Scalars['String']>;
  nonprofitWebsiteUrl: Scalars['String'];
  portalId: Scalars['String'];
  storyId?: InputMaybe<Scalars['String']>;
  storyTitle?: InputMaybe<Scalars['String']>;
  themeColor?: InputMaybe<Scalars['String']>;
};

export type DonationPortal = {
  DonationPortalBlock?: Maybe<Array<Maybe<DonationPortalBlock>>>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  availableFrequencies: Array<DonationInterval>;
  campaignId?: Maybe<Scalars['String']>;
  colorTheme: ColorTheme;
  createdAt: Scalars['DateTime'];
  createdUserId: Scalars['Int'];
  customAmounts?: Maybe<Array<Maybe<CustomAmount>>>;
  customAmountsOn: Scalars['Boolean'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  hashedId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  socialDescription?: Maybe<Scalars['String']>;
  socialTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedUserId: Scalars['Int'];
};

export type DonationPortalBlock = {
  asset: Asset;
  assetId: Scalars['Int'];
  assetType: AssetType;
  createdAt: Scalars['DateTime'];
  donationPortalId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type DonationsData = {
  orgsWithCampaigns?: Maybe<Scalars['Int']>;
};

export type DonationsDemoStatus = {
  isDonationsDemo: Scalars['Boolean'];
};

export type DonorAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type DuplicateUsers = {
  emails: Array<Maybe<Scalars['String']>>;
};

export type EmailImpactReportResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type EndLoginAsResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type EngagementDashboard = {
  academyData?: Maybe<AcademyData>;
  coachingData?: Maybe<CoachingData>;
  donationsData?: Maybe<DonationsData>;
  goalsData?: Maybe<GoalsData>;
  message?: Maybe<Scalars['String']>;
  priorityNeedsData?: Maybe<PriorityNeedsData>;
  storiesData?: Maybe<StoriesData>;
  whatTheyDoingData?: Maybe<WhatTheyDoingData>;
  yourCohort?: Maybe<YourCohort>;
};

export type EngagementData = {
  n30Days?: Maybe<Scalars['Int']>;
  n90Days?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
};

export type Entry = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  entryGroup: EntryGroup;
  entryGroupId: Scalars['Int'];
  goalToDimension: GoalToDimension;
  goalToDimensionId: Scalars['Int'];
  id: Scalars['Int'];
  lastUpdatedUser?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
};

export type EntryGroup = {
  Entry: Array<Entry>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['String']>;
  goal: Goal;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  lastUpdatedUser?: Maybe<User>;
  reportedAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type EntryGroupInput = {
  details?: InputMaybe<Scalars['String']>;
  goalId: Scalars['Int'];
  reportedAt: Scalars['DateTime'];
};

export type EntryInput = {
  goalToDimensionId: Scalars['Int'];
  value: Scalars['Float'];
};

export type EventPropertiesFilter = {
  equals: Scalars['String'];
  path?: InputMaybe<Array<Scalars['String']>>;
};

export type ExtendedChecklistItem = {
  additionalInformation: ChecklistItemAdditionalInformation;
  checklistItem: ChecklistItem;
};

export type ExtractDocumentTextInput = {
  cloudinaryUrl: Scalars['String'];
  mimeType: Scalars['String'];
};

export type ExtractDocumentTextResult = {
  /** Number of characters in the extracted text */
  characterCount: Scalars['Int'];
  /** Extracted text content from the document */
  text: Scalars['String'];
  /** Whether the text was truncated due to length limits */
  truncated: Scalars['Boolean'];
};

export type FeatureFlags = {
  featureFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FeatureGatingLimit = {
  featureName?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  lowestPlanTier?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type FeatureLimits = {
  available?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  lowestPlanTier?: Maybe<Scalars['String']>;
  used?: Maybe<Scalars['Int']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export enum FeedActivityType {
  AcademyResourceCompleted = 'ACADEMY_RESOURCE_COMPLETED',
  AcademyTrackCompleted = 'ACADEMY_TRACK_COMPLETED',
  AcademyTrackStarted = 'ACADEMY_TRACK_STARTED',
  CoachingSessionCompleted = 'COACHING_SESSION_COMPLETED',
  DonationReceived = 'DONATION_RECEIVED',
  FunderConnected = 'FUNDER_CONNECTED',
  GoalCompleted = 'GOAL_COMPLETED',
  GoalCreated = 'GOAL_CREATED',
  GoalUpdated = 'GOAL_UPDATED',
  MetricReported = 'METRIC_REPORTED',
  OrganizationMilestone = 'ORGANIZATION_MILESTONE',
  StoryPublished = 'STORY_PUBLISHED',
  StoryShared = 'STORY_SHARED',
  SuggestionClicked = 'SUGGESTION_CLICKED',
  SuggestionCompleted = 'SUGGESTION_COMPLETED',
  SuggestionCreated = 'SUGGESTION_CREATED',
  SuggestionDismissed = 'SUGGESTION_DISMISSED',
  SuggestionShown = 'SUGGESTION_SHOWN',
  TeamMemberAdded = 'TEAM_MEMBER_ADDED'
}

export enum FeedEntityType {
  AcademyResource = 'ACADEMY_RESOURCE',
  AcademyTrack = 'ACADEMY_TRACK',
  CoachingSession = 'COACHING_SESSION',
  Donation = 'DONATION',
  Funder = 'FUNDER',
  Goal = 'GOAL',
  Metric = 'METRIC',
  Organization = 'ORGANIZATION',
  Story = 'STORY',
  SuggestionTemplate = 'SUGGESTION_TEMPLATE',
  TeamMember = 'TEAM_MEMBER'
}

export type FeedItem = {
  activityEntityType: FeedEntityType;
  activityType: FeedActivityType;
  body: Scalars['String'];
  callToActionLink?: Maybe<Scalars['String']>;
  callToActionText?: Maybe<Scalars['String']>;
  category: FeedItemCategory;
  createdAt: Scalars['DateTime'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  eventAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  interactedAt?: Maybe<Scalars['DateTime']>;
  parameters?: Maybe<Scalars['Json']>;
  seenOnDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: FeedItemType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export enum FeedItemCategory {
  Compliance = 'COMPLIANCE',
  Fundraising = 'FUNDRAISING',
  General = 'GENERAL',
  Learning = 'LEARNING',
  Networking = 'NETWORKING',
  Operations = 'OPERATIONS',
  Storytelling = 'STORYTELLING'
}

export type FeedItemFilters = {
  activityEntityType?: InputMaybe<FeedEntityType>;
  activityType?: InputMaybe<FeedActivityType>;
  category?: InputMaybe<FeedItemCategory>;
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<FeedItemType>;
};

export type FeedItemResponse = {
  hasMore: Scalars['Boolean'];
  items: Array<FeedItem>;
  nextCursor?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export enum FeedItemType {
  ActionItem = 'ACTION_ITEM',
  MyActivity = 'MY_ACTIVITY',
  Suggestion = 'SUGGESTION'
}

export type Files = {
  complianceDocType?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type FilterOption = {
  label: Scalars['String'];
  nonprofitOrgIds: Array<Scalars['Int']>;
  type: FilterType;
  value: Scalars['Int'];
};

export enum FilterType {
  Cohort = 'Cohort',
  MissionArea = 'MissionArea'
}

export type FilteredTransactions = {
  nextPage?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Maybe<NonprofitTransaction>>>;
};

/** filters to apply to Stripe charges.search API */
export type Filters = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  createdBefore?: InputMaybe<Scalars['Int']>;
  maxAmount?: InputMaybe<Scalars['Int']>;
  minAmount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<TransactionStatus>;
};

export enum FormationPlan {
  Basic = 'BASIC',
  Growth = 'GROWTH',
  Impact = 'IMPACT',
  Plus = 'PLUS',
  Pro = 'PRO'
}

export type FunderCollaboratedGoal = {
  goalId: Scalars['Int'];
  goalLink: Scalars['String'];
  goalTitle: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type FunderDashboardFilters = {
  cohorts: Array<FilterOption>;
  missionAreas: Array<FilterOption>;
};

export type FunderOrg = {
  cohorts?: Maybe<Array<Maybe<FunderOrgCohort>>>;
  createdAt: Scalars['DateTime'];
  disabled: Scalars['Boolean'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isTest: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  nonprofitOrgs?: Maybe<Array<Maybe<NonprofitOrg>>>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<Maybe<FunderOrgUser>>>;
};

export type FunderOrgBasic = {
  disabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isTest?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type FunderOrgCohort = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type FunderOrgConfig = {
  orgId?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  shellAppRedirectEnabled?: Maybe<Scalars['Boolean']>;
  sponsoredNonprofits?: Maybe<Array<SponsoredNonprofit>>;
  user?: Maybe<UserUnion>;
};

export type FunderOrgDetails = {
  orgName?: Maybe<Scalars['String']>;
};

export type FunderOrgIdWithNonProfits = {
  funderOrgId?: Maybe<Scalars['Int']>;
  nonprofitOrgs: Array<Maybe<NonprofitOrg>>;
};

export type FunderOrgPaginatedResult = {
  funders?: Maybe<Array<FunderOrg>>;
  total: Scalars['Int'];
};

export type FunderOrgToNonprofit = {
  /** The date the funder org was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The date the funder org was disabled */
  disabledAt?: Maybe<Scalars['DateTime']>;
  /** The id of the funder org */
  id: Scalars['Int'];
  /** The name of the funder org */
  name?: Maybe<Scalars['String']>;
  /** The date the funder org was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FunderOrgToNonprofitOrg = {
  funderOrgId?: Maybe<Scalars['Int']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
};

export type FunderOrgToNonprofitOrgInput = {
  /** The date the funder org and nonprofit org relationship has been deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** The id of the funder org */
  funderOrgId?: Maybe<Scalars['Int']>;
  /** The id of the nonprofit org */
  nonprofitOrgId?: Maybe<Scalars['Int']>;
};

export type FunderOrgToSharedGoal = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  funderOrg: FunderOrg;
  funderOrgId: Scalars['Int'];
  goal: Goal;
  goalGroup?: Maybe<GoalGroup>;
  goalGroupId?: Maybe<Scalars['Int']>;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  isGoalSharedByFunder: Scalars['Boolean'];
  isGoalSharedByNonprofit: Scalars['Boolean'];
  sharedAt: Scalars['DateTime'];
};

export type FunderOrgToSharedStory = {
  funderOrgId: Scalars['Int'];
  sharedAt: Scalars['DateTime'];
  storyId: Scalars['Int'];
};

export enum FunderOrgToUserRelationship {
  CeoDirector = 'CEO_DIRECTOR',
  CommunityOutreachManager = 'COMMUNITY_OUTREACH_MANAGER',
  Consultant = 'CONSULTANT',
  GrantsManager = 'GRANTS_MANAGER',
  Marketing = 'MARKETING',
  Other = 'OTHER',
  ProgramOfficer = 'PROGRAM_OFFICER'
}

export enum FunderOrgToUserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type FunderOrgUser = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
};

export type FunderProfileViewLimits = {
  available?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  limitExpiryDate?: Maybe<Scalars['DateTime']>;
  used?: Maybe<Scalars['Int']>;
  viewedFunderEins?: Maybe<Array<Maybe<Scalars['Int']>>>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type FunderReport = {
  aggregateData?: Maybe<Scalars['Json']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  funderOrgId?: Maybe<Scalars['Int']>;
  reportData?: Maybe<Scalars['Json']>;
  summaryData?: Maybe<Scalars['Json']>;
  targetDate?: Maybe<Scalars['String']>;
};

export type FunderUser = {
  email?: Maybe<Scalars['String']>;
  isNonprofitUser?: Maybe<Scalars['Boolean']>;
  userAlreadyExists?: Maybe<Scalars['Boolean']>;
};

export type FunderUserConfig = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  funderOrgRole?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  permissions: Array<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  spaces?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FunderUserDetails = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
};

export type FunderUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  role: FunderOrgToUserRole;
};

export type FunderUserSettingsUpdateInput = {
  firstName: Scalars['String'];
  funderOrgRelationship?: InputMaybe<FunderOrgToUserRelationship>;
  lastLoggedInAt?: InputMaybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  role?: InputMaybe<FunderOrgToUserRole>;
};

export type FundingOrg990 = {
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Scalars['String']>;
  assets?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['Int']>;
  grantAverage?: Maybe<Scalars['Float']>;
  grantCount?: Maybe<Scalars['Int']>;
  grantMax?: Maybe<Scalars['Float']>;
  grantMin?: Maybe<Scalars['Float']>;
  grantTotalAmount?: Maybe<Scalars['Float']>;
  grants?: Maybe<Scalars['Json']>;
  grantsToPreselectedOnly?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  incomeAmount?: Maybe<Scalars['Float']>;
  locationsOfImpact?: Maybe<Scalars['Json']>;
  matchPercentage?: Maybe<Scalars['Float']>;
  nteeCode?: Maybe<Scalars['String']>;
  nteeDescription?: Maybe<Scalars['Json']>;
  organizationName?: Maybe<Scalars['String']>;
  people?: Maybe<Scalars['Json']>;
  state?: Maybe<Scalars['String']>;
  taxYear?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

export type GenerateFinancialHealthAssessmentReportInput = {
  additionalInputs?: InputMaybe<Scalars['Json']>;
  balanceSheetText?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
  organizationLegalName?: InputMaybe<Scalars['String']>;
  profitAndLossText?: InputMaybe<Scalars['String']>;
};

export type GenerateGrantAnalysisReportInput = {
  additionalInputs?: InputMaybe<Scalars['Json']>;
  anonymizeOrganization?: InputMaybe<Scalars['Boolean']>;
  balanceSheetText?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  grantAmount: Scalars['Int'];
  grantDeadline: Scalars['String'];
  grantDescription?: InputMaybe<Scalars['String']>;
  grantEligibility?: InputMaybe<Scalars['String']>;
  grantFocusArea: Scalars['String'];
  grantRestrictions?: InputMaybe<Scalars['String']>;
  grantTitle: Scalars['String'];
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  profitAndLossText?: InputMaybe<Scalars['String']>;
  uploadedFileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type GenerateNonprofitIntelligenceReportInput = {
  additionalInputs?: InputMaybe<Scalars['Json']>;
  anonymizeOrganization?: InputMaybe<Scalars['Boolean']>;
  ein?: InputMaybe<Scalars['String']>;
  focusAreas?: InputMaybe<Array<Scalars['String']>>;
  geographicScope?: InputMaybe<Scalars['String']>;
  includeBoardAnalysis?: InputMaybe<Scalars['Boolean']>;
  includeFinancialAnalysis?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
  peerOrganizations?: InputMaybe<Array<Scalars['String']>>;
};

export type GenerateStoryFromMurdocOpportunityInput = {
  /** Any additional requests for the story generation */
  additionalRequests?: InputMaybe<Scalars['String']>;
  /** Target audience for the story */
  audience: AiStoryAudienceType;
  /** ID of the nonprofit organization */
  nonprofitOrgId: Scalars['Int'];
  /** The selected story opportunity */
  opportunity: MurdocStoryOpportunityInput;
  /** Purpose/goal type for the story */
  purpose: AiStoryGoalType;
};

export type GenerationReport = {
  generated?: Maybe<Scalars['Boolean']>;
};

export type GetBoxFolderInput = {
  boxId: Scalars['String'];
  metaDataTemplate: Scalars['String'];
};

export type GetFeedItemsInput = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FeedItemFilters>;
  first?: InputMaybe<Scalars['Int']>;
};

export type GetUserRecommendationsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  placement?: InputMaybe<RecommendationPlacement>;
  status?: InputMaybe<RecommendationStatus>;
};

export type Goal = {
  ChecklistItem: Array<ChecklistItem>;
  EntryGroup: Array<EntryGroup>;
  FunderOrgToSharedGoal: Array<FunderOrgToSharedGoal>;
  GoalToDimension: Array<GoalToDimension>;
  GoalUpdate: Array<GoalUpdate>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  attachments: Array<Attachment>;
  category?: Maybe<GoalCategory>;
  /** The id of the first attached chart */
  chartId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  /** Indicates if the goal has an attached chart */
  hasChart?: Maybe<Scalars['Boolean']>;
  /** Indicates if the goal has an attached chart and it has at least one update */
  hasUpdates?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  impactCategory?: Maybe<GoalImpactCategory>;
  isComplete: Scalars['Boolean'];
  lastUpdatedUser?: Maybe<User>;
  metric?: Maybe<MetricType>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  /** Number of attachments associated with this goal */
  numAttachments?: Maybe<Scalars['Int']>;
  /** Number of progress updates associated with this goal */
  numProgressUpdates?: Maybe<Scalars['Int']>;
  oneOnOneCoachingEvents?: Maybe<Array<Maybe<OneOnOneCoachingEvent>>>;
  owner?: Maybe<User>;
  reportedMetricGroup?: Maybe<ReportedMetricGroup>;
  reportedMetricGroupId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  target?: Maybe<Scalars['Float']>;
  templateLibraryId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  type: GoalType;
  unitOfMeasurement?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum GoalCategory {
  BoardManagement = 'BOARD_MANAGEMENT',
  Compliance = 'COMPLIANCE',
  DataImpact = 'DATA_IMPACT',
  DeiAccessibility = 'DEI_ACCESSIBILITY',
  EventManagement = 'EVENT_MANAGEMENT',
  Finance = 'FINANCE',
  Formation = 'FORMATION',
  Fundraising = 'FUNDRAISING',
  Grants = 'GRANTS',
  InternalCapacity = 'INTERNAL_CAPACITY',
  MarketingCommunications = 'MARKETING_COMMUNICATIONS',
  MissionDriven = 'MISSION_DRIVEN',
  None = 'NONE',
  Other = 'OTHER',
  PeopleOperations = 'PEOPLE_OPERATIONS',
  ProgramManagement = 'PROGRAM_MANAGEMENT',
  Storytelling = 'STORYTELLING',
  StrategicPlanning = 'STRATEGIC_PLANNING',
  TechnologySolutions = 'TECHNOLOGY_SOLUTIONS',
  VolunteerManagement = 'VOLUNTEER_MANAGEMENT'
}

export type GoalDimensionInput = {
  id?: InputMaybe<Scalars['Int']>;
  startingValue?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type GoalGroup = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  category: GoalCategory;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isFunderAssigned: Scalars['Boolean'];
  startDate?: Maybe<Scalars['DateTime']>;
  target?: Maybe<Scalars['Float']>;
  targetDescription?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GoalGroupCard = {
  category: GoalCategory;
  completedTasks: Scalars['Int'];
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  goalGroupId: Scalars['Int'];
  isFunderAssigned: Scalars['Boolean'];
  numGrantees: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  target?: Maybe<Scalars['Float']>;
  targetDescription: Scalars['String'];
  targetProgress: Scalars['Float'];
  title: Scalars['String'];
  totalTasks: Scalars['Int'];
};

export type GoalGroupChartData = {
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  seriesData: Array<GoalGroupChartSeries>;
  target?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
  totalValue: Scalars['Float'];
  unitOfMeasurement?: Maybe<Scalars['String']>;
};

export type GoalGroupChartDataPoint = {
  x: Scalars['String'];
  y?: Maybe<Scalars['Float']>;
};

export type GoalGroupChartSeries = {
  data: Array<GoalGroupChartDataPoint>;
  goalName: Scalars['String'];
  nonprofitOrgName: Scalars['String'];
};

export enum GoalGroupChartType {
  GoalProgress = 'GOAL_PROGRESS',
  TaskCompletion = 'TASK_COMPLETION'
}

export type GoalGroupGranteeInfo = {
  completedTasks: Scalars['Int'];
  goalName: Scalars['String'];
  goalProgress: Scalars['Float'];
  goalTarget?: Maybe<Scalars['Float']>;
  nonprofitOrgId: Scalars['Int'];
  totalTasks: Scalars['Int'];
};

export enum GoalImpactCategory {
  Mission = 'MISSION',
  Organizational = 'ORGANIZATIONAL'
}

export type GoalInput = {
  details?: InputMaybe<Scalars['String']>;
  goalId: Scalars['Int'];
  metric: MetricType;
  reportedMetricGroupId?: InputMaybe<Scalars['Int']>;
  target?: InputMaybe<Scalars['Float']>;
  unitOfMeasurement: Scalars['String'];
};

export type GoalRecommendation = {
  description: Scalars['String'];
  target: Scalars['String'];
  title: Scalars['String'];
  unit: Scalars['String'];
};

export type GoalSharedToFunderCard = {
  ChecklistItem: Array<ChecklistItem>;
  EntryGroup: Array<EntryGroup>;
  category: GoalCategory;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  impactCategory?: Maybe<GoalImpactCategory>;
  isComplete: Scalars['Boolean'];
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  target?: Maybe<Scalars['Float']>;
  targetProgress?: Maybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type GoalTemplate = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  category?: Maybe<GoalCategory>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  templateLibraryId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type GoalTextUpdateInput = {
  description: Scalars['String'];
  goalId: Scalars['Int'];
  goalUpdateId?: InputMaybe<Scalars['Int']>;
  reportedAt: Scalars['DateTime'];
  taskId?: InputMaybe<Scalars['Int']>;
};

export type GoalToCreate = {
  category: GoalCategory;
  label: Scalars['String'];
  templateLibraryId: Scalars['String'];
};

export type GoalToDimension = {
  Entry: Array<Entry>;
  dimension: Dimension;
  dimensionId: Scalars['Int'];
  displayOrder: Scalars['Int'];
  goal: Goal;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
};

export enum GoalType {
  Campaign = 'CAMPAIGN',
  FunderShared = 'FUNDER_SHARED',
  GoalsWizard = 'GOALS_WIZARD',
  Onboarding = 'ONBOARDING',
  Template = 'TEMPLATE',
  UserCustom = 'USER_CUSTOM'
}

export type GoalUpdate = {
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  goal: Goal;
  goalId: Scalars['Int'];
  id: Scalars['Int'];
  lastUpdatedUser: User;
  reportedAt: Scalars['DateTime'];
  /** The task that the goal update is associated */
  taskId?: Maybe<Scalars['Int']>;
  /** The title of the task that the goal update is associated with */
  taskTitle?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type GoalUpdateInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  category?: InputMaybe<GoalCategory>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  impactCategory?: InputMaybe<GoalImpactCategory>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  isGoalSharedByNonprofit?: InputMaybe<Scalars['Boolean']>;
  metric?: InputMaybe<MetricType>;
  ownerId?: InputMaybe<Scalars['Int']>;
  shareWithFunderOrgId?: InputMaybe<Scalars['Int']>;
  shareWithFunderOrgIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  target?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<GoalType>;
  unitOfMeasurement?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum GoalUpdateSortOptions {
  UpdatedAtDesc = 'updatedAtDesc'
}

export type GoalUpdatesResponse = {
  nodes: Array<SingleGoalUpdate>;
};

export type GoalsByMonth = {
  activeMonthStart?: Maybe<Scalars['String']>;
  n?: Maybe<Scalars['Int']>;
};

export type GoalsData = {
  goalsCreatedByMonth?: Maybe<Array<Maybe<GoalsByMonth>>>;
  goalsUpdatedByMonth?: Maybe<Array<Maybe<GoalsByMonth>>>;
  totalOrgsWithGoals?: Maybe<Scalars['Int']>;
};

export type GoalsPrioritizedByTaskCreateDate = {
  goalId: Scalars['Int'];
  goalLink: Scalars['String'];
  goalTitle: Scalars['String'];
  latestTaskId: Scalars['Int'];
  numTasks: Scalars['Int'];
  numTasksCompleted: Scalars['Int'];
};

/** Grant amount range or typical value */
export type GrantAmount = {
  /** Maximum grant amount */
  max?: Maybe<Scalars['Int']>;
  /** Minimum grant amount */
  min?: Maybe<Scalars['Int']>;
  /** Typical grant amount description (e.g., "$10,000-$25,000") */
  typical?: Maybe<Scalars['String']>;
};

/** Grant deadline category: OPEN (≤30 days), UPCOMING (30-90 days), ROLLING (no fixed deadline) */
export enum GrantDeadlineCategory {
  Open = 'OPEN',
  Rolling = 'ROLLING',
  Upcoming = 'UPCOMING'
}

export type GrantInfo = {
  amount: Scalars['Int'];
  name: Scalars['String'];
};

export type GrantInput = {
  amount: Scalars['Int'];
  end: Scalars['DateTime'];
  initiativeName: Scalars['String'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
};

/** Rate limit information for grant research */
export type GrantResearchRateLimit = {
  /** Whether the org can generate a new report */
  canGenerateReport: Scalars['Boolean'];
  /** ID of the most recent report if one exists */
  lastReportId?: Maybe<Scalars['Int']>;
  /** When the org can next generate a report (if rate limited) */
  nextAvailableAt?: Maybe<Scalars['DateTime']>;
};

/** A grant research report generated by Murdoc AI */
export type GrantResearchReport = {
  /** When the report generation completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** When this report expires and can no longer be viewed */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** List of researched grants in this report */
  grants: Array<ResearchedGrant>;
  /** Total number of grants found */
  grantsFoundCount: Scalars['Int'];
  /** Number of grants with open deadlines (≤30 days) */
  grantsOpenCount: Scalars['Int'];
  /** Number of grants with rolling/no deadline */
  grantsRollingCount: Scalars['Int'];
  /** Number of grants with upcoming deadlines (30-90 days) */
  grantsUpcomingCount: Scalars['Int'];
  id: Scalars['Int'];
  /** Murdoc report run ID for tracking */
  murdocReportRunId?: Maybe<Scalars['String']>;
  /** Current status of the report generation */
  status: GrantResearchStatus;
};

/** Status of a grant research report */
export enum GrantResearchStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type GranteeAccountInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  role: NonprofitOrgToUserRole;
};

export type GranteeUserBasicInput = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  role: NonprofitOrgToUserRole;
};

export type GranteeUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  nonprofitOrgRole?: InputMaybe<NonprofitOrgRole>;
  phone?: InputMaybe<Scalars['String']>;
  role: NonprofitOrgToUserRole;
};

export type GroupCoachingEvent = {
  activityType?: Maybe<ActivityType>;
  attendeeDetails?: Maybe<Array<Maybe<GroupCoachingEventAttendee>>>;
  attendees?: Maybe<Array<Maybe<User>>>;
  body?: Maybe<Scalars['String']>;
  bookingUrl?: Maybe<Scalars['String']>;
  circleEventId?: Maybe<Scalars['Int']>;
  circleEventUrl?: Maybe<Scalars['String']>;
  coachEmail?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endsAt: Scalars['DateTime'];
  extensiveData?: Maybe<Scalars['Json']>;
  focusArea?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  googleCalendarId?: Maybe<Scalars['String']>;
  googleCalendarLink?: Maybe<Scalars['String']>;
  hideAttendees: Scalars['Boolean'];
  id: Scalars['Int'];
  meetingBody?: Maybe<Scalars['String']>;
  meetingTitle?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  recordingLink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  startsAt: Scalars['DateTime'];
  status?: Maybe<OneOnOneCoachingEventStatus>;
  summary?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  transcriptData?: Maybe<Scalars['Json']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  userRsvpNotes?: Maybe<Scalars['String']>;
  userRsvpStatus?: Maybe<Scalars['String']>;
  videoConferenceUrl?: Maybe<Scalars['String']>;
};

export type GroupCoachingEventAttendee = {
  attendedEvent: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  groupCoachingEvent?: Maybe<GroupCoachingEvent>;
  groupCoachingEventId: Scalars['Int'];
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  rsvpStatus: RsvpStatus;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type GroupCoachingEventInput = {
  activityType: ActivityType;
  attendeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  body?: InputMaybe<Scalars['String']>;
  bookingUrl?: InputMaybe<Scalars['String']>;
  coachEmail?: InputMaybe<Scalars['String']>;
  coachName?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  endsAt: Scalars['DateTime'];
  extensiveData?: InputMaybe<Scalars['Json']>;
  focusArea?: InputMaybe<Scalars['String']>;
  googleCalendarId?: InputMaybe<Scalars['String']>;
  googleCalendarLink?: InputMaybe<Scalars['String']>;
  hideAttendees: Scalars['Boolean'];
  meetingBody?: InputMaybe<Scalars['String']>;
  meetingTitle?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  recordingLink?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  startsAt: Scalars['DateTime'];
  status?: InputMaybe<OneOnOneCoachingEventStatus>;
  summary?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  transcriptData?: InputMaybe<Scalars['Json']>;
  videoConferenceUrl?: InputMaybe<Scalars['String']>;
};

export type GroupCoachingEventRsvpInput = {
  groupCoachingEventId: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  rsvpStatus: RsvpStatus;
};

export type GroupCoachingEvents = {
  groupCoachingEvents?: Maybe<Array<Maybe<GroupCoachingEvent>>>;
};

export type HideDimensions = {
  nonprofitOrgIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type ImpactDashboardActivity = {
  resource: ImpactDashboardActivityResourceDetails;
  userFullName: Scalars['String'];
  userId: Scalars['Int'];
  userStatus: Scalars['String'];
};

export type ImpactDashboardActivityResourceDetails = {
  courseId: Scalars['String'];
  id: Scalars['String'];
  nonprofitTopic: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ImpactReport = {
  funderCollaboratedGoals: Array<FunderCollaboratedGoal>;
  goalsPrioritizedByTaskCreateDate: Array<GoalsPrioritizedByTaskCreateDate>;
  impactGoalsUrl: Scalars['String'];
  pastReportPeriodActivity: Array<CategoryActivity>;
  reportEndDate: Scalars['String'];
  reportStartDate: Scalars['String'];
  showEmptyState?: Maybe<Scalars['Boolean']>;
  tasksSummary: TasksSummary;
};

export type InitializeCommunityResponse = {
  /** The URL of the Community website */
  communityURL: Scalars['String'];
};

export type InitiativeInput = {
  end: Scalars['DateTime'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
};

export type JobExecution = {
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorStack?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobName: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  payload?: Maybe<Scalars['Json']>;
  result?: Maybe<Scalars['Json']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: JobStatus;
};

export type JobExecutionConnection = {
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  nodes: Array<JobExecution>;
  totalCount: Scalars['Int'];
};

export type JobExecutionFilter = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  createdByUserId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  jobName?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<JobStatus>;
};

export type JobStat = {
  completed: Scalars['Int'];
  failed: Scalars['Int'];
  jobName: Scalars['String'];
  pending: Scalars['Int'];
  running: Scalars['Int'];
  successRate: Scalars['Float'];
  total: Scalars['Int'];
};

export type JobStats = {
  jobStats: Array<JobStat>;
};

export enum JobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type LoginAsResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type MaOsByMonth = {
  activeMonthStart?: Maybe<Scalars['String']>;
  n?: Maybe<Scalars['Int']>;
};

export type McpApiKey = {
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
};

export type Metadata = {
  donor?: Maybe<Scalars['String']>;
  donorEmail?: Maybe<Scalars['String']>;
  donorFirstName?: Maybe<Scalars['String']>;
  donorLastName?: Maybe<Scalars['String']>;
  honoree?: Maybe<Scalars['String']>;
  honoreeEmail?: Maybe<Scalars['String']>;
  honoreeFirstName?: Maybe<Scalars['String']>;
  honoreeLastName?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  storyId?: Maybe<Scalars['String']>;
  storyTitle?: Maybe<Scalars['String']>;
};

export enum MetricType {
  Average = 'AVERAGE',
  Total = 'TOTAL'
}

export type MissingPriority = {
  category?: Maybe<GoalCategory>;
  challenges?: Maybe<Scalars['String']>;
  priorityNotes?: Maybe<Scalars['String']>;
};

export type MissionGoalsProgressStats = {
  missionGoalChartProgress?: Maybe<ProgressStat>;
  missionGoalChartUpdates?: Maybe<ProgressStat>;
  missionGoalsWithTargets?: Maybe<ProgressStat>;
  orgsWithMissionGoals?: Maybe<ProgressStat>;
};

export type MurdocEmbedSession = {
  /** When the session token expires */
  expiresAt: Scalars['DateTime'];
  /** URL to load in the iframe for Murdoc embed */
  iframeUrl: Scalars['String'];
  /** When the session should be refreshed (80% of lifetime) */
  refreshAt: Scalars['DateTime'];
};

export type MurdocReport = {
  /** Array of document citations used in the report */
  citations: Array<Scalars['Json']>;
  /** Expiration timestamp for download URL */
  downloadExpiresAt?: Maybe<Scalars['DateTime']>;
  /** Format of downloadable document (pdf or docx) */
  downloadFormat?: Maybe<Scalars['String']>;
  /** URL for downloading PDF/DOCX version (if generated) */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Markdown content of the report with {{VIZ:n}} placeholders */
  markdown: Scalars['String'];
  /** Report metadata including generation time, stage count, etc. */
  metadata: Scalars['Json'];
  /** Unique identifier for the report run */
  runId: Scalars['String'];
  /** Current status of the report */
  status: MurdocReportRunStatus;
  /** Array of chart.js visualization configurations */
  visualizations: Array<Scalars['Json']>;
};

export type MurdocReportRunResult = {
  /** Optional URL for polling progress updates */
  progressUrl?: Maybe<Scalars['String']>;
  /** When available, contains the parsed Murdoc response (markdown, visualizations, metadata) */
  reportData?: Maybe<Scalars['Json']>;
  /** The slug of the report template being generated */
  reportSlug?: Maybe<Scalars['String']>;
  /** Unique identifier for the report generation run */
  runId: Scalars['String'];
  /** Initial status of the run (typically QUEUED) */
  status: MurdocReportRunStatus;
  /** ID of the user who initiated the report generation */
  userId: Scalars['Int'];
};

export enum MurdocReportRunStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING'
}

export type MurdocStoryOpportunitiesResponse = {
  /** Timestamp when the analysis was generated */
  generatedAt?: Maybe<Scalars['String']>;
  /** List of detected story opportunities */
  opportunities: Array<MurdocStoryOpportunity>;
  /** Enriched organization context */
  orgContext?: Maybe<MurdocStoryOrgContext>;
  /** Summary of findings from Murdoc analysis */
  summary?: Maybe<Scalars['String']>;
  /** Any warnings or notes from the analysis */
  warnings?: Maybe<Array<Scalars['String']>>;
};

export type MurdocStoryOpportunity = {
  /** Category of the story opportunity */
  category: StoryOpportunityCategoryType;
  /** Relevant excerpt from the source content */
  contentExcerpt?: Maybe<Scalars['String']>;
  /** AI-assessed relevance score (1-100) */
  relevanceScore: Scalars['Int'];
  /** Platform where the content was found */
  sourcePlatform: StoryOpportunitySourcePlatform;
  /** URL of the source content */
  sourceUrl?: Maybe<Scalars['String']>;
  /** Suggested storytelling angle or approach */
  suggestedAngle?: Maybe<Scalars['String']>;
  /** Short compelling title for the story opportunity */
  title: Scalars['String'];
};

export type MurdocStoryOpportunityInput = {
  category: StoryOpportunityCategoryType;
  contentExcerpt?: InputMaybe<Scalars['String']>;
  relevanceScore: Scalars['Int'];
  sourcePlatform: StoryOpportunitySourcePlatform;
  sourceUrl?: InputMaybe<Scalars['String']>;
  suggestedAngle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MurdocStoryOrgContext = {
  /** Focus areas or program categories */
  focusAreas?: Maybe<Array<Scalars['String']>>;
  /** Organization mission statement */
  mission?: Maybe<Scalars['String']>;
  /** Organization name */
  name?: Maybe<Scalars['String']>;
  /** Geographic location/state */
  state?: Maybe<Scalars['String']>;
};

export type Mutation = {
  FindOrCreateColorTheme: ColorTheme;
  SelfCheckout: CheckoutResponse;
  addGoal?: Maybe<Goal>;
  addGoalMeasurement?: Maybe<Goal>;
  assignGoalsToGoalGroup?: Maybe<CreateOrUpdateManyResponse>;
  autoCompleteTasksMutation: UpdatedTasksResult;
  claimAiCoachingIntervention?: Maybe<TriggerInterventionResponse>;
  completeQuickBooksConnection?: Maybe<QuickBooksConnection>;
  createAttachment?: Maybe<Attachment>;
  createAutomatedGoal?: Maybe<AutomatedGoal>;
  createBoxConfig?: Maybe<BoxConfig>;
  createCampaign: Campaign;
  createChart?: Maybe<Chart>;
  createChartCategories?: Maybe<Array<Maybe<ChartCategory>>>;
  createChartDataPoints?: Maybe<CreateOrUpdateManyResponse>;
  createCharts?: Maybe<Array<Maybe<Chart>>>;
  createDonationsDemoAccount?: Maybe<DonationsDemoStatus>;
  createEntry?: Maybe<EntryGroup>;
  createFeedItem?: Maybe<FeedItem>;
  createFunderOrg: FunderOrg;
  createFunderUser: FunderUser;
  createGoalGroup?: Maybe<GoalGroup>;
  createGroupCoachingEvent: GroupCoachingEvent;
  createIncompleteUserSurveys: CreateUserSurveysResponse;
  createManyFunderUsers?: Maybe<Array<Maybe<FunderUser>>>;
  createManyNonprofitOrgUsers?: Maybe<Array<Maybe<NonprofitUser>>>;
  createMurdocEmbedSession: MurdocEmbedSession;
  createNonprofitOrg: NonprofitOrg;
  /**
   * This adds existing user to an existing nonprofit organization.
   *       It does not provision any other resource
   */
  createNonprofitOrgToUserRelationship?: Maybe<NonprofitOrgConfig>;
  createNonprofitOrgUser: NonprofitUser;
  createNonprofitToViewedFunder?: Maybe<NonprofitOrgToViewedFundingOrg990>;
  createOnboardingGoal?: Maybe<CreateOnboardingGoalResponse>;
  createOneOnOneCoachingEvent?: Maybe<OneOnOneCoachingEvent>;
  createOrRetrieveCloudinaryConfig?: Maybe<CloudinaryConfig>;
  createReportedMetricGroup: ReportedMetricGroup;
  createStripeConnect?: Maybe<StripeConnectAccount>;
  createTaxExemptionStatus?: Maybe<TaxExemptionStatus>;
  createTemplateGoals?: Maybe<TemplateGoals>;
  declineAiCoachingIntervention?: Maybe<TriggerInterventionResponse>;
  deleteAttachment?: Maybe<Attachment>;
  deleteChecklistItem?: Maybe<ChecklistItem>;
  deleteGoalDimensionRelationship?: Maybe<DeleteGoalDimensionResponse>;
  deleteGoalUpdate: GoalUpdate;
  deleteGroupCoachingEvent: Scalars['Boolean'];
  deleteOneOnOneCoachingEvent?: Maybe<Scalars['Boolean']>;
  deleteRecurringTasks?: Maybe<Array<Maybe<ChecklistItem>>>;
  disconnectQuickBooks: Scalars['Boolean'];
  dismissFeedItem?: Maybe<FeedItem>;
  /** Dismiss a researched grant from your list */
  dismissResearchedGrant: ResearchedGrant;
  duplicateStory?: Maybe<Story>;
  editGoalGroup?: Maybe<GoalGroup>;
  endLoginAs?: Maybe<EndLoginAsResponse>;
  /** Extract text content from a document stored in Cloudinary. Supports PDF, Excel, and CSV files. */
  extractDocumentText: ExtractDocumentTextResult;
  generateDataVisualization?: Maybe<DataVisualizationResult>;
  /** Generate a financial health assessment using Murdoc and return the parsed report payload for dashboard rendering. */
  generateFinancialHealthAssessmentReport: MurdocReportRunResult;
  /** Generate a grant analysis report using Murdoc. Returns a run ID for tracking progress. */
  generateGrantAnalysisReport: MurdocReportRunResult;
  /** Generate a new grant research report using Murdoc AI. Rate limited to 1 per org per week. */
  generateGrantResearchReport: GrantResearchReport;
  generateMcpApiKey: McpApiKey;
  /** Generate a nonprofit intelligence report using Murdoc. Returns a run ID for tracking progress. */
  generateNonprofitIntelligenceReport: MurdocReportRunResult;
  /** Generate an AI story from a Murdoc-detected opportunity */
  generateStoryFromMurdocOpportunity?: Maybe<AiStoriesResponse>;
  generateUserRecommendations?: Maybe<UserRecommendationsResponse>;
  getNewBoxToken?: Maybe<ReturnedTokenData>;
  hideDimensions?: Maybe<HideDimensions>;
  initializeCommunity?: Maybe<InitializeCommunityResponse>;
  initiateQuickBooksConnection?: Maybe<QuickBooksAuthUrl>;
  loginAs?: Maybe<LoginAsResponse>;
  markFeedItemInteracted?: Maybe<FeedItem>;
  markFeedItemSeen?: Maybe<FeedItem>;
  markTaskAsCompleted: ExtendedChecklistItem;
  nonprofitBoard?: Maybe<NonprofitBoard>;
  nonprofitDeiInitiatives?: Maybe<NonprofitDeiInitiatives>;
  notifyResiliaToAddGoal: Scalars['Boolean'];
  postAiCoachingToFeed?: Maybe<TriggerInterventionResponse>;
  promptProgressUpdate?: Maybe<PromptProgressUpdateResponse>;
  recordLoginEvent?: Maybe<RecordLoginEventResponse>;
  refetchFeatureFlags?: Maybe<FeatureFlags>;
  refetchGongTranscript: RefetchTranscriptResponse;
  refetchHubspot: RefetchHubspotResponse;
  removeCohortMembership?: Maybe<RemoveCohortMembershipResponse>;
  removeCohortOwnership?: Maybe<RemoveCohortOwnershipResponse>;
  removeFunderUser: FunderOrgToUser;
  removeNonprofitOrgUser: NonprofitOrgToUser;
  removeSavedFunderForNonprofit?: Maybe<NonprofitOrgToSavedFundingOrg990>;
  resendFunderInvite?: Maybe<ResendInvite>;
  resendInvite?: Maybe<ResendInvite>;
  retriggerGoalsWizard?: Maybe<NonprofitOrgProfile>;
  retriggerProfiler?: Maybe<RetriggerProfilerResponse>;
  retryJob?: Maybe<RetryJobResult>;
  revokeMcpApiKey: Scalars['Boolean'];
  rsvpToGroupCoachingEvent: GroupCoachingEventAttendee;
  saveFunderForNonprofit?: Maybe<NonprofitOrgToSavedFundingOrg990>;
  /** Save a researched grant to your saved list */
  saveResearchedGrant: ResearchedGrant;
  sendAiCoachingEmail?: Maybe<TriggerInterventionResponse>;
  shareStoryWithFunder?: Maybe<FunderOrgToSharedStory>;
  trackAdblockerDetected?: Maybe<TrackAdblockerDetectedResponse>;
  trackRecommendationInteraction?: Maybe<UserRecommendation>;
  trackWithoutPII: TrackWithoutPiiResponse;
  triggerAiCoachingIntervention?: Maybe<TriggerInterventionResponse>;
  unshareStoryWithFunder?: Maybe<FunderOrgToSharedStory>;
  updateAiCoachingIntervention?: Maybe<TriggerInterventionResponse>;
  updateAttachment?: Maybe<Attachment>;
  updateAutoStoriesSettings?: Maybe<AutoStoriesSettings>;
  updateCampaign: Campaign;
  updateChart?: Maybe<Chart>;
  updateChartCategory?: Maybe<ChartCategory>;
  updateChartDataPoints?: Maybe<CreateOrUpdateManyResponse>;
  updateDonationPortal?: Maybe<DonationPortal>;
  updateEntryGroup?: Maybe<EntryGroup>;
  updateFunderUserSettings: User;
  updateGoal: Goal;
  updateGroupCoachingEvent: GroupCoachingEvent;
  updateNonprofitOrgCommunitySettings?: Maybe<UpdateNonprofitOrgCommunitySettingsResponse>;
  updateNonprofitOrgMission: NonprofitOrg;
  updateNonprofitOrgProfile?: Maybe<NonprofitOrgProfile>;
  updateOneOnOneCoachingEvent?: Maybe<OneOnOneCoachingEvent>;
  updateReportedMetricGroup: ReportedMetricGroup;
  updateStory?: Maybe<Story>;
  updateStripeConnect?: Maybe<StripeConnectAccount>;
  updateTaxExemptionStatus?: Maybe<UpdateTaxExemptionStatusResponse>;
  updateUserSettings: User;
  upsertChecklistItem?: Maybe<ChecklistItem>;
  upsertCohort?: Maybe<UpsertCohortResponse>;
  upsertCohortMembership?: Maybe<UpsertCohortMembershipResponse>;
  upsertCohortOwnership?: Maybe<UpsertCohortOwnershipResponse>;
  upsertDonationPortal?: Maybe<DonationPortal>;
  upsertFunderOrgPlatformProduct?: Maybe<UpsertFunderOrgPlatformProductResponse>;
  upsertFunderOrgToNonprofitOrg: FunderOrgToNonprofitOrgInput;
  upsertGoalUpdate: GoalUpdate;
  upsertNonprofitOrgPlatformPlanAddOn?: Maybe<UpsertNonprofitOrgPlatformPlanAddOnResponse>;
  upsertNonprofitOrgSettings: NonprofitOrg;
  upsertNonprofitPreonboarding?: Maybe<NonprofitPreonboarding>;
  upsertRecurringChecklistItem?: Maybe<Array<Maybe<ChecklistItem>>>;
  upsertStory?: Maybe<Story>;
  upsertTemplateLibrary: TemplateLibrary;
  upsertUserSurvey?: Maybe<UserSurvey>;
};


export type MutationFindOrCreateColorThemeArgs = {
  chosenColor: Scalars['String'];
};


export type MutationSelfCheckoutArgs = {
  selfCheckoutInput: CheckoutInput;
};


export type MutationAddGoalArgs = {
  goalInfo: AddGoalInput;
};


export type MutationAddGoalMeasurementArgs = {
  dimensionInfo: Array<GoalDimensionInput>;
  goalInfo: GoalInput;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationAssignGoalsToGoalGroupArgs = {
  data: AssignGoalsToGoalGroupInput;
};


export type MutationAutoCompleteTasksMutationArgs = {
  resourceId: Scalars['String'];
};


export type MutationClaimAiCoachingInterventionArgs = {
  interventionId: Scalars['Int'];
};


export type MutationCompleteQuickBooksConnectionArgs = {
  code: Scalars['String'];
  realmId: Scalars['String'];
  state: Scalars['String'];
};


export type MutationCreateAttachmentArgs = {
  filename: Scalars['String'];
  format?: InputMaybe<Scalars['String']>;
  goalId: Scalars['Int'];
  publicId: Scalars['String'];
  resourceType?: InputMaybe<Scalars['String']>;
  secureUrl: Scalars['String'];
};


export type MutationCreateAutomatedGoalArgs = {
  appcuesFlowId: Scalars['String'];
  createObjective?: InputMaybe<Scalars['Boolean']>;
  isGoalSharedByFunder?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
  shareWithFunderOrgId?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateBoxConfigArgs = {
  orgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationCreateCampaignArgs = {
  campaignInput: CampaignInput;
  orgId: Scalars['Int'];
};


export type MutationCreateChartArgs = {
  data: CreateChartInput;
};


export type MutationCreateChartCategoriesArgs = {
  chartId: Scalars['Int'];
  data: Array<ChartCategoryInput>;
};


export type MutationCreateChartDataPointsArgs = {
  data: Array<ChartDataPointInput>;
};


export type MutationCreateChartsArgs = {
  data: CreateChartsInput;
};


export type MutationCreateDonationsDemoAccountArgs = {
  updatedBy: Scalars['String'];
  userEmail: Scalars['String'];
};


export type MutationCreateEntryArgs = {
  entryGroupInfo: EntryGroupInput;
  entryInfo: Array<EntryInput>;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationCreateFeedItemArgs = {
  input: CreateFeedItemInput;
};


export type MutationCreateFunderOrgArgs = {
  funderOrgInfo: AccountInput;
};


export type MutationCreateFunderUserArgs = {
  funderOrgId: Scalars['Int'];
  funderUserInfo: FunderUserInput;
};


export type MutationCreateGoalGroupArgs = {
  data?: InputMaybe<CreateGoalGroupInput>;
};


export type MutationCreateGroupCoachingEventArgs = {
  input: GroupCoachingEventInput;
};


export type MutationCreateIncompleteUserSurveysArgs = {
  userIds: Array<Scalars['Int']>;
};


export type MutationCreateManyFunderUsersArgs = {
  funderOrgId: Scalars['Int'];
  funderUsersInfo: Array<BulkFunderUserInput>;
  inviterUserId: Scalars['Int'];
};


export type MutationCreateManyNonprofitOrgUsersArgs = {
  inviteType?: InputMaybe<NonprofitOrgInviteType>;
  nonprofitOrgId: Scalars['Int'];
  nonprofitUserInfo: GranteeUserBasicInput;
  sendInvite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateMurdocEmbedSessionArgs = {
  orgId: Scalars['Int'];
};


export type MutationCreateNonprofitOrgArgs = {
  funderOrgId?: InputMaybe<Scalars['Int']>;
  granteeInfo: GranteeAccountInput;
  orgInfo: OrgInput;
  platformPlan?: InputMaybe<PlatformPlan>;
  promoCodeId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateNonprofitOrgToUserRelationshipArgs = {
  nonprofitOrgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationCreateNonprofitOrgUserArgs = {
  inviteType?: InputMaybe<NonprofitOrgInviteType>;
  nonprofitOrgId: Scalars['Int'];
  nonprofitUserInfo: GranteeUserInput;
  sendInvite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateNonprofitToViewedFunderArgs = {
  funderEin: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationCreateOnboardingGoalArgs = {
  nonprofitOrgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationCreateOneOnOneCoachingEventArgs = {
  input: OneOnOneCoachingEventInput;
};


export type MutationCreateOrRetrieveCloudinaryConfigArgs = {
  orgId: Scalars['Int'];
};


export type MutationCreateReportedMetricGroupArgs = {
  nonprofitOrgId: Scalars['Int'];
  reportedMetricGroupInfo: ReportedMetricGroupInput;
};


export type MutationCreateStripeConnectArgs = {
  email: Scalars['String'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationCreateTaxExemptionStatusArgs = {
  nonprofitOrgId: Scalars['Int'];
  taxExemptionStatus: Scalars['Boolean'];
  updatedBy: Scalars['String'];
  verificationMethod: VerificationMethod;
};


export type MutationCreateTemplateGoalsArgs = {
  nonprofitOrgId: Scalars['Int'];
  templateIds: Array<Scalars['Int']>;
};


export type MutationDeclineAiCoachingInterventionArgs = {
  interventionId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteAttachmentArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteChecklistItemArgs = {
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationDeleteGoalDimensionRelationshipArgs = {
  goalToDimensionId: Scalars['Int'];
};


export type MutationDeleteGoalUpdateArgs = {
  goalUpdateId: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationDeleteGroupCoachingEventArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteOneOnOneCoachingEventArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteRecurringTasksArgs = {
  checklistItemGroupId: Scalars['Int'];
  checklistItemId: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
  option: DeleteRecurringTasksOption;
};


export type MutationDisconnectQuickBooksArgs = {
  orgId: Scalars['Int'];
};


export type MutationDismissFeedItemArgs = {
  feedItemId: Scalars['Int'];
};


export type MutationDismissResearchedGrantArgs = {
  grantId: Scalars['Int'];
};


export type MutationDuplicateStoryArgs = {
  storyId: Scalars['Int'];
};


export type MutationEditGoalGroupArgs = {
  data: CreateGoalGroupInput;
  funderOrgId: Scalars['Int'];
  goalGroupId: Scalars['Int'];
};


export type MutationExtractDocumentTextArgs = {
  input: ExtractDocumentTextInput;
};


export type MutationGenerateDataVisualizationArgs = {
  naturalLanguageQuery: Scalars['String'];
};


export type MutationGenerateFinancialHealthAssessmentReportArgs = {
  input: GenerateFinancialHealthAssessmentReportInput;
};


export type MutationGenerateGrantAnalysisReportArgs = {
  input: GenerateGrantAnalysisReportInput;
};


export type MutationGenerateGrantResearchReportArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type MutationGenerateMcpApiKeyArgs = {
  name: Scalars['String'];
};


export type MutationGenerateNonprofitIntelligenceReportArgs = {
  input: GenerateNonprofitIntelligenceReportInput;
};


export type MutationGenerateStoryFromMurdocOpportunityArgs = {
  input: GenerateStoryFromMurdocOpportunityInput;
};


export type MutationGenerateUserRecommendationsArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationGetNewBoxTokenArgs = {
  userId: Scalars['Int'];
};


export type MutationHideDimensionsArgs = {
  nonprofitOrgIds: Array<Scalars['Int']>;
};


export type MutationInitializeCommunityArgs = {
  agreedCommunityGuidelines: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  postSlug?: InputMaybe<Scalars['String']>;
  spaceSlug?: InputMaybe<Scalars['String']>;
};


export type MutationInitiateQuickBooksConnectionArgs = {
  orgId: Scalars['Int'];
};


export type MutationLoginAsArgs = {
  userId: Scalars['Int'];
};


export type MutationMarkFeedItemInteractedArgs = {
  feedItemId: Scalars['Int'];
};


export type MutationMarkFeedItemSeenArgs = {
  feedItemId: Scalars['Int'];
};


export type MutationMarkTaskAsCompletedArgs = {
  taskId: Scalars['Int'];
};


export type MutationNonprofitBoardArgs = {
  developmentInitiatives?: InputMaybe<Scalars['String']>;
  developmentStrategy?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationNonprofitDeiInitiativesArgs = {
  description: Scalars['String'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationNotifyResiliaToAddGoalArgs = {
  userId: Scalars['Int'];
};


export type MutationPostAiCoachingToFeedArgs = {
  interventionId: Scalars['Int'];
  message: Scalars['String'];
};


export type MutationRecordLoginEventArgs = {
  anonymousId: Scalars['String'];
  email: Scalars['String'];
};


export type MutationRefetchGongTranscriptArgs = {
  id: Scalars['Int'];
};


export type MutationRefetchHubspotArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveCohortMembershipArgs = {
  ids: Array<Scalars['Int']>;
};


export type MutationRemoveCohortOwnershipArgs = {
  id: Scalars['Int'];
};


export type MutationRemoveFunderUserArgs = {
  funderId: Scalars['Int'];
  removeFunderUserInfo: RemoveFunderUserInput;
};


export type MutationRemoveNonprofitOrgUserArgs = {
  nonprofitOrgId: Scalars['Int'];
  removeNonprofitOrgUserInfo: RemoveNonprofitOrgUserInput;
};


export type MutationRemoveSavedFunderForNonprofitArgs = {
  funderEin: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationResendFunderInviteArgs = {
  funderOrgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationResendInviteArgs = {
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
};


export type MutationRetriggerGoalsWizardArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type MutationRetriggerProfilerArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type MutationRetryJobArgs = {
  jobId: Scalars['String'];
};


export type MutationRevokeMcpApiKeyArgs = {
  id: Scalars['ID'];
};


export type MutationRsvpToGroupCoachingEventArgs = {
  input: GroupCoachingEventRsvpInput;
};


export type MutationSaveFunderForNonprofitArgs = {
  funderEin: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationSaveResearchedGrantArgs = {
  grantId: Scalars['Int'];
};


export type MutationSendAiCoachingEmailArgs = {
  interventionId: Scalars['Int'];
  message: Scalars['String'];
};


export type MutationShareStoryWithFunderArgs = {
  funderOrgId: Scalars['Int'];
  storyId: Scalars['Int'];
};


export type MutationTrackRecommendationInteractionArgs = {
  input?: InputMaybe<TrackRecommendationInteractionInput>;
};


export type MutationTrackWithoutPiiArgs = {
  trackWithoutPIIInput: TrackWithoutPiiInput;
};


export type MutationTriggerAiCoachingInterventionArgs = {
  force?: InputMaybe<Scalars['Boolean']>;
  identifier: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUnshareStoryWithFunderArgs = {
  funderOrgId: Scalars['Int'];
  storyId: Scalars['Int'];
};


export type MutationUpdateAiCoachingInterventionArgs = {
  coachFeedback?: InputMaybe<Scalars['String']>;
  coachRating?: InputMaybe<Scalars['String']>;
  editedMessage?: InputMaybe<Scalars['String']>;
  interventionId: Scalars['Int'];
};


export type MutationUpdateAttachmentArgs = {
  filename?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};


export type MutationUpdateAutoStoriesSettingsArgs = {
  nonprofitOrgId: Scalars['Int'];
  settings: AutoStoriesSettingsInput;
};


export type MutationUpdateCampaignArgs = {
  campaignId: Scalars['String'];
  campaignInput: CampaignInput;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateChartArgs = {
  data: UpdateChartInput;
};


export type MutationUpdateChartCategoryArgs = {
  data: UpdateChartCategoryInput;
};


export type MutationUpdateChartDataPointsArgs = {
  data: Array<UpdateChartDataPointInput>;
};


export type MutationUpdateDonationPortalArgs = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  portalId: Scalars['Int'];
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  updatedUserId: Scalars['Int'];
};


export type MutationUpdateEntryGroupArgs = {
  entryGroupInfo: UpdateEntryGroupInput;
  entryInfo: Array<UpdateEntryInput>;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationUpdateFunderUserSettingsArgs = {
  funderId: Scalars['Int'];
  userIdToUpdate?: InputMaybe<Scalars['Int']>;
  userSettingsInfo: FunderUserSettingsUpdateInput;
};


export type MutationUpdateGoalArgs = {
  goalUpdateInfo: GoalUpdateInput;
};


export type MutationUpdateGroupCoachingEventArgs = {
  id: Scalars['Int'];
  input: GroupCoachingEventInput;
};


export type MutationUpdateNonprofitOrgCommunitySettingsArgs = {
  nonprofitOrgId: Scalars['Int'];
  spaceGroupIds: Array<Scalars['String']>;
  spaceIds: Array<Scalars['String']>;
};


export type MutationUpdateNonprofitOrgMissionArgs = {
  orgInfo: UpdateNonprofitOrgInput;
};


export type MutationUpdateNonprofitOrgProfileArgs = {
  updateNonprofitOrgProfileInput?: InputMaybe<UpdateNonprofitOrgProfileInput>;
};


export type MutationUpdateOneOnOneCoachingEventArgs = {
  id: Scalars['Int'];
  input: OneOnOneCoachingEventInput;
};


export type MutationUpdateReportedMetricGroupArgs = {
  reportedMetricGroupInfo: ReportedMetricGroupUpdateInput;
};


export type MutationUpdateStoryArgs = {
  storyUpdateInput: StoryUpdateInput;
};


export type MutationUpdateStripeConnectArgs = {
  connectAccountMetadata: ConnectAccountMetadata;
  stripeConnectId: Scalars['String'];
};


export type MutationUpdateTaxExemptionStatusArgs = {
  dealStageId: Scalars['String'];
  nonprofitOrgId: Scalars['Int'];
  questionnaireLink?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserSettingsArgs = {
  nonprofitOrgId: Scalars['Int'];
  responsibility?: InputMaybe<ResponsibilityInput>;
  userIdToUpdate?: InputMaybe<Scalars['Int']>;
  userSettingsInfo: UserSettingsUpdateInput;
};


export type MutationUpsertChecklistItemArgs = {
  itemInfo: ChecklistItemInput;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationUpsertCohortArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  funderOrgIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  memberRoles?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationUpsertCohortMembershipArgs = {
  cohortId: Scalars['Int'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  nonprofitOrgIds: Array<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationUpsertCohortOwnershipArgs = {
  cohortId: Scalars['Int'];
  funderOrgId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationUpsertDonationPortalArgs = {
  content: PortalContentInput;
  hashedId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationUpsertFunderOrgPlatformProductArgs = {
  auth0Role: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  funderOrgId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertFunderOrgToNonprofitOrgArgs = {
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  funderOrgId: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};


export type MutationUpsertGoalUpdateArgs = {
  goalUpdateInfo: GoalTextUpdateInput;
  nonprofitOrgId: Scalars['Int'];
};


export type MutationUpsertNonprofitOrgPlatformPlanAddOnArgs = {
  auth0Role: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
  stripePriceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertNonprofitOrgSettingsArgs = {
  nonprofitOrgId: Scalars['Int'];
  nonprofitOrgRelations?: InputMaybe<NonprofitOrgRelationsInput>;
  orgFinancialSettings?: InputMaybe<OrgFinancialSettingsInput>;
  orgSettings: OrgSettingsInput;
};


export type MutationUpsertNonprofitPreonboardingArgs = {
  ein?: InputMaybe<Scalars['String']>;
  funderOrgId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  impactIntelligenceStatus?: InputMaybe<NonprofitImpactIntelligencePreonboardingStatus>;
  orgName: Scalars['String'];
  status?: InputMaybe<NonprofitPreonboardingStatus>;
};


export type MutationUpsertRecurringChecklistItemArgs = {
  nonprofitOrgId: Scalars['Int'];
  recurringItemInfo: RecurringChecklistItemInput;
};


export type MutationUpsertStoryArgs = {
  storyUpsertInput: StoryUpsertInput;
};


export type MutationUpsertTemplateLibraryArgs = {
  templateLibraryInput: TemplateLibraryInput;
};


export type MutationUpsertUserSurveyArgs = {
  userSurveyData: UserSurveyUpsertInput;
};

export type NeedsProgressUpdateResponse = {
  /** Whether this user should be prompted to submit a progress update. */
  needsProgressUpdate?: Maybe<Scalars['Boolean']>;
};

export type Nonprofit = {
  grantAwardAmount?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  user?: Maybe<UserConfig>;
};

export type NonprofitBoard = {
  developmentInitiatives?: Maybe<Scalars['String']>;
  developmentStrategy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  representation?: Maybe<Scalars['String']>;
};

export type NonprofitCharge = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeFeeId?: Maybe<Scalars['String']>;
  disputeFeeReversalId?: Maybe<Scalars['String']>;
  disputeId?: Maybe<Scalars['String']>;
  disputeReversalId?: Maybe<Scalars['String']>;
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  refundIds: Array<Maybe<Scalars['String']>>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitDashboardData = {
  activeCount?: Maybe<Scalars['Int']>;
  cohorts?: Maybe<Array<Maybe<CohortData>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NonprofitData = {
  orgId?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
};

export type NonprofitDeiInitiatives = {
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type NonprofitDispute = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  chargeId: Scalars['String'];
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeFeeId?: Maybe<Scalars['String']>;
  disputeFeeReversalId?: Maybe<Scalars['String']>;
  disputeReversalId?: Maybe<Scalars['String']>;
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitDisputeFee = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  chargeId: Scalars['String'];
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeFeeReversalId?: Maybe<Scalars['String']>;
  disputeId?: Maybe<Scalars['String']>;
  disputeReversalId?: Maybe<Scalars['String']>;
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitDisputeFeeReversal = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  chargeId: Scalars['String'];
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeFeeId?: Maybe<Scalars['String']>;
  disputeId?: Maybe<Scalars['String']>;
  disputeReversalId?: Maybe<Scalars['String']>;
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitDisputeReversal = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  chargeId: Scalars['String'];
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeFeeId?: Maybe<Scalars['String']>;
  disputeFeeReversalId?: Maybe<Scalars['String']>;
  disputeId?: Maybe<Scalars['String']>;
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitDonation = {
  amount?: Maybe<Scalars['Int']>;
  application?: Maybe<Scalars['String']>;
  application_fee?: Maybe<Scalars['String']>;
  application_fee_amount?: Maybe<Scalars['Int']>;
  brand?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disputeDetails?: Maybe<Scalars['Json']>;
  fee?: Maybe<Scalars['Int']>;
  funding?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isRecurring: Scalars['Boolean'];
  last4?: Maybe<Scalars['String']>;
  metadata?: Maybe<Metadata>;
  net?: Maybe<Scalars['Int']>;
  object?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  recurrenceDetails?: Maybe<NonprofitDonationRecurrenceDetails>;
  refundDetails?: Maybe<Scalars['Json']>;
  refunded?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type NonprofitDonationRecurrenceDetails = {
  interval: NonprofitDonationRecurrenceDetailsInterval;
  status: NonprofitDonationRecurrenceDetailsStatus;
};

export enum NonprofitDonationRecurrenceDetailsInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export enum NonprofitDonationRecurrenceDetailsStatus {
  Active = 'active',
  Canceled = 'canceled'
}

export type NonprofitDonationSummary = {
  /** average donation amount in cents, excluding fees */
  average: Scalars['Int'];
  /** total number of donations made to a nonprofit */
  donationCount: Scalars['Int'];
  /** total amount donated to a nonprofit in cents, excluding fees */
  netRaised: Scalars['Int'];
  /** total number of transactions for a nonprofit */
  transactionCount: Scalars['Int'];
};

export enum NonprofitExperienceRange {
  Experience_1To_3 = 'EXPERIENCE_1_TO_3',
  Experience_4To_7 = 'EXPERIENCE_4_TO_7',
  Experience_8AndUp = 'EXPERIENCE_8_AND_UP',
  ExperienceLimited = 'EXPERIENCE_LIMITED'
}

export enum NonprofitImpactIntelligencePreonboardingStatus {
  AccountProvisioned = 'ACCOUNT_PROVISIONED',
  Uploaded = 'UPLOADED'
}

export type NonprofitOrg = {
  id: Scalars['Int'];
  missionStatement?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type NonprofitOrgAdmin = {
  cohorts?: Maybe<Array<Maybe<Cohort>>>;
  createdAt: Scalars['DateTime'];
  disabled: Scalars['Boolean'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  ein?: Maybe<Scalars['String']>;
  formationPlan?: Maybe<FormationPlan>;
  funders?: Maybe<Array<Maybe<FunderOrg>>>;
  hasProfile?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isFiscallySponsored?: Maybe<Scalars['Boolean']>;
  isTest: Scalars['Boolean'];
  legalName?: Maybe<Scalars['String']>;
  missionStatement?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platformPlan?: Maybe<PlatformPlan>;
  state?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<Maybe<NonprofitOrgUserAdmin>>>;
  websiteUrl?: Maybe<Scalars['String']>;
  yearEstablished?: Maybe<Scalars['Int']>;
};

export type NonprofitOrgBasic = {
  cohortMemberships?: Maybe<Array<Maybe<CohortMembership>>>;
  disabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isTest?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type NonprofitOrgBillingDetails = {
  formationCost?: Maybe<Scalars['Int']>;
  isLegacyPricing: Scalars['Boolean'];
  isTrialing: Scalars['Boolean'];
  nextBillingDate: Scalars['Int'];
  platformCost: Scalars['Int'];
  trialEnd?: Maybe<Scalars['Int']>;
};

export type NonprofitOrgConfig = {
  activeFunders?: Maybe<Array<Maybe<Scalars['Int']>>>;
  address?: Maybe<Scalars['Json']>;
  cloudinaryId?: Maybe<Scalars['String']>;
  donationFeePercent?: Maybe<Scalars['Float']>;
  donationPortalHashedId?: Maybe<Scalars['String']>;
  donationPortalId?: Maybe<Scalars['Int']>;
  ein?: Maybe<Scalars['String']>;
  featureFlags?: Maybe<Array<Maybe<Scalars['String']>>>;
  formationPlan?: Maybe<Scalars['String']>;
  funderOrgId?: Maybe<Scalars['Int']>;
  hasTaxExemptStatusAtSignup?: Maybe<Scalars['Boolean']>;
  is501c3Verified?: Maybe<Scalars['Boolean']>;
  isBipocLed?: Maybe<Scalars['Boolean']>;
  isBipocServing?: Maybe<Scalars['Boolean']>;
  isFiscallySponsored?: Maybe<Scalars['Boolean']>;
  isFounder?: Maybe<Scalars['Boolean']>;
  isStripeConnectActive?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  logoBoxId?: Maybe<Scalars['String']>;
  logoCloudinaryFileId?: Maybe<Scalars['String']>;
  missionStatement?: Maybe<Scalars['String']>;
  nonprofitOrgRole?: Maybe<NonprofitOrgRole>;
  numBoardMembers?: Maybe<Scalars['Int']>;
  numTeamMembers?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  paidStaffSizeRange?: Maybe<PaidStaffSizeRange>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  platformPlan?: Maybe<Scalars['String']>;
  platformPlanAddOns?: Maybe<Array<Maybe<Scalars['String']>>>;
  role?: Maybe<NonprofitOrgToUserRole>;
  shellAppRedirectEnabled?: Maybe<Scalars['Boolean']>;
  stripeConnectId?: Maybe<Scalars['String']>;
  stripeConnectIssues?: Maybe<StripeConnectIssues>;
  taxExemptionStatus?: Maybe<Scalars['String']>;
  user?: Maybe<UserConfig>;
  volunteerSizeRange?: Maybe<VolunteerSizeRange>;
  websiteUrl?: Maybe<Scalars['String']>;
  yearEstablished?: Maybe<Scalars['Int']>;
};

export type NonprofitOrgConfigResponse = {
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type NonprofitOrgDonationsDetails = {
  /** A list of errors associated with this account’s ability to receive donations. */
  errors: Array<Maybe<NonprofitOrgDonationsError>>;
  /** URL for entering or re-entering Stripe Connect onboarding. */
  onboardingUrl?: Maybe<Scalars['String']>;
  /** The state in which we display the nonprofit’s ability to receive donations. */
  state: NonprofitOrgDonationsState;
};

export type NonprofitOrgDonationsError = {
  /** A code for identifying the type of error. */
  code: Scalars['String'];
};

export enum NonprofitOrgDonationsState {
  DisabledBy_501c3 = 'disabled_by_501c3',
  ErroredStripe = 'errored_stripe',
  NotStarted = 'not_started',
  PendingDowngraded = 'pending_downgraded',
  Ready = 'ready',
  ReadyDowngraded = 'ready_downgraded',
  Started = 'started',
  Verifying = 'verifying',
  VerifyingDowngraded = 'verifying_downgraded'
}

export type NonprofitOrgFinancialDetails = {
  budgetRange?: Maybe<BudgetRange>;
  id: Scalars['Int'];
  isFundingDiverse?: Maybe<Scalars['Boolean']>;
  isFundingRecurring?: Maybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
};

export type NonprofitOrgForSuccess = {
  /** The date that the org was added to our database */
  createdAt: Scalars['String'];
  /** The EIN of the org for its donations account */
  ein?: Maybe<Scalars['String']>;
  /** The ID of the NonprofitOrg */
  id: Scalars['Int'];
  /** Whether the org is currently marked as 501(c)(3) verified */
  is501c3Verified: Scalars['Boolean'];
  /** The date that the org was last checked for 501(c)(3) verification */
  lastTaxExemptionAt?: Maybe<Scalars['String']>;
  /** The method by which the org was last checked for 501(c)(3) verification */
  lastTaxExemptionMethod?: Maybe<VerificationMethod>;
  /** Who or what last checked the org for 501(c)(3) verification */
  lastTaxExemptionUpdatedBy?: Maybe<Scalars['String']>;
  /** A human-readable description of the person or process that last checked for 501(c)(3) verification */
  lastVerifiedBy?: Maybe<Scalars['String']>;
  /** The legal name of the org for collecting donations */
  legalName?: Maybe<Scalars['String']>;
  /** The name of the org as entered during checkout */
  name?: Maybe<Scalars['String']>;
};

export type NonprofitOrgForSuccessConnection = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Edge-Types */
  edges?: Maybe<Array<Maybe<NonprofitOrgForSuccessEdge>>>;
  /** Flattened list of NonprofitOrgForSuccess type */
  nodes?: Maybe<Array<Maybe<NonprofitOrgForSuccess>>>;
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type NonprofitOrgForSuccessEdge = {
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Cursor */
  cursor: Scalars['String'];
  /** https://facebook.github.io/relay/graphql/connections.htm#sec-Node */
  node?: Maybe<NonprofitOrgForSuccess>;
};

export enum NonprofitOrgInviteType {
  Grantee = 'grantee',
  TeamMember = 'team_member'
}

export type NonprofitOrgPaginatedResult = {
  nonprofits?: Maybe<Array<NonprofitOrgAdmin>>;
  total: Scalars['Int'];
};

export type NonprofitOrgProfile = {
  candidData?: Maybe<Scalars['Json']>;
  confirmedAreasOfImpact: Array<Scalars['String']>;
  confirmedOrgSummary?: Maybe<Scalars['String']>;
  confirmedOrgSummaryUpdatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  instagramData?: Maybe<Scalars['Json']>;
  nonprofitOrgId: Scalars['Int'];
  suggestedAreasOfImpact: Array<Scalars['String']>;
  suggestedOrgSummary?: Maybe<Scalars['String']>;
  twitterData?: Maybe<Scalars['Json']>;
  websiteData?: Maybe<Scalars['Json']>;
};

export type NonprofitOrgRelationsInput = {
  nteeCodes: Array<Scalars['Int']>;
  staffClassificationTypes: Array<Scalars['Int']>;
};

export enum NonprofitOrgRole {
  Americorps = 'AMERICORPS',
  BoardMember = 'BOARD_MEMBER',
  ExecutiveDirector = 'EXECUTIVE_DIRECTOR',
  FounderExecutive = 'FOUNDER_EXECUTIVE',
  Intern = 'INTERN',
  Other = 'OTHER',
  PaidStaff = 'PAID_STAFF',
  Staff = 'STAFF',
  Volunteer = 'VOLUNTEER',
  VolunteerIntern = 'VOLUNTEER_INTERN'
}

export type NonprofitOrgTeam = {
  limits?: Maybe<FeatureLimits>;
  users?: Maybe<Array<Maybe<NonprofitOrgToUser>>>;
};

export type NonprofitOrgToGrantInput = {
  amount: Scalars['Int'];
  grantId: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};

export type NonprofitOrgToNteeCodeMajorGroup = {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  nteeCodeId: Scalars['Int'];
};

export type NonprofitOrgToSavedFundingOrg990 = {
  fundingOrg990?: Maybe<FundingOrg990>;
  fundingOrg990Id?: Maybe<Scalars['Int']>;
  nonprofitOrg?: Maybe<NonprofitOrg>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
};

export type NonprofitOrgToStaffClassificationType = {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  staffClassificationTypeId: Scalars['Int'];
};

export type NonprofitOrgToUser = {
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  isFounder?: Maybe<Scalars['Boolean']>;
  lastInviteSentAt?: Maybe<Scalars['DateTime']>;
  nonprofitOrgId: Scalars['Int'];
  nonprofitOrgRole?: Maybe<NonprofitOrgRole>;
  role: NonprofitOrgToUserRole;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<NonprofitUserObj>;
  userId?: Maybe<Scalars['Int']>;
};

export enum NonprofitOrgToUserRole {
  Admin = 'ADMIN',
  Board = 'BOARD',
  FunderContact = 'FUNDER_CONTACT',
  Owner = 'OWNER',
  Staff = 'STAFF'
}

export type NonprofitOrgToUserToResponsibility = {
  createdAt: Scalars['DateTime'];
  nonprofitOrgId: Scalars['Int'];
  responsibility: Responsibility;
  responsibilityId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type NonprofitOrgToViewedFundingOrg990 = {
  fundingOrg990?: Maybe<FundingOrg990>;
  fundingOrg990Id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  viewDate?: Maybe<Scalars['DateTime']>;
};

export type NonprofitOrgUserAdmin = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type NonprofitPreonboarding = {
  createdAt: Scalars['DateTime'];
  ein?: Maybe<Scalars['String']>;
  funderOrgId: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  impactIntelligenceStatus?: Maybe<NonprofitImpactIntelligencePreonboardingStatus>;
  orgName: Scalars['String'];
  status?: Maybe<NonprofitPreonboardingStatus>;
  updatedAt: Scalars['DateTime'];
};

export enum NonprofitPreonboardingStatus {
  AwaitingPpmVerification = 'AWAITING_PPM_VERIFICATION',
  EligibleForOptIn = 'ELIGIBLE_FOR_OPT_IN',
  EnterpriseAccessGranted = 'ENTERPRISE_ACCESS_GRANTED',
  IneligibleForOptIn = 'INELIGIBLE_FOR_OPT_IN',
  OptedIn = 'OPTED_IN'
}

export type NonprofitRefund = NonprofitTransaction & {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  chargeId: Scalars['String'];
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitTransaction = {
  /** Gross amount of the transaction, in cents */
  amount: Scalars['Int'];
  /** The ID for the balance transaction object. */
  balanceTransactionId?: Maybe<Scalars['String']>;
  /** The id of the campaign that the donation was made to. */
  campaignId?: Maybe<Scalars['String']>;
  card?: Maybe<NonprofitTransactionCard>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created: Scalars['Int'];
  disputeStatus: NonprofitTransactionDisputeStatus;
  /** The full name provided by the donor. */
  donor?: Maybe<Scalars['String']>;
  donorAddress?: Maybe<DonorAddress>;
  /** The email provided by the donor. */
  donorEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  donorFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  donorLastName?: Maybe<Scalars['String']>;
  /** Fees (in cents) paid for this transaction */
  fee: Scalars['Int'];
  feeCovered: Scalars['Boolean'];
  /** The full name of an honoree provided by the donor. */
  honoree?: Maybe<Scalars['String']>;
  /** The email of an honoree provided by the donor. */
  honoreeEmail?: Maybe<Scalars['String']>;
  /** The first name provided by the donor. */
  honoreeFirstName?: Maybe<Scalars['String']>;
  /** The last name provided by the donor. */
  honoreeLastName?: Maybe<Scalars['String']>;
  /** The Stripe id for the corresponding charge, refund or dispute-related object */
  id: Scalars['String'];
  /** The last name provided by the donor. */
  isAnonymousDonation?: Maybe<Scalars['Boolean']>;
  isRecurring: Scalars['Boolean'];
  /** Net amount of the transaction, in cents */
  net: Scalars['Int'];
  paymentMethod?: Maybe<NonprofitTransactionPaymentMethod>;
  recurrenceDetails?: Maybe<NonprofitTransactionRecurrenceDetails>;
  status: NonprofitTransactionStatus;
  /** The story which the donor viewed prior to making the donation. */
  story?: Maybe<NonprofitTransactionStory>;
  type: NonprofitTransactionType;
};

export type NonprofitTransactionCard = {
  /** The payment network used by the card. */
  brand: NonprofitTransactionCardBrand;
  fundingType: NonprofitTransactionCardFundingType;
  /** The last four digits of the card. */
  last4: Scalars['String'];
};

export enum NonprofitTransactionCardBrand {
  Amex = 'amex',
  CartesBancaires = 'cartes_bancaires',
  Diners = 'diners',
  Discover = 'discover',
  EftposAu = 'eftpos_au',
  Interac = 'interac',
  Jcb = 'jcb',
  Link = 'link',
  Mastercard = 'mastercard',
  Unionpay = 'unionpay',
  Unknown = 'unknown',
  Visa = 'visa'
}

export enum NonprofitTransactionCardFundingType {
  Credit = 'credit',
  Debit = 'debit',
  Prepaid = 'prepaid',
  Unknown = 'unknown'
}

export enum NonprofitTransactionDisputeStatus {
  InquiryClosed = 'inquiry_closed',
  InquiryPending = 'inquiry_pending',
  Lost = 'lost',
  None = 'none',
  Pending = 'pending',
  Won = 'won'
}

export enum NonprofitTransactionPaymentMethod {
  Card = 'card',
  Other = 'other'
}

export type NonprofitTransactionRecurrenceDetails = {
  interval: NonprofitTransactionRecurrenceDetailsInterval;
  status: NonprofitTransactionRecurrenceDetailsStatus;
};

export enum NonprofitTransactionRecurrenceDetailsInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export enum NonprofitTransactionRecurrenceDetailsStatus {
  Active = 'active',
  Canceled = 'canceled'
}

export type NonprofitTransactionResponse = {
  hasMore?: Maybe<Scalars['Boolean']>;
  transactions?: Maybe<Array<Maybe<NonprofitTransaction>>>;
};

export enum NonprofitTransactionStatus {
  Failed = 'failed',
  Pending = 'pending',
  Succeeded = 'succeeded'
}

export type NonprofitTransactionStory = {
  id: Scalars['String'];
  imageId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum NonprofitTransactionType {
  Charge = 'charge',
  Dispute = 'dispute',
  DisputeFee = 'dispute_fee',
  DisputeFeeReversal = 'dispute_fee_reversal',
  DisputeReversal = 'dispute_reversal',
  Refund = 'refund'
}

export type NonprofitUser = {
  email?: Maybe<Scalars['String']>;
};

export type NonprofitUserObj = {
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NotificationDetails = {
  last4?: Maybe<Scalars['String']>;
};

export enum NotificationType {
  PayoutFailed = 'PAYOUT_FAILED'
}

export type Notifications = {
  details?: Maybe<NotificationDetails>;
  type: NotificationType;
};

export type NteeCodeMajorGroup = {
  code: Scalars['String'];
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
};

export type ObjectiveTemplate = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  templateLibraryId: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type OnboardingDataInput = {
  experience: NonprofitExperienceRange;
  priorities?: InputMaybe<Array<GoalCategory>>;
  responsibilities: Array<OnboardingResponsibilityInput>;
  role: UserSurveyRole;
};

export type OnboardingResponsibilityInput = {
  category: GoalCategory;
  confidenceLevel: Scalars['Int'];
};

export type OneOnOneCoachingAdminPaginatedResult = {
  events: Array<OneOnOneCoachingEvent>;
  total: Scalars['Int'];
};

export type OneOnOneCoachingEvent = {
  activityType?: Maybe<Scalars['String']>;
  bookingUrl: Scalars['String'];
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  endsAt: Scalars['DateTime'];
  formGuid?: Maybe<Scalars['String']>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  hubspotId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  meetingBody?: Maybe<Scalars['String']>;
  meetingTitle?: Maybe<Scalars['String']>;
  meetingType?: Maybe<Scalars['String']>;
  organizerEmail?: Maybe<Scalars['String']>;
  organizerName?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  status?: Maybe<OneOnOneCoachingEventStatus>;
  summary?: Maybe<Scalars['String']>;
  transcript?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  userSlug: Scalars['String'];
  videoConferenceUrl?: Maybe<Scalars['String']>;
};

export type OneOnOneCoachingEventInput = {
  activityType?: InputMaybe<Scalars['String']>;
  bookingUrl: Scalars['String'];
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  endsAt: Scalars['DateTime'];
  formGuid?: InputMaybe<Scalars['String']>;
  goalIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  hubspotId?: InputMaybe<Scalars['String']>;
  meetingBody?: InputMaybe<Scalars['String']>;
  meetingTitle?: InputMaybe<Scalars['String']>;
  organizerEmail?: InputMaybe<Scalars['String']>;
  organizerName?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  status?: InputMaybe<OneOnOneCoachingEventStatus>;
  summary?: InputMaybe<Scalars['String']>;
  transcript?: InputMaybe<Scalars['String']>;
  userSlug: Scalars['String'];
  videoConferenceUrl?: InputMaybe<Scalars['String']>;
};

export enum OneOnOneCoachingEventStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  NoShow = 'NO_SHOW',
  Requested = 'REQUESTED',
  Rescheduled = 'RESCHEDULED',
  Scheduled = 'SCHEDULED'
}

export type OneOnOneCoachingEvents = {
  oneOnOneCoachingEvents?: Maybe<Array<Maybe<OneOnOneCoachingEvent>>>;
};

export enum OptimizationType {
  CampaignsHeadlineAndBody = 'CAMPAIGNS_HEADLINE_AND_BODY'
}

/** Represents attributes of organizations as captured in the Org990Attributes table. */
export type Org990Attributes = {
  /** 990 data mission description */
  missionDesc?: Maybe<Scalars['String']>;
  /** Nonprofit Org Id */
  orgId: Scalars['Int'];
};

export type OrgFinancialSettingsInput = {
  budgetRange?: InputMaybe<BudgetRange>;
  isFundingDiverse?: InputMaybe<Scalars['Boolean']>;
  isFundingRecurring?: InputMaybe<Scalars['Boolean']>;
};

export type OrgGoalsTaskProgressChart = {
  completedItems: Array<SeriesData>;
  createdItems: Array<SeriesData>;
  progress: Array<SeriesData>;
};

export type OrgGoalsTaskProgressStats = {
  goalTemplatesUsed?: Maybe<ProgressStat>;
  goalsWithTasks?: Maybe<ProgressStat>;
  totalGoalsAdded?: Maybe<ProgressStat>;
  totalTasksAdded?: Maybe<ProgressStat>;
  totalTasksCompleted?: Maybe<ProgressStat>;
};

export type OrgInput = {
  ein?: InputMaybe<Scalars['String']>;
  isFiscallySponsored?: InputMaybe<Scalars['Boolean']>;
  orgName: Scalars['String'];
  orgUuid?: InputMaybe<Scalars['Int']>;
  state: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type OrgSettingsInput = {
  address?: InputMaybe<Scalars['Json']>;
  ein?: InputMaybe<Scalars['String']>;
  hasTaxExemptStatusAtSignup?: InputMaybe<Scalars['Boolean']>;
  isBipocLed?: InputMaybe<Scalars['Boolean']>;
  isBipocServing?: InputMaybe<Scalars['Boolean']>;
  isFiscallySponsored?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  logoBoxId?: InputMaybe<Scalars['String']>;
  logoCloudinaryFileId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  numBoardMembers?: InputMaybe<Scalars['Int']>;
  paidStaffSizeRange?: InputMaybe<PaidStaffSizeRange>;
  state?: InputMaybe<Scalars['String']>;
  volunteerSizeRange?: InputMaybe<VolunteerSizeRange>;
  websiteUrl?: InputMaybe<Scalars['String']>;
  yearEstablished?: InputMaybe<Scalars['Int']>;
};

/** PageInfo cursor, as defined in https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo */
export type PageInfo = {
  /** The cursor corresponding to the last nodes in edges. Null if the connection is empty. */
  endCursor?: Maybe<Scalars['String']>;
  /** Used to indicate whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Used to indicate whether more edges exist prior to the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor corresponding to the first nodes in edges. Null if the connection is empty. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum PaidStaffSizeRange {
  Staff_1To_4 = 'STAFF_1_TO_4',
  Staff_5To_9 = 'STAFF_5_TO_9',
  Staff_10To_19 = 'STAFF_10_TO_19',
  Staff_20To_39 = 'STAFF_20_TO_39',
  Staff_40To_69 = 'STAFF_40_TO_69',
  Staff_70To_99 = 'STAFF_70_TO_99',
  Staff_100AndUp = 'STAFF_100_AND_UP',
  StaffNone = 'STAFF_NONE'
}

export enum PayoutType {
  BankAccount = 'bank_account',
  Card = 'card'
}

export enum PlatformPlan {
  Advanced = 'ADVANCED',
  Enterprise = 'ENTERPRISE',
  Performance = 'PERFORMANCE',
  Plus = 'PLUS',
  Pro = 'PRO',
  Starter = 'STARTER'
}

export type PortalContentInput = {
  colorThemeId: Scalars['Int'];
  customAmounts?: InputMaybe<Array<InputMaybe<CustomAmountInput>>>;
  customAmountsOn?: InputMaybe<Scalars['Boolean']>;
  donationPortalBlocks: Array<DonationBlockUpsertInput>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  socialDescription?: InputMaybe<Scalars['String']>;
  socialTitle?: InputMaybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  updatedUserId: Scalars['Int'];
};

export type Priorities = {
  firstPriority: Priority;
  missingPriority: MissingPriority;
  secondPriority: Priority;
  thirdPriority: Priority;
};

export type PrioritiesProgressStats = {
  orgsWithLeaders?: Maybe<ProgressStat>;
  orgsWithPriorities?: Maybe<ProgressStat>;
  totalOrgsCount?: Maybe<ProgressStat>;
};

export type Priority = {
  category: GoalCategory;
  challenges?: Maybe<Scalars['String']>;
  confidenceLevel: Scalars['Int'];
  customPriorities?: Maybe<Scalars['String']>;
  selectedGoals: Array<GoalToCreate>;
};

export type PriorityData = {
  confidenceLevel: Scalars['Float'];
  data: Array<Scalars['Int']>;
  label: Scalars['String'];
  roleData?: Maybe<Scalars['Json']>;
  totalResponses: Scalars['Int'];
};

export type PriorityNeedTopic = {
  baselineconfidence?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['String']>;
  confidencechangepercent?: Maybe<Scalars['String']>;
  currentconfidence?: Maybe<Scalars['Float']>;
  totalbaselineusers?: Maybe<Scalars['Int']>;
  totalcurrentusers?: Maybe<Scalars['Int']>;
};

export type PriorityNeedsData = {
  priorityNeedTopics?: Maybe<Array<Maybe<PriorityNeedTopic>>>;
  topPriorities?: Maybe<Array<Maybe<TopPriority>>>;
};

export type ProgressStat = {
  currentValue: Scalars['Int'];
  previousValue?: Maybe<Scalars['Int']>;
  totalValue?: Maybe<Scalars['Int']>;
};

export type PromoCode = {
  amountOff?: Maybe<Scalars['Float']>;
  couponId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percentOff?: Maybe<Scalars['Float']>;
  promoId?: Maybe<Scalars['String']>;
};

export type PromptInput = {
  description: Scalars['String'];
  headline: Scalars['String'];
  modifier?: InputMaybe<Scalars['String']>;
};

export type PromptProgressUpdateResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type PublicDonationPortal = {
  DonationPortalBlock?: Maybe<Array<Maybe<DonationPortalBlock>>>;
  applicationFee?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  availableFrequencies: Array<DonationInterval>;
  campaignId?: Maybe<Scalars['String']>;
  customAmounts?: Maybe<Array<Maybe<CustomAmount>>>;
  customAmountsOn?: Maybe<Scalars['Boolean']>;
  fundraisingProgress?: Maybe<Scalars['Int']>;
  fundraisingTarget?: Maybe<Scalars['Int']>;
  hashedId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoCloudinaryFileId?: Maybe<Scalars['String']>;
  nonprofitLogoBoxId?: Maybe<Scalars['String']>;
  nonprofitName?: Maybe<Scalars['String']>;
  nonprofitWebsiteUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  socialDescription?: Maybe<Scalars['String']>;
  socialTitle?: Maybe<Scalars['String']>;
  /** The state in which we display the nonprofit’s ability to receive donations. */
  state: PublicNonprofitOrgDonationsState;
  storyDescription?: Maybe<Scalars['String']>;
  storyId?: Maybe<Scalars['Int']>;
  storyImage?: Maybe<Scalars['String']>;
  storyName?: Maybe<Scalars['String']>;
  themeColor?: Maybe<Scalars['String']>;
};

export enum PublicNonprofitOrgDonationsState {
  DisabledBy_501c3 = 'disabled_by_501c3',
  ErroredStripe = 'errored_stripe',
  NotStarted = 'not_started',
  PendingDowngraded = 'pending_downgraded',
  Ready = 'ready',
  ReadyDowngraded = 'ready_downgraded',
  Started = 'started',
  Verifying = 'verifying',
  VerifyingDowngraded = 'verifying_downgraded'
}

export type PublicStory = {
  block?: Maybe<Array<Maybe<Block>>>;
  colorTheme?: Maybe<ColorTheme>;
  headerLogoImgUrl?: Maybe<Scalars['String']>;
  headerWebsiteUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  logoCloudinaryFileId?: Maybe<Scalars['String']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  nonprofitOrgName?: Maybe<Scalars['String']>;
  previewDescription?: Maybe<Scalars['String']>;
  previewImageCloudinaryFileId?: Maybe<Scalars['String']>;
  previewTitle?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  showHeader?: Maybe<Scalars['Boolean']>;
  showTableOfContents?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  urlTitle?: Maybe<Scalars['String']>;
};

export type Query = {
  Asset?: Maybe<Array<Maybe<Asset>>>;
  NonprofitOrgToViewedFundingOrg990?: Maybe<Array<Maybe<NonprofitOrgToViewedFundingOrg990>>>;
  StoriesSharedWithFunderOrg?: Maybe<Array<Maybe<Story>>>;
  Story?: Maybe<Array<Maybe<Story>>>;
  adminOneOnOneCoachingEvents: OneOnOneCoachingAdminPaginatedResult;
  aiCoachingIntervention?: Maybe<AiCoachingIntervention>;
  aiCoachingInterventions?: Maybe<AiCoachingInterventionsResponse>;
  aiImpactDashboardSummary?: Maybe<AiImpactDashboardSummary>;
  allChartCategories?: Maybe<Array<Maybe<ChartCategory>>>;
  allDonationPortals?: Maybe<Array<Maybe<DonationPortal>>>;
  autoStoriesSettings?: Maybe<AutoStoriesSettings>;
  campaignGating?: Maybe<CampaignGating>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  categoryByTitle?: Maybe<ChartCategory>;
  chart?: Maybe<Chart>;
  chartCategory?: Maybe<Array<Maybe<ChartCategory>>>;
  checkStripePromo?: Maybe<PromoCode>;
  checkoutSessionData?: Maybe<DonationCheckoutSessionData>;
  cohort?: Maybe<Cohort>;
  colorTheme: Array<ColorTheme>;
  communityComments?: Maybe<CommunityCommentConnection>;
  communityEvents?: Maybe<Array<CommunityEvent>>;
  communityGuidelines?: Maybe<CommunityGuidelines>;
  communityPosts?: Maybe<CommunityPostConnection>;
  communityTopPosts?: Maybe<CommunityTopPostsResponse>;
  /** Get upcoming community events sorted by RSVP count */
  communityTrendingEvents?: Maybe<Array<CommunityTrendingEvent>>;
  complianceDocuments?: Maybe<ComplianceDocuments>;
  createConnectAccountLink?: Maybe<StripeConnectAccountLink>;
  dashboardImpactReport?: Maybe<ImpactReport>;
  donationCheckoutUrl?: Maybe<DonationCheckoutUrl>;
  donationPortalAndBlocks?: Maybe<DonationPortal>;
  emailServiceImpactReport?: Maybe<EmailImpactReportResponse>;
  engagementDashboard?: Maybe<EngagementDashboard>;
  featureGatingLimit?: Maybe<Array<Maybe<FeatureGatingLimit>>>;
  findDuplicateUsers?: Maybe<DuplicateUsers>;
  funderDashboardFilters?: Maybe<FunderDashboardFilters>;
  funderOrg?: Maybe<FunderOrg>;
  funderOrgCohortQuery?: Maybe<FunderOrgIdWithNonProfits>;
  funderOrgConfig?: Maybe<FunderOrgConfig>;
  funderOrgDetails?: Maybe<FunderOrgDetails>;
  funderOrgToNonprofit?: Maybe<FunderOrgToNonprofit>;
  funderOrgToNonprofitOrg?: Maybe<FunderOrgToNonprofitOrg>;
  funderProfileViewLimits?: Maybe<FunderProfileViewLimits>;
  funders?: Maybe<Array<Maybe<FunderOrg>>>;
  fundingOrg990?: Maybe<FundingOrg990>;
  generateGoals: Array<GoalRecommendation>;
  generateInternalFunderReport?: Maybe<GenerationReport>;
  generatePortfolioReport?: Maybe<GenerationReport>;
  getAiOptimizedCopy?: Maybe<AiResponse>;
  getAiOptimizedStory?: Maybe<AiStoriesResponse>;
  getBoxConfig?: Maybe<BoxConfig>;
  getChangePlanPortalLinks?: Maybe<StripeChangePlanPortalLinks>;
  getCloudinaryAssets?: Maybe<Array<Maybe<CloudinaryAssets>>>;
  getDimensions?: Maybe<Array<Maybe<Dimension>>>;
  getFeatureFlags?: Maybe<FeatureFlags>;
  getFeedItems?: Maybe<FeedItemResponse>;
  getFeedItemsByCategory?: Maybe<FeedItemResponse>;
  getFeedItemsByType?: Maybe<FeedItemResponse>;
  getFilterNonprofitOrgs?: Maybe<Array<NonprofitOrg>>;
  getFilteredNonprofitTransactions?: Maybe<FilteredTransactions>;
  getFunderUsers?: Maybe<Array<Maybe<FunderOrgToUser>>>;
  getInitiatives?: Maybe<ReportedMetricGroupWithLimit>;
  getInternalFunderReport?: Maybe<FunderReport>;
  /** Get the latest completed financial health assessment report for an organization */
  getLatestFinancialHealthAssessmentReport?: Maybe<MurdocReportRunResult>;
  /** Get the full content of a completed Murdoc report */
  getMurdocReport?: Maybe<MurdocReport>;
  /** Get the status of a Murdoc report generation run */
  getMurdocReportRunStatus?: Maybe<MurdocReportRunResult>;
  /** Get story opportunities from Murdoc by analyzing nonprofit social media content */
  getMurdocStoryOpportunities?: Maybe<MurdocStoryOpportunitiesResponse>;
  getMyMcpApiKeys: Array<McpApiKey>;
  getNonprofitDonationSummary?: Maybe<NonprofitDonationSummary>;
  getNonprofitDonations?: Maybe<Array<Maybe<NonprofitDonation>>>;
  getNonprofitOrg?: Maybe<NonprofitOrgAdmin>;
  getNonprofitOrgBillingDetails?: Maybe<NonprofitOrgBillingDetails>;
  getNonprofitOrgToUserToResponsibility?: Maybe<Array<Maybe<NonprofitOrgToUserToResponsibility>>>;
  getNonprofitOrgs?: Maybe<Array<NonprofitOrg>>;
  getNonprofitPreonboarding?: Maybe<Array<Maybe<NonprofitPreonboarding>>>;
  getNonprofitTransaction?: Maybe<NonprofitTransaction>;
  getNonprofitTransactions?: Maybe<NonprofitTransactionResponse>;
  getNotifications?: Maybe<Array<Maybe<Notifications>>>;
  getOnboardingContactList?: Maybe<Array<Maybe<Contact>>>;
  /** Fetch attributes for a specific organization using its orgId. */
  getOrg990Attributes?: Maybe<Org990Attributes>;
  getPresetGuestToken?: Maybe<Scalars['String']>;
  getPublicStory?: Maybe<PublicStory>;
  getRecentFunderReports: Array<Maybe<RecentReports>>;
  getResponsibility?: Maybe<Array<Maybe<Responsibility>>>;
  getStories?: Maybe<Array<Maybe<Stories>>>;
  getStripeConnectAccount?: Maybe<StripeConnectAccount>;
  getStripePrice?: Maybe<StripePrice>;
  getTasks: Array<ChecklistItem>;
  getTaxExemptionStatus?: Maybe<TaxExemptionStatusResponse>;
  getTemplateLibrary: Array<TemplateLibrary>;
  getThirdPartyNonprofitOrgConfig?: Maybe<NonprofitOrgConfigResponse>;
  getUnreadFeedItemsCount: Scalars['Int'];
  getUserById?: Maybe<UserAdmin>;
  getUserRecommendations?: Maybe<UserRecommendationsResponse>;
  goalGroupCards: Array<GoalGroupCard>;
  goalGroupChart?: Maybe<GoalGroupChartData>;
  goalGroupGranteesInfo: Array<GoalGroupGranteeInfo>;
  goalSharedToFunderCard: Array<Maybe<GoalSharedToFunderCard>>;
  goalUpdates?: Maybe<GoalUpdatesResponse>;
  goals?: Maybe<Array<Maybe<Goal>>>;
  /** Check rate limit status for grant research */
  grantResearchRateLimit: GrantResearchRateLimit;
  groupCoachingEvents: Array<GroupCoachingEvent>;
  impactDashboardAcademyActivity: Array<ImpactDashboardActivity>;
  jobExecution?: Maybe<JobExecution>;
  jobStats?: Maybe<JobStats>;
  /** Get the most recent grant research report for an org */
  latestGrantResearchReport?: Maybe<GrantResearchReport>;
  missionGoalsProgressStats?: Maybe<MissionGoalsProgressStats>;
  missionGoalsTargetProgress?: Maybe<Array<Maybe<SeriesData>>>;
  needsProgressUpdate?: Maybe<NeedsProgressUpdateResponse>;
  needsUserSurveyUpdate?: Maybe<Scalars['Boolean']>;
  nonprofitBoard?: Maybe<NonprofitBoard>;
  nonprofitDeiInitiatives?: Maybe<NonprofitDeiInitiatives>;
  nonprofitOrg?: Maybe<NonprofitOrgConfig>;
  nonprofitOrgDonationsDetails?: Maybe<NonprofitOrgDonationsDetails>;
  nonprofitOrgFinancialDetails?: Maybe<NonprofitOrgFinancialDetails>;
  nonprofitOrgProfile?: Maybe<NonprofitOrgProfile>;
  nonprofitOrgTeam?: Maybe<NonprofitOrgTeam>;
  nonprofitOrgToNteeCode?: Maybe<Array<Maybe<NonprofitOrgToNteeCodeMajorGroup>>>;
  nonprofitOrgToSavedFundingOrg990?: Maybe<Array<Maybe<NonprofitOrgToSavedFundingOrg990>>>;
  nonprofitOrgToStaffClassificationType?: Maybe<Array<Maybe<NonprofitOrgToStaffClassificationType>>>;
  nonprofitOrgToUser?: Maybe<Array<Maybe<NonprofitOrgToUser>>>;
  nonprofitOrgsForSuccess?: Maybe<NonprofitOrgForSuccessConnection>;
  nonprofitUserEvent?: Maybe<Array<Maybe<UserEvent>>>;
  nteeCodeMajorGroup?: Maybe<Array<Maybe<NteeCodeMajorGroup>>>;
  oneOnOneCoachingEvents?: Maybe<Array<Maybe<OneOnOneCoachingEvent>>>;
  orgGoalsTaskProgressChart?: Maybe<OrgGoalsTaskProgressChart>;
  orgGoalsTaskProgressStats?: Maybe<OrgGoalsTaskProgressStats>;
  prioritiesProgressStats?: Maybe<PrioritiesProgressStats>;
  publicDonationPortal?: Maybe<PublicDonationPortal>;
  quickBooksConnection?: Maybe<QuickBooksConnection>;
  recommendedFundersForNonprofit?: Maybe<Array<Maybe<FundingOrg990>>>;
  reportedMetricGroup?: Maybe<Array<Maybe<ReportedMetricGroup>>>;
  savedFunderLimits?: Maybe<SavedFunderLimits>;
  searchCohorts?: Maybe<CohortPaginatedResult>;
  searchFunders?: Maybe<FunderOrgPaginatedResult>;
  searchJobExecutions?: Maybe<JobExecutionConnection>;
  searchNonprofits?: Maybe<NonprofitOrgPaginatedResult>;
  searchUsers?: Maybe<UserAdminPaginatedResult>;
  shellAppRedirectEnabled: Scalars['Boolean'];
  staffClassificationType?: Maybe<Array<Maybe<StaffClassificationType>>>;
  storyGating?: Maybe<StoryGating>;
  stripePayouts?: Maybe<StripePayouts>;
  topPriorities: Array<PriorityData>;
  updateConnectAccountLink?: Maybe<StripeConnectAccountLink>;
  user?: Maybe<UserConfig>;
  userEvent?: Maybe<Array<Maybe<UserEvent>>>;
  userGroupCoachingEvents?: Maybe<Array<Maybe<GroupCoachingEvent>>>;
  userOneOnOneCoachingEvents?: Maybe<Array<Maybe<OneOnOneCoachingEvent>>>;
  userRsvpGroupCoachingEvents?: Maybe<Array<Maybe<GroupCoachingEvent>>>;
  userSurvey?: Maybe<UserSurvey>;
  userSurveyPriorities: Array<UserSurveyPriority>;
  userSurveys: Array<UserSurvey>;
};


export type QueryAssetArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgToViewedFundingOrg990Args = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryStoriesSharedWithFunderOrgArgs = {
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId: Scalars['Int'];
};


export type QueryStoryArgs = {
  hashedId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  storyId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminOneOnOneCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  excludeDeleted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryAiCoachingInterventionArgs = {
  id: Scalars['Int'];
};


export type QueryAiCoachingInterventionsArgs = {
  claimedByMe?: InputMaybe<Scalars['Boolean']>;
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  shouldIntervene?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<InputMaybe<AiCoachingInterventionStatus>>>;
  unclaimed?: InputMaybe<Scalars['Boolean']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  userSearch?: InputMaybe<Scalars['String']>;
};


export type QueryAiImpactDashboardSummaryArgs = {
  funderOrgId: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
  summaryType: GoalImpactCategory;
};


export type QueryAllChartCategoriesArgs = {
  chartId: Scalars['Int'];
};


export type QueryAllDonationPortalsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryAutoStoriesSettingsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryCampaignGatingArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryCampaignsArgs = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
};


export type QueryCategoryByTitleArgs = {
  chartId: Scalars['Int'];
  title: Scalars['String'];
};


export type QueryChartArgs = {
  goalId?: InputMaybe<Scalars['Int']>;
};


export type QueryChartCategoryArgs = {
  chartId: Scalars['Int'];
};


export type QueryCheckStripePromoArgs = {
  code: Scalars['String'];
};


export type QueryCheckoutSessionDataArgs = {
  portalId: Scalars['String'];
  sessionId: Scalars['String'];
};


export type QueryCohortArgs = {
  id: Scalars['Int'];
};


export type QueryCommunityCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityEventsArgs = {
  filter?: InputMaybe<CommunityEventsFilterOption>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityTopPostsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryCommunityTrendingEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryComplianceDocumentsArgs = {
  folderId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};


export type QueryCreateConnectAccountLinkArgs = {
  returnUrl: Scalars['String'];
  stripeAccountId: Scalars['String'];
};


export type QueryDashboardImpactReportArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryDonationCheckoutUrlArgs = {
  amountInCents: Scalars['Int'];
  donationMetadata: DonationMetadata;
  donationPortalId: Scalars['String'];
  feeCovered: Scalars['Boolean'];
  interval: DonationInterval;
  nonprofitOrgId: Scalars['Int'];
  recaptchaToken: Scalars['String'];
  utmSource?: InputMaybe<Scalars['String']>;
};


export type QueryDonationPortalAndBlocksArgs = {
  hashedId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};


export type QueryEngagementDashboardArgs = {
  cohortId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  timePeriod?: InputMaybe<TimePeriod>;
};


export type QueryFeatureGatingLimitArgs = {
  planName: Scalars['String'];
};


export type QueryFindDuplicateUsersArgs = {
  emails: Array<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};


export type QueryFunderDashboardFiltersArgs = {
  funderOrgId: Scalars['Int'];
};


export type QueryFunderOrgArgs = {
  id: Scalars['Int'];
};


export type QueryFunderOrgCohortQueryArgs = {
  funderEmail?: InputMaybe<Scalars['String']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgIds: Array<Scalars['Int']>;
  returnAllNonprofitsInCohort?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFunderOrgConfigArgs = {
  email: Scalars['String'];
};


export type QueryFunderOrgDetailsArgs = {
  funderOrgId: Scalars['Int'];
};


export type QueryFunderOrgToNonprofitArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryFunderOrgToNonprofitOrgArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryFunderProfileViewLimitsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryFundingOrg990Args = {
  fundingOrg990Id: Scalars['Int'];
};


export type QueryGenerateGoalsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGenerateInternalFunderReportArgs = {
  dateOverride?: InputMaybe<Scalars['String']>;
  funderOrgId: Scalars['Int'];
  skipEmail?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAiOptimizedCopyArgs = {
  optimizationType: OptimizationType;
  orgId: Scalars['Int'];
  prompt: PromptInput;
};


export type QueryGetAiOptimizedStoryArgs = {
  goalId?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['Int'];
  prompt: StoryPromptInput;
};


export type QueryGetBoxConfigArgs = {
  orgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryGetChangePlanPortalLinksArgs = {
  returnUrl: Scalars['String'];
  stripeCustomerId: Scalars['String'];
};


export type QueryGetCloudinaryAssetsArgs = {
  orgId: Scalars['Int'];
};


export type QueryGetDimensionsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGetFeedItemsArgs = {
  input: GetFeedItemsInput;
};


export type QueryGetFeedItemsByCategoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  category: FeedItemCategory;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFeedItemsByTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  type: FeedItemType;
};


export type QueryGetFilteredNonprofitTransactionsArgs = {
  filters?: InputMaybe<Filters>;
  page?: InputMaybe<Scalars['String']>;
  stripeConnectId: Scalars['String'];
};


export type QueryGetFunderUsersArgs = {
  funderOrgId: Scalars['Int'];
};


export type QueryGetInitiativesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  planName?: InputMaybe<Scalars['String']>;
};


export type QueryGetInternalFunderReportArgs = {
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId: Scalars['Int'];
};


export type QueryGetLatestFinancialHealthAssessmentReportArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGetMurdocReportArgs = {
  runId: Scalars['String'];
};


export type QueryGetMurdocReportRunStatusArgs = {
  runId: Scalars['String'];
};


export type QueryGetMurdocStoryOpportunitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
  socialUrls?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetNonprofitDonationSummaryArgs = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  stripeConnectId: Scalars['String'];
};


export type QueryGetNonprofitDonationsArgs = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  stripeConnectId: Scalars['String'];
};


export type QueryGetNonprofitOrgArgs = {
  id: Scalars['Int'];
};


export type QueryGetNonprofitOrgBillingDetailsArgs = {
  customerId: Scalars['String'];
  formationPlan?: InputMaybe<FormationPlan>;
  platformPlan?: InputMaybe<PlatformPlan>;
};


export type QueryGetNonprofitOrgToUserToResponsibilityArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGetNonprofitPreonboardingArgs = {
  funderOrgId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryGetNonprofitTransactionArgs = {
  stripeConnectId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetNonprofitTransactionsArgs = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  startingAfter?: InputMaybe<Scalars['String']>;
  stripeConnectId: Scalars['String'];
};


export type QueryGetNotificationsArgs = {
  stripeConnectId: Scalars['String'];
};


export type QueryGetOnboardingContactListArgs = {
  fileId?: InputMaybe<Scalars['Int']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrg990AttributesArgs = {
  orgId: Scalars['Int'];
};


export type QueryGetPresetGuestTokenArgs = {
  firstName: Scalars['String'];
  funderOrgId: Scalars['Int'];
  lastName: Scalars['String'];
  presetDashboardId: Scalars['String'];
};


export type QueryGetPublicStoryArgs = {
  hashedStoryId: Scalars['String'];
};


export type QueryGetStoriesArgs = {
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetStripeConnectAccountArgs = {
  stripeAccountId: Scalars['String'];
};


export type QueryGetStripePriceArgs = {
  formationPlan?: InputMaybe<FormationPlan>;
  platformPlan: PlatformPlan;
};


export type QueryGetTasksArgs = {
  isCompleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetTaxExemptionStatusArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGetThirdPartyNonprofitOrgConfigArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGetUserByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGetUserRecommendationsArgs = {
  input?: InputMaybe<GetUserRecommendationsInput>;
};


export type QueryGoalGroupCardsArgs = {
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId: Scalars['Int'];
  goalGroupId?: InputMaybe<Scalars['Int']>;
};


export type QueryGoalGroupChartArgs = {
  funderOrgId: Scalars['Int'];
  goalGroupId: Scalars['Int'];
  type: GoalGroupChartType;
};


export type QueryGoalGroupGranteesInfoArgs = {
  funderOrgId: Scalars['Int'];
  goalGroupId: Scalars['Int'];
};


export type QueryGoalSharedToFunderCardArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId: Scalars['Int'];
  goalId?: InputMaybe<Scalars['Int']>;
};


export type QueryGoalUpdatesArgs = {
  goalId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<GoalUpdateSortOptions>;
};


export type QueryGoalsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']>;
  goalId?: InputMaybe<Scalars['String']>;
  includeOnboarding?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<GoalType>;
};


export type QueryGrantResearchRateLimitArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryGroupCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryImpactDashboardAcademyActivityArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryJobExecutionArgs = {
  id: Scalars['String'];
};


export type QueryJobStatsArgs = {
  hoursBack?: InputMaybe<Scalars['Int']>;
};


export type QueryLatestGrantResearchReportArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryMissionGoalsProgressStatsArgs = {
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryMissionGoalsTargetProgressArgs = {
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryNonprofitBoardArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitDeiInitiativesArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgArgs = {
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
};


export type QueryNonprofitOrgDonationsDetailsArgs = {
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
};


export type QueryNonprofitOrgFinancialDetailsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgProfileArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgTeamArgs = {
  nonprofitOrgId: Scalars['Int'];
  planName: Scalars['String'];
};


export type QueryNonprofitOrgToNteeCodeArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgToSavedFundingOrg990Args = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgToStaffClassificationTypeArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgToUserArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryNonprofitOrgsForSuccessArgs = {
  after?: InputMaybe<Scalars['String']>;
  attemptedOnly?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  failedOnly?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  noManual?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNonprofitUserEventArgs = {
  eventNames: Array<Scalars['String']>;
};


export type QueryOneOnOneCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type QueryOrgGoalsTaskProgressChartArgs = {
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryOrgGoalsTaskProgressStatsArgs = {
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryPrioritiesProgressStatsArgs = {
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
};


export type QueryPublicDonationPortalArgs = {
  donationPortalId: Scalars['String'];
  hashedStoryId?: InputMaybe<Scalars['String']>;
};


export type QueryQuickBooksConnectionArgs = {
  orgId: Scalars['Int'];
};


export type QueryRecommendedFundersForNonprofitArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryReportedMetricGroupArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QuerySavedFunderLimitsArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QuerySearchCohortsArgs = {
  funderName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchFundersArgs = {
  cohortName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  userEmail?: InputMaybe<Scalars['String']>;
};


export type QuerySearchJobExecutionsArgs = {
  filter?: InputMaybe<JobExecutionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
};


export type QuerySearchNonprofitsArgs = {
  cohortName?: InputMaybe<Scalars['String']>;
  funderName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  profileSearchTerm?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};


export type QuerySearchUsersArgs = {
  email?: InputMaybe<Scalars['String']>;
  funderName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryStoryGatingArgs = {
  nonprofitOrgId: Scalars['Int'];
};


export type QueryStripePayoutsArgs = {
  createdAfter?: InputMaybe<Scalars['Int']>;
  stripeConnectId: Scalars['String'];
};


export type QueryTopPrioritiesArgs = {
  daysAgo?: InputMaybe<Scalars['Int']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryUpdateConnectAccountLinkArgs = {
  returnUrl: Scalars['String'];
  stripeAccountId: Scalars['String'];
};


export type QueryUserEventArgs = {
  eventNames: Array<Scalars['String']>;
  eventPropertiesFilter?: InputMaybe<EventPropertiesFilter>;
};


export type QueryUserGroupCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['Int'];
};


export type QueryUserOneOnOneCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryUserRsvpGroupCoachingEventsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<InputMaybe<RsvpStatus>>>;
};


export type QueryUserSurveyArgs = {
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<SurveyType>;
};


export type QueryUserSurveyPrioritiesArgs = {
  userId: Scalars['Int'];
};


export type QueryUserSurveysArgs = {
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<SurveyType>;
  types?: InputMaybe<Array<SurveyType>>;
};

export type QuickBooksAuthUrl = {
  state: Scalars['String'];
  url: Scalars['String'];
};

export type QuickBooksConnection = {
  companyName: Scalars['String'];
  connectedAt: Scalars['DateTime'];
  id: Scalars['String'];
  lastDataFetch?: Maybe<Scalars['DateTime']>;
  needsReauth: Scalars['Boolean'];
  nonprofitOrgId: Scalars['Int'];
  status: QuickBooksConnectionStatus;
};

export enum QuickBooksConnectionStatus {
  Active = 'ACTIVE',
  Disconnected = 'DISCONNECTED',
  ReauthRequired = 'REAUTH_REQUIRED',
  RefreshNeeded = 'REFRESH_NEEDED'
}

export type RecentReports = {
  createdAt?: Maybe<Scalars['DateTime']>;
  funderOrgId?: Maybe<Scalars['Int']>;
  targetDate?: Maybe<Scalars['String']>;
};

export enum RecommendationPlacement {
  MainFeed = 'MAIN_FEED',
  Sidebar = 'SIDEBAR'
}

export enum RecommendationStatus {
  Clicked = 'CLICKED',
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  Pending = 'PENDING',
  Shown = 'SHOWN'
}

export type RecommendationTemplate = {
  callToActionLink?: Maybe<Scalars['String']>;
  callToActionText?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  key: Scalars['String'];
  placement: RecommendationPlacement;
  priority: Scalars['Int'];
  targetAudience?: Maybe<Scalars['Json']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RecordLoginEventResponse = {
  lastLogin?: Maybe<Scalars['String']>;
};

export type RecurringChecklistItem = {
  dayOfMonth?: InputMaybe<Scalars['IntOrLast']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<Scalars['String']>;
  frequency: Scalars['Int'];
  month?: InputMaybe<Scalars['Int']>;
  monthInQuarter?: InputMaybe<Scalars['Int']>;
  numberOfOccurrences?: InputMaybe<Scalars['Int']>;
  recurrenceType: TaskRecurrenceType;
  startDate: Scalars['String'];
  weekOfMonth?: InputMaybe<Scalars['IntOrLast']>;
};

export type RecurringChecklistItemInput = {
  checklistItemInput: ChecklistItemInput;
  recurringChecklistItem: RecurringChecklistItem;
};

export type RefetchHubspotResponse = {
  success: Scalars['Boolean'];
};

export type RefetchTranscriptResponse = {
  success: Scalars['Boolean'];
};

export type RemoveCohortMembershipResponse = {
  success: Scalars['Boolean'];
};

export type RemoveCohortOwnershipResponse = {
  success: Scalars['Boolean'];
};

export type RemoveFunderUserInput = {
  currentUserId: Scalars['Int'];
  deletedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type RemoveNonprofitOrgUserInput = {
  currentUserId: Scalars['Int'];
  deletedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type ReportedMetricGroup = {
  Goal: Array<Goal>;
  NonprofitOrg: NonprofitOrg;
  archivedAt?: Maybe<Scalars['DateTime']>;
  category?: Maybe<ReportedMetricGroupCategory>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isV2: Scalars['Boolean'];
  nonprofitOrgId: Scalars['Int'];
  start?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ReportedMetricGroupCategory {
  Dei = 'DEI',
  Onboarding = 'ONBOARDING'
}

export type ReportedMetricGroupInput = {
  end?: InputMaybe<Scalars['DateTime']>;
  isV2: Scalars['Boolean'];
  start?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type ReportedMetricGroupUpdateInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  end?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  start?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type ReportedMetricGroupWithLimit = {
  reportedMetricGatingLimit?: Maybe<ReportedMetricFeatureGatingLimits>;
  reportedMetricGroups?: Maybe<Array<Maybe<ReportedMetricGroup>>>;
};

/** A grant discovered through AI research */
export type ResearchedGrant = {
  /** Direct URL to the application */
  applicationUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Specific deadline date if known */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Categorization of the grant deadline */
  deadlineCategory: GrantDeadlineCategory;
  /** When the user dismissed this grant */
  dismissedAt?: Maybe<Scalars['DateTime']>;
  /** Eligibility requirements summary */
  eligibility?: Maybe<Scalars['String']>;
  /** URL to the grant details page */
  externalUrl?: Maybe<Scalars['String']>;
  /** Focus areas the grant supports */
  focusAreas?: Maybe<Array<Scalars['String']>>;
  /** EIN of the funder if known */
  funderEin?: Maybe<Scalars['String']>;
  /** Name of the organization offering the grant */
  funderName: Scalars['String'];
  /** Geographic restrictions if any */
  geographicRequirements?: Maybe<Scalars['String']>;
  /** Grant amount range or typical value */
  grantAmount?: Maybe<GrantAmount>;
  /** Name of the grant program */
  grantName: Scalars['String'];
  id: Scalars['Int'];
  /** 2-3 specific reasons why this grant matches the org */
  matchReasons: Array<Scalars['String']>;
  /** AI-generated match score 0-100 based on org alignment */
  matchScore: Scalars['Int'];
  /** When the user saved this grant */
  savedAt?: Maybe<Scalars['DateTime']>;
  /** User status: NEW, SAVED, or DISMISSED */
  status: ResearchedGrantStatus;
  updatedAt: Scalars['DateTime'];
};

/** Status of a researched grant from user perspective */
export enum ResearchedGrantStatus {
  Dismissed = 'DISMISSED',
  New = 'NEW',
  Saved = 'SAVED'
}

export type ResendInvite = {
  success?: Maybe<Scalars['Boolean']>;
};

export type Responsibility = {
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
};

export type ResponsibilityInput = {
  ids: Array<Scalars['Int']>;
};

export type RetriggerProfilerResponse = {
  success: Scalars['Boolean'];
};

export type RetryJobResult = {
  error?: Maybe<Scalars['String']>;
  newJobId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ReturnedTokenData = {
  tokenData?: Maybe<TokenData>;
};

export enum RsvpStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type SavedFunderLimits = {
  available?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  used?: Maybe<Scalars['Int']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type SeriesData = {
  x: Scalars['String'];
  y?: Maybe<Scalars['Float']>;
};

export type SingleGoalUpdate = {
  /** The description of the goal update */
  description: Scalars['String'];
  /** The unique identifier of the goal that the update is associated with */
  goalId: Scalars['Int'];
  /** The title of the goal that the update is associated with */
  goalTitle: Scalars['String'];
  /** The unique identifier of the goal update */
  id: Scalars['Int'];
  /** The firstname of the user who last updated the goal */
  lastUpdatedUserFirstname: Scalars['String'];
  /** The unique identifier of the user who last updated the goal */
  lastUpdatedUserId: Scalars['Int'];
  /** The lastname of the user who last updated the goal */
  lastUpdatedUserLastname: Scalars['String'];
  /** The date when the goal update was reported */
  reportedAt?: Maybe<Scalars['DateTime']>;
  /** The task that the goal update is associated */
  taskId?: Maybe<Scalars['Int']>;
  /** The title of the task that the goal update is associated with */
  taskTitle?: Maybe<Scalars['String']>;
};

export enum SocialMediaPlatform {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Twitter = 'TWITTER',
  Website = 'WEBSITE'
}

export type SocialMediaUrlConfig = {
  platform: SocialMediaPlatform;
  url: Scalars['String'];
};

export type SocialMediaUrlInput = {
  platform: SocialMediaPlatform;
  url: Scalars['String'];
};

export type SponsoredNonprofit = {
  name?: Maybe<Scalars['String']>;
  nonprofitOrgId?: Maybe<Scalars['Int']>;
};

export type StaffClassificationType = {
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['Int'];
};

export type Stories = {
  FunderOrgs?: Maybe<Array<Maybe<StoryFunderOrg>>>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ctaClickCount: Scalars['Int'];
  hasClickTrackableBlock: Scalars['Boolean'];
  hashedId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  templateUsed: TemplateUsedType;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  urlTitle?: Maybe<Scalars['String']>;
  viewCount: Scalars['Int'];
};

export type StoriesData = {
  orgsWithStories?: Maybe<Scalars['Int']>;
  topStoriesByViews?: Maybe<Array<Maybe<TopStory>>>;
  totalStories?: Maybe<Scalars['Int']>;
};

export type Story = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  blocks?: Maybe<Array<Maybe<Block>>>;
  cloudinaryLogoId?: Maybe<Scalars['String']>;
  colorTheme?: Maybe<ColorTheme>;
  colorThemeId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  ctaClickCount?: Maybe<Scalars['Int']>;
  donationPortalId?: Maybe<Scalars['String']>;
  goal?: Maybe<Goal>;
  goalId?: Maybe<Scalars['Int']>;
  hashedId?: Maybe<Scalars['String']>;
  headerLogoImgUrl?: Maybe<Scalars['String']>;
  headerWebsiteUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
  nonprofitOrgName?: Maybe<Scalars['String']>;
  previewDescription?: Maybe<Scalars['String']>;
  previewImageCloudinaryFileId?: Maybe<Scalars['String']>;
  previewImageId?: Maybe<Scalars['String']>;
  previewTitle?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  sharedAt?: Maybe<Scalars['DateTime']>;
  showHeader: Scalars['Boolean'];
  showTableOfContents: Scalars['Boolean'];
  templateUsed: TemplateUsedType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  urlTitle?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  viewCount?: Maybe<Scalars['Int']>;
};

export type StoryFunderOrg = {
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type StoryGating = {
  limit?: Maybe<Scalars['Int']>;
  limitCycle?: Maybe<Scalars['String']>;
  numberOfStoriesUsed?: Maybe<Scalars['Int']>;
};

export enum StoryOpportunityCategoryType {
  Achievement = 'ACHIEVEMENT',
  Event = 'EVENT',
  Fundraising = 'FUNDRAISING',
  Impact = 'IMPACT',
  Milestone = 'MILESTONE',
  Testimonial = 'TESTIMONIAL'
}

export enum StoryOpportunitySourcePlatform {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Twitter = 'TWITTER',
  Website = 'WEBSITE'
}

export type StoryPromptInput = {
  additionalRequests?: InputMaybe<Scalars['String']>;
  audience: AiStoryAudienceType;
  goal?: InputMaybe<AiStoryGoalType>;
  impact?: InputMaybe<Scalars['String']>;
  importance?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<AiStoryGoalType>;
};

export type StoryQueryInput = {
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  storyId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type StoryUpdateInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
  publishedAt?: InputMaybe<Scalars['DateTime']>;
};

export type StoryUpsertInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  blocks: Array<BlockUpsertInput>;
  boxNarrativeFolderId?: InputMaybe<Scalars['String']>;
  cloudinaryOrgFolderId?: InputMaybe<Scalars['String']>;
  colorThemeId?: InputMaybe<Scalars['Int']>;
  goalId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  infographicDataUri?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
  previewDescription?: InputMaybe<Scalars['String']>;
  previewImageCloudinaryFileId?: InputMaybe<Scalars['String']>;
  previewImageId?: InputMaybe<Scalars['String']>;
  previewTitle?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  showHeader: Scalars['Boolean'];
  showTableOfContents?: InputMaybe<Scalars['Boolean']>;
  templateUsed: TemplateUsedType;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  urlTitle?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type StripeChangePlanPortalLinks = {
  isTrialing?: Maybe<Scalars['Boolean']>;
  performance?: Maybe<Scalars['String']>;
  plus?: Maybe<Scalars['String']>;
  pro?: Maybe<Scalars['String']>;
  starter?: Maybe<Scalars['String']>;
  trialEnd?: Maybe<Scalars['Int']>;
};

export type StripeConnectAccount = {
  bankAccount?: Maybe<BankAccount>;
  capabilities?: Maybe<Capabilities>;
  id?: Maybe<Scalars['String']>;
  payouts_enabled?: Maybe<Scalars['Boolean']>;
};

export type StripeConnectAccountLink = {
  url?: Maybe<Scalars['String']>;
};

export type StripeConnectIssues = {
  errors?: Maybe<Array<Maybe<Scalars['Json']>>>;
  missingBusinessUrl?: Maybe<Scalars['Boolean']>;
  pendingVerification?: Maybe<Array<Maybe<Scalars['String']>>>;
  resumeKYCUrl?: Maybe<Scalars['String']>;
};

export type StripePayout = {
  amount?: Maybe<Scalars['Int']>;
  arrival_date?: Maybe<Scalars['Int']>;
  automatic?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  destination?: Maybe<Scalars['String']>;
  failure_code?: Maybe<Scalars['String']>;
  failure_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  livemode?: Maybe<Scalars['Boolean']>;
  method?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  reversed_by?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  statement_descriptor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<PayoutType>;
};

export type StripePayouts = {
  currentBalanceInCents?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<StripePayout>>>;
  payoutFrequency?: Maybe<Scalars['String']>;
  totalPaidOutInCents?: Maybe<Scalars['Int']>;
};

export type StripePrice = {
  formationPrice?: Maybe<Scalars['Float']>;
  platformPrice?: Maybe<Scalars['Float']>;
};

export enum SurveyType {
  FourMonthCheckIn = 'FOUR_MONTH_CHECK_IN',
  Intake = 'INTAKE',
  NeedsAssessment = 'NEEDS_ASSESSMENT',
  Onboarding = 'ONBOARDING',
  ThreeMonthCheckIn = 'THREE_MONTH_CHECK_IN'
}

export enum TaskRecurrenceType {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export type TasksSummary = {
  totalTasks: Scalars['Int'];
  totalTasksAssigned: Scalars['Int'];
  totalTasksCompletedOverall: Scalars['Int'];
  totalTasksCompletedThisReportPeriod: Scalars['Int'];
  totalTasksUnassigned: Scalars['Int'];
};

export type TaxExemptionStatus = {
  is501c3Verified?: Maybe<Scalars['Boolean']>;
};

export type TaxExemptionStatusResponse = {
  status: TaxExemptionStatusTypes;
};

export enum TaxExemptionStatusTypes {
  GatheringInformation = 'GATHERING_INFORMATION',
  PreparingOrgDocuments = 'PREPARING_ORG_DOCUMENTS',
  PreppingTaxExemption = 'PREPPING_TAX_EXEMPTION',
  TaxExemptionSuccessful = 'TAX_EXEMPTION_SUCCESSFUL',
  WaitingOnIrs = 'WAITING_ON_IRS',
  WaitingOnStateDep = 'WAITING_ON_STATE_DEP'
}

export type TemplateGoals = {
  goals?: Maybe<Array<Maybe<Goal>>>;
};

export type TemplateLibrary = {
  appcuesFlowId?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  checklistItemTemplate: Array<ChecklistItemTemplate>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  goalTemplate: Array<GoalTemplate>;
  id: Scalars['Int'];
  objectiveTemplate: Array<ObjectiveTemplate>;
  showInListing: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type TemplateLibraryInput = {
  appcuesFlowId?: InputMaybe<Scalars['String']>;
  checklistItemTemplate: Array<ChecklistItemTemplateInput>;
  description?: InputMaybe<Scalars['String']>;
  goalCategory?: InputMaybe<GoalCategory>;
  goalTitle: Scalars['String'];
  id: Scalars['Int'];
  objectiveTitle?: InputMaybe<Scalars['String']>;
  showInListing?: InputMaybe<Scalars['Boolean']>;
};

export enum TemplateUsedType {
  AiGenerated = 'AI_GENERATED',
  AnnualReport = 'ANNUAL_REPORT',
  BlankStory = 'BLANK_STORY',
  FundraisingAppeal = 'FUNDRAISING_APPEAL',
  GrantSuccessSnapshot = 'GRANT_SUCCESS_SNAPSHOT',
  ImpactNarrative = 'IMPACT_NARRATIVE',
  ProgressReport = 'PROGRESS_REPORT',
  ProjectUpdate = 'PROJECT_UPDATE',
  Testimonial = 'TESTIMONIAL'
}

export enum TimePeriod {
  AllTime = 'ALL_TIME',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export type TokenData = {
  accessToken?: Maybe<Scalars['String']>;
  acquiredAt?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['String']>;
};

export type TopCoachingTopic = {
  sessionCount?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['String']>;
};

export type TopPriority = {
  avgConfidence?: Maybe<Scalars['Float']>;
  category?: Maybe<Scalars['String']>;
  userCount?: Maybe<Scalars['Int']>;
};

export type TopResource = {
  resourceName?: Maybe<Scalars['String']>;
  resourceType?: Maybe<Scalars['String']>;
  totalInteractions?: Maybe<Scalars['Int']>;
};

export type TopStory = {
  n?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TrackAdblockerDetectedResponse = {
  success: Scalars['Boolean'];
};

export type TrackRecommendationInteractionInput = {
  action: RecommendationStatus;
  recommendationId: Scalars['Int'];
};

export type TrackWithoutPiiResponse = {
  success: Scalars['Boolean'];
};

export enum TransactionStatus {
  All = 'ALL',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type TriggerInterventionResponse = {
  interventionId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateChartCategoryInput = {
  chartCategoryId: Scalars['Int'];
  shouldArchive?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type UpdateChartDataPointInput = {
  chartCategoryId: Scalars['Int'];
  chartId: Scalars['Int'];
  date?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  shouldArchive?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type UpdateChartInput = {
  calculationType?: InputMaybe<CalculationType>;
  chartId: Scalars['Int'];
  shouldArchive?: InputMaybe<Scalars['Boolean']>;
  target?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  unitOfMeasurement: Scalars['String'];
};

export type UpdateEntryGroupInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  details?: InputMaybe<Scalars['String']>;
  entryGroupId: Scalars['Int'];
  reportedAt: Scalars['DateTime'];
};

export type UpdateEntryInput = {
  entryId: Scalars['Int'];
  value: Scalars['Float'];
};

export type UpdateNonprofitOrgCommunitySettingsResponse = {
  nonprofitOrgId?: Maybe<Scalars['Int']>;
  spaceGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  spaceIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateNonprofitOrgInput = {
  missionStatement: Scalars['String'];
  orgId: Scalars['Int'];
};

export type UpdateNonprofitOrgProfileInput = {
  confirmedAreasOfImpact?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  confirmedOrgSummary?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
};

export type UpdateTaxExemptionStatusResponse = {
  id?: Maybe<Scalars['String']>;
};

export type UpdatedTasksResult = {
  success: Scalars['Boolean'];
  updatedTasks: Scalars['Int'];
};

export type UpsertCohortMembershipResponse = {
  /** The number of created or updated Cohort Memberships */
  count: Scalars['Int'];
};

export type UpsertCohortOwnershipResponse = {
  /** The id of the Cohort */
  cohortId: Scalars['Int'];
  /** The id of the Owner */
  funderOrgId: Scalars['Int'];
  /** The id of the Ownership object */
  id: Scalars['Int'];
};

export type UpsertCohortResponse = {
  /** The date for which the Cohort stops or stopped being active */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The id of the Cohort */
  id: Scalars['Int'];
  /** The Auth0 roles for which associated permissions will be added to all Cohort members */
  memberRoles: Array<Maybe<Scalars['String']>>;
  /** The name of the Cohort */
  name: Scalars['String'];
  /** The date for which the Cohort starts or started being active */
  startDate?: Maybe<Scalars['DateTime']>;
};

export type User = {
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAdmin = {
  createdAt?: Maybe<Scalars['DateTime']>;
  disabled: Scalars['Boolean'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  funderOrgs?: Maybe<Array<Maybe<FunderOrg>>>;
  id: Scalars['Int'];
  isTest: Scalars['Boolean'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  nonprofitExperienceRange?: Maybe<Scalars['String']>;
  nonprofitOrgs?: Maybe<Array<Maybe<NonprofitOrgAdmin>>>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserAdminPaginatedResult = {
  total: Scalars['Int'];
  users: Array<Maybe<UserAdmin>>;
};

export type UserConfig = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  nonprofitExperienceRange?: Maybe<NonprofitExperienceRange>;
  permissions: Array<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  spaces?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserEvent = {
  eventName?: Maybe<Scalars['String']>;
  eventProperties: Scalars['Json'];
  eventTimeStamp: Scalars['DateTime'];
  id: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};

export type UserRecommendation = {
  clickedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dismissedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadata?: Maybe<Scalars['Json']>;
  nonprofitOrg?: Maybe<NonprofitOrg>;
  nonprofitOrgId: Scalars['Int'];
  placement: RecommendationPlacement;
  recommendationTemplate?: Maybe<RecommendationTemplate>;
  recommendationTemplateId: Scalars['Int'];
  score: Scalars['Float'];
  shownAt?: Maybe<Scalars['DateTime']>;
  status: RecommendationStatus;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

export type UserRecommendationsResponse = {
  recommendations: Array<UserRecommendation>;
  totalCount: Scalars['Int'];
};

export type UserSettingsUpdateInput = {
  firstName: Scalars['String'];
  isFounder?: InputMaybe<Scalars['Boolean']>;
  lastLoggedInAt?: InputMaybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  nonprofitExperienceRange?: InputMaybe<NonprofitExperienceRange>;
  nonprofitOrgRole?: InputMaybe<NonprofitOrgRole>;
  role?: InputMaybe<NonprofitOrgToUserRole>;
};

export type UserSurvey = {
  UserSurveyPriority: Array<UserSurveyPriority>;
  baselineConfidence?: Maybe<Scalars['Int']>;
  baselineSupportNeeded?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  nonprofitExperienceLevel?: Maybe<NonprofitExperienceRange>;
  nonprofitOrgId: Scalars['Int'];
  orgMissionChange?: Maybe<Scalars['Int']>;
  orgMissionChangeExplanation?: Maybe<Scalars['String']>;
  primaryFunction: UserSurveyPrimaryFunction;
  response?: Maybe<Scalars['Json']>;
  role: UserSurveyRole;
  type: SurveyType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['Int'];
};

export enum UserSurveyPrimaryFunction {
  Executive = 'EXECUTIVE',
  FinanceOperations = 'FINANCE_OPERATIONS',
  Fundraising = 'FUNDRAISING',
  MarketingCommunications = 'MARKETING_COMMUNICATIONS',
  MultipleFunctions = 'MULTIPLE_FUNCTIONS',
  Other = 'OTHER',
  Programming = 'PROGRAMMING'
}

export type UserSurveyPriority = {
  UserSurveyPriorityTopic: Array<UserSurveyPriorityTopic>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  category: GoalCategory;
  challenges?: Maybe<Scalars['String']>;
  confidenceLevel: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  customPriorities?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  rank: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSurveyId: Scalars['Int'];
};

export type UserSurveyPriorityTopic = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  templateLibraryId?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSurveyPriorityId: Scalars['Int'];
};

export type UserSurveyQueryInput = {
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
};

export type UserSurveyResponse = {
  priorities: Priorities;
};

export enum UserSurveyRole {
  AssistantAssociateCoordinator = 'ASSISTANT_ASSOCIATE_COORDINATOR',
  BoardMember = 'BOARD_MEMBER',
  Director = 'DIRECTOR',
  Executive = 'EXECUTIVE',
  Manager = 'MANAGER',
  OrgLeader = 'ORG_LEADER',
  TeamMember = 'TEAM_MEMBER',
  Volunteer = 'VOLUNTEER'
}

export type UserSurveyUpsertInput = {
  id?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId: Scalars['Int'];
  onboardingData?: InputMaybe<OnboardingDataInput>;
  response: Scalars['Json'];
  role: UserSurveyRole;
  type: SurveyType;
};

export type UserUnion = FunderUserConfig | UserConfig;

export enum VerificationMethod {
  App = 'APP',
  Manual = 'MANUAL'
}

export enum VolunteerSizeRange {
  Volunteer_1To_4 = 'VOLUNTEER_1_TO_4',
  Volunteer_5To_9 = 'VOLUNTEER_5_TO_9',
  Volunteer_10To_19 = 'VOLUNTEER_10_TO_19',
  Volunteer_20To_39 = 'VOLUNTEER_20_TO_39',
  Volunteer_40To_69 = 'VOLUNTEER_40_TO_69',
  Volunteer_70To_99 = 'VOLUNTEER_70_TO_99',
  Volunteer_100AndUp = 'VOLUNTEER_100_AND_UP',
  VolunteerNone = 'VOLUNTEER_NONE'
}

export type WhatTheyDoingData = {
  academyCFUF?: Maybe<Scalars['Float']>;
  coachingCFUF?: Maybe<Scalars['Float']>;
  communityCFUF?: Maybe<Scalars['Float']>;
  donationsCFUF?: Maybe<Scalars['Float']>;
  funderFinderCFUF?: Maybe<Scalars['Float']>;
  impactCFUF?: Maybe<Scalars['Float']>;
  maosByMonth?: Maybe<Array<Maybe<MaOsByMonth>>>;
};

export type YourCohort = {
  activeOrgsByMonth?: Maybe<Array<Maybe<ActiveOrgsByMonth>>>;
  engagementData?: Maybe<Array<Maybe<EngagementData>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FunderOrgToUser = {
  deletedAt?: Maybe<Scalars['DateTime']>;
  funderOrgId?: Maybe<Scalars['Int']>;
  funderOrgRole?: Maybe<Scalars['String']>;
  lastInviteSentAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<FunderUserDetails>;
  userId?: Maybe<Scalars['Int']>;
};

export type ReportedMetricFeatureGatingLimits = {
  selfReportingGoals: FeatureLimits;
  selfReportingInitiatives: FeatureLimits;
};

export enum TrackWithoutPiiEventType {
  Page = 'page',
  Track = 'track'
}

export type TrackWithoutPiiInput = {
  /** If provided, an email belonging to a user whose user ID will be attached to the event as a property userId */
  email?: InputMaybe<Scalars['String']>;
  /** The name of the event to track */
  eventName: Scalars['String'];
  /** The type of event to track. Defaults to track. */
  eventType?: InputMaybe<TrackWithoutPiiEventType>;
  /** Other properties to attach to the event, as a stringified JSON object. */
  propertiesString: Scalars['String'];
};

export type UpsertFunderOrgPlatformProductResponse = {
  /** Role name in Auth0 given to users of the Funder */
  auth0Role: Scalars['String'];
  /** When the record was created */
  createdAt: Scalars['DateTime'];
  /** Whether the product is enabled for the funder */
  enabled: Scalars['Boolean'];
  /** ID for Funder */
  funderOrgId: Scalars['Int'];
  /** ID for FunderPlatformProduct object */
  id: Scalars['Int'];
  /** ID for Stripe Price associated with product */
  stripePriceId?: Maybe<Scalars['String']>;
  /** ID for Stripe Product associated with product */
  stripeProductId?: Maybe<Scalars['String']>;
  /** When the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export type UpsertNonprofitOrgPlatformPlanAddOnResponse = {
  /** Role name in Auth0 given to users of the Nonprofit Org */
  auth0Role: Scalars['String'];
  /** When the record was created */
  createdAt: Scalars['DateTime'];
  /** Whether the add on is enabled for the org */
  enabled: Scalars['Boolean'];
  /** ID for NonprofitOrgPlatformPlanAddOn object */
  id: Scalars['Int'];
  /** ID for Nonprofit Org */
  nonprofitOrgId: Scalars['Int'];
  /** ID for Stripe Price associated with add on */
  stripePriceId?: Maybe<Scalars['String']>;
  /** ID for Stripe Product associated with add on */
  stripeProductId?: Maybe<Scalars['String']>;
  /** When the record was last updated */
  updatedAt: Scalars['DateTime'];
};

export type AddGoalMutationVariables = Exact<{
  goalInfo: AddGoalInput;
}>;


export type AddGoalMutation = { addGoal?: { id: number, title: string, category?: GoalCategory | null, nonprofitOrgId?: number | null, owner?: { id: number, firstName: string, lastName: string } | null } | null };

export type AddGoalMeasurementMutationVariables = Exact<{
  goalInfo: GoalInput;
  dimensionInfo: Array<GoalDimensionInput> | GoalDimensionInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type AddGoalMeasurementMutation = { addGoalMeasurement?: { id: number, title: string } | null };

export type AssignGoalsToGoalGroupMutationVariables = Exact<{
  data: AssignGoalsToGoalGroupInput;
}>;


export type AssignGoalsToGoalGroupMutation = { assignGoalsToGoalGroup?: { count?: number | null } | null };

export type AutoCompleteTasksMutationMutationVariables = Exact<{
  resourceId: Scalars['String'];
}>;


export type AutoCompleteTasksMutationMutation = { autoCompleteTasksMutation: { updatedTasks: number, success: boolean } };

export type UpdateChartCategoryMutationVariables = Exact<{
  data: UpdateChartCategoryInput;
}>;


export type UpdateChartCategoryMutation = { updateChartCategory?: { id: number, title: string, chartId: number } | null };

export type CreateChartCategoriesMutationVariables = Exact<{
  chartId: Scalars['Int'];
  data: Array<ChartCategoryInput> | ChartCategoryInput;
}>;


export type CreateChartCategoriesMutation = { createChartCategories?: Array<{ id: number, title: string, chartId: number } | null> | null };

export type CreateChartDataPointsMutationVariables = Exact<{
  data: Array<ChartDataPointInput> | ChartDataPointInput;
}>;


export type CreateChartDataPointsMutation = { createChartDataPoints?: { count?: number | null } | null };

export type CompleteQuickBooksConnectionMutationVariables = Exact<{
  code: Scalars['String'];
  state: Scalars['String'];
  realmId: Scalars['String'];
}>;


export type CompleteQuickBooksConnectionMutation = { completeQuickBooksConnection?: { id: string, nonprofitOrgId: number, companyName: string, status: QuickBooksConnectionStatus, connectedAt: any, lastDataFetch?: any | null, needsReauth: boolean } | null };

export type CreateAttachmentMutationVariables = Exact<{
  filename: Scalars['String'];
  format?: InputMaybe<Scalars['String']>;
  goalId: Scalars['Int'];
  publicId: Scalars['String'];
  secureUrl: Scalars['String'];
  resourceType?: InputMaybe<Scalars['String']>;
}>;


export type CreateAttachmentMutation = { createAttachment?: { id: number, createdAt: any, filename: string, format?: string | null, secureUrl: string, publicId: string, resourceType?: string | null } | null };

export type CreateAutomatedGoalMutationVariables = Exact<{
  appcuesFlowId: Scalars['String'];
  nonprofitOrgId: Scalars['Int'];
  createObjective?: InputMaybe<Scalars['Boolean']>;
  shareWithFunderOrgId?: InputMaybe<Scalars['Int']>;
  isGoalSharedByFunder?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateAutomatedGoalMutation = { createAutomatedGoal?: { templateLibraryId?: number | null, objective?: { id: number, title: string } | null, goal?: { id: number, title: string, category?: GoalCategory | null, type: GoalType, owner?: { id: number, firstName: string, lastName: string } | null } | null, checklistItems?: Array<{ id: number, title: string } | null> | null } | null };

export type CreateBoxConfigMutationVariables = Exact<{
  userId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type CreateBoxConfigMutation = { createBoxConfig?: { boxId?: string | null } | null };

export type CreateCampaignMutationVariables = Exact<{
  orgId: Scalars['Int'];
  campaignInput: CampaignInput;
}>;


export type CreateCampaignMutation = { createCampaign: { id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdUserId?: number | null, updatedUserId?: number | null, fundraisingTarget?: number | null, publishedAt?: any | null, archivedAt?: any | null, hashedPortalId?: string | null } };

export type CreateChartMutationVariables = Exact<{
  data: CreateChartInput;
}>;


export type CreateChartMutation = { createChart?: { id: number } | null };

export type CreateChartsMutationVariables = Exact<{
  data: CreateChartsInput;
}>;


export type CreateChartsMutation = { createCharts?: Array<{ id: number } | null> | null };

export type CreateEntryMutationVariables = Exact<{
  entryGroupInfo: EntryGroupInput;
  entryInfo: Array<EntryInput> | EntryInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type CreateEntryMutation = { createEntry?: { id: number } | null };

export type CreateGoalGroupMutationVariables = Exact<{
  data: CreateGoalGroupInput;
}>;


export type CreateGoalGroupMutation = { createGoalGroup?: { id: number, title: string, description?: string | null, category: GoalCategory, startDate?: any | null, endDate?: any | null } | null };

export type CreateGroupCoachingEventMutationVariables = Exact<{
  input: GroupCoachingEventInput;
}>;


export type CreateGroupCoachingEventMutation = { createGroupCoachingEvent: { id: number, name: string, userId: number, createdAt: any, updatedAt: any, startsAt: any, endsAt: any, duration?: number | null, bookingUrl?: string | null, hideAttendees: boolean, body?: string | null, googleCalendarId?: string | null, googleCalendarLink?: string | null, slug: string, focusArea?: string | null, coachName?: string | null, coachEmail?: string | null, recordingLink?: string | null, activityType?: ActivityType | null, meetingBody?: string | null, meetingTitle?: string | null, videoConferenceUrl?: string | null, status?: OneOnOneCoachingEventStatus | null } };

export type CreateManyFunderUsersMutationVariables = Exact<{
  funderUsersInfo: Array<BulkFunderUserInput> | BulkFunderUserInput;
  funderOrgId: Scalars['Int'];
  inviterUserId: Scalars['Int'];
}>;


export type CreateManyFunderUsersMutation = { createManyFunderUsers?: Array<{ email?: string | null } | null> | null };

export type CreateManyNonprofitOrgUsersMutationVariables = Exact<{
  nonprofitUserInfo: GranteeUserBasicInput;
  nonprofitOrgId: Scalars['Int'];
  sendInvite?: InputMaybe<Scalars['Boolean']>;
  inviteType?: InputMaybe<NonprofitOrgInviteType>;
}>;


export type CreateManyNonprofitOrgUsersMutation = { createManyNonprofitOrgUsers?: Array<{ email?: string | null } | null> | null };

export type CreateMurdocEmbedSessionMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type CreateMurdocEmbedSessionMutation = { createMurdocEmbedSession: { iframeUrl: string, expiresAt: any, refreshAt: any } };

export type CreateNonprofitToViewedFunderMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  funderEin: Scalars['Int'];
}>;


export type CreateNonprofitToViewedFunderMutation = { createNonprofitToViewedFunder?: { id?: number | null, nonprofitOrgId?: number | null, fundingOrg990Id?: number | null, viewDate?: any | null } | null };

export type AddCsToNonprofitOrgMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type AddCsToNonprofitOrgMutation = { createNonprofitOrgToUserRelationship?: { orgName?: string | null, orgId?: number | null, formationPlan?: string | null, platformPlan?: string | null } | null };

export type CreateNonprofitOrgUserMutationVariables = Exact<{
  nonprofitUserInfo: GranteeUserInput;
  nonprofitOrgId: Scalars['Int'];
  sendInvite?: InputMaybe<Scalars['Boolean']>;
  inviteType?: InputMaybe<NonprofitOrgInviteType>;
}>;


export type CreateNonprofitOrgUserMutation = { createNonprofitOrgUser: { email?: string | null } };

export type CreateOrRetrieveCloudinaryConfigMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type CreateOrRetrieveCloudinaryConfigMutation = { createOrRetrieveCloudinaryConfig?: { cloudinaryId?: string | null } | null };

export type CreateReportedMetricGroupMutationVariables = Exact<{
  reportedMetricGroupInfo: ReportedMetricGroupInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type CreateReportedMetricGroupMutation = { createReportedMetricGroup: { id: number, title: string, NonprofitOrg: { id: number } } };

export type CreateStripeConnectMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  email: Scalars['String'];
}>;


export type CreateStripeConnectMutation = { createStripeConnect?: { id?: string | null, payouts_enabled?: boolean | null, capabilities?: { transfers?: string | null, card_payments?: string | null } | null } | null };

export type CreateTemplateGoalsMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  templateIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CreateTemplateGoalsMutation = { createTemplateGoals?: { goals?: Array<{ id: number, type: GoalType, templateLibraryId?: number | null, title: string } | null> | null } | null };

export type CreateIncompleteUserSurveysMutationVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CreateIncompleteUserSurveysMutation = { createIncompleteUserSurveys: { userIds: Array<number> } };

export type DeleteChecklistItemMutationVariables = Exact<{
  id: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
}>;


export type DeleteChecklistItemMutation = { deleteChecklistItem?: { id: number } | null };

export type DeleteGoalDimensionRelationshipMutationVariables = Exact<{
  goalToDimensionId: Scalars['Int'];
}>;


export type DeleteGoalDimensionRelationshipMutation = { deleteGoalDimensionRelationship?: { success?: boolean | null } | null };

export type DeleteGoalUpdateMutationVariables = Exact<{
  goalUpdateId: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
}>;


export type DeleteGoalUpdateMutation = { deleteGoalUpdate: { id: number } };

export type DeleteRecurringTasksMutationVariables = Exact<{
  checklistItemId: Scalars['Int'];
  checklistItemGroupId: Scalars['Int'];
  option: DeleteRecurringTasksOption;
  nonprofitOrgId: Scalars['Int'];
}>;


export type DeleteRecurringTasksMutation = { deleteRecurringTasks?: Array<{ id: number } | null> | null };

export type DisconnectQuickBooksMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type DisconnectQuickBooksMutation = { disconnectQuickBooks: boolean };

export type DuplicateStoryMutationVariables = Exact<{
  storyId: Scalars['Int'];
}>;


export type DuplicateStoryMutation = { duplicateStory?: { id: number, nonprofitOrgId: number, title: string, updatedAt: any, publishedAt?: any | null, urlTitle?: string | null, previewTitle?: string | null, previewDescription?: string | null, previewImageId?: string | null, previewImageCloudinaryFileId?: string | null, hashedId?: string | null, blocks?: Array<{ id: number, assetId: number, backgroundColor?: string | null, assetType: AssetType, createdAt: any, updatedAt: any, asset: { id: number, assetType: AssetType, assetDetails?: any | null, createdAt: any, updatedAt: any } } | null> | null } | null };

export type EditGoalGroupMutationVariables = Exact<{
  data: CreateGoalGroupInput;
  funderOrgId: Scalars['Int'];
  goalGroupId: Scalars['Int'];
}>;


export type EditGoalGroupMutation = { editGoalGroup?: { id: number, title: string, description?: string | null, category: GoalCategory, startDate?: any | null, endDate?: any | null } | null };

export type EndLoginAsMutationVariables = Exact<{ [key: string]: never; }>;


export type EndLoginAsMutation = { endLoginAs?: { success?: boolean | null } | null };

export type ExtractDocumentTextMutationVariables = Exact<{
  input: ExtractDocumentTextInput;
}>;


export type ExtractDocumentTextMutation = { extractDocumentText: { text: string, truncated: boolean, characterCount: number } };

export type FindDuplicateUsersQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
  nonprofitOrgId: Scalars['Int'];
}>;


export type FindDuplicateUsersQuery = { findDuplicateUsers?: { emails: Array<string | null> } | null };

export type FindOrCreateColorThemeMutationVariables = Exact<{
  chosenColor: Scalars['String'];
}>;


export type FindOrCreateColorThemeMutation = { FindOrCreateColorTheme: { id: number, color: string } };

export type GenerateFinancialHealthAssessmentReportMutationVariables = Exact<{
  input: GenerateFinancialHealthAssessmentReportInput;
}>;


export type GenerateFinancialHealthAssessmentReportMutation = { generateFinancialHealthAssessmentReport: { runId: string, status: MurdocReportRunStatus, reportSlug?: string | null, progressUrl?: string | null, userId: number, reportData?: any | null } };

export type GenerateGrantAnalysisReportMutationVariables = Exact<{
  input: GenerateGrantAnalysisReportInput;
}>;


export type GenerateGrantAnalysisReportMutation = { generateGrantAnalysisReport: { runId: string, status: MurdocReportRunStatus, reportSlug?: string | null, userId: number } };

export type GenerateMcpApiKeyMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type GenerateMcpApiKeyMutation = { generateMcpApiKey: { id: string, name?: string | null, key?: string | null, createdAt: any, expiresAt?: any | null, revokedAt?: any | null, lastUsedAt?: any | null } };

export type GenerateNonprofitIntelligenceReportMutationVariables = Exact<{
  input: GenerateNonprofitIntelligenceReportInput;
}>;


export type GenerateNonprofitIntelligenceReportMutation = { generateNonprofitIntelligenceReport: { runId: string, status: MurdocReportRunStatus, reportSlug?: string | null, userId: number } };

export type GenerateStoryFromMurdocOpportunityMutationVariables = Exact<{
  input: GenerateStoryFromMurdocOpportunityInput;
}>;


export type GenerateStoryFromMurdocOpportunityMutation = { generateStoryFromMurdocOpportunity?: { template?: Array<AssetType> | null, hasError?: boolean | null, isInappropriate?: boolean | null, blocks?: Array<{ buttonText?: string | null, note?: string | null, url?: string | null, type?: string | null } | { cloudinaryFileId?: string | null, type?: string | null } | { entityMap?: any | null, type?: string | null, blocks?: Array<{ key?: string | null, data?: any | null, text?: string | null, type?: string | null, depth?: number | null, entityRanges?: any | null, inlineStyleRanges?: any | null } | null> | null }> | null } | null };

export type GetNewBoxTokenMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GetNewBoxTokenMutation = { getNewBoxToken?: { tokenData?: { accessToken?: string | null, expiresIn?: string | null, acquiredAt?: string | null } | null } | null };

export type GenerateGrantResearchReportMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GenerateGrantResearchReportMutation = { generateGrantResearchReport: { id: number, status: GrantResearchStatus, createdAt: any } };

export type SaveResearchedGrantMutationVariables = Exact<{
  grantId: Scalars['Int'];
}>;


export type SaveResearchedGrantMutation = { saveResearchedGrant: { id: number, status: ResearchedGrantStatus, savedAt?: any | null } };

export type DismissResearchedGrantMutationVariables = Exact<{
  grantId: Scalars['Int'];
}>;


export type DismissResearchedGrantMutation = { dismissResearchedGrant: { id: number, status: ResearchedGrantStatus, dismissedAt?: any | null } };

export type InitializeCommunityMutationVariables = Exact<{
  agreedCommunityGuidelines: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  spaceSlug?: InputMaybe<Scalars['String']>;
  postSlug?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
}>;


export type InitializeCommunityMutation = { initializeCommunity?: { communityURL: string } | null };

export type InitiateQuickBooksConnectionMutationVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type InitiateQuickBooksConnectionMutation = { initiateQuickBooksConnection?: { url: string, state: string } | null };

export type LoginAsMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type LoginAsMutation = { loginAs?: { success?: boolean | null } | null };

export type MarkTaskAsCompletedMutationVariables = Exact<{
  taskId: Scalars['Int'];
}>;


export type MarkTaskAsCompletedMutation = { markTaskAsCompleted: { checklistItem: { id: number, title: string, isCompleted?: boolean | null, updatedAt: any, resourceId?: string | null, dueDate?: string | null, linkText?: string | null, linkUrl?: string | null, lastUpdatedUser: { id: number, firstName: string, lastName: string }, owner?: { id: number, firstName: string, lastName: string } | null }, additionalInformation: { goalId?: number | null, goalType?: string | null, initiativeId?: number | null, templateLibraryId?: number | null } } };

export type NotifyResiliaToAddGoalMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type NotifyResiliaToAddGoalMutation = { notifyResiliaToAddGoal: boolean };

export type PromptProgressUpdateMutationVariables = Exact<{ [key: string]: never; }>;


export type PromptProgressUpdateMutation = { promptProgressUpdate?: { success?: boolean | null } | null };

export type RefetchGongTranscriptMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RefetchGongTranscriptMutation = { refetchGongTranscript: { success: boolean } };

export type RefetchHubspotMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RefetchHubspotMutation = { refetchHubspot: { success: boolean } };

export type RemoveFunderUserMutationVariables = Exact<{
  removeFunderUserInfo: RemoveFunderUserInput;
  funderId: Scalars['Int'];
}>;


export type RemoveFunderUserMutation = { removeFunderUser: { funderOrgId?: number | null } };

export type RemoveNonprofitOrgUserMutationVariables = Exact<{
  removeNonprofitOrgUserInfo: RemoveNonprofitOrgUserInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type RemoveNonprofitOrgUserMutation = { removeNonprofitOrgUser: { nonprofitOrgId: number } };

export type RemoveSavedFunderForNonprofitMutationVariables = Exact<{
  funderEin: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
}>;


export type RemoveSavedFunderForNonprofitMutation = { removeSavedFunderForNonprofit?: { nonprofitOrgId?: number | null, fundingOrg990Id?: number | null } | null };

export type ResendFunderInviteMutationVariables = Exact<{
  userId: Scalars['Int'];
  funderOrgId: Scalars['Int'];
}>;


export type ResendFunderInviteMutation = { resendFunderInvite?: { success?: boolean | null } | null };

export type ResendInviteMutationVariables = Exact<{
  userId: Scalars['Int'];
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
}>;


export type ResendInviteMutation = { resendInvite?: { success?: boolean | null } | null };

export type RetriggerGoalsWizardMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type RetriggerGoalsWizardMutation = { retriggerGoalsWizard?: { id: number, nonprofitOrgId: number, confirmedOrgSummary?: string | null, confirmedAreasOfImpact: Array<string>, confirmedOrgSummaryUpdatedAt?: any | null } | null };

export type RetriggerProfilerMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type RetriggerProfilerMutation = { retriggerProfiler?: { success: boolean } | null };

export type RetryJobMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;


export type RetryJobMutation = { retryJob?: { success: boolean, newJobId?: string | null, error?: string | null } | null };

export type RevokeMcpApiKeyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RevokeMcpApiKeyMutation = { revokeMcpApiKey: boolean };

export type RsvpToGroupCoachingEventMutationVariables = Exact<{
  input: GroupCoachingEventRsvpInput;
}>;


export type RsvpToGroupCoachingEventMutation = { rsvpToGroupCoachingEvent: { id: number, groupCoachingEventId: number, userId: number, rsvpStatus: RsvpStatus, attendedEvent: boolean, createdAt: any, updatedAt: any, notes?: string | null } };

export type SaveFunderForNonprofitMutationVariables = Exact<{
  funderEin: Scalars['Int'];
  nonprofitOrgId: Scalars['Int'];
}>;


export type SaveFunderForNonprofitMutation = { saveFunderForNonprofit?: { nonprofitOrgId?: number | null, fundingOrg990Id?: number | null } | null };

export type SelfCheckoutMutationVariables = Exact<{
  selfCheckoutInput: CheckoutInput;
}>;


export type SelfCheckoutMutation = { SelfCheckout: { email?: string | null, userId?: number | null, orgId?: number | null, setpasswordURL?: string | null } };

export type ShareStoryWithFunderMutationVariables = Exact<{
  funderOrgId: Scalars['Int'];
  storyId: Scalars['Int'];
}>;


export type ShareStoryWithFunderMutation = { shareStoryWithFunder?: { storyId: number, sharedAt: any } | null };

export type TrackAdblockerDetectedMutationVariables = Exact<{ [key: string]: never; }>;


export type TrackAdblockerDetectedMutation = { trackAdblockerDetected?: { success: boolean } | null };

export type UnshareStoryWithFunderMutationVariables = Exact<{
  funderOrgId: Scalars['Int'];
  storyId: Scalars['Int'];
}>;


export type UnshareStoryWithFunderMutation = { unshareStoryWithFunder?: { storyId: number } | null };

export type UpdateAutoStoriesSettingsMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  settings: AutoStoriesSettingsInput;
}>;


export type UpdateAutoStoriesSettingsMutation = { updateAutoStoriesSettings?: { nonprofitOrgId: number, autoStoriesEnabled: boolean, notifyEmails?: Array<string | null> | null, lastScan?: any | null, socialUrls?: Array<{ platform: SocialMediaPlatform, url: string } | null> | null } | null };

export type UpdateCampaignMutationVariables = Exact<{
  campaignId: Scalars['String'];
  campaignInput: CampaignInput;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateCampaignMutation = { updateCampaign: { id?: string | null, initiativeGoalId?: number | null, draftGoalName?: string | null, draftObjectiveName?: string | null } };

export type UpdateChartMutationVariables = Exact<{
  data: UpdateChartInput;
}>;


export type UpdateChartMutation = { updateChart?: { id: number } | null };

export type UpdateChartDataPointsMutationVariables = Exact<{
  data: Array<UpdateChartDataPointInput> | UpdateChartDataPointInput;
}>;


export type UpdateChartDataPointsMutation = { updateChartDataPoints?: { count?: number | null } | null };

export type UpdateDonationPortalMutationVariables = Exact<{
  portalId: Scalars['Int'];
  updatedUserId: Scalars['Int'];
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateDonationPortalMutation = { updateDonationPortal?: { id: number, nonprofitOrgId: number, createdUserId: number, updatedUserId: number, createdAt: any, name?: string | null, updatedAt: any } | null };

export type UpdateEntryGroupMutationVariables = Exact<{
  entryGroupInfo: UpdateEntryGroupInput;
  entryInfo: Array<UpdateEntryInput> | UpdateEntryInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type UpdateEntryGroupMutation = { updateEntryGroup?: { id: number } | null };

export type UpdateFunderUserSettingsMutationVariables = Exact<{
  funderId: Scalars['Int'];
  userIdToUpdate?: InputMaybe<Scalars['Int']>;
  userSettingsInfo: FunderUserSettingsUpdateInput;
}>;


export type UpdateFunderUserSettingsMutation = { updateFunderUserSettings: { id: number } };

export type UpdateGoalMutationVariables = Exact<{
  goalUpdateInfo: GoalUpdateInput;
}>;


export type UpdateGoalMutation = { updateGoal: { id: number, title: string, category?: GoalCategory | null, unitOfMeasurement?: string | null, target?: number | null, archivedAt?: any | null, owner?: { id: number, firstName: string, lastName: string } | null } };

export type NonprofitBoardMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  developmentStrategy?: InputMaybe<Scalars['String']>;
  developmentInitiatives?: InputMaybe<Scalars['String']>;
}>;


export type NonprofitBoardMutation = { nonprofitBoard?: { developmentStrategy?: string | null, developmentInitiatives?: string | null } | null };

export type UpdateNonprofitOrgMissionMutationVariables = Exact<{
  orgInfo: UpdateNonprofitOrgInput;
}>;


export type UpdateNonprofitOrgMissionMutation = { updateNonprofitOrgMission: { id: number, missionStatement?: string | null } };

export type UpdateNonprofitOrgProfileMutationVariables = Exact<{
  updateNonprofitOrgProfileInput?: InputMaybe<UpdateNonprofitOrgProfileInput>;
}>;


export type UpdateNonprofitOrgProfileMutation = { updateNonprofitOrgProfile?: { confirmedAreasOfImpact: Array<string>, confirmedOrgSummary?: string | null, nonprofitOrgId: number } | null };

export type UpdateReportedMetricGroupMutationVariables = Exact<{
  reportedMetricGroupInfo: ReportedMetricGroupUpdateInput;
}>;


export type UpdateReportedMetricGroupMutation = { updateReportedMetricGroup: { id: number, title: string, NonprofitOrg: { id: number } } };

export type UpdateStoryMutationVariables = Exact<{
  storyUpdateInput: StoryUpdateInput;
}>;


export type UpdateStoryMutation = { updateStory?: { id: number } | null };

export type UpdateTaxExemptionStatusMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  dealStageId: Scalars['String'];
  questionnaireLink?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTaxExemptionStatusMutation = { updateTaxExemptionStatus?: { id?: string | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  userIdToUpdate?: InputMaybe<Scalars['Int']>;
  userSettingsInfo: UserSettingsUpdateInput;
  responsibility?: InputMaybe<ResponsibilityInput>;
}>;


export type UpdateUserSettingsMutation = { updateUserSettings: { id: number } };

export type UpsertDonationPortalMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  hashedId?: InputMaybe<Scalars['String']>;
  content: PortalContentInput;
}>;


export type UpsertDonationPortalMutation = { upsertDonationPortal?: { id: number, hashedId?: string | null, publishedAt?: any | null, nonprofitOrgId: number, createdUserId: number, updatedUserId: number, createdAt: any, name?: string | null, updatedAt: any, customAmountsOn: boolean, socialDescription?: string | null, socialTitle?: string | null, colorTheme: { id: number }, customAmounts?: Array<{ amountInCents?: number | null } | null> | null, DonationPortalBlock?: Array<{ id: number, assetId: number, assetType: AssetType, createdAt: any, updatedAt: any, asset: { id: number, assetType: AssetType, assetDetails?: any | null, createdAt: any, updatedAt: any } } | null> | null } | null };

export type UpsertChecklistItemMutationVariables = Exact<{
  itemInfo: ChecklistItemInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type UpsertChecklistItemMutation = { upsertChecklistItem?: { id: number, title: string, isCompleted?: boolean | null, updatedAt: any, resourceId?: string | null, dueDate?: string | null, linkText?: string | null, linkUrl?: string | null, owner?: { id: number, firstName: string, lastName: string } | null, lastUpdatedUser: { id: number, firstName: string, lastName: string } } | null };

export type UpsertGoalUpdateMutationVariables = Exact<{
  goalUpdateInfo: GoalTextUpdateInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type UpsertGoalUpdateMutation = { upsertGoalUpdate: { id: number, goalId: number, taskId?: number | null, taskTitle?: string | null, description: string, reportedAt: any, updatedAt: any, lastUpdatedUser: { id: number, firstName: string, lastName: string } } };

export type NonprofitOrgDeiInitiativesMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  description: Scalars['String'];
}>;


export type NonprofitOrgDeiInitiativesMutation = { nonprofitDeiInitiatives?: { orgId?: number | null, description?: string | null } | null };

export type UpsertNonprofitOrgSettingsMutationVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  orgSettings: OrgSettingsInput;
  nonprofitOrgRelations?: InputMaybe<NonprofitOrgRelationsInput>;
  orgFinancialSettings?: InputMaybe<OrgFinancialSettingsInput>;
}>;


export type UpsertNonprofitOrgSettingsMutation = { upsertNonprofitOrgSettings: { id: number, name?: string | null } };

export type UpsertRecurringChecklistItemMutationVariables = Exact<{
  recurringItemInfo: RecurringChecklistItemInput;
  nonprofitOrgId: Scalars['Int'];
}>;


export type UpsertRecurringChecklistItemMutation = { upsertRecurringChecklistItem?: Array<{ id: number, dueDate?: string | null, updatedAt: any, owner?: { id: number } | null } | null> | null };

export type UpsertStoryMutationVariables = Exact<{
  storyUpsertInput: StoryUpsertInput;
}>;


export type UpsertStoryMutation = { upsertStory?: { id: number, nonprofitOrgId: number, title: string, updatedAt: any, publishedAt?: any | null, urlTitle?: string | null, previewTitle?: string | null, previewDescription?: string | null, previewImageId?: string | null, previewImageCloudinaryFileId?: string | null, hashedId?: string | null, blocks?: Array<{ id: number, assetId: number, backgroundColor?: string | null, assetType: AssetType, createdAt: any, updatedAt: any, asset: { id: number, assetType: AssetType, assetDetails?: any | null, createdAt: any, updatedAt: any } } | null> | null } | null };

export type UpsertUserSurveyMutationVariables = Exact<{
  userSurveyData: UserSurveyUpsertInput;
}>;


export type UpsertUserSurveyMutation = { upsertUserSurvey?: { id: number, nonprofitOrgId: number, response?: any | null, role: UserSurveyRole, type: SurveyType } | null };

export type CreateOneOnOneCoachingEventMutationVariables = Exact<{
  input: OneOnOneCoachingEventInput;
}>;


export type CreateOneOnOneCoachingEventMutation = { createOneOnOneCoachingEvent?: { id: number, createdAt: any, updatedAt: any, startsAt: any, endsAt: any, contactEmail: string, contactName: string, bookingUrl: string, userSlug: string, organizerEmail?: string | null, organizerName?: string | null, duration?: number | null, formGuid?: string | null } | null };

export type UpdateAttachmentMutationVariables = Exact<{
  filename: Scalars['String'];
  id: Scalars['Int'];
}>;


export type UpdateAttachmentMutation = { updateAttachment?: { id: number, createdAt: any, filename: string, format?: string | null, secureUrl: string, publicId: string, resourceType?: string | null } | null };

export type GetAdminOneOnOneCoachingEventsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  excludeDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAdminOneOnOneCoachingEventsQuery = { adminOneOnOneCoachingEvents: { total: number, events: Array<{ id: number, startsAt: any, endsAt: any, contactEmail: string, contactName: string, bookingUrl: string, userSlug: string, organizerEmail?: string | null, organizerName?: string | null, duration?: number | null, formGuid?: string | null, hubspotId?: string | null, meetingBody?: string | null, meetingType?: string | null, meetingTitle?: string | null, videoConferenceUrl?: string | null, transcript?: string | null, summary?: string | null, status?: OneOnOneCoachingEventStatus | null, createdAt: any, updatedAt: any, deletedAt?: any | null, userId: number }> } };

export type GetAiCoachingInterventionsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  userEmail?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  shouldIntervene?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<AiCoachingInterventionStatus> | AiCoachingInterventionStatus>;
  claimedByMe?: InputMaybe<Scalars['Boolean']>;
  unclaimed?: InputMaybe<Scalars['Boolean']>;
  userSearch?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  cohortId?: InputMaybe<Scalars['Int']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAiCoachingInterventionsQuery = { aiCoachingInterventions?: { total?: number | null, interventions?: Array<{ id?: number | null, identifier?: string | null, version?: string | null, trigger?: string | null, shouldIntervene?: boolean | null, createdAt?: any | null, updatedAt?: any | null, message?: string | null, editedMessage?: string | null, status?: AiCoachingInterventionStatus | null, claimedAt?: any | null, coachFeedback?: string | null, coachRating?: AiCoachingRating | null, emailedAt?: any | null, postedToFeedAt?: any | null, declinedAt?: any | null, declineReason?: string | null, claimedBy?: { id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null> | null } | null };

export type GetAiCoachingInterventionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAiCoachingInterventionQuery = { aiCoachingIntervention?: { id?: number | null, identifier?: string | null, version?: string | null, trigger?: string | null, shouldIntervene?: boolean | null, createdAt?: any | null, updatedAt?: any | null, message?: string | null, editedMessage?: string | null, status?: AiCoachingInterventionStatus | null, claimedAt?: any | null, coachFeedback?: string | null, coachRating?: AiCoachingRating | null, emailedAt?: any | null, postedToFeedAt?: any | null, declinedAt?: any | null, declineReason?: string | null, claimedBy?: { id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null, user?: { id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, platformPlan?: PlatformPlan | null, funderOrgs?: Array<{ id?: number | null, name?: string | null, disabled?: boolean | null } | null> | null, nonprofitOrgs?: Array<{ id?: number | null, name?: string | null, disabled?: boolean | null, cohortMemberships?: Array<{ id?: number | null, startDate?: any | null, endDate?: any | null, cohort?: { id: number, name: string } | null } | null> | null } | null> | null } | null } | null };

export type TriggerInterventionMutationVariables = Exact<{
  identifier: Scalars['String'];
  userId: Scalars['Int'];
  force?: InputMaybe<Scalars['Boolean']>;
}>;


export type TriggerInterventionMutation = { triggerAiCoachingIntervention?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type ClaimAiCoachingInterventionMutationVariables = Exact<{
  interventionId: Scalars['Int'];
}>;


export type ClaimAiCoachingInterventionMutation = { claimAiCoachingIntervention?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type UpdateAiCoachingInterventionMutationVariables = Exact<{
  interventionId: Scalars['Int'];
  editedMessage?: InputMaybe<Scalars['String']>;
  coachFeedback?: InputMaybe<Scalars['String']>;
  coachRating?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAiCoachingInterventionMutation = { updateAiCoachingIntervention?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type SendAiCoachingEmailMutationVariables = Exact<{
  interventionId: Scalars['Int'];
  message: Scalars['String'];
}>;


export type SendAiCoachingEmailMutation = { sendAiCoachingEmail?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type PostAiCoachingToFeedMutationVariables = Exact<{
  interventionId: Scalars['Int'];
  message: Scalars['String'];
}>;


export type PostAiCoachingToFeedMutation = { postAiCoachingToFeed?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type DeclineAiCoachingInterventionMutationVariables = Exact<{
  interventionId: Scalars['Int'];
  reason?: InputMaybe<Scalars['String']>;
}>;


export type DeclineAiCoachingInterventionMutation = { declineAiCoachingIntervention?: { success?: boolean | null, message?: string | null, interventionId?: number | null } | null };

export type GetUserInterventionHistoryQueryVariables = Exact<{
  userId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserInterventionHistoryQuery = { aiCoachingInterventions?: { total?: number | null, interventions?: Array<{ id?: number | null, identifier?: string | null, version?: string | null, shouldIntervene?: boolean | null, createdAt?: any | null, status?: AiCoachingInterventionStatus | null, claimedAt?: any | null, emailedAt?: any | null, postedToFeedAt?: any | null, declinedAt?: any | null, declineReason?: string | null, claimedBy?: { id?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null> | null } | null };

export type GetFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterOptionsQuery = { nonprofitOrgs?: Array<{ id: number, name?: string | null }> | null, funderOrgs?: Array<{ id: number, name?: string | null, disabled: boolean } | null> | null, cohorts?: { cohorts?: Array<{ id: number, name: string }> | null } | null };

export type AiImpactDashboardSummaryQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  summaryType: GoalImpactCategory;
}>;


export type AiImpactDashboardSummaryQuery = { aiImpactDashboardSummary?: { copy?: string | null, bulletpoints?: Array<string | null> | null, hasError?: boolean | null } | null };

export type AllChartCategoriesQueryVariables = Exact<{
  chartId: Scalars['Int'];
}>;


export type AllChartCategoriesQuery = { allChartCategories?: Array<{ chartId: number, id: number, title: string, archivedAt?: any | null, ChartDataPoint: Array<{ archivedAt?: any | null, chartCategoryId: number, id: number, date: any, value?: number | null }> } | null> | null };

export type AllDonationPortalsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type AllDonationPortalsQuery = { allDonationPortals?: Array<{ id: number, hashedId?: string | null, name?: string | null, publishedAt?: any | null, archivedAt?: any | null } | null> | null };

export type ChartQueryVariables = Exact<{
  goalId?: InputMaybe<Scalars['Int']>;
}>;


export type ChartQuery = { chart?: { calculationType: CalculationType, id: number, target?: number | null, title: string, unitOfMeasurement: string, goalId: number, seriesData: Array<{ title: string, data: Array<{ x: string, y?: number | null } | null> } | null> } | null };

export type ChartCategoryQueryVariables = Exact<{
  chartId: Scalars['Int'];
}>;


export type ChartCategoryQuery = { chartCategory?: Array<{ chartId: number, id: number, title: string, archivedAt?: any | null, ChartDataPoint: Array<{ archivedAt?: any | null, chartCategoryId: number, id: number, date: any, value?: number | null }> } | null> | null };

export type CheckStripePromoQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type CheckStripePromoQuery = { checkStripePromo?: { promoId?: string | null, name?: string | null, percentOff?: number | null, amountOff?: number | null, couponId?: string | null } | null };

export type CommunityGuidelinesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityGuidelinesQuery = { communityGuidelines?: { isAgreed: boolean } | null };

export type CommunityTopPostsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CommunityTopPostsQuery = { communityTopPosts?: { posts: Array<{ id: number, name: string, body: string, postDate: string, likesCount: number, commentsCount: number, postLink: string, totalEngagement: number, poster: { name: string, avatarUrl?: string | null }, commenters: Array<{ name: string, avatarUrl?: string | null }> }> } | null };

export type CommunityTrendingEventsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CommunityTrendingEventsQuery = { communityTrendingEvents?: Array<{ id: number, circleEventId?: number | null, name: string, eventType?: string | null, startsAt: any, endsAt: any, rsvpCount: number, summary?: string | null, virtualLocationUrl?: string | null, body?: string | null }> | null };

export type CreateConnectAccountLinkQueryVariables = Exact<{
  stripeAccountId: Scalars['String'];
  returnUrl: Scalars['String'];
}>;


export type CreateConnectAccountLinkQuery = { createConnectAccountLink?: { url?: string | null } | null };

export type DashboardImpactReportQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type DashboardImpactReportQuery = { dashboardImpactReport?: { reportEndDate: string, reportStartDate: string, impactGoalsUrl: string, showEmptyState?: boolean | null, goalsPrioritizedByTaskCreateDate: Array<{ goalId: number, goalTitle: string, numTasks: number, numTasksCompleted: number, goalLink: string }>, funderCollaboratedGoals: Array<{ goalId: number, goalTitle: string, goalLink: string, updatedAt: any }>, tasksSummary: { totalTasksAssigned: number, totalTasksUnassigned: number, totalTasks: number, totalTasksCompletedOverall: number, totalTasksCompletedThisReportPeriod: number }, pastReportPeriodActivity: Array<{ academyResourcesViewed: number, goalCategory: string, goalsCreated: number, tasksCompleted: number }> } | null };

export type DonationPortalAndBlocksQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  hashedId?: InputMaybe<Scalars['String']>;
}>;


export type DonationPortalAndBlocksQuery = { donationPortalAndBlocks?: { id: number, nonprofitOrgId: number, createdUserId: number, updatedUserId: number, createdAt: any, updatedAt: any, publishedAt?: any | null, hashedId?: string | null, name?: string | null, availableFrequencies: Array<DonationInterval>, campaignId?: string | null, customAmountsOn: boolean, socialTitle?: string | null, socialDescription?: string | null, colorTheme: { id: number, color: string }, customAmounts?: Array<{ amountInCents?: number | null } | null> | null, DonationPortalBlock?: Array<{ id: number, assetId: number, assetType: AssetType, createdAt: any, updatedAt: any, donationPortalId: number, asset: { id: number, assetType: AssetType, createdAt: any, updatedAt: any, reusable: boolean, createdUserId: number, nonprofitOrgId: number, updatedUserId: number, assetDetails?: any | null } } | null> | null } | null };

export type EngagementDashboardQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type EngagementDashboardQuery = { engagementDashboard?: { yourCohort?: { totalCount?: number | null, activeOrgsByMonth?: Array<{ activeMonth?: string | null, n?: number | null } | null> | null, engagementData?: Array<{ orgName?: string | null, n30Days?: number | null, n90Days?: number | null } | null> | null } | null, goalsData?: { totalOrgsWithGoals?: number | null, goalsCreatedByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null, goalsUpdatedByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null } | null, coachingData?: { totalOneOnOneSessions?: number | null, oneOnOneSessionsByMonth?: Array<{ activeWeek?: string | null, n?: number | null } | null> | null, groupSessionsByMonth?: Array<{ activeWeek?: string | null, n?: number | null } | null> | null } | null, academyData?: { resourcesViewed?: number | null, templatesDownloaded?: number | null, coursesCompleted?: number | null, learningTracksCompleted?: number | null, topResources?: Array<{ resourceName?: string | null, resourceType?: string | null, totalInteractions?: number | null } | null> | null } | null, storiesData?: { orgsWithStories?: number | null, totalStories?: number | null, topStoriesByViews?: Array<{ title?: string | null, url?: string | null, n?: number | null } | null> | null } | null, donationsData?: { orgsWithCampaigns?: number | null } | null, priorityNeedsData?: { priorityNeedTopics?: Array<{ category?: string | null, totalbaselineusers?: number | null, totalcurrentusers?: number | null, baselineconfidence?: number | null, currentconfidence?: number | null, confidencechangepercent?: string | null } | null> | null, topPriorities?: Array<{ category?: string | null, userCount?: number | null, avgConfidence?: number | null } | null> | null } | null, whatTheyDoingData?: { impactCFUF?: number | null, coachingCFUF?: number | null, academyCFUF?: number | null, communityCFUF?: number | null, funderFinderCFUF?: number | null, donationsCFUF?: number | null, maosByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null } | null } | null };

export type CohortSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type CohortSectionQuery = { engagementDashboard?: { yourCohort?: { totalCount?: number | null, activeOrgsByMonth?: Array<{ activeMonth?: string | null, n?: number | null } | null> | null, engagementData?: Array<{ orgName?: string | null, n30Days?: number | null, n90Days?: number | null } | null> | null } | null } | null };

export type GoalsSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type GoalsSectionQuery = { engagementDashboard?: { goalsData?: { totalOrgsWithGoals?: number | null, goalsCreatedByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null, goalsUpdatedByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null } | null } | null };

export type CoachingSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type CoachingSectionQuery = { engagementDashboard?: { coachingData?: { totalOneOnOneSessions?: number | null, oneOnOneSessionsByMonth?: Array<{ activeWeek?: string | null, n?: number | null } | null> | null, groupSessionsByMonth?: Array<{ activeWeek?: string | null, n?: number | null } | null> | null, topCoachingTopics?: Array<{ topic?: string | null, sessionCount?: number | null } | null> | null } | null } | null };

export type AcademySectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type AcademySectionQuery = { engagementDashboard?: { academyData?: { resourcesViewed?: number | null, templatesDownloaded?: number | null, coursesCompleted?: number | null, learningTracksCompleted?: number | null, topResources?: Array<{ resourceName?: string | null, resourceType?: string | null, totalInteractions?: number | null } | null> | null } | null } | null };

export type StoriesSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type StoriesSectionQuery = { engagementDashboard?: { storiesData?: { orgsWithStories?: number | null, totalStories?: number | null, topStoriesByViews?: Array<{ title?: string | null, url?: string | null, n?: number | null } | null> | null } | null } | null };

export type DonationsSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type DonationsSectionQuery = { engagementDashboard?: { donationsData?: { orgsWithCampaigns?: number | null } | null } | null };

export type TopPrioritiesSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type TopPrioritiesSectionQuery = { engagementDashboard?: { priorityNeedsData?: { topPriorities?: Array<{ category?: string | null, userCount?: number | null, avgConfidence?: number | null } | null> | null } | null } | null };

export type WhatTheyDoingSectionQueryVariables = Exact<{
  cohortId?: InputMaybe<Scalars['Int']>;
  timePeriod?: InputMaybe<TimePeriod>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type WhatTheyDoingSectionQuery = { engagementDashboard?: { whatTheyDoingData?: { impactCFUF?: number | null, coachingCFUF?: number | null, academyCFUF?: number | null, communityCFUF?: number | null, funderFinderCFUF?: number | null, donationsCFUF?: number | null, maosByMonth?: Array<{ activeMonthStart?: string | null, n?: number | null } | null> | null } | null } | null };

export type GetFeedItemsQueryVariables = Exact<{
  input: GetFeedItemsInput;
}>;


export type GetFeedItemsQuery = { getFeedItems?: { totalCount: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ id: number, userId: number, type: FeedItemType, activityEntityType: FeedEntityType, activityType: FeedActivityType, title: string, category: FeedItemCategory, body: string, callToActionLink?: string | null, callToActionText?: string | null, createdAt: any, eventAt?: any | null, updatedAt?: any | null, seenOnDate?: any | null, interactedAt?: any | null, dismissedAt?: any | null, parameters?: any | null, user?: { id: number, firstName: string, lastName: string } | null }> } | null };

export type GetFeedItemsByTypeQueryVariables = Exact<{
  type: FeedItemType;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetFeedItemsByTypeQuery = { getFeedItemsByType?: { totalCount: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ id: number, userId: number, type: FeedItemType, activityEntityType: FeedEntityType, activityType: FeedActivityType, title: string, category: FeedItemCategory, body: string, callToActionLink?: string | null, callToActionText?: string | null, createdAt: any, eventAt?: any | null, updatedAt?: any | null, seenOnDate?: any | null, interactedAt?: any | null, dismissedAt?: any | null, parameters?: any | null, user?: { id: number, firstName: string, lastName: string } | null }> } | null };

export type GetFeedItemsByCategoryQueryVariables = Exact<{
  category: FeedItemCategory;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetFeedItemsByCategoryQuery = { getFeedItemsByCategory?: { totalCount: number, hasMore: boolean, nextCursor?: string | null, items: Array<{ id: number, userId: number, type: FeedItemType, activityEntityType: FeedEntityType, activityType: FeedActivityType, title: string, category: FeedItemCategory, body: string, callToActionLink?: string | null, callToActionText?: string | null, createdAt: any, eventAt?: any | null, updatedAt?: any | null, seenOnDate?: any | null, interactedAt?: any | null, dismissedAt?: any | null, parameters?: any | null, user?: { id: number, firstName: string, lastName: string } | null }> } | null };

export type GetUnreadFeedItemsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadFeedItemsCountQuery = { getUnreadFeedItemsCount: number };

export type MarkFeedItemSeenMutationVariables = Exact<{
  feedItemId: Scalars['Int'];
}>;


export type MarkFeedItemSeenMutation = { markFeedItemSeen?: { id: number, seenOnDate?: any | null, updatedAt?: any | null } | null };

export type MarkFeedItemInteractedMutationVariables = Exact<{
  feedItemId: Scalars['Int'];
}>;


export type MarkFeedItemInteractedMutation = { markFeedItemInteracted?: { id: number, interactedAt?: any | null, updatedAt?: any | null } | null };

export type DismissFeedItemMutationVariables = Exact<{
  feedItemId: Scalars['Int'];
}>;


export type DismissFeedItemMutation = { dismissFeedItem?: { id: number, dismissedAt?: any | null, updatedAt?: any | null } | null };

export type CreateFeedItemMutationVariables = Exact<{
  input: CreateFeedItemInput;
}>;


export type CreateFeedItemMutation = { createFeedItem?: { id: number, userId: number, type: FeedItemType, activityEntityType: FeedEntityType, activityType: FeedActivityType, title: string, category: FeedItemCategory, body: string, callToActionLink?: string | null, callToActionText?: string | null, createdAt: any, eventAt?: any | null, parameters?: any | null, user?: { id: number, firstName: string, lastName: string } | null } | null };

export type FunderDashboardFiltersQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
}>;


export type FunderDashboardFiltersQuery = { funderDashboardFilters?: { cohorts: Array<{ type: FilterType, label: string, nonprofitOrgIds: Array<number>, value: number }>, missionAreas: Array<{ type: FilterType, label: string, nonprofitOrgIds: Array<number>, value: number }> } | null };

export type FundersQueryVariables = Exact<{ [key: string]: never; }>;


export type FundersQuery = { funders?: Array<{ id: number, name?: string | null } | null> | null };

export type GenerateInternalFunderReportQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  dateOverride?: InputMaybe<Scalars['String']>;
  skipEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateInternalFunderReportQuery = { generateInternalFunderReport?: { generated?: boolean | null } | null };

export type GenerateGoalsQueryQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GenerateGoalsQueryQuery = { generateGoals: Array<{ title: string, description: string, unit: string, target: string }> };

export type GetAiOptimizedCopyQueryVariables = Exact<{
  prompt: PromptInput;
  optimizationType: OptimizationType;
  orgId: Scalars['Int'];
}>;


export type GetAiOptimizedCopyQuery = { getAiOptimizedCopy?: { headline?: string | null, description?: string | null, hasError?: boolean | null } | null };

export type GetAiOptimizedStoryQueryVariables = Exact<{
  prompt: StoryPromptInput;
  orgId: Scalars['Int'];
  goalId?: InputMaybe<Scalars['Int']>;
}>;


export type GetAiOptimizedStoryQuery = { getAiOptimizedStory?: { template?: Array<AssetType> | null, hasError?: boolean | null, blocks?: Array<{ buttonText?: string | null, note?: string | null, url?: string | null, type?: string | null } | { cloudinaryFileId?: string | null, type?: string | null } | { entityMap?: any | null, type?: string | null, blocks?: Array<{ key?: string | null, data?: any | null, text?: string | null, type?: string | null, depth?: number | null, entityRanges?: any | null, inlineStyleRanges?: any | null } | null> | null }> | null } | null };

export type AssetQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type AssetQuery = { Asset?: Array<{ id: number, assetType: AssetType, assetDetails?: any | null, createdUserId: number, updatedUserId: number, createdAt: any, updatedAt: any } | null> | null };

export type GetAutoStoriesSettingsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetAutoStoriesSettingsQuery = { autoStoriesSettings?: { nonprofitOrgId: number, autoStoriesEnabled: boolean, notifyEmails?: Array<string | null> | null, lastScan?: any | null, socialUrls?: Array<{ platform: SocialMediaPlatform, url: string } | null> | null } | null };

export type GetBoxConfigQueryVariables = Exact<{
  userId: Scalars['Int'];
  orgId: Scalars['Int'];
}>;


export type GetBoxConfigQuery = { getBoxConfig?: { boxId?: string | null, tokenData?: { accessToken?: string | null, expiresIn?: string | null, acquiredAt?: string | null } | null } | null };

export type CampaignGatingQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type CampaignGatingQuery = { campaignGating?: { limit?: number | null, limitCycle?: string | null, numberOfCampaignsUsed?: number | null } | null };

export type CampaignsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  createdAfter?: InputMaybe<Scalars['Int']>;
}>;


export type CampaignsQuery = { campaigns?: Array<{ id?: string | null, nonprofitOrgId?: number | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, archivedAt?: any | null, createdUserId?: number | null, updatedUserId?: number | null, publishedAt?: any | null, fundraisingTarget?: number | null, portalId?: number | null, hashedPortalId?: string | null, initiativeGoalId?: number | null, draftGoalName?: string | null, draftObjectiveName?: string | null, firstPublishedAt?: any | null, donations?: Array<{ id: string, donorStripeAccountId: string, createdAt: any, amount: number, netAmount: number, refunded: boolean, disputed: boolean } | null> | null } | null> | null };

export type GetCategoryByTitleQueryVariables = Exact<{
  chartId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type GetCategoryByTitleQuery = { categoryByTitle?: { id: number, chartId: number, title: string, archivedAt?: any | null } | null };

export type CheckoutSessionDataQueryVariables = Exact<{
  sessionId: Scalars['String'];
  portalId: Scalars['String'];
}>;


export type CheckoutSessionDataQuery = { checkoutSessionData?: { email?: string | null, chargedAmount?: number | null, donationAmount?: number | null, feeAmount?: number | null, feeCovered?: boolean | null, date?: any | null, expiresAt?: any | null, redirectUrl?: string | null, orgLegalName?: string | null, ein?: string | null, orgAddress?: string | null, billingPortalUrl?: string | null, nextBillingDate?: any | null, statementDescriptor?: string | null } | null };

export type GetCloudinaryAssetsQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetCloudinaryAssetsQuery = { getCloudinaryAssets?: Array<{ cloudinary_public_file_id?: string | null } | null> | null };

export type CohortQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type CohortQuery = { cohort?: { id: number, name: string, startDate?: any | null, endDate?: any | null, createdAt: any, updatedAt: any, memberRoles: Array<string>, cohortOwnerships?: Array<{ id?: number | null, funderOrg?: { id: number, name?: string | null, disabled: boolean } | null } | null> | null, cohortMemberships?: Array<{ id?: number | null, startDate?: any | null, endDate?: any | null, nonprofitOrg?: { id: number, name?: string | null } | null } | null> | null } | null };

export type ColorThemeQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorThemeQuery = { colorTheme: Array<{ id: number, color: string }> };

export type CommunityEventsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<CommunityEventsFilterOption>;
}>;


export type CommunityEventsQuery = { communityEvents?: Array<{ name: string, url?: string | null, startsAt: any, endsAt: any }> | null };

export type ComplianceDocumentsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  folderId?: InputMaybe<Scalars['String']>;
}>;


export type ComplianceDocumentsQuery = { complianceDocuments?: { folderId?: string | null, files?: Array<{ id?: string | null, etag?: string | null, created_at?: string | null, downloadUrl?: string | null, complianceDocType?: string | null }> | null } | null };

export type GetDimensionsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetDimensionsQuery = { getDimensions?: Array<{ id: number, title: string, isHidden: boolean } | null> | null };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { getFeatureFlags?: { featureFlags?: Array<string | null> | null } | null };

export type FeatureGatingLimitQueryVariables = Exact<{
  planName: Scalars['String'];
}>;


export type FeatureGatingLimitQuery = { featureGatingLimit?: Array<{ featureName?: string | null, visible?: boolean | null, lowestPlanTier?: string | null, limit?: number | null } | null> | null };

export type FunderOrgQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FunderOrgQuery = { funderOrg?: { id: number, name?: string | null, disabled: boolean, isTest: boolean, createdAt: any, updatedAt: any, disabledAt?: any | null, nonprofitOrgs?: Array<{ id: number, name?: string | null } | null> | null, cohorts?: Array<{ id?: number | null, name?: string | null } | null> | null, users?: Array<{ id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } | null };

export type FunderOrgCohortQueryQueryVariables = Exact<{
  funderEmail?: InputMaybe<Scalars['String']>;
  funderOrgId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgIds: Array<Scalars['Int']> | Scalars['Int'];
  returnAllNonprofitsInCohort?: InputMaybe<Scalars['Boolean']>;
}>;


export type FunderOrgCohortQueryQuery = { funderOrgCohortQuery?: { funderOrgId?: number | null, nonprofitOrgs: Array<{ id: number, name?: string | null } | null> } | null };

export type GetFunderOrgConfigQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetFunderOrgConfigQuery = { funderOrgConfig?: { orgName?: string | null, orgId?: number | null, shellAppRedirectEnabled?: boolean | null, sponsoredNonprofits?: Array<{ nonprofitOrgId?: number | null, name?: string | null }> | null, user?: { id: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, role?: string | null, funderOrgRole?: string | null } | {} | null } | null };

export type GetFunderOrgDetailsQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
}>;


export type GetFunderOrgDetailsQuery = { funderOrgDetails?: { orgName?: string | null } | null };

export type GetFunderOrgToNonprofitQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetFunderOrgToNonprofitQuery = { funderOrgToNonprofit?: { id: number, name?: string | null, createdAt?: any | null, updatedAt?: any | null, disabledAt?: any | null } | null };

export type GetFunderOrgToNonprofitOrgQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetFunderOrgToNonprofitOrgQuery = { funderOrgToNonprofitOrg?: { nonprofitOrgId?: number | null, funderOrgId?: number | null } | null };

export type GetNonprofitPreonboardingQueryVariables = Exact<{
  funderOrgId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
}>;


export type GetNonprofitPreonboardingQuery = { getNonprofitPreonboarding?: Array<{ createdAt: any, funderOrgId: number, id?: number | null, orgName: string, status?: NonprofitPreonboardingStatus | null, impactIntelligenceStatus?: NonprofitImpactIntelligencePreonboardingStatus | null, updatedAt: any } | null> | null };

export type FundingOrg990QueryVariables = Exact<{
  fundingOrg990Id: Scalars['Int'];
}>;


export type FundingOrg990Query = { fundingOrg990?: { id?: number | null, ein?: number | null, organizationName?: string | null, address?: string | null, city?: string | null, state?: string | null, website?: string | null, assets?: number | null, incomeAmount?: number | null, nteeCode?: string | null, nteeDescription?: any | null, locationsOfImpact?: any | null, grantCount?: number | null, grantMax?: number | null, grantMin?: number | null, grantAverage?: number | null, grantTotalAmount?: number | null, grants?: any | null, grantsToPreselectedOnly?: boolean | null, people?: any | null, taxYear?: number | null, createdDate?: any | null, active?: boolean | null } | null };

export type FunderProfileViewLimitsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type FunderProfileViewLimitsQuery = { funderProfileViewLimits?: { visible?: boolean | null, limitExpiryDate?: any | null, limit?: number | null, used?: number | null, available?: number | null, viewedFunderEins?: Array<number | null> | null } | null };

export type GetFunderUsersQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
}>;


export type GetFunderUsersQuery = { getFunderUsers?: Array<{ role?: string | null, funderOrgRole?: string | null, lastInviteSentAt?: any | null, funderOrgId?: number | null, user?: { id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null };

export type GetGroupCoachingEventsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetGroupCoachingEventsQuery = { groupCoachingEvents: Array<{ id: number, name: string, userId: number, createdAt: any, updatedAt: any, startsAt: any, endsAt: any, duration?: number | null, bookingUrl?: string | null, slug: string, hideAttendees: boolean, body?: string | null, googleCalendarId?: string | null, googleCalendarLink?: string | null, focusArea?: string | null, coachName?: string | null, recordingLink?: string | null, meetingBody?: string | null, meetingTitle?: string | null, activityType?: ActivityType | null, videoConferenceUrl?: string | null, transcript?: string | null, summary?: string | null, status?: OneOnOneCoachingEventStatus | null, userRsvpStatus?: string | null, userRsvpNotes?: string | null, circleEventId?: number | null, circleEventUrl?: string | null, user?: { id: number } | null, attendees?: Array<{ id: number } | null> | null }> };

export type GetOneOnOneCoachingEventsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetOneOnOneCoachingEventsQuery = { oneOnOneCoachingEvents?: Array<{ id: number, startsAt: any, endsAt: any, contactEmail: string, contactName: string, userSlug: string, meetingBody?: string | null, activityType?: string | null, meetingTitle?: string | null, organizerName?: string | null, duration?: number | null, videoConferenceUrl?: string | null, transcript?: string | null, summary?: string | null, status?: OneOnOneCoachingEventStatus | null, goals?: Array<{ id: number, title: string } | null> | null } | null> | null };

export type GetInitiativesQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  planName: Scalars['String'];
}>;


export type GetInitiativesQuery = { getInitiatives?: { reportedMetricGroups?: Array<{ id: number, title: string, createdAt: any, archivedAt?: any | null, Goal: Array<{ updatedAt: any, id: number, type: GoalType, title: string, category?: GoalCategory | null, metric?: MetricType | null, unitOfMeasurement?: string | null, target?: number | null, templateLibraryId?: number | null, createdAt: any, archivedAt?: any | null, GoalToDimension: Array<{ id: number, displayOrder: number, dimension: { title: string, updatedAt: any, lastUpdatedUser?: { firstName: string, lastName: string } | null } }>, lastUpdatedUser?: { firstName: string, lastName: string } | null, owner?: { id: number, firstName: string, lastName: string } | null, GoalUpdate: Array<{ id: number, description: string, updatedAt: any, reportedAt: any, goalId: number, lastUpdatedUser: { firstName: string, lastName: string } }>, EntryGroup: Array<{ id: number, details?: string | null, reportedAt: any, archivedAt?: any | null, updatedAt: any, lastUpdatedUser?: { firstName: string, lastName: string } | null, Entry: Array<{ id: number, value: number, updatedAt: any, goalToDimension: { dimension: { id: number, title: string, updatedAt: any, lastUpdatedUser?: { firstName: string, lastName: string } | null } }, lastUpdatedUser?: { firstName: string, lastName: string } | null }> }>, ChecklistItem: Array<{ id: number, title: string, isCompleted?: boolean | null, updatedAt: any, resourceId?: string | null, linkText?: string | null, linkUrl?: string | null, dueDate?: string | null, lastUpdatedUser: { id: number, firstName: string, lastName: string }, owner?: { id: number, firstName: string, lastName: string } | null }> }> } | null> | null, reportedMetricGatingLimit?: { selfReportingInitiatives: { available?: number | null, limit?: number | null, used?: number | null, visible?: boolean | null }, selfReportingGoals: { available?: number | null, limit?: number | null, used?: number | null, visible?: boolean | null } } | null } | null };

export type GetInternalFunderReportQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
}>;


export type GetInternalFunderReportQuery = { getInternalFunderReport?: { aggregateData?: any | null, summaryData?: any | null, reportData?: any | null } | null };

export type GetJobExecutionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetJobExecutionQuery = { jobExecution?: { id: string, jobName: string, status: JobStatus, payload?: any | null, result?: any | null, errorMessage?: string | null, errorStack?: string | null, createdAt: any, startedAt?: any | null, completedAt?: any | null, duration?: number | null, createdByUserId?: number | null, organizationId?: number | null, createdByUser?: { id: number, firstName: string, lastName: string } | null } | null };

export type GetJobStatsQueryVariables = Exact<{
  hoursBack?: InputMaybe<Scalars['Int']>;
}>;


export type GetJobStatsQuery = { jobStats?: { jobStats: Array<{ jobName: string, total: number, pending: number, running: number, completed: number, failed: number, successRate: number }> } | null };

export type GetLatestFinancialHealthAssessmentReportQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetLatestFinancialHealthAssessmentReportQuery = { getLatestFinancialHealthAssessmentReport?: { runId: string, status: MurdocReportRunStatus, reportSlug?: string | null, progressUrl?: string | null, userId: number, reportData?: any | null } | null };

export type GetMurdocReportQueryVariables = Exact<{
  runId: Scalars['String'];
}>;


export type GetMurdocReportQuery = { getMurdocReport?: { runId: string, markdown: string, visualizations: Array<any>, citations: Array<any>, metadata: any, downloadUrl?: string | null, downloadFormat?: string | null, downloadExpiresAt?: any | null, status: MurdocReportRunStatus } | null };

export type GetMurdocReportRunStatusQueryVariables = Exact<{
  runId: Scalars['String'];
}>;


export type GetMurdocReportRunStatusQuery = { getMurdocReportRunStatus?: { runId: string, status: MurdocReportRunStatus, reportSlug?: string | null, userId: number } | null };

export type GetMurdocStoryOpportunitiesQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  socialUrls?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetMurdocStoryOpportunitiesQuery = { getMurdocStoryOpportunities?: { generatedAt?: string | null, summary?: string | null, warnings?: Array<string> | null, opportunities: Array<{ title: string, category: StoryOpportunityCategoryType, relevanceScore: number, sourcePlatform: StoryOpportunitySourcePlatform, sourceUrl?: string | null, contentExcerpt?: string | null, suggestedAngle?: string | null }>, orgContext?: { name?: string | null, mission?: string | null, state?: string | null, focusAreas?: Array<string> | null } | null } | null };

export type GetMyMcpApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMcpApiKeysQuery = { getMyMcpApiKeys: Array<{ id: string, name?: string | null, key?: string | null, createdAt: any, expiresAt?: any | null, revokedAt?: any | null, lastUsedAt?: any | null }> };

export type GetNonprofitByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetNonprofitByIdQuery = { getNonprofitOrg?: { id: number, name?: string | null, missionStatement?: string | null, disabled: boolean, formationPlan?: FormationPlan | null, platformPlan?: PlatformPlan | null, ein?: string | null, legalName?: string | null, websiteUrl?: string | null, isFiscallySponsored?: boolean | null, isTest: boolean, state?: string | null, yearEstablished?: number | null, createdAt: any, updatedAt: any, disabledAt?: any | null, hasProfile?: boolean | null, funders?: Array<{ id: number, name?: string | null } | null> | null, cohorts?: Array<{ id: number, name: string } | null> | null, users?: Array<{ id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null } | null> | null } | null };

export type NonprofitDeiInitiativesQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitDeiInitiativesQuery = { nonprofitDeiInitiatives?: { id?: number | null, description?: string | null, category?: string | null } | null };

export type GetNonprofitOrgBillingDetailsQueryVariables = Exact<{
  customerId: Scalars['String'];
  platformPlan?: InputMaybe<PlatformPlan>;
  formationPlan?: InputMaybe<FormationPlan>;
}>;


export type GetNonprofitOrgBillingDetailsQuery = { getNonprofitOrgBillingDetails?: { platformCost: number, formationCost?: number | null, trialEnd?: number | null, nextBillingDate: number, isTrialing: boolean, isLegacyPricing: boolean } | null };

export type NonprofitBoardDevelopmentQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitBoardDevelopmentQuery = { nonprofitBoard?: { id?: number | null, developmentStrategy?: string | null, developmentInitiatives?: string | null } | null };

export type NonprofitBoardRepresentationQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitBoardRepresentationQuery = { nonprofitBoard?: { id?: number | null, representation?: string | null } | null };

export type GetNonprofitOrgConfigQueryVariables = Exact<{
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
}>;


export type GetNonprofitOrgConfigQuery = { nonprofitOrg?: { orgName?: string | null, orgId?: number | null, legalName?: string | null, role?: NonprofitOrgToUserRole | null, formationPlan?: string | null, platformPlan?: string | null, stripeConnectId?: string | null, isStripeConnectActive?: boolean | null, permissions?: Array<string | null> | null, logoBoxId?: string | null, websiteUrl?: string | null, nonprofitOrgRole?: NonprofitOrgRole | null, hasTaxExemptStatusAtSignup?: boolean | null, ein?: string | null, isFiscallySponsored?: boolean | null, is501c3Verified?: boolean | null, isBipocLed?: boolean | null, isBipocServing?: boolean | null, yearEstablished?: number | null, address?: any | null, featureFlags?: Array<string | null> | null, logoCloudinaryFileId?: string | null, paidStaffSizeRange?: PaidStaffSizeRange | null, volunteerSizeRange?: VolunteerSizeRange | null, numBoardMembers?: number | null, numTeamMembers?: number | null, donationPortalId?: number | null, donationPortalHashedId?: string | null, isFounder?: boolean | null, donationFeePercent?: number | null, missionStatement?: string | null, taxExemptionStatus?: string | null, platformPlanAddOns?: Array<string | null> | null, funderOrgId?: number | null, activeFunders?: Array<number | null> | null, shellAppRedirectEnabled?: boolean | null, user?: { id: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, nonprofitExperienceRange?: NonprofitExperienceRange | null, updatedAt?: any | null } | null, stripeConnectIssues?: { errors?: Array<any | null> | null, resumeKYCUrl?: string | null, pendingVerification?: Array<string | null> | null, missingBusinessUrl?: boolean | null } | null } | null };

export type NonprofitOrgDonationsDetailsQueryVariables = Exact<{
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
}>;


export type NonprofitOrgDonationsDetailsQuery = { nonprofitOrgDonationsDetails?: { state: NonprofitOrgDonationsState, onboardingUrl?: string | null, errors: Array<{ code: string } | null> } | null };

export type NonprofitOrgFinancialDetailsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgFinancialDetailsQuery = { nonprofitOrgFinancialDetails?: { id: number, nonprofitOrgId: number, isFundingDiverse?: boolean | null, isFundingRecurring?: boolean | null, budgetRange?: BudgetRange | null } | null };

export type NonprofitOrgTeamQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  planName: Scalars['String'];
}>;


export type NonprofitOrgTeamQuery = { nonprofitOrgTeam?: { users?: Array<{ nonprofitOrgId: number, lastInviteSentAt?: any | null, role: NonprofitOrgToUserRole, nonprofitOrgRole?: NonprofitOrgRole | null, userId?: number | null, user?: { firstName?: string | null, lastName?: string | null, id?: number | null, email?: string | null, createdAt?: any | null, updatedAt?: any | null } | null } | null> | null, limits?: { visible?: boolean | null, limit?: number | null, used?: number | null, available?: number | null, lowestPlanTier?: string | null } | null } | null };

export type NonprofitOrgToNteeCodeQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgToNteeCodeQuery = { nonprofitOrgToNteeCode?: Array<{ id: number, nteeCodeId: number } | null> | null };

export type NonprofitOrgToStaffCalssificationTypeQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgToStaffCalssificationTypeQuery = { nonprofitOrgToStaffClassificationType?: Array<{ id: number, staffClassificationTypeId: number } | null> | null };

export type GetNonprofitOrgToUserToResponsibilityQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetNonprofitOrgToUserToResponsibilityQuery = { getNonprofitOrgToUserToResponsibility?: Array<{ responsibilityId: number, responsibility: { description: string } } | null> | null };

export type NonprofitOrgToUserQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgToUserQuery = { nonprofitOrgToUser?: Array<{ nonprofitOrgId: number, role: NonprofitOrgToUserRole, userId?: number | null, user?: { firstName?: string | null, lastName?: string | null, id?: number | null, email?: string | null, createdAt?: any | null } | null } | null> | null };

export type GetNonprofitOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonprofitOrgsQuery = { getNonprofitOrgs?: Array<{ id: number, name?: string | null }> | null };

export type NonprofitUserEventQueryVariables = Exact<{
  eventNames: Array<Scalars['String']> | Scalars['String'];
}>;


export type NonprofitUserEventQuery = { nonprofitUserEvent?: Array<{ id: number, userId?: number | null, eventName?: string | null, eventTimeStamp: any, eventProperties: any } | null> | null };

export type GetNotificationsQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
}>;


export type GetNotificationsQuery = { getNotifications?: Array<{ type: NotificationType, details?: { last4?: string | null } | null } | null> | null };

export type NteeCodeMajorGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type NteeCodeMajorGroupQuery = { nteeCodeMajorGroup?: Array<{ id: number, description: string } | null> | null };

export type GetPresetGuestTokenQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  presetDashboardId: Scalars['String'];
}>;


export type GetPresetGuestTokenQuery = { getPresetGuestToken?: string | null };

export type GetQuickBooksConnectionQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetQuickBooksConnectionQuery = { quickBooksConnection?: { id: string, nonprofitOrgId: number, companyName: string, status: QuickBooksConnectionStatus, connectedAt: any, lastDataFetch?: any | null, needsReauth: boolean } | null };

export type GetRecentFunderReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecentFunderReportsQuery = { getRecentFunderReports: Array<{ funderOrgId?: number | null, createdAt?: any | null, targetDate?: string | null } | null> };

export type RecommendedFundersForNonprofitQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type RecommendedFundersForNonprofitQuery = { recommendedFundersForNonprofit?: Array<{ ein?: number | null, organizationName?: string | null, locationsOfImpact?: any | null, nteeDescription?: any | null, grantCount?: number | null, grantTotalAmount?: number | null, grantAverage?: number | null, state?: string | null, matchPercentage?: number | null } | null> | null };

export type ReportedMetricGroupQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type ReportedMetricGroupQuery = { reportedMetricGroup?: Array<{ id: number, title: string, start?: any | null, end?: any | null } | null> | null };

export type GetResponsibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResponsibilityQuery = { getResponsibility?: Array<{ id: number, description: string, displayOrder: number } | null> | null };

export type SavedFunderLimitsQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type SavedFunderLimitsQuery = { savedFunderLimits?: { visible?: boolean | null, limit?: number | null, used?: number | null, available?: number | null } | null };

export type NonprofitOrgToSavedFundingOrg990QueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgToSavedFundingOrg990Query = { nonprofitOrgToSavedFundingOrg990?: Array<{ nonprofitOrgId?: number | null, fundingOrg990Id?: number | null, fundingOrg990?: { ein?: number | null, organizationName?: string | null, grantsToPreselectedOnly?: boolean | null, nteeDescription?: any | null, city?: string | null, state?: string | null, locationsOfImpact?: any | null, grantAverage?: number | null } | null } | null> | null };

export type GetShellAppRedirectQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShellAppRedirectQuery = { shellAppRedirectEnabled: boolean };

export type StaffClassificationTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type StaffClassificationTypeQuery = { staffClassificationType?: Array<{ id: number, description: string } | null> | null };

export type StoryQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  storyId?: InputMaybe<Scalars['Int']>;
  hashedId?: InputMaybe<Scalars['String']>;
  includeBlocks?: Scalars['Boolean'];
}>;


export type StoryQuery = { Story?: Array<{ id: number, nonprofitOrgId: number, userId: number, templateUsed: TemplateUsedType, title: string, urlTitle?: string | null, hashedId?: string | null, publishedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, showHeader: boolean, showTableOfContents: boolean, headerLogoImgUrl?: string | null, headerWebsiteUrl?: string | null, previewTitle?: string | null, previewDescription?: string | null, previewImageId?: string | null, previewImageCloudinaryFileId?: string | null, goalId?: number | null, donationPortalId?: string | null, viewCount?: number | null, ctaClickCount?: number | null, nonprofitOrgName?: string | null, cloudinaryLogoId?: string | null, colorTheme?: { id: number, color: string } | null, blocks?: Array<{ id: number, storyId: number, assetId: number, assetType: AssetType, order: number, createdAt: any, updatedAt: any, backgroundColor?: string | null, asset: { id: number, assetType: AssetType, reusable: boolean, assetDetails?: any | null, nonprofitOrgId: number, createdUserId: number, updatedUserId: number, createdAt: any, updatedAt: any } } | null> | null } | null> | null };

export type GetStoriesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
}>;


export type GetStoriesQuery = { getStories?: Array<{ id?: number | null, templateUsed: TemplateUsedType, title?: string | null, hashedId?: string | null, publishedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, archivedAt?: any | null, viewCount: number, ctaClickCount: number, hasClickTrackableBlock: boolean, FunderOrgs?: Array<{ id?: number | null, name?: string | null } | null> | null } | null> | null };

export type StoriesSharedWithFunderOrgQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  cohortId?: InputMaybe<Scalars['Int']>;
}>;


export type StoriesSharedWithFunderOrgQuery = { StoriesSharedWithFunderOrg?: Array<{ id: number, nonprofitOrgId: number, nonprofitOrgName?: string | null, userId: number, templateUsed: TemplateUsedType, title: string, hashedId?: string | null, publishedAt?: any | null, createdAt: any, updatedAt: any, archivedAt?: any | null, showHeader: boolean, sharedAt?: any | null, headerLogoImgUrl?: string | null, headerWebsiteUrl?: string | null, previewTitle?: string | null, previewDescription?: string | null, previewImageId?: string | null, previewImageCloudinaryFileId?: string | null, goalId?: number | null, donationPortalId?: string | null, colorTheme?: { id: number, color: string } | null, blocks?: Array<{ id: number, storyId: number, assetId: number, assetType: AssetType, order: number, createdAt: any, updatedAt: any, asset: { id: number, assetType: AssetType, reusable: boolean, assetDetails?: any | null, nonprofitOrgId: number, createdUserId: number, updatedUserId: number, createdAt: any, updatedAt: any } } | null> | null } | null> | null };

export type StoryGatingQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type StoryGatingQuery = { storyGating?: { limit?: number | null, limitCycle?: string | null, numberOfStoriesUsed?: number | null } | null };

export type GetChangePlanPortalLinksQueryVariables = Exact<{
  stripeCustomerId: Scalars['String'];
  returnUrl: Scalars['String'];
}>;


export type GetChangePlanPortalLinksQuery = { getChangePlanPortalLinks?: { starter?: string | null, performance?: string | null, isTrialing?: boolean | null, trialEnd?: number | null } | null };

export type GetStripeConnectAccountQueryVariables = Exact<{
  stripeAccountId: Scalars['String'];
}>;


export type GetStripeConnectAccountQuery = { getStripeConnectAccount?: { id?: string | null, payouts_enabled?: boolean | null, bankAccount?: { routingNumber?: string | null, last4?: string | null } | null, capabilities?: { transfers?: string | null, card_payments?: string | null } | null } | null };

export type GetFilteredNonprofitTransactionsQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  page?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Filters>;
}>;


export type GetFilteredNonprofitTransactionsQuery = { getFilteredNonprofitTransactions?: { nextPage?: string | null, transactions?: Array<{ refundIds: Array<string | null>, disputeId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | null> | null } | null };

export type GetNonprofitDonationSummaryQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  createdAfter?: InputMaybe<Scalars['Int']>;
}>;


export type GetNonprofitDonationSummaryQuery = { getNonprofitDonationSummary?: { netRaised: number, donationCount: number, average: number, transactionCount: number } | null };

export type GetNonprofitDonationsQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  createdAfter?: InputMaybe<Scalars['Int']>;
}>;


export type GetNonprofitDonationsQuery = { getNonprofitDonations?: Array<{ id?: string | null, amount?: number | null, fee?: number | null, net?: number | null, application_fee_amount?: number | null, created?: number | null, currency?: string | null, description?: string | null, object?: string | null, status?: string | null, last4?: string | null, funding?: string | null, paymentMethod?: string | null, brand?: string | null, refundDetails?: any | null, disputeDetails?: any | null, type?: string | null, metadata?: { donor?: string | null, donorEmail?: string | null, storyId?: string | null, storyTitle?: string | null, honoree?: string | null, honoreeEmail?: string | null, imageId?: string | null } | null } | null> | null };

export type GetNonprofitTransactionQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  transactionId: Scalars['String'];
}>;


export type GetNonprofitTransactionQuery = { getNonprofitTransaction?: { refundIds: Array<string | null>, disputeId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, donor?: string | null, donorEmail?: string | null, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | null };

export type GetNonprofitTransactionsQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  createdAfter?: InputMaybe<Scalars['Int']>;
  startingAfter?: InputMaybe<Scalars['String']>;
}>;


export type GetNonprofitTransactionsQuery = { getNonprofitTransactions?: { hasMore?: boolean | null, transactions?: Array<{ refundIds: Array<string | null>, disputeId?: string | null, disputeFeeId?: string | null, disputeReversalId?: string | null, disputeFeeReversalId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, disputeFeeId?: string | null, disputeReversalId?: string | null, disputeFeeReversalId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, disputeId?: string | null, disputeReversalId?: string | null, disputeFeeReversalId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, disputeId?: string | null, disputeFeeId?: string | null, disputeReversalId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, disputeId?: string | null, disputeFeeId?: string | null, disputeFeeReversalId?: string | null, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | { chargeId: string, id: string, amount: number, balanceTransactionId?: string | null, fee: number, net: number, created: number, status: NonprofitTransactionStatus, paymentMethod?: NonprofitTransactionPaymentMethod | null, isAnonymousDonation?: boolean | null, donor?: string | null, donorEmail?: string | null, disputeStatus: NonprofitTransactionDisputeStatus, honoree?: string | null, honoreeEmail?: string | null, feeCovered: boolean, campaignId?: string | null, isRecurring: boolean, type: NonprofitTransactionType, card?: { last4: string, brand: NonprofitTransactionCardBrand, fundingType: NonprofitTransactionCardFundingType } | null, donorAddress?: { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null } | null, story?: { id: string, title?: string | null, imageId?: string | null } | null, recurrenceDetails?: { interval: NonprofitTransactionRecurrenceDetailsInterval, status: NonprofitTransactionRecurrenceDetailsStatus } | null } | null> | null } | null };

export type GetStripePriceQueryVariables = Exact<{
  platformPlan: PlatformPlan;
  formationPlan?: InputMaybe<FormationPlan>;
}>;


export type GetStripePriceQuery = { getStripePrice?: { platformPrice?: number | null, formationPrice?: number | null } | null };

export type GetTasksQueryVariables = Exact<{
  isCompleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetTasksQuery = { getTasks: Array<{ id: number, goalId: number, title: string, isCompleted?: boolean | null, updatedAt: any, resourceId?: string | null, linkUrl?: string | null, linkText?: string | null }> };

export type GetTaxExemptionStatusQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetTaxExemptionStatusQuery = { getTaxExemptionStatus?: { status: TaxExemptionStatusTypes } | null };

export type GetTemplateLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplateLibraryQuery = { getTemplateLibrary: Array<{ id: number, appcuesFlowId?: string | null, createdAt: any, updatedAt: any, archivedAt?: any | null, showInListing: boolean, description?: string | null, checklistItemTemplate: Array<{ id: number, title: string, resourceId?: string | null, displayOrder: number, linkText?: string | null, linkUrl?: string | null, templateLibraryId: number, createdAt: any, updatedAt: any }>, goalTemplate: Array<{ id: number, title: string, category?: GoalCategory | null }> }> };

export type GetThirdPartyNonprofitOrgConfigQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetThirdPartyNonprofitOrgConfigQuery = { getThirdPartyNonprofitOrgConfig?: { nonprofitOrgId?: number | null, stripeCustomerId?: string | null } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetUserByIdQuery = { getUserById?: { id: number, email: string, firstName: string, lastName: string, phone?: string | null, disabled: boolean, isTest: boolean, createdAt?: any | null, updatedAt?: any | null, disabledAt?: any | null, lastLoggedInAt?: any | null, nonprofitExperienceRange?: string | null, nonprofitOrgs?: Array<{ id: number, name?: string | null, disabled: boolean, isTest: boolean } | null> | null, funderOrgs?: Array<{ id: number, name?: string | null, disabled: boolean, isTest: boolean } | null> | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { user?: { createdAt?: any | null, id: number, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, nonprofitExperienceRange?: NonprofitExperienceRange | null, permissions: Array<string>, lastLoggedInAt?: any | null, spaces?: Array<string> | null } | null };

export type UserEventQueryVariables = Exact<{
  eventNames: Array<Scalars['String']> | Scalars['String'];
  eventPropertiesFilter?: InputMaybe<EventPropertiesFilter>;
}>;


export type UserEventQuery = { userEvent?: Array<{ id: number, userId?: number | null, eventName?: string | null, eventTimeStamp: any, eventProperties: any } | null> | null };

export type GetUserRsvpGroupCoachingEventsQueryVariables = Exact<{
  status?: InputMaybe<Array<InputMaybe<RsvpStatus>> | InputMaybe<RsvpStatus>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserRsvpGroupCoachingEventsQuery = { userRsvpGroupCoachingEvents?: Array<{ id: number, name: string, userId: number, createdAt: any, updatedAt: any, startsAt: any, endsAt: any, duration?: number | null, bookingUrl?: string | null, slug: string, hideAttendees: boolean, body?: string | null, googleCalendarId?: string | null, googleCalendarLink?: string | null, focusArea?: string | null, coachName?: string | null, recordingLink?: string | null, meetingBody?: string | null, meetingTitle?: string | null, activityType?: ActivityType | null, videoConferenceUrl?: string | null, transcript?: string | null, summary?: string | null, status?: OneOnOneCoachingEventStatus | null, userRsvpStatus?: string | null, userRsvpNotes?: string | null, circleEventId?: number | null, circleEventUrl?: string | null } | null> | null };

export type NonprofitOrgToViewedFundingOrg990QueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type NonprofitOrgToViewedFundingOrg990Query = { NonprofitOrgToViewedFundingOrg990?: Array<{ nonprofitOrgId?: number | null, fundingOrg990Id?: number | null, fundingOrg990?: { ein?: number | null, organizationName?: string | null, grantsToPreselectedOnly?: boolean | null, nteeDescription?: any | null, city?: string | null, state?: string | null, locationsOfImpact?: any | null, grantAverage?: number | null } | null } | null> | null };

export type GoalGroupCardsInfoQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  goalGroupId?: InputMaybe<Scalars['Int']>;
  cohortId?: InputMaybe<Scalars['Int']>;
}>;


export type GoalGroupCardsInfoQuery = { goalGroupCards: Array<{ category: GoalCategory, completedTasks: number, description: string, endDate?: any | null, goalGroupId: number, numGrantees: number, startDate?: any | null, target?: number | null, targetDescription: string, targetProgress: number, totalTasks: number, title: string, isFunderAssigned: boolean }> };

export type GoalGroupChartQueryVariables = Exact<{
  goalGroupId: Scalars['Int'];
  type: GoalGroupChartType;
  funderOrgId: Scalars['Int'];
}>;


export type GoalGroupChartQuery = { goalGroupChart?: { id: number, title: string, target?: number | null, unitOfMeasurement?: string | null, goalId: number, totalValue: number, seriesData: Array<{ goalName: string, nonprofitOrgName: string, data: Array<{ x: string, y?: number | null }> }> } | null };

export type GoalGroupGranteesInfoQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  goalGroupId: Scalars['Int'];
}>;


export type GoalGroupGranteesInfoQuery = { goalGroupGranteesInfo: Array<{ completedTasks: number, goalName: string, goalProgress: number, goalTarget?: number | null, nonprofitOrgId: number, totalTasks: number }> };

export type GoalSharedToFunderCardQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  goalId?: InputMaybe<Scalars['Int']>;
  funderOrgId: Scalars['Int'];
  cohortId?: InputMaybe<Scalars['Int']>;
}>;


export type GoalSharedToFunderCardQuery = { goalSharedToFunderCard: Array<{ nonprofitOrgId?: number | null, category: GoalCategory, isComplete: boolean, description?: string | null, endDate?: any | null, id?: number | null, title: string, startDate?: any | null, target?: number | null, targetProgress?: number | null, impactCategory?: GoalImpactCategory | null, ChecklistItem: Array<{ createdAt: any, goalId: number, dueDate?: string | null, id: number, isCompleted?: boolean | null, linkText?: string | null, linkUrl?: string | null, resourceId?: string | null, title: string, updatedAt: any }>, EntryGroup: Array<{ id: number }> } | null> };

export type GoalUpdatesQueryVariables = Exact<{
  goalId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<GoalUpdateSortOptions>;
}>;


export type GoalUpdatesQuery = { goalUpdates?: { nodes: Array<{ id: number, goalId: number, goalTitle: string, description: string, lastUpdatedUserId: number, lastUpdatedUserFirstname: string, lastUpdatedUserLastname: string, taskId?: number | null, taskTitle?: string | null, reportedAt?: any | null }> } | null };

export type GoalsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  includeOnboarding?: InputMaybe<Scalars['Boolean']>;
  goalId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<GoalType>;
}>;


export type GoalsQuery = { goals?: Array<{ archivedAt?: any | null, category?: GoalCategory | null, impactCategory?: GoalImpactCategory | null, isComplete: boolean, numProgressUpdates?: number | null, numAttachments?: number | null, hasChart?: boolean | null, hasUpdates?: boolean | null, chartId?: number | null, createdAt: any, description?: string | null, endDate?: any | null, id: number, nonprofitOrgId?: number | null, metric?: MetricType | null, startDate?: any | null, target?: number | null, templateLibraryId?: number | null, title: string, type: GoalType, unitOfMeasurement?: string | null, updatedAt: any, ChecklistItem: Array<{ createdAt: any, goalId: number, dueDate?: string | null, id: number, isCompleted?: boolean | null, linkText?: string | null, linkUrl?: string | null, resourceId?: string | null, title: string, updatedAt: any, checklistItemGroupId?: number | null, owner?: { id: number, firstName: string, lastName: string } | null }>, GoalUpdate: Array<{ createdAt: any, description: string, id: number, goalId: number, lastUpdatedUser: { id: number, firstName: string, lastName: string } }>, owner?: { id: number, firstName: string, lastName: string } | null, FunderOrgToSharedGoal: Array<{ funderOrgId: number, sharedAt: any, goalId: number, isGoalSharedByFunder: boolean, isGoalSharedByNonprofit: boolean, archivedAt?: any | null, funderOrg: { id: number, name?: string | null } }>, attachments: Array<{ id: number, createdAt: any, filename: string, format?: string | null, secureUrl: string, publicId: string, resourceType?: string | null, owner?: { id: number, firstName: string, lastName: string } | null }> } | null> | null };

export type LatestGrantResearchReportQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type LatestGrantResearchReportQuery = { latestGrantResearchReport?: { id: number, status: GrantResearchStatus, grantsFoundCount: number, grantsOpenCount: number, grantsUpcomingCount: number, grantsRollingCount: number, createdAt: any, completedAt?: any | null, grants: Array<{ id: number, grantName: string, funderName: string, funderEin?: string | null, externalUrl?: string | null, deadlineCategory: GrantDeadlineCategory, deadline?: any | null, matchScore: number, matchReasons: Array<string>, eligibility?: string | null, focusAreas?: Array<string> | null, geographicRequirements?: string | null, applicationUrl?: string | null, status: ResearchedGrantStatus, savedAt?: any | null, dismissedAt?: any | null, grantAmount?: { min?: number | null, max?: number | null, typical?: string | null } | null }> } | null };

export type GrantResearchRateLimitQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GrantResearchRateLimitQuery = { grantResearchRateLimit: { canGenerateReport: boolean, nextAvailableAt?: any | null, lastReportId?: number | null } };

export type ImpactDashboardAcademyActivityQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type ImpactDashboardAcademyActivityQuery = { impactDashboardAcademyActivity: Array<{ userFullName: string, userId: number, userStatus: string, resource: { courseId: string, id: string, nonprofitTopic: string, title: string, type: string } }> };

export type ImpactDashboardGoalsQueryVariables = Exact<{
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']>;
  createdAtEnd?: InputMaybe<Scalars['DateTime']>;
  goalId?: InputMaybe<Scalars['String']>;
  nonprofitOrgId: Scalars['Int'];
}>;


export type ImpactDashboardGoalsQuery = { goals?: Array<{ archivedAt?: any | null, category?: GoalCategory | null, createdAt: any, description?: string | null, endDate?: any | null, id: number, nonprofitOrgId?: number | null, metric?: MetricType | null, startDate?: any | null, target?: number | null, templateLibraryId?: number | null, title: string, type: GoalType, unitOfMeasurement?: string | null, updatedAt: any, ChecklistItem: Array<{ createdAt: any, goalId: number, dueDate?: string | null, id: number, isCompleted?: boolean | null, linkText?: string | null, linkUrl?: string | null, resourceId?: string | null, title: string, updatedAt: any, owner?: { id: number, firstName: string, lastName: string } | null }>, GoalUpdate: Array<{ createdAt: any, description: string, id: number, goalId: number, lastUpdatedUser: { id: number, firstName: string, lastName: string } }>, owner?: { id: number, firstName: string, lastName: string } | null, FunderOrgToSharedGoal: Array<{ funderOrgId: number, sharedAt: any, goalId: number, isGoalSharedByFunder: boolean, isGoalSharedByNonprofit: boolean, archivedAt?: any | null, funderOrg: { id: number, name?: string | null } }> } | null> | null };

export type MissionGoalsProgressStatsQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type MissionGoalsProgressStatsQuery = { missionGoalsProgressStats?: { orgsWithMissionGoals?: { currentValue: number, previousValue?: number | null } | null, missionGoalsWithTargets?: { currentValue: number, totalValue?: number | null } | null, missionGoalChartUpdates?: { currentValue: number, previousValue?: number | null } | null, missionGoalChartProgress?: { currentValue: number, previousValue?: number | null } | null } | null };

export type MissionGoalsTargetProgressQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type MissionGoalsTargetProgressQuery = { missionGoalsTargetProgress?: Array<{ x: string, y?: number | null } | null> | null };

export type NeedsProgressUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type NeedsProgressUpdateQuery = { needsProgressUpdate?: { needsProgressUpdate?: boolean | null } | null };

export type NeedsUserSurveyUpdateQueryVariables = Exact<{ [key: string]: never; }>;


export type NeedsUserSurveyUpdateQuery = { needsUserSurveyUpdate?: boolean | null };

export type GetNonprofitOrgProfileQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
}>;


export type GetNonprofitOrgProfileQuery = { nonprofitOrgProfile?: { id: number, nonprofitOrgId: number, candidData?: any | null, websiteData?: any | null, instagramData?: any | null, twitterData?: any | null, confirmedOrgSummary?: string | null, confirmedOrgSummaryUpdatedAt?: any | null, confirmedAreasOfImpact: Array<string>, suggestedOrgSummary?: string | null, suggestedAreasOfImpact: Array<string> } | null };

export type GetOrg990AttributesQueryVariables = Exact<{
  orgId: Scalars['Int'];
}>;


export type GetOrg990AttributesQuery = { getOrg990Attributes?: { orgId: number, missionDesc?: string | null } | null };

export type OrgGoalsTaskProgressChartQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
  nonprofitOrgIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type OrgGoalsTaskProgressChartQuery = { orgGoalsTaskProgressChart?: { createdItems: Array<{ x: string, y?: number | null }>, completedItems: Array<{ x: string, y?: number | null }>, progress: Array<{ x: string, y?: number | null }> } | null };

export type OrgGoalsTaskProgressStatsQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  lookBackPeriod: Scalars['Int'];
}>;


export type OrgGoalsTaskProgressStatsQuery = { orgGoalsTaskProgressStats?: { totalGoalsAdded?: { currentValue: number, previousValue?: number | null } | null, goalsWithTasks?: { currentValue: number, previousValue?: number | null } | null, goalTemplatesUsed?: { currentValue: number, previousValue?: number | null } | null, totalTasksAdded?: { currentValue: number, previousValue?: number | null } | null, totalTasksCompleted?: { currentValue: number, previousValue?: number | null } | null } | null };

export type PrioritiesProgressStatsQueryVariables = Exact<{
  funderOrgId: Scalars['Int'];
  lookBackPeriod: Scalars['Int'];
}>;


export type PrioritiesProgressStatsQuery = { prioritiesProgressStats?: { totalOrgsCount?: { currentValue: number, previousValue?: number | null } | null, orgsWithLeaders?: { currentValue: number, previousValue?: number | null } | null, orgsWithPriorities?: { currentValue: number, previousValue?: number | null } | null } | null };

export type GetUserRecommendationsQueryVariables = Exact<{
  input: GetUserRecommendationsInput;
}>;


export type GetUserRecommendationsQuery = { getUserRecommendations?: { totalCount: number, recommendations: Array<{ id: number, userId: number, nonprofitOrgId: number, score: number, status: RecommendationStatus, placement: RecommendationPlacement, shownAt?: any | null, clickedAt?: any | null, dismissedAt?: any | null, completedAt?: any | null, metadata?: any | null, expiresAt?: any | null, createdAt: any, updatedAt: any, recommendationTemplate?: { id: number, key: string, title: string, description: string, category: string, priority: number, placement: RecommendationPlacement, targetAudience?: any | null, callToActionText?: string | null, callToActionLink?: string | null, iconName?: string | null, isActive: boolean, createdAt: any, updatedAt: any } | null, user?: { id: number, firstName: string, lastName: string } | null, nonprofitOrg?: { id: number, name?: string | null } | null }> } | null };

export type TrackRecommendationInteractionMutationVariables = Exact<{
  input: TrackRecommendationInteractionInput;
}>;


export type TrackRecommendationInteractionMutation = { trackRecommendationInteraction?: { id: number, status: RecommendationStatus, shownAt?: any | null, clickedAt?: any | null, dismissedAt?: any | null, completedAt?: any | null } | null };

export type GenerateUserRecommendationsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
}>;


export type GenerateUserRecommendationsMutation = { generateUserRecommendations?: { totalCount: number, recommendations: Array<{ id: number, userId: number, nonprofitOrgId: number, score: number, status: RecommendationStatus, placement: RecommendationPlacement, createdAt: any, recommendationTemplate?: { id: number, key: string, title: string, description: string, category: string, callToActionText?: string | null, callToActionLink?: string | null } | null }> } | null };

export type SearchCohortsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  funderName?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchCohortsQuery = { searchCohorts?: { total: number, cohorts?: Array<{ id: number, name: string, startDate?: any | null, endDate?: any | null, createdAt: any, updatedAt: any, memberRoles: Array<string>, cohortOwnerships?: Array<{ id?: number | null, funderOrg?: { id: number, name?: string | null } | null } | null> | null, cohortMemberships?: Array<{ id?: number | null, startDate?: any | null, endDate?: any | null, nonprofitOrg?: { id: number, name?: string | null } | null } | null> | null }> | null } | null };

export type SearchFundersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  cohortName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchFundersQuery = { searchFunders?: { total: number, funders?: Array<{ id: number, name?: string | null, disabled: boolean, isTest: boolean, createdAt: any, updatedAt: any, disabledAt?: any | null, nonprofitOrgs?: Array<{ id: number, name?: string | null } | null> | null, cohorts?: Array<{ id?: number | null, name?: string | null } | null> | null, users?: Array<{ id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null> | null }> | null } | null };

export type SearchJobExecutionsQueryVariables = Exact<{
  filter?: InputMaybe<JobExecutionFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
}>;


export type SearchJobExecutionsQuery = { searchJobExecutions?: { totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, nodes: Array<{ id: string, jobName: string, status: JobStatus, payload?: any | null, result?: any | null, errorMessage?: string | null, errorStack?: string | null, createdAt: any, startedAt?: any | null, completedAt?: any | null, duration?: number | null, createdByUserId?: number | null, organizationId?: number | null, createdByUser?: { id: number, firstName: string, lastName: string } | null }> } | null };

export type SearchNonprofitsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  funderName?: InputMaybe<Scalars['String']>;
  cohortName?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  profileSearchTerm?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchNonprofitsQuery = { searchNonprofits?: { total: number, nonprofits?: Array<{ id: number, name?: string | null, disabled: boolean, formationPlan?: FormationPlan | null, platformPlan?: PlatformPlan | null, ein?: string | null, websiteUrl?: string | null, isFiscallySponsored?: boolean | null, isTest: boolean, funders?: Array<{ id: number, name?: string | null } | null> | null, cohorts?: Array<{ id: number, name: string } | null> | null, users?: Array<{ id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null } | null> | null }> | null } | null };

export type SearchUsersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nonprofitName?: InputMaybe<Scalars['String']>;
  funderName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SearchUsersQuery = { searchUsers?: { total: number, users: Array<{ id: number, email: string, firstName: string, lastName: string, disabled: boolean, isTest: boolean, createdAt?: any | null, updatedAt?: any | null, disabledAt?: any | null, lastLoggedInAt?: any | null, nonprofitOrgs?: Array<{ id: number, name?: string | null } | null> | null, funderOrgs?: Array<{ id: number, name?: string | null } | null> | null } | null> } | null };

export type StripePayoutsQueryVariables = Exact<{
  stripeConnectId: Scalars['String'];
  createdAfter?: InputMaybe<Scalars['Int']>;
}>;


export type StripePayoutsQuery = { stripePayouts?: { totalPaidOutInCents?: number | null, currentBalanceInCents?: number | null, payoutFrequency?: string | null, items?: Array<{ id?: string | null, amount?: number | null, arrival_date?: number | null, created?: number | null, status?: string | null, reversed_by?: string | null } | null> | null } | null };

export type TopPrioritiesQueryVariables = Exact<{
  funderOrgId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  daysAgo?: InputMaybe<Scalars['Int']>;
}>;


export type TopPrioritiesQuery = { topPriorities: Array<{ label: string, data: Array<number>, confidenceLevel: number, totalResponses: number, roleData?: any | null }> };

export type UpdateConnectAccountLinkQueryVariables = Exact<{
  stripeAccountId: Scalars['String'];
  returnUrl: Scalars['String'];
}>;


export type UpdateConnectAccountLinkQuery = { updateConnectAccountLink?: { url?: string | null } | null };

export type UserOneOnOneCoachingEventsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UserOneOnOneCoachingEventsQuery = { userOneOnOneCoachingEvents?: Array<{ id: number, userId: number, createdAt: any, updatedAt: any, startsAt: any, endsAt: any, contactEmail: string, contactName: string, bookingUrl: string, userSlug: string, organizerEmail?: string | null, organizerName?: string | null, duration?: number | null, formGuid?: string | null, hubspotId?: string | null, meetingBody?: string | null, meetingTitle?: string | null, videoConferenceUrl?: string | null, transcript?: string | null, summary?: string | null, status?: OneOnOneCoachingEventStatus | null, goals?: Array<{ id: number, title: string } | null> | null } | null> | null };

export type UserPrioritiesQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserPrioritiesQuery = { userSurveyPriorities: Array<{ id: number, rank: number, category: GoalCategory, confidenceLevel: number, challenges?: string | null, createdAt: any }> };

export type UserSurveyQueryVariables = Exact<{
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<SurveyType>;
}>;


export type UserSurveyQuery = { userSurvey?: { completedAt?: any | null, id: number, orgMissionChange?: number | null, orgMissionChangeExplanation?: string | null, primaryFunction: UserSurveyPrimaryFunction, response?: any | null, role: UserSurveyRole, type: SurveyType, UserSurveyPriority: Array<{ archivedAt?: any | null, category: GoalCategory, confidenceLevel: number, customPriorities?: string | null, id: number, rank: number, UserSurveyPriorityTopic: Array<{ id: number, topic?: string | null }> }> } | null };

export type UserSurveysQueryVariables = Exact<{
  nonprofitOrgId: Scalars['Int'];
  type?: InputMaybe<SurveyType>;
  types?: InputMaybe<Array<SurveyType> | SurveyType>;
}>;


export type UserSurveysQuery = { userSurveys: Array<{ id: number, isCompleted: boolean }> };


export const AddGoalDocument = gql`
    mutation addGoal($goalInfo: AddGoalInput!) {
  addGoal(goalInfo: $goalInfo) {
    id
    title
    category
    nonprofitOrgId
    owner {
      id
      firstName
      lastName
    }
  }
}
    `;
export type AddGoalMutationFn = Apollo.MutationFunction<AddGoalMutation, AddGoalMutationVariables>;

/**
 * __useAddGoalMutation__
 *
 * To run a mutation, you first call `useAddGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoalMutation, { data, loading, error }] = useAddGoalMutation({
 *   variables: {
 *      goalInfo: // value for 'goalInfo'
 *   },
 * });
 */
export function useAddGoalMutation(baseOptions?: Apollo.MutationHookOptions<AddGoalMutation, AddGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoalMutation, AddGoalMutationVariables>(AddGoalDocument, options);
      }
export type AddGoalMutationHookResult = ReturnType<typeof useAddGoalMutation>;
export type AddGoalMutationResult = Apollo.MutationResult<AddGoalMutation>;
export type AddGoalMutationOptions = Apollo.BaseMutationOptions<AddGoalMutation, AddGoalMutationVariables>;
export const AddGoalMeasurementDocument = gql`
    mutation addGoalMeasurement($goalInfo: GoalInput!, $dimensionInfo: [GoalDimensionInput!]!, $nonprofitOrgId: Int!) {
  addGoalMeasurement(
    goalInfo: $goalInfo
    dimensionInfo: $dimensionInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
    title
  }
}
    `;
export type AddGoalMeasurementMutationFn = Apollo.MutationFunction<AddGoalMeasurementMutation, AddGoalMeasurementMutationVariables>;

/**
 * __useAddGoalMeasurementMutation__
 *
 * To run a mutation, you first call `useAddGoalMeasurementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGoalMeasurementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGoalMeasurementMutation, { data, loading, error }] = useAddGoalMeasurementMutation({
 *   variables: {
 *      goalInfo: // value for 'goalInfo'
 *      dimensionInfo: // value for 'dimensionInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useAddGoalMeasurementMutation(baseOptions?: Apollo.MutationHookOptions<AddGoalMeasurementMutation, AddGoalMeasurementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGoalMeasurementMutation, AddGoalMeasurementMutationVariables>(AddGoalMeasurementDocument, options);
      }
export type AddGoalMeasurementMutationHookResult = ReturnType<typeof useAddGoalMeasurementMutation>;
export type AddGoalMeasurementMutationResult = Apollo.MutationResult<AddGoalMeasurementMutation>;
export type AddGoalMeasurementMutationOptions = Apollo.BaseMutationOptions<AddGoalMeasurementMutation, AddGoalMeasurementMutationVariables>;
export const AssignGoalsToGoalGroupDocument = gql`
    mutation AssignGoalsToGoalGroup($data: AssignGoalsToGoalGroupInput!) {
  assignGoalsToGoalGroup(data: $data) {
    count
  }
}
    `;
export type AssignGoalsToGoalGroupMutationFn = Apollo.MutationFunction<AssignGoalsToGoalGroupMutation, AssignGoalsToGoalGroupMutationVariables>;

/**
 * __useAssignGoalsToGoalGroupMutation__
 *
 * To run a mutation, you first call `useAssignGoalsToGoalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignGoalsToGoalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignGoalsToGoalGroupMutation, { data, loading, error }] = useAssignGoalsToGoalGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAssignGoalsToGoalGroupMutation(baseOptions?: Apollo.MutationHookOptions<AssignGoalsToGoalGroupMutation, AssignGoalsToGoalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignGoalsToGoalGroupMutation, AssignGoalsToGoalGroupMutationVariables>(AssignGoalsToGoalGroupDocument, options);
      }
export type AssignGoalsToGoalGroupMutationHookResult = ReturnType<typeof useAssignGoalsToGoalGroupMutation>;
export type AssignGoalsToGoalGroupMutationResult = Apollo.MutationResult<AssignGoalsToGoalGroupMutation>;
export type AssignGoalsToGoalGroupMutationOptions = Apollo.BaseMutationOptions<AssignGoalsToGoalGroupMutation, AssignGoalsToGoalGroupMutationVariables>;
export const AutoCompleteTasksMutationDocument = gql`
    mutation autoCompleteTasksMutation($resourceId: String!) {
  autoCompleteTasksMutation(resourceId: $resourceId) {
    updatedTasks
    success
  }
}
    `;
export type AutoCompleteTasksMutationMutationFn = Apollo.MutationFunction<AutoCompleteTasksMutationMutation, AutoCompleteTasksMutationMutationVariables>;

/**
 * __useAutoCompleteTasksMutationMutation__
 *
 * To run a mutation, you first call `useAutoCompleteTasksMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoCompleteTasksMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoCompleteTasksMutationMutation, { data, loading, error }] = useAutoCompleteTasksMutationMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useAutoCompleteTasksMutationMutation(baseOptions?: Apollo.MutationHookOptions<AutoCompleteTasksMutationMutation, AutoCompleteTasksMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoCompleteTasksMutationMutation, AutoCompleteTasksMutationMutationVariables>(AutoCompleteTasksMutationDocument, options);
      }
export type AutoCompleteTasksMutationMutationHookResult = ReturnType<typeof useAutoCompleteTasksMutationMutation>;
export type AutoCompleteTasksMutationMutationResult = Apollo.MutationResult<AutoCompleteTasksMutationMutation>;
export type AutoCompleteTasksMutationMutationOptions = Apollo.BaseMutationOptions<AutoCompleteTasksMutationMutation, AutoCompleteTasksMutationMutationVariables>;
export const UpdateChartCategoryDocument = gql`
    mutation UpdateChartCategory($data: UpdateChartCategoryInput!) {
  updateChartCategory(data: $data) {
    id
    title
    chartId
  }
}
    `;
export type UpdateChartCategoryMutationFn = Apollo.MutationFunction<UpdateChartCategoryMutation, UpdateChartCategoryMutationVariables>;

/**
 * __useUpdateChartCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateChartCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartCategoryMutation, { data, loading, error }] = useUpdateChartCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChartCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChartCategoryMutation, UpdateChartCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChartCategoryMutation, UpdateChartCategoryMutationVariables>(UpdateChartCategoryDocument, options);
      }
export type UpdateChartCategoryMutationHookResult = ReturnType<typeof useUpdateChartCategoryMutation>;
export type UpdateChartCategoryMutationResult = Apollo.MutationResult<UpdateChartCategoryMutation>;
export type UpdateChartCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateChartCategoryMutation, UpdateChartCategoryMutationVariables>;
export const CreateChartCategoriesDocument = gql`
    mutation CreateChartCategories($chartId: Int!, $data: [ChartCategoryInput!]!) {
  createChartCategories(chartId: $chartId, data: $data) {
    id
    title
    chartId
  }
}
    `;
export type CreateChartCategoriesMutationFn = Apollo.MutationFunction<CreateChartCategoriesMutation, CreateChartCategoriesMutationVariables>;

/**
 * __useCreateChartCategoriesMutation__
 *
 * To run a mutation, you first call `useCreateChartCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartCategoriesMutation, { data, loading, error }] = useCreateChartCategoriesMutation({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChartCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartCategoriesMutation, CreateChartCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartCategoriesMutation, CreateChartCategoriesMutationVariables>(CreateChartCategoriesDocument, options);
      }
export type CreateChartCategoriesMutationHookResult = ReturnType<typeof useCreateChartCategoriesMutation>;
export type CreateChartCategoriesMutationResult = Apollo.MutationResult<CreateChartCategoriesMutation>;
export type CreateChartCategoriesMutationOptions = Apollo.BaseMutationOptions<CreateChartCategoriesMutation, CreateChartCategoriesMutationVariables>;
export const CreateChartDataPointsDocument = gql`
    mutation CreateChartDataPoints($data: [ChartDataPointInput!]!) {
  createChartDataPoints(data: $data) {
    count
  }
}
    `;
export type CreateChartDataPointsMutationFn = Apollo.MutationFunction<CreateChartDataPointsMutation, CreateChartDataPointsMutationVariables>;

/**
 * __useCreateChartDataPointsMutation__
 *
 * To run a mutation, you first call `useCreateChartDataPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartDataPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartDataPointsMutation, { data, loading, error }] = useCreateChartDataPointsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChartDataPointsMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartDataPointsMutation, CreateChartDataPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartDataPointsMutation, CreateChartDataPointsMutationVariables>(CreateChartDataPointsDocument, options);
      }
export type CreateChartDataPointsMutationHookResult = ReturnType<typeof useCreateChartDataPointsMutation>;
export type CreateChartDataPointsMutationResult = Apollo.MutationResult<CreateChartDataPointsMutation>;
export type CreateChartDataPointsMutationOptions = Apollo.BaseMutationOptions<CreateChartDataPointsMutation, CreateChartDataPointsMutationVariables>;
export const CompleteQuickBooksConnectionDocument = gql`
    mutation completeQuickBooksConnection($code: String!, $state: String!, $realmId: String!) {
  completeQuickBooksConnection(code: $code, state: $state, realmId: $realmId) {
    id
    nonprofitOrgId
    companyName
    status
    connectedAt
    lastDataFetch
    needsReauth
  }
}
    `;
export type CompleteQuickBooksConnectionMutationFn = Apollo.MutationFunction<CompleteQuickBooksConnectionMutation, CompleteQuickBooksConnectionMutationVariables>;

/**
 * __useCompleteQuickBooksConnectionMutation__
 *
 * To run a mutation, you first call `useCompleteQuickBooksConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteQuickBooksConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeQuickBooksConnectionMutation, { data, loading, error }] = useCompleteQuickBooksConnectionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *      realmId: // value for 'realmId'
 *   },
 * });
 */
export function useCompleteQuickBooksConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteQuickBooksConnectionMutation, CompleteQuickBooksConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteQuickBooksConnectionMutation, CompleteQuickBooksConnectionMutationVariables>(CompleteQuickBooksConnectionDocument, options);
      }
export type CompleteQuickBooksConnectionMutationHookResult = ReturnType<typeof useCompleteQuickBooksConnectionMutation>;
export type CompleteQuickBooksConnectionMutationResult = Apollo.MutationResult<CompleteQuickBooksConnectionMutation>;
export type CompleteQuickBooksConnectionMutationOptions = Apollo.BaseMutationOptions<CompleteQuickBooksConnectionMutation, CompleteQuickBooksConnectionMutationVariables>;
export const CreateAttachmentDocument = gql`
    mutation CreateAttachment($filename: String!, $format: String, $goalId: Int!, $publicId: String!, $secureUrl: String!, $resourceType: String) {
  createAttachment(
    filename: $filename
    format: $format
    goalId: $goalId
    publicId: $publicId
    secureUrl: $secureUrl
    resourceType: $resourceType
  ) {
    id
    createdAt
    filename
    format
    secureUrl
    publicId
    resourceType
  }
}
    `;
export type CreateAttachmentMutationFn = Apollo.MutationFunction<CreateAttachmentMutation, CreateAttachmentMutationVariables>;

/**
 * __useCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttachmentMutation, { data, loading, error }] = useCreateAttachmentMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      format: // value for 'format'
 *      goalId: // value for 'goalId'
 *      publicId: // value for 'publicId'
 *      secureUrl: // value for 'secureUrl'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttachmentMutation, CreateAttachmentMutationVariables>(CreateAttachmentDocument, options);
      }
export type CreateAttachmentMutationHookResult = ReturnType<typeof useCreateAttachmentMutation>;
export type CreateAttachmentMutationResult = Apollo.MutationResult<CreateAttachmentMutation>;
export type CreateAttachmentMutationOptions = Apollo.BaseMutationOptions<CreateAttachmentMutation, CreateAttachmentMutationVariables>;
export const CreateAutomatedGoalDocument = gql`
    mutation createAutomatedGoal($appcuesFlowId: String!, $nonprofitOrgId: Int!, $createObjective: Boolean, $shareWithFunderOrgId: Int, $isGoalSharedByFunder: Boolean) {
  createAutomatedGoal(
    appcuesFlowId: $appcuesFlowId
    nonprofitOrgId: $nonprofitOrgId
    createObjective: $createObjective
    shareWithFunderOrgId: $shareWithFunderOrgId
    isGoalSharedByFunder: $isGoalSharedByFunder
  ) {
    templateLibraryId
    objective {
      id
      title
    }
    goal {
      id
      title
      category
      type
      owner {
        id
        firstName
        lastName
      }
    }
    checklistItems {
      id
      title
    }
  }
}
    `;
export type CreateAutomatedGoalMutationFn = Apollo.MutationFunction<CreateAutomatedGoalMutation, CreateAutomatedGoalMutationVariables>;

/**
 * __useCreateAutomatedGoalMutation__
 *
 * To run a mutation, you first call `useCreateAutomatedGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomatedGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomatedGoalMutation, { data, loading, error }] = useCreateAutomatedGoalMutation({
 *   variables: {
 *      appcuesFlowId: // value for 'appcuesFlowId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      createObjective: // value for 'createObjective'
 *      shareWithFunderOrgId: // value for 'shareWithFunderOrgId'
 *      isGoalSharedByFunder: // value for 'isGoalSharedByFunder'
 *   },
 * });
 */
export function useCreateAutomatedGoalMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomatedGoalMutation, CreateAutomatedGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomatedGoalMutation, CreateAutomatedGoalMutationVariables>(CreateAutomatedGoalDocument, options);
      }
export type CreateAutomatedGoalMutationHookResult = ReturnType<typeof useCreateAutomatedGoalMutation>;
export type CreateAutomatedGoalMutationResult = Apollo.MutationResult<CreateAutomatedGoalMutation>;
export type CreateAutomatedGoalMutationOptions = Apollo.BaseMutationOptions<CreateAutomatedGoalMutation, CreateAutomatedGoalMutationVariables>;
export const CreateBoxConfigDocument = gql`
    mutation createBoxConfig($userId: Int!, $orgId: Int!) {
  createBoxConfig(userId: $userId, orgId: $orgId) {
    boxId
  }
}
    `;
export type CreateBoxConfigMutationFn = Apollo.MutationFunction<CreateBoxConfigMutation, CreateBoxConfigMutationVariables>;

/**
 * __useCreateBoxConfigMutation__
 *
 * To run a mutation, you first call `useCreateBoxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBoxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBoxConfigMutation, { data, loading, error }] = useCreateBoxConfigMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCreateBoxConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateBoxConfigMutation, CreateBoxConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBoxConfigMutation, CreateBoxConfigMutationVariables>(CreateBoxConfigDocument, options);
      }
export type CreateBoxConfigMutationHookResult = ReturnType<typeof useCreateBoxConfigMutation>;
export type CreateBoxConfigMutationResult = Apollo.MutationResult<CreateBoxConfigMutation>;
export type CreateBoxConfigMutationOptions = Apollo.BaseMutationOptions<CreateBoxConfigMutation, CreateBoxConfigMutationVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($orgId: Int!, $campaignInput: CampaignInput!) {
  createCampaign(orgId: $orgId, campaignInput: $campaignInput) {
    id
    createdAt
    updatedAt
    createdUserId
    updatedUserId
    fundraisingTarget
    publishedAt
    archivedAt
    hashedPortalId
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      campaignInput: // value for 'campaignInput'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const CreateChartDocument = gql`
    mutation createChart($data: CreateChartInput!) {
  createChart(data: $data) {
    id
  }
}
    `;
export type CreateChartMutationFn = Apollo.MutationFunction<CreateChartMutation, CreateChartMutationVariables>;

/**
 * __useCreateChartMutation__
 *
 * To run a mutation, you first call `useCreateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartMutation, { data, loading, error }] = useCreateChartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChartMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartMutation, CreateChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartMutation, CreateChartMutationVariables>(CreateChartDocument, options);
      }
export type CreateChartMutationHookResult = ReturnType<typeof useCreateChartMutation>;
export type CreateChartMutationResult = Apollo.MutationResult<CreateChartMutation>;
export type CreateChartMutationOptions = Apollo.BaseMutationOptions<CreateChartMutation, CreateChartMutationVariables>;
export const CreateChartsDocument = gql`
    mutation createCharts($data: CreateChartsInput!) {
  createCharts(data: $data) {
    id
  }
}
    `;
export type CreateChartsMutationFn = Apollo.MutationFunction<CreateChartsMutation, CreateChartsMutationVariables>;

/**
 * __useCreateChartsMutation__
 *
 * To run a mutation, you first call `useCreateChartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChartsMutation, { data, loading, error }] = useCreateChartsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateChartsMutation(baseOptions?: Apollo.MutationHookOptions<CreateChartsMutation, CreateChartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChartsMutation, CreateChartsMutationVariables>(CreateChartsDocument, options);
      }
export type CreateChartsMutationHookResult = ReturnType<typeof useCreateChartsMutation>;
export type CreateChartsMutationResult = Apollo.MutationResult<CreateChartsMutation>;
export type CreateChartsMutationOptions = Apollo.BaseMutationOptions<CreateChartsMutation, CreateChartsMutationVariables>;
export const CreateEntryDocument = gql`
    mutation createEntry($entryGroupInfo: EntryGroupInput!, $entryInfo: [EntryInput!]!, $nonprofitOrgId: Int!) {
  createEntry(
    entryGroupInfo: $entryGroupInfo
    entryInfo: $entryInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
  }
}
    `;
export type CreateEntryMutationFn = Apollo.MutationFunction<CreateEntryMutation, CreateEntryMutationVariables>;

/**
 * __useCreateEntryMutation__
 *
 * To run a mutation, you first call `useCreateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntryMutation, { data, loading, error }] = useCreateEntryMutation({
 *   variables: {
 *      entryGroupInfo: // value for 'entryGroupInfo'
 *      entryInfo: // value for 'entryInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useCreateEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntryMutation, CreateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntryMutation, CreateEntryMutationVariables>(CreateEntryDocument, options);
      }
export type CreateEntryMutationHookResult = ReturnType<typeof useCreateEntryMutation>;
export type CreateEntryMutationResult = Apollo.MutationResult<CreateEntryMutation>;
export type CreateEntryMutationOptions = Apollo.BaseMutationOptions<CreateEntryMutation, CreateEntryMutationVariables>;
export const CreateGoalGroupDocument = gql`
    mutation CreateGoalGroup($data: CreateGoalGroupInput!) {
  createGoalGroup(data: $data) {
    id
    title
    description
    category
    startDate
    endDate
  }
}
    `;
export type CreateGoalGroupMutationFn = Apollo.MutationFunction<CreateGoalGroupMutation, CreateGoalGroupMutationVariables>;

/**
 * __useCreateGoalGroupMutation__
 *
 * To run a mutation, you first call `useCreateGoalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalGroupMutation, { data, loading, error }] = useCreateGoalGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGoalGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalGroupMutation, CreateGoalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalGroupMutation, CreateGoalGroupMutationVariables>(CreateGoalGroupDocument, options);
      }
export type CreateGoalGroupMutationHookResult = ReturnType<typeof useCreateGoalGroupMutation>;
export type CreateGoalGroupMutationResult = Apollo.MutationResult<CreateGoalGroupMutation>;
export type CreateGoalGroupMutationOptions = Apollo.BaseMutationOptions<CreateGoalGroupMutation, CreateGoalGroupMutationVariables>;
export const CreateGroupCoachingEventDocument = gql`
    mutation CreateGroupCoachingEvent($input: GroupCoachingEventInput!) {
  createGroupCoachingEvent(input: $input) {
    id
    name
    userId
    createdAt
    updatedAt
    startsAt
    endsAt
    duration
    bookingUrl
    hideAttendees
    body
    googleCalendarId
    googleCalendarLink
    slug
    focusArea
    coachName
    coachEmail
    recordingLink
    activityType
    meetingBody
    meetingTitle
    videoConferenceUrl
    status
  }
}
    `;
export type CreateGroupCoachingEventMutationFn = Apollo.MutationFunction<CreateGroupCoachingEventMutation, CreateGroupCoachingEventMutationVariables>;

/**
 * __useCreateGroupCoachingEventMutation__
 *
 * To run a mutation, you first call `useCreateGroupCoachingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupCoachingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupCoachingEventMutation, { data, loading, error }] = useCreateGroupCoachingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupCoachingEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupCoachingEventMutation, CreateGroupCoachingEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupCoachingEventMutation, CreateGroupCoachingEventMutationVariables>(CreateGroupCoachingEventDocument, options);
      }
export type CreateGroupCoachingEventMutationHookResult = ReturnType<typeof useCreateGroupCoachingEventMutation>;
export type CreateGroupCoachingEventMutationResult = Apollo.MutationResult<CreateGroupCoachingEventMutation>;
export type CreateGroupCoachingEventMutationOptions = Apollo.BaseMutationOptions<CreateGroupCoachingEventMutation, CreateGroupCoachingEventMutationVariables>;
export const CreateManyFunderUsersDocument = gql`
    mutation createManyFunderUsers($funderUsersInfo: [BulkFunderUserInput!]!, $funderOrgId: Int!, $inviterUserId: Int!) {
  createManyFunderUsers(
    funderUsersInfo: $funderUsersInfo
    funderOrgId: $funderOrgId
    inviterUserId: $inviterUserId
  ) {
    email
  }
}
    `;
export type CreateManyFunderUsersMutationFn = Apollo.MutationFunction<CreateManyFunderUsersMutation, CreateManyFunderUsersMutationVariables>;

/**
 * __useCreateManyFunderUsersMutation__
 *
 * To run a mutation, you first call `useCreateManyFunderUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyFunderUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyFunderUsersMutation, { data, loading, error }] = useCreateManyFunderUsersMutation({
 *   variables: {
 *      funderUsersInfo: // value for 'funderUsersInfo'
 *      funderOrgId: // value for 'funderOrgId'
 *      inviterUserId: // value for 'inviterUserId'
 *   },
 * });
 */
export function useCreateManyFunderUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateManyFunderUsersMutation, CreateManyFunderUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManyFunderUsersMutation, CreateManyFunderUsersMutationVariables>(CreateManyFunderUsersDocument, options);
      }
export type CreateManyFunderUsersMutationHookResult = ReturnType<typeof useCreateManyFunderUsersMutation>;
export type CreateManyFunderUsersMutationResult = Apollo.MutationResult<CreateManyFunderUsersMutation>;
export type CreateManyFunderUsersMutationOptions = Apollo.BaseMutationOptions<CreateManyFunderUsersMutation, CreateManyFunderUsersMutationVariables>;
export const CreateManyNonprofitOrgUsersDocument = gql`
    mutation createManyNonprofitOrgUsers($nonprofitUserInfo: GranteeUserBasicInput!, $nonprofitOrgId: Int!, $sendInvite: Boolean, $inviteType: NonprofitOrgInviteType) {
  createManyNonprofitOrgUsers(
    nonprofitUserInfo: $nonprofitUserInfo
    nonprofitOrgId: $nonprofitOrgId
    sendInvite: $sendInvite
    inviteType: $inviteType
  ) {
    email
  }
}
    `;
export type CreateManyNonprofitOrgUsersMutationFn = Apollo.MutationFunction<CreateManyNonprofitOrgUsersMutation, CreateManyNonprofitOrgUsersMutationVariables>;

/**
 * __useCreateManyNonprofitOrgUsersMutation__
 *
 * To run a mutation, you first call `useCreateManyNonprofitOrgUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyNonprofitOrgUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyNonprofitOrgUsersMutation, { data, loading, error }] = useCreateManyNonprofitOrgUsersMutation({
 *   variables: {
 *      nonprofitUserInfo: // value for 'nonprofitUserInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      sendInvite: // value for 'sendInvite'
 *      inviteType: // value for 'inviteType'
 *   },
 * });
 */
export function useCreateManyNonprofitOrgUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateManyNonprofitOrgUsersMutation, CreateManyNonprofitOrgUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManyNonprofitOrgUsersMutation, CreateManyNonprofitOrgUsersMutationVariables>(CreateManyNonprofitOrgUsersDocument, options);
      }
export type CreateManyNonprofitOrgUsersMutationHookResult = ReturnType<typeof useCreateManyNonprofitOrgUsersMutation>;
export type CreateManyNonprofitOrgUsersMutationResult = Apollo.MutationResult<CreateManyNonprofitOrgUsersMutation>;
export type CreateManyNonprofitOrgUsersMutationOptions = Apollo.BaseMutationOptions<CreateManyNonprofitOrgUsersMutation, CreateManyNonprofitOrgUsersMutationVariables>;
export const CreateMurdocEmbedSessionDocument = gql`
    mutation CreateMurdocEmbedSession($orgId: Int!) {
  createMurdocEmbedSession(orgId: $orgId) {
    iframeUrl
    expiresAt
    refreshAt
  }
}
    `;
export type CreateMurdocEmbedSessionMutationFn = Apollo.MutationFunction<CreateMurdocEmbedSessionMutation, CreateMurdocEmbedSessionMutationVariables>;

/**
 * __useCreateMurdocEmbedSessionMutation__
 *
 * To run a mutation, you first call `useCreateMurdocEmbedSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMurdocEmbedSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMurdocEmbedSessionMutation, { data, loading, error }] = useCreateMurdocEmbedSessionMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCreateMurdocEmbedSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateMurdocEmbedSessionMutation, CreateMurdocEmbedSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMurdocEmbedSessionMutation, CreateMurdocEmbedSessionMutationVariables>(CreateMurdocEmbedSessionDocument, options);
      }
export type CreateMurdocEmbedSessionMutationHookResult = ReturnType<typeof useCreateMurdocEmbedSessionMutation>;
export type CreateMurdocEmbedSessionMutationResult = Apollo.MutationResult<CreateMurdocEmbedSessionMutation>;
export type CreateMurdocEmbedSessionMutationOptions = Apollo.BaseMutationOptions<CreateMurdocEmbedSessionMutation, CreateMurdocEmbedSessionMutationVariables>;
export const CreateNonprofitToViewedFunderDocument = gql`
    mutation createNonprofitToViewedFunder($nonprofitOrgId: Int!, $funderEin: Int!) {
  createNonprofitToViewedFunder(
    nonprofitOrgId: $nonprofitOrgId
    funderEin: $funderEin
  ) {
    id
    nonprofitOrgId
    fundingOrg990Id
    viewDate
  }
}
    `;
export type CreateNonprofitToViewedFunderMutationFn = Apollo.MutationFunction<CreateNonprofitToViewedFunderMutation, CreateNonprofitToViewedFunderMutationVariables>;

/**
 * __useCreateNonprofitToViewedFunderMutation__
 *
 * To run a mutation, you first call `useCreateNonprofitToViewedFunderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNonprofitToViewedFunderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNonprofitToViewedFunderMutation, { data, loading, error }] = useCreateNonprofitToViewedFunderMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      funderEin: // value for 'funderEin'
 *   },
 * });
 */
export function useCreateNonprofitToViewedFunderMutation(baseOptions?: Apollo.MutationHookOptions<CreateNonprofitToViewedFunderMutation, CreateNonprofitToViewedFunderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNonprofitToViewedFunderMutation, CreateNonprofitToViewedFunderMutationVariables>(CreateNonprofitToViewedFunderDocument, options);
      }
export type CreateNonprofitToViewedFunderMutationHookResult = ReturnType<typeof useCreateNonprofitToViewedFunderMutation>;
export type CreateNonprofitToViewedFunderMutationResult = Apollo.MutationResult<CreateNonprofitToViewedFunderMutation>;
export type CreateNonprofitToViewedFunderMutationOptions = Apollo.BaseMutationOptions<CreateNonprofitToViewedFunderMutation, CreateNonprofitToViewedFunderMutationVariables>;
export const AddCsToNonprofitOrgDocument = gql`
    mutation addCSToNonprofitOrg($nonprofitOrgId: Int!, $userId: Int!) {
  createNonprofitOrgToUserRelationship(
    nonprofitOrgId: $nonprofitOrgId
    userId: $userId
  ) {
    orgName
    orgId
    formationPlan
    platformPlan
  }
}
    `;
export type AddCsToNonprofitOrgMutationFn = Apollo.MutationFunction<AddCsToNonprofitOrgMutation, AddCsToNonprofitOrgMutationVariables>;

/**
 * __useAddCsToNonprofitOrgMutation__
 *
 * To run a mutation, you first call `useAddCsToNonprofitOrgMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCsToNonprofitOrgMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCsToNonprofitOrgMutation, { data, loading, error }] = useAddCsToNonprofitOrgMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddCsToNonprofitOrgMutation(baseOptions?: Apollo.MutationHookOptions<AddCsToNonprofitOrgMutation, AddCsToNonprofitOrgMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCsToNonprofitOrgMutation, AddCsToNonprofitOrgMutationVariables>(AddCsToNonprofitOrgDocument, options);
      }
export type AddCsToNonprofitOrgMutationHookResult = ReturnType<typeof useAddCsToNonprofitOrgMutation>;
export type AddCsToNonprofitOrgMutationResult = Apollo.MutationResult<AddCsToNonprofitOrgMutation>;
export type AddCsToNonprofitOrgMutationOptions = Apollo.BaseMutationOptions<AddCsToNonprofitOrgMutation, AddCsToNonprofitOrgMutationVariables>;
export const CreateNonprofitOrgUserDocument = gql`
    mutation createNonprofitOrgUser($nonprofitUserInfo: GranteeUserInput!, $nonprofitOrgId: Int!, $sendInvite: Boolean, $inviteType: NonprofitOrgInviteType) {
  createNonprofitOrgUser(
    nonprofitUserInfo: $nonprofitUserInfo
    nonprofitOrgId: $nonprofitOrgId
    sendInvite: $sendInvite
    inviteType: $inviteType
  ) {
    email
  }
}
    `;
export type CreateNonprofitOrgUserMutationFn = Apollo.MutationFunction<CreateNonprofitOrgUserMutation, CreateNonprofitOrgUserMutationVariables>;

/**
 * __useCreateNonprofitOrgUserMutation__
 *
 * To run a mutation, you first call `useCreateNonprofitOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNonprofitOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNonprofitOrgUserMutation, { data, loading, error }] = useCreateNonprofitOrgUserMutation({
 *   variables: {
 *      nonprofitUserInfo: // value for 'nonprofitUserInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      sendInvite: // value for 'sendInvite'
 *      inviteType: // value for 'inviteType'
 *   },
 * });
 */
export function useCreateNonprofitOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateNonprofitOrgUserMutation, CreateNonprofitOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNonprofitOrgUserMutation, CreateNonprofitOrgUserMutationVariables>(CreateNonprofitOrgUserDocument, options);
      }
export type CreateNonprofitOrgUserMutationHookResult = ReturnType<typeof useCreateNonprofitOrgUserMutation>;
export type CreateNonprofitOrgUserMutationResult = Apollo.MutationResult<CreateNonprofitOrgUserMutation>;
export type CreateNonprofitOrgUserMutationOptions = Apollo.BaseMutationOptions<CreateNonprofitOrgUserMutation, CreateNonprofitOrgUserMutationVariables>;
export const CreateOrRetrieveCloudinaryConfigDocument = gql`
    mutation createOrRetrieveCloudinaryConfig($orgId: Int!) {
  createOrRetrieveCloudinaryConfig(orgId: $orgId) {
    cloudinaryId
  }
}
    `;
export type CreateOrRetrieveCloudinaryConfigMutationFn = Apollo.MutationFunction<CreateOrRetrieveCloudinaryConfigMutation, CreateOrRetrieveCloudinaryConfigMutationVariables>;

/**
 * __useCreateOrRetrieveCloudinaryConfigMutation__
 *
 * To run a mutation, you first call `useCreateOrRetrieveCloudinaryConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrRetrieveCloudinaryConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrRetrieveCloudinaryConfigMutation, { data, loading, error }] = useCreateOrRetrieveCloudinaryConfigMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useCreateOrRetrieveCloudinaryConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrRetrieveCloudinaryConfigMutation, CreateOrRetrieveCloudinaryConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrRetrieveCloudinaryConfigMutation, CreateOrRetrieveCloudinaryConfigMutationVariables>(CreateOrRetrieveCloudinaryConfigDocument, options);
      }
export type CreateOrRetrieveCloudinaryConfigMutationHookResult = ReturnType<typeof useCreateOrRetrieveCloudinaryConfigMutation>;
export type CreateOrRetrieveCloudinaryConfigMutationResult = Apollo.MutationResult<CreateOrRetrieveCloudinaryConfigMutation>;
export type CreateOrRetrieveCloudinaryConfigMutationOptions = Apollo.BaseMutationOptions<CreateOrRetrieveCloudinaryConfigMutation, CreateOrRetrieveCloudinaryConfigMutationVariables>;
export const CreateReportedMetricGroupDocument = gql`
    mutation createReportedMetricGroup($reportedMetricGroupInfo: ReportedMetricGroupInput!, $nonprofitOrgId: Int!) {
  createReportedMetricGroup(
    reportedMetricGroupInfo: $reportedMetricGroupInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
    title
    NonprofitOrg {
      id
    }
  }
}
    `;
export type CreateReportedMetricGroupMutationFn = Apollo.MutationFunction<CreateReportedMetricGroupMutation, CreateReportedMetricGroupMutationVariables>;

/**
 * __useCreateReportedMetricGroupMutation__
 *
 * To run a mutation, you first call `useCreateReportedMetricGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportedMetricGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportedMetricGroupMutation, { data, loading, error }] = useCreateReportedMetricGroupMutation({
 *   variables: {
 *      reportedMetricGroupInfo: // value for 'reportedMetricGroupInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useCreateReportedMetricGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportedMetricGroupMutation, CreateReportedMetricGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportedMetricGroupMutation, CreateReportedMetricGroupMutationVariables>(CreateReportedMetricGroupDocument, options);
      }
export type CreateReportedMetricGroupMutationHookResult = ReturnType<typeof useCreateReportedMetricGroupMutation>;
export type CreateReportedMetricGroupMutationResult = Apollo.MutationResult<CreateReportedMetricGroupMutation>;
export type CreateReportedMetricGroupMutationOptions = Apollo.BaseMutationOptions<CreateReportedMetricGroupMutation, CreateReportedMetricGroupMutationVariables>;
export const CreateStripeConnectDocument = gql`
    mutation createStripeConnect($nonprofitOrgId: Int!, $email: String!) {
  createStripeConnect(nonprofitOrgId: $nonprofitOrgId, email: $email) {
    id
    payouts_enabled
    capabilities {
      transfers
      card_payments
    }
  }
}
    `;
export type CreateStripeConnectMutationFn = Apollo.MutationFunction<CreateStripeConnectMutation, CreateStripeConnectMutationVariables>;

/**
 * __useCreateStripeConnectMutation__
 *
 * To run a mutation, you first call `useCreateStripeConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeConnectMutation, { data, loading, error }] = useCreateStripeConnectMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateStripeConnectMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeConnectMutation, CreateStripeConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeConnectMutation, CreateStripeConnectMutationVariables>(CreateStripeConnectDocument, options);
      }
export type CreateStripeConnectMutationHookResult = ReturnType<typeof useCreateStripeConnectMutation>;
export type CreateStripeConnectMutationResult = Apollo.MutationResult<CreateStripeConnectMutation>;
export type CreateStripeConnectMutationOptions = Apollo.BaseMutationOptions<CreateStripeConnectMutation, CreateStripeConnectMutationVariables>;
export const CreateTemplateGoalsDocument = gql`
    mutation createTemplateGoals($nonprofitOrgId: Int!, $templateIds: [Int!]!) {
  createTemplateGoals(nonprofitOrgId: $nonprofitOrgId, templateIds: $templateIds) {
    goals {
      id
      type
      templateLibraryId
      title
    }
  }
}
    `;
export type CreateTemplateGoalsMutationFn = Apollo.MutationFunction<CreateTemplateGoalsMutation, CreateTemplateGoalsMutationVariables>;

/**
 * __useCreateTemplateGoalsMutation__
 *
 * To run a mutation, you first call `useCreateTemplateGoalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateGoalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateGoalsMutation, { data, loading, error }] = useCreateTemplateGoalsMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useCreateTemplateGoalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateGoalsMutation, CreateTemplateGoalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateGoalsMutation, CreateTemplateGoalsMutationVariables>(CreateTemplateGoalsDocument, options);
      }
export type CreateTemplateGoalsMutationHookResult = ReturnType<typeof useCreateTemplateGoalsMutation>;
export type CreateTemplateGoalsMutationResult = Apollo.MutationResult<CreateTemplateGoalsMutation>;
export type CreateTemplateGoalsMutationOptions = Apollo.BaseMutationOptions<CreateTemplateGoalsMutation, CreateTemplateGoalsMutationVariables>;
export const CreateIncompleteUserSurveysDocument = gql`
    mutation CreateIncompleteUserSurveys($userIds: [Int!]!) {
  createIncompleteUserSurveys(userIds: $userIds) {
    userIds
  }
}
    `;
export type CreateIncompleteUserSurveysMutationFn = Apollo.MutationFunction<CreateIncompleteUserSurveysMutation, CreateIncompleteUserSurveysMutationVariables>;

/**
 * __useCreateIncompleteUserSurveysMutation__
 *
 * To run a mutation, you first call `useCreateIncompleteUserSurveysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncompleteUserSurveysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncompleteUserSurveysMutation, { data, loading, error }] = useCreateIncompleteUserSurveysMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useCreateIncompleteUserSurveysMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncompleteUserSurveysMutation, CreateIncompleteUserSurveysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncompleteUserSurveysMutation, CreateIncompleteUserSurveysMutationVariables>(CreateIncompleteUserSurveysDocument, options);
      }
export type CreateIncompleteUserSurveysMutationHookResult = ReturnType<typeof useCreateIncompleteUserSurveysMutation>;
export type CreateIncompleteUserSurveysMutationResult = Apollo.MutationResult<CreateIncompleteUserSurveysMutation>;
export type CreateIncompleteUserSurveysMutationOptions = Apollo.BaseMutationOptions<CreateIncompleteUserSurveysMutation, CreateIncompleteUserSurveysMutationVariables>;
export const DeleteChecklistItemDocument = gql`
    mutation deleteChecklistItem($id: Int!, $nonprofitOrgId: Int!) {
  deleteChecklistItem(id: $id, nonprofitOrgId: $nonprofitOrgId) {
    id
  }
}
    `;
export type DeleteChecklistItemMutationFn = Apollo.MutationFunction<DeleteChecklistItemMutation, DeleteChecklistItemMutationVariables>;

/**
 * __useDeleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useDeleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChecklistItemMutation, { data, loading, error }] = useDeleteChecklistItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useDeleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChecklistItemMutation, DeleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChecklistItemMutation, DeleteChecklistItemMutationVariables>(DeleteChecklistItemDocument, options);
      }
export type DeleteChecklistItemMutationHookResult = ReturnType<typeof useDeleteChecklistItemMutation>;
export type DeleteChecklistItemMutationResult = Apollo.MutationResult<DeleteChecklistItemMutation>;
export type DeleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<DeleteChecklistItemMutation, DeleteChecklistItemMutationVariables>;
export const DeleteGoalDimensionRelationshipDocument = gql`
    mutation deleteGoalDimensionRelationship($goalToDimensionId: Int!) {
  deleteGoalDimensionRelationship(goalToDimensionId: $goalToDimensionId) {
    success
  }
}
    `;
export type DeleteGoalDimensionRelationshipMutationFn = Apollo.MutationFunction<DeleteGoalDimensionRelationshipMutation, DeleteGoalDimensionRelationshipMutationVariables>;

/**
 * __useDeleteGoalDimensionRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteGoalDimensionRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoalDimensionRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoalDimensionRelationshipMutation, { data, loading, error }] = useDeleteGoalDimensionRelationshipMutation({
 *   variables: {
 *      goalToDimensionId: // value for 'goalToDimensionId'
 *   },
 * });
 */
export function useDeleteGoalDimensionRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoalDimensionRelationshipMutation, DeleteGoalDimensionRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoalDimensionRelationshipMutation, DeleteGoalDimensionRelationshipMutationVariables>(DeleteGoalDimensionRelationshipDocument, options);
      }
export type DeleteGoalDimensionRelationshipMutationHookResult = ReturnType<typeof useDeleteGoalDimensionRelationshipMutation>;
export type DeleteGoalDimensionRelationshipMutationResult = Apollo.MutationResult<DeleteGoalDimensionRelationshipMutation>;
export type DeleteGoalDimensionRelationshipMutationOptions = Apollo.BaseMutationOptions<DeleteGoalDimensionRelationshipMutation, DeleteGoalDimensionRelationshipMutationVariables>;
export const DeleteGoalUpdateDocument = gql`
    mutation deleteGoalUpdate($goalUpdateId: Int!, $nonprofitOrgId: Int!) {
  deleteGoalUpdate(goalUpdateId: $goalUpdateId, nonprofitOrgId: $nonprofitOrgId) {
    id
  }
}
    `;
export type DeleteGoalUpdateMutationFn = Apollo.MutationFunction<DeleteGoalUpdateMutation, DeleteGoalUpdateMutationVariables>;

/**
 * __useDeleteGoalUpdateMutation__
 *
 * To run a mutation, you first call `useDeleteGoalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGoalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGoalUpdateMutation, { data, loading, error }] = useDeleteGoalUpdateMutation({
 *   variables: {
 *      goalUpdateId: // value for 'goalUpdateId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useDeleteGoalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGoalUpdateMutation, DeleteGoalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGoalUpdateMutation, DeleteGoalUpdateMutationVariables>(DeleteGoalUpdateDocument, options);
      }
export type DeleteGoalUpdateMutationHookResult = ReturnType<typeof useDeleteGoalUpdateMutation>;
export type DeleteGoalUpdateMutationResult = Apollo.MutationResult<DeleteGoalUpdateMutation>;
export type DeleteGoalUpdateMutationOptions = Apollo.BaseMutationOptions<DeleteGoalUpdateMutation, DeleteGoalUpdateMutationVariables>;
export const DeleteRecurringTasksDocument = gql`
    mutation deleteRecurringTasks($checklistItemId: Int!, $checklistItemGroupId: Int!, $option: DeleteRecurringTasksOption!, $nonprofitOrgId: Int!) {
  deleteRecurringTasks(
    checklistItemId: $checklistItemId
    checklistItemGroupId: $checklistItemGroupId
    option: $option
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
  }
}
    `;
export type DeleteRecurringTasksMutationFn = Apollo.MutationFunction<DeleteRecurringTasksMutation, DeleteRecurringTasksMutationVariables>;

/**
 * __useDeleteRecurringTasksMutation__
 *
 * To run a mutation, you first call `useDeleteRecurringTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurringTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurringTasksMutation, { data, loading, error }] = useDeleteRecurringTasksMutation({
 *   variables: {
 *      checklistItemId: // value for 'checklistItemId'
 *      checklistItemGroupId: // value for 'checklistItemGroupId'
 *      option: // value for 'option'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useDeleteRecurringTasksMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurringTasksMutation, DeleteRecurringTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurringTasksMutation, DeleteRecurringTasksMutationVariables>(DeleteRecurringTasksDocument, options);
      }
export type DeleteRecurringTasksMutationHookResult = ReturnType<typeof useDeleteRecurringTasksMutation>;
export type DeleteRecurringTasksMutationResult = Apollo.MutationResult<DeleteRecurringTasksMutation>;
export type DeleteRecurringTasksMutationOptions = Apollo.BaseMutationOptions<DeleteRecurringTasksMutation, DeleteRecurringTasksMutationVariables>;
export const DisconnectQuickBooksDocument = gql`
    mutation disconnectQuickBooks($orgId: Int!) {
  disconnectQuickBooks(orgId: $orgId)
}
    `;
export type DisconnectQuickBooksMutationFn = Apollo.MutationFunction<DisconnectQuickBooksMutation, DisconnectQuickBooksMutationVariables>;

/**
 * __useDisconnectQuickBooksMutation__
 *
 * To run a mutation, you first call `useDisconnectQuickBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectQuickBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectQuickBooksMutation, { data, loading, error }] = useDisconnectQuickBooksMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useDisconnectQuickBooksMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectQuickBooksMutation, DisconnectQuickBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectQuickBooksMutation, DisconnectQuickBooksMutationVariables>(DisconnectQuickBooksDocument, options);
      }
export type DisconnectQuickBooksMutationHookResult = ReturnType<typeof useDisconnectQuickBooksMutation>;
export type DisconnectQuickBooksMutationResult = Apollo.MutationResult<DisconnectQuickBooksMutation>;
export type DisconnectQuickBooksMutationOptions = Apollo.BaseMutationOptions<DisconnectQuickBooksMutation, DisconnectQuickBooksMutationVariables>;
export const DuplicateStoryDocument = gql`
    mutation duplicateStory($storyId: Int!) {
  duplicateStory(storyId: $storyId) {
    id
    nonprofitOrgId
    title
    updatedAt
    publishedAt
    urlTitle
    previewTitle
    previewDescription
    previewImageId
    previewImageCloudinaryFileId
    hashedId
    blocks {
      id
      assetId
      backgroundColor
      assetType
      createdAt
      updatedAt
      asset {
        id
        assetType
        assetDetails
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type DuplicateStoryMutationFn = Apollo.MutationFunction<DuplicateStoryMutation, DuplicateStoryMutationVariables>;

/**
 * __useDuplicateStoryMutation__
 *
 * To run a mutation, you first call `useDuplicateStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateStoryMutation, { data, loading, error }] = useDuplicateStoryMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useDuplicateStoryMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateStoryMutation, DuplicateStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateStoryMutation, DuplicateStoryMutationVariables>(DuplicateStoryDocument, options);
      }
export type DuplicateStoryMutationHookResult = ReturnType<typeof useDuplicateStoryMutation>;
export type DuplicateStoryMutationResult = Apollo.MutationResult<DuplicateStoryMutation>;
export type DuplicateStoryMutationOptions = Apollo.BaseMutationOptions<DuplicateStoryMutation, DuplicateStoryMutationVariables>;
export const EditGoalGroupDocument = gql`
    mutation EditGoalGroup($data: CreateGoalGroupInput!, $funderOrgId: Int!, $goalGroupId: Int!) {
  editGoalGroup(data: $data, funderOrgId: $funderOrgId, goalGroupId: $goalGroupId) {
    id
    title
    description
    category
    startDate
    endDate
  }
}
    `;
export type EditGoalGroupMutationFn = Apollo.MutationFunction<EditGoalGroupMutation, EditGoalGroupMutationVariables>;

/**
 * __useEditGoalGroupMutation__
 *
 * To run a mutation, you first call `useEditGoalGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGoalGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGoalGroupMutation, { data, loading, error }] = useEditGoalGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      funderOrgId: // value for 'funderOrgId'
 *      goalGroupId: // value for 'goalGroupId'
 *   },
 * });
 */
export function useEditGoalGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditGoalGroupMutation, EditGoalGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGoalGroupMutation, EditGoalGroupMutationVariables>(EditGoalGroupDocument, options);
      }
export type EditGoalGroupMutationHookResult = ReturnType<typeof useEditGoalGroupMutation>;
export type EditGoalGroupMutationResult = Apollo.MutationResult<EditGoalGroupMutation>;
export type EditGoalGroupMutationOptions = Apollo.BaseMutationOptions<EditGoalGroupMutation, EditGoalGroupMutationVariables>;
export const EndLoginAsDocument = gql`
    mutation EndLoginAs {
  endLoginAs {
    success
  }
}
    `;
export type EndLoginAsMutationFn = Apollo.MutationFunction<EndLoginAsMutation, EndLoginAsMutationVariables>;

/**
 * __useEndLoginAsMutation__
 *
 * To run a mutation, you first call `useEndLoginAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndLoginAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endLoginAsMutation, { data, loading, error }] = useEndLoginAsMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndLoginAsMutation(baseOptions?: Apollo.MutationHookOptions<EndLoginAsMutation, EndLoginAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndLoginAsMutation, EndLoginAsMutationVariables>(EndLoginAsDocument, options);
      }
export type EndLoginAsMutationHookResult = ReturnType<typeof useEndLoginAsMutation>;
export type EndLoginAsMutationResult = Apollo.MutationResult<EndLoginAsMutation>;
export type EndLoginAsMutationOptions = Apollo.BaseMutationOptions<EndLoginAsMutation, EndLoginAsMutationVariables>;
export const ExtractDocumentTextDocument = gql`
    mutation ExtractDocumentText($input: ExtractDocumentTextInput!) {
  extractDocumentText(input: $input) {
    text
    truncated
    characterCount
  }
}
    `;
export type ExtractDocumentTextMutationFn = Apollo.MutationFunction<ExtractDocumentTextMutation, ExtractDocumentTextMutationVariables>;

/**
 * __useExtractDocumentTextMutation__
 *
 * To run a mutation, you first call `useExtractDocumentTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractDocumentTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractDocumentTextMutation, { data, loading, error }] = useExtractDocumentTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractDocumentTextMutation(baseOptions?: Apollo.MutationHookOptions<ExtractDocumentTextMutation, ExtractDocumentTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtractDocumentTextMutation, ExtractDocumentTextMutationVariables>(ExtractDocumentTextDocument, options);
      }
export type ExtractDocumentTextMutationHookResult = ReturnType<typeof useExtractDocumentTextMutation>;
export type ExtractDocumentTextMutationResult = Apollo.MutationResult<ExtractDocumentTextMutation>;
export type ExtractDocumentTextMutationOptions = Apollo.BaseMutationOptions<ExtractDocumentTextMutation, ExtractDocumentTextMutationVariables>;
export const FindDuplicateUsersDocument = gql`
    query findDuplicateUsers($emails: [String!]!, $nonprofitOrgId: Int!) {
  findDuplicateUsers(emails: $emails, nonprofitOrgId: $nonprofitOrgId) {
    emails
  }
}
    `;

/**
 * __useFindDuplicateUsersQuery__
 *
 * To run a query within a React component, call `useFindDuplicateUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDuplicateUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDuplicateUsersQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useFindDuplicateUsersQuery(baseOptions: Apollo.QueryHookOptions<FindDuplicateUsersQuery, FindDuplicateUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDuplicateUsersQuery, FindDuplicateUsersQueryVariables>(FindDuplicateUsersDocument, options);
      }
export function useFindDuplicateUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDuplicateUsersQuery, FindDuplicateUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDuplicateUsersQuery, FindDuplicateUsersQueryVariables>(FindDuplicateUsersDocument, options);
        }
export type FindDuplicateUsersQueryHookResult = ReturnType<typeof useFindDuplicateUsersQuery>;
export type FindDuplicateUsersLazyQueryHookResult = ReturnType<typeof useFindDuplicateUsersLazyQuery>;
export type FindDuplicateUsersQueryResult = Apollo.QueryResult<FindDuplicateUsersQuery, FindDuplicateUsersQueryVariables>;
export const FindOrCreateColorThemeDocument = gql`
    mutation FindOrCreateColorTheme($chosenColor: String!) {
  FindOrCreateColorTheme(chosenColor: $chosenColor) {
    id
    color
  }
}
    `;
export type FindOrCreateColorThemeMutationFn = Apollo.MutationFunction<FindOrCreateColorThemeMutation, FindOrCreateColorThemeMutationVariables>;

/**
 * __useFindOrCreateColorThemeMutation__
 *
 * To run a mutation, you first call `useFindOrCreateColorThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindOrCreateColorThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findOrCreateColorThemeMutation, { data, loading, error }] = useFindOrCreateColorThemeMutation({
 *   variables: {
 *      chosenColor: // value for 'chosenColor'
 *   },
 * });
 */
export function useFindOrCreateColorThemeMutation(baseOptions?: Apollo.MutationHookOptions<FindOrCreateColorThemeMutation, FindOrCreateColorThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindOrCreateColorThemeMutation, FindOrCreateColorThemeMutationVariables>(FindOrCreateColorThemeDocument, options);
      }
export type FindOrCreateColorThemeMutationHookResult = ReturnType<typeof useFindOrCreateColorThemeMutation>;
export type FindOrCreateColorThemeMutationResult = Apollo.MutationResult<FindOrCreateColorThemeMutation>;
export type FindOrCreateColorThemeMutationOptions = Apollo.BaseMutationOptions<FindOrCreateColorThemeMutation, FindOrCreateColorThemeMutationVariables>;
export const GenerateFinancialHealthAssessmentReportDocument = gql`
    mutation GenerateFinancialHealthAssessmentReport($input: GenerateFinancialHealthAssessmentReportInput!) {
  generateFinancialHealthAssessmentReport(input: $input) {
    runId
    status
    reportSlug
    progressUrl
    userId
    reportData
  }
}
    `;
export type GenerateFinancialHealthAssessmentReportMutationFn = Apollo.MutationFunction<GenerateFinancialHealthAssessmentReportMutation, GenerateFinancialHealthAssessmentReportMutationVariables>;

/**
 * __useGenerateFinancialHealthAssessmentReportMutation__
 *
 * To run a mutation, you first call `useGenerateFinancialHealthAssessmentReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFinancialHealthAssessmentReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFinancialHealthAssessmentReportMutation, { data, loading, error }] = useGenerateFinancialHealthAssessmentReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateFinancialHealthAssessmentReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateFinancialHealthAssessmentReportMutation, GenerateFinancialHealthAssessmentReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateFinancialHealthAssessmentReportMutation, GenerateFinancialHealthAssessmentReportMutationVariables>(GenerateFinancialHealthAssessmentReportDocument, options);
      }
export type GenerateFinancialHealthAssessmentReportMutationHookResult = ReturnType<typeof useGenerateFinancialHealthAssessmentReportMutation>;
export type GenerateFinancialHealthAssessmentReportMutationResult = Apollo.MutationResult<GenerateFinancialHealthAssessmentReportMutation>;
export type GenerateFinancialHealthAssessmentReportMutationOptions = Apollo.BaseMutationOptions<GenerateFinancialHealthAssessmentReportMutation, GenerateFinancialHealthAssessmentReportMutationVariables>;
export const GenerateGrantAnalysisReportDocument = gql`
    mutation GenerateGrantAnalysisReport($input: GenerateGrantAnalysisReportInput!) {
  generateGrantAnalysisReport(input: $input) {
    runId
    status
    reportSlug
    userId
  }
}
    `;
export type GenerateGrantAnalysisReportMutationFn = Apollo.MutationFunction<GenerateGrantAnalysisReportMutation, GenerateGrantAnalysisReportMutationVariables>;

/**
 * __useGenerateGrantAnalysisReportMutation__
 *
 * To run a mutation, you first call `useGenerateGrantAnalysisReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGrantAnalysisReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGrantAnalysisReportMutation, { data, loading, error }] = useGenerateGrantAnalysisReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateGrantAnalysisReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGrantAnalysisReportMutation, GenerateGrantAnalysisReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGrantAnalysisReportMutation, GenerateGrantAnalysisReportMutationVariables>(GenerateGrantAnalysisReportDocument, options);
      }
export type GenerateGrantAnalysisReportMutationHookResult = ReturnType<typeof useGenerateGrantAnalysisReportMutation>;
export type GenerateGrantAnalysisReportMutationResult = Apollo.MutationResult<GenerateGrantAnalysisReportMutation>;
export type GenerateGrantAnalysisReportMutationOptions = Apollo.BaseMutationOptions<GenerateGrantAnalysisReportMutation, GenerateGrantAnalysisReportMutationVariables>;
export const GenerateMcpApiKeyDocument = gql`
    mutation generateMcpApiKey($name: String!) {
  generateMcpApiKey(name: $name) {
    id
    name
    key
    createdAt
    expiresAt
    revokedAt
    lastUsedAt
  }
}
    `;
export type GenerateMcpApiKeyMutationFn = Apollo.MutationFunction<GenerateMcpApiKeyMutation, GenerateMcpApiKeyMutationVariables>;

/**
 * __useGenerateMcpApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateMcpApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMcpApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMcpApiKeyMutation, { data, loading, error }] = useGenerateMcpApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGenerateMcpApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMcpApiKeyMutation, GenerateMcpApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMcpApiKeyMutation, GenerateMcpApiKeyMutationVariables>(GenerateMcpApiKeyDocument, options);
      }
export type GenerateMcpApiKeyMutationHookResult = ReturnType<typeof useGenerateMcpApiKeyMutation>;
export type GenerateMcpApiKeyMutationResult = Apollo.MutationResult<GenerateMcpApiKeyMutation>;
export type GenerateMcpApiKeyMutationOptions = Apollo.BaseMutationOptions<GenerateMcpApiKeyMutation, GenerateMcpApiKeyMutationVariables>;
export const GenerateNonprofitIntelligenceReportDocument = gql`
    mutation GenerateNonprofitIntelligenceReport($input: GenerateNonprofitIntelligenceReportInput!) {
  generateNonprofitIntelligenceReport(input: $input) {
    runId
    status
    reportSlug
    userId
  }
}
    `;
export type GenerateNonprofitIntelligenceReportMutationFn = Apollo.MutationFunction<GenerateNonprofitIntelligenceReportMutation, GenerateNonprofitIntelligenceReportMutationVariables>;

/**
 * __useGenerateNonprofitIntelligenceReportMutation__
 *
 * To run a mutation, you first call `useGenerateNonprofitIntelligenceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateNonprofitIntelligenceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateNonprofitIntelligenceReportMutation, { data, loading, error }] = useGenerateNonprofitIntelligenceReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateNonprofitIntelligenceReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateNonprofitIntelligenceReportMutation, GenerateNonprofitIntelligenceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateNonprofitIntelligenceReportMutation, GenerateNonprofitIntelligenceReportMutationVariables>(GenerateNonprofitIntelligenceReportDocument, options);
      }
export type GenerateNonprofitIntelligenceReportMutationHookResult = ReturnType<typeof useGenerateNonprofitIntelligenceReportMutation>;
export type GenerateNonprofitIntelligenceReportMutationResult = Apollo.MutationResult<GenerateNonprofitIntelligenceReportMutation>;
export type GenerateNonprofitIntelligenceReportMutationOptions = Apollo.BaseMutationOptions<GenerateNonprofitIntelligenceReportMutation, GenerateNonprofitIntelligenceReportMutationVariables>;
export const GenerateStoryFromMurdocOpportunityDocument = gql`
    mutation generateStoryFromMurdocOpportunity($input: GenerateStoryFromMurdocOpportunityInput!) {
  generateStoryFromMurdocOpportunity(input: $input) {
    blocks {
      ... on AiTextBlockType {
        blocks {
          key
          data
          text
          type
          depth
          entityRanges
          inlineStyleRanges
        }
        entityMap
        type
      }
      ... on AiImageBlockType {
        cloudinaryFileId
        type
      }
      ... on AiCtaBlockType {
        buttonText
        note
        url
        type
      }
    }
    template
    hasError
    isInappropriate
  }
}
    `;
export type GenerateStoryFromMurdocOpportunityMutationFn = Apollo.MutationFunction<GenerateStoryFromMurdocOpportunityMutation, GenerateStoryFromMurdocOpportunityMutationVariables>;

/**
 * __useGenerateStoryFromMurdocOpportunityMutation__
 *
 * To run a mutation, you first call `useGenerateStoryFromMurdocOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStoryFromMurdocOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStoryFromMurdocOpportunityMutation, { data, loading, error }] = useGenerateStoryFromMurdocOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateStoryFromMurdocOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<GenerateStoryFromMurdocOpportunityMutation, GenerateStoryFromMurdocOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateStoryFromMurdocOpportunityMutation, GenerateStoryFromMurdocOpportunityMutationVariables>(GenerateStoryFromMurdocOpportunityDocument, options);
      }
export type GenerateStoryFromMurdocOpportunityMutationHookResult = ReturnType<typeof useGenerateStoryFromMurdocOpportunityMutation>;
export type GenerateStoryFromMurdocOpportunityMutationResult = Apollo.MutationResult<GenerateStoryFromMurdocOpportunityMutation>;
export type GenerateStoryFromMurdocOpportunityMutationOptions = Apollo.BaseMutationOptions<GenerateStoryFromMurdocOpportunityMutation, GenerateStoryFromMurdocOpportunityMutationVariables>;
export const GetNewBoxTokenDocument = gql`
    mutation getNewBoxToken($userId: Int!) {
  getNewBoxToken(userId: $userId) {
    tokenData {
      accessToken
      expiresIn
      acquiredAt
    }
  }
}
    `;
export type GetNewBoxTokenMutationFn = Apollo.MutationFunction<GetNewBoxTokenMutation, GetNewBoxTokenMutationVariables>;

/**
 * __useGetNewBoxTokenMutation__
 *
 * To run a mutation, you first call `useGetNewBoxTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetNewBoxTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getNewBoxTokenMutation, { data, loading, error }] = useGetNewBoxTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNewBoxTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetNewBoxTokenMutation, GetNewBoxTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetNewBoxTokenMutation, GetNewBoxTokenMutationVariables>(GetNewBoxTokenDocument, options);
      }
export type GetNewBoxTokenMutationHookResult = ReturnType<typeof useGetNewBoxTokenMutation>;
export type GetNewBoxTokenMutationResult = Apollo.MutationResult<GetNewBoxTokenMutation>;
export type GetNewBoxTokenMutationOptions = Apollo.BaseMutationOptions<GetNewBoxTokenMutation, GetNewBoxTokenMutationVariables>;
export const GenerateGrantResearchReportDocument = gql`
    mutation generateGrantResearchReport($nonprofitOrgId: Int!) {
  generateGrantResearchReport(nonprofitOrgId: $nonprofitOrgId) {
    id
    status
    createdAt
  }
}
    `;
export type GenerateGrantResearchReportMutationFn = Apollo.MutationFunction<GenerateGrantResearchReportMutation, GenerateGrantResearchReportMutationVariables>;

/**
 * __useGenerateGrantResearchReportMutation__
 *
 * To run a mutation, you first call `useGenerateGrantResearchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGrantResearchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGrantResearchReportMutation, { data, loading, error }] = useGenerateGrantResearchReportMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGenerateGrantResearchReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGrantResearchReportMutation, GenerateGrantResearchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGrantResearchReportMutation, GenerateGrantResearchReportMutationVariables>(GenerateGrantResearchReportDocument, options);
      }
export type GenerateGrantResearchReportMutationHookResult = ReturnType<typeof useGenerateGrantResearchReportMutation>;
export type GenerateGrantResearchReportMutationResult = Apollo.MutationResult<GenerateGrantResearchReportMutation>;
export type GenerateGrantResearchReportMutationOptions = Apollo.BaseMutationOptions<GenerateGrantResearchReportMutation, GenerateGrantResearchReportMutationVariables>;
export const SaveResearchedGrantDocument = gql`
    mutation saveResearchedGrant($grantId: Int!) {
  saveResearchedGrant(grantId: $grantId) {
    id
    status
    savedAt
  }
}
    `;
export type SaveResearchedGrantMutationFn = Apollo.MutationFunction<SaveResearchedGrantMutation, SaveResearchedGrantMutationVariables>;

/**
 * __useSaveResearchedGrantMutation__
 *
 * To run a mutation, you first call `useSaveResearchedGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveResearchedGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveResearchedGrantMutation, { data, loading, error }] = useSaveResearchedGrantMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *   },
 * });
 */
export function useSaveResearchedGrantMutation(baseOptions?: Apollo.MutationHookOptions<SaveResearchedGrantMutation, SaveResearchedGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveResearchedGrantMutation, SaveResearchedGrantMutationVariables>(SaveResearchedGrantDocument, options);
      }
export type SaveResearchedGrantMutationHookResult = ReturnType<typeof useSaveResearchedGrantMutation>;
export type SaveResearchedGrantMutationResult = Apollo.MutationResult<SaveResearchedGrantMutation>;
export type SaveResearchedGrantMutationOptions = Apollo.BaseMutationOptions<SaveResearchedGrantMutation, SaveResearchedGrantMutationVariables>;
export const DismissResearchedGrantDocument = gql`
    mutation dismissResearchedGrant($grantId: Int!) {
  dismissResearchedGrant(grantId: $grantId) {
    id
    status
    dismissedAt
  }
}
    `;
export type DismissResearchedGrantMutationFn = Apollo.MutationFunction<DismissResearchedGrantMutation, DismissResearchedGrantMutationVariables>;

/**
 * __useDismissResearchedGrantMutation__
 *
 * To run a mutation, you first call `useDismissResearchedGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissResearchedGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissResearchedGrantMutation, { data, loading, error }] = useDismissResearchedGrantMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *   },
 * });
 */
export function useDismissResearchedGrantMutation(baseOptions?: Apollo.MutationHookOptions<DismissResearchedGrantMutation, DismissResearchedGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissResearchedGrantMutation, DismissResearchedGrantMutationVariables>(DismissResearchedGrantDocument, options);
      }
export type DismissResearchedGrantMutationHookResult = ReturnType<typeof useDismissResearchedGrantMutation>;
export type DismissResearchedGrantMutationResult = Apollo.MutationResult<DismissResearchedGrantMutation>;
export type DismissResearchedGrantMutationOptions = Apollo.BaseMutationOptions<DismissResearchedGrantMutation, DismissResearchedGrantMutationVariables>;
export const InitializeCommunityDocument = gql`
    mutation initializeCommunity($agreedCommunityGuidelines: Boolean!, $name: String, $spaceSlug: String, $postSlug: String, $orgName: String) {
  initializeCommunity(
    agreedCommunityGuidelines: $agreedCommunityGuidelines
    name: $name
    spaceSlug: $spaceSlug
    postSlug: $postSlug
    orgName: $orgName
  ) {
    communityURL
  }
}
    `;
export type InitializeCommunityMutationFn = Apollo.MutationFunction<InitializeCommunityMutation, InitializeCommunityMutationVariables>;

/**
 * __useInitializeCommunityMutation__
 *
 * To run a mutation, you first call `useInitializeCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeCommunityMutation, { data, loading, error }] = useInitializeCommunityMutation({
 *   variables: {
 *      agreedCommunityGuidelines: // value for 'agreedCommunityGuidelines'
 *      name: // value for 'name'
 *      spaceSlug: // value for 'spaceSlug'
 *      postSlug: // value for 'postSlug'
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useInitializeCommunityMutation(baseOptions?: Apollo.MutationHookOptions<InitializeCommunityMutation, InitializeCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeCommunityMutation, InitializeCommunityMutationVariables>(InitializeCommunityDocument, options);
      }
export type InitializeCommunityMutationHookResult = ReturnType<typeof useInitializeCommunityMutation>;
export type InitializeCommunityMutationResult = Apollo.MutationResult<InitializeCommunityMutation>;
export type InitializeCommunityMutationOptions = Apollo.BaseMutationOptions<InitializeCommunityMutation, InitializeCommunityMutationVariables>;
export const InitiateQuickBooksConnectionDocument = gql`
    mutation initiateQuickBooksConnection($orgId: Int!) {
  initiateQuickBooksConnection(orgId: $orgId) {
    url
    state
  }
}
    `;
export type InitiateQuickBooksConnectionMutationFn = Apollo.MutationFunction<InitiateQuickBooksConnectionMutation, InitiateQuickBooksConnectionMutationVariables>;

/**
 * __useInitiateQuickBooksConnectionMutation__
 *
 * To run a mutation, you first call `useInitiateQuickBooksConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateQuickBooksConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateQuickBooksConnectionMutation, { data, loading, error }] = useInitiateQuickBooksConnectionMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useInitiateQuickBooksConnectionMutation(baseOptions?: Apollo.MutationHookOptions<InitiateQuickBooksConnectionMutation, InitiateQuickBooksConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateQuickBooksConnectionMutation, InitiateQuickBooksConnectionMutationVariables>(InitiateQuickBooksConnectionDocument, options);
      }
export type InitiateQuickBooksConnectionMutationHookResult = ReturnType<typeof useInitiateQuickBooksConnectionMutation>;
export type InitiateQuickBooksConnectionMutationResult = Apollo.MutationResult<InitiateQuickBooksConnectionMutation>;
export type InitiateQuickBooksConnectionMutationOptions = Apollo.BaseMutationOptions<InitiateQuickBooksConnectionMutation, InitiateQuickBooksConnectionMutationVariables>;
export const LoginAsDocument = gql`
    mutation LoginAs($userId: Int!) {
  loginAs(userId: $userId) {
    success
  }
}
    `;
export type LoginAsMutationFn = Apollo.MutationFunction<LoginAsMutation, LoginAsMutationVariables>;

/**
 * __useLoginAsMutation__
 *
 * To run a mutation, you first call `useLoginAsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsMutation, { data, loading, error }] = useLoginAsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLoginAsMutation(baseOptions?: Apollo.MutationHookOptions<LoginAsMutation, LoginAsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAsMutation, LoginAsMutationVariables>(LoginAsDocument, options);
      }
export type LoginAsMutationHookResult = ReturnType<typeof useLoginAsMutation>;
export type LoginAsMutationResult = Apollo.MutationResult<LoginAsMutation>;
export type LoginAsMutationOptions = Apollo.BaseMutationOptions<LoginAsMutation, LoginAsMutationVariables>;
export const MarkTaskAsCompletedDocument = gql`
    mutation markTaskAsCompleted($taskId: Int!) {
  markTaskAsCompleted(taskId: $taskId) {
    checklistItem {
      id
      title
      isCompleted
      lastUpdatedUser {
        id
        firstName
        lastName
      }
      owner {
        id
        firstName
        lastName
      }
      updatedAt
      resourceId
      dueDate
      linkText
      linkUrl
    }
    additionalInformation {
      goalId
      goalType
      initiativeId
      templateLibraryId
    }
  }
}
    `;
export type MarkTaskAsCompletedMutationFn = Apollo.MutationFunction<MarkTaskAsCompletedMutation, MarkTaskAsCompletedMutationVariables>;

/**
 * __useMarkTaskAsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkTaskAsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTaskAsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTaskAsCompletedMutation, { data, loading, error }] = useMarkTaskAsCompletedMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useMarkTaskAsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTaskAsCompletedMutation, MarkTaskAsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTaskAsCompletedMutation, MarkTaskAsCompletedMutationVariables>(MarkTaskAsCompletedDocument, options);
      }
export type MarkTaskAsCompletedMutationHookResult = ReturnType<typeof useMarkTaskAsCompletedMutation>;
export type MarkTaskAsCompletedMutationResult = Apollo.MutationResult<MarkTaskAsCompletedMutation>;
export type MarkTaskAsCompletedMutationOptions = Apollo.BaseMutationOptions<MarkTaskAsCompletedMutation, MarkTaskAsCompletedMutationVariables>;
export const NotifyResiliaToAddGoalDocument = gql`
    mutation NotifyResiliaToAddGoal($userId: Int!) {
  notifyResiliaToAddGoal(userId: $userId)
}
    `;
export type NotifyResiliaToAddGoalMutationFn = Apollo.MutationFunction<NotifyResiliaToAddGoalMutation, NotifyResiliaToAddGoalMutationVariables>;

/**
 * __useNotifyResiliaToAddGoalMutation__
 *
 * To run a mutation, you first call `useNotifyResiliaToAddGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyResiliaToAddGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyResiliaToAddGoalMutation, { data, loading, error }] = useNotifyResiliaToAddGoalMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotifyResiliaToAddGoalMutation(baseOptions?: Apollo.MutationHookOptions<NotifyResiliaToAddGoalMutation, NotifyResiliaToAddGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyResiliaToAddGoalMutation, NotifyResiliaToAddGoalMutationVariables>(NotifyResiliaToAddGoalDocument, options);
      }
export type NotifyResiliaToAddGoalMutationHookResult = ReturnType<typeof useNotifyResiliaToAddGoalMutation>;
export type NotifyResiliaToAddGoalMutationResult = Apollo.MutationResult<NotifyResiliaToAddGoalMutation>;
export type NotifyResiliaToAddGoalMutationOptions = Apollo.BaseMutationOptions<NotifyResiliaToAddGoalMutation, NotifyResiliaToAddGoalMutationVariables>;
export const PromptProgressUpdateDocument = gql`
    mutation PromptProgressUpdate {
  promptProgressUpdate {
    success
  }
}
    `;
export type PromptProgressUpdateMutationFn = Apollo.MutationFunction<PromptProgressUpdateMutation, PromptProgressUpdateMutationVariables>;

/**
 * __usePromptProgressUpdateMutation__
 *
 * To run a mutation, you first call `usePromptProgressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromptProgressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promptProgressUpdateMutation, { data, loading, error }] = usePromptProgressUpdateMutation({
 *   variables: {
 *   },
 * });
 */
export function usePromptProgressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PromptProgressUpdateMutation, PromptProgressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromptProgressUpdateMutation, PromptProgressUpdateMutationVariables>(PromptProgressUpdateDocument, options);
      }
export type PromptProgressUpdateMutationHookResult = ReturnType<typeof usePromptProgressUpdateMutation>;
export type PromptProgressUpdateMutationResult = Apollo.MutationResult<PromptProgressUpdateMutation>;
export type PromptProgressUpdateMutationOptions = Apollo.BaseMutationOptions<PromptProgressUpdateMutation, PromptProgressUpdateMutationVariables>;
export const RefetchGongTranscriptDocument = gql`
    mutation RefetchGongTranscript($id: Int!) {
  refetchGongTranscript(id: $id) {
    success
  }
}
    `;
export type RefetchGongTranscriptMutationFn = Apollo.MutationFunction<RefetchGongTranscriptMutation, RefetchGongTranscriptMutationVariables>;

/**
 * __useRefetchGongTranscriptMutation__
 *
 * To run a mutation, you first call `useRefetchGongTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchGongTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchGongTranscriptMutation, { data, loading, error }] = useRefetchGongTranscriptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefetchGongTranscriptMutation(baseOptions?: Apollo.MutationHookOptions<RefetchGongTranscriptMutation, RefetchGongTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchGongTranscriptMutation, RefetchGongTranscriptMutationVariables>(RefetchGongTranscriptDocument, options);
      }
export type RefetchGongTranscriptMutationHookResult = ReturnType<typeof useRefetchGongTranscriptMutation>;
export type RefetchGongTranscriptMutationResult = Apollo.MutationResult<RefetchGongTranscriptMutation>;
export type RefetchGongTranscriptMutationOptions = Apollo.BaseMutationOptions<RefetchGongTranscriptMutation, RefetchGongTranscriptMutationVariables>;
export const RefetchHubspotDocument = gql`
    mutation RefetchHubspot($id: Int!) {
  refetchHubspot(id: $id) {
    success
  }
}
    `;
export type RefetchHubspotMutationFn = Apollo.MutationFunction<RefetchHubspotMutation, RefetchHubspotMutationVariables>;

/**
 * __useRefetchHubspotMutation__
 *
 * To run a mutation, you first call `useRefetchHubspotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchHubspotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchHubspotMutation, { data, loading, error }] = useRefetchHubspotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefetchHubspotMutation(baseOptions?: Apollo.MutationHookOptions<RefetchHubspotMutation, RefetchHubspotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchHubspotMutation, RefetchHubspotMutationVariables>(RefetchHubspotDocument, options);
      }
export type RefetchHubspotMutationHookResult = ReturnType<typeof useRefetchHubspotMutation>;
export type RefetchHubspotMutationResult = Apollo.MutationResult<RefetchHubspotMutation>;
export type RefetchHubspotMutationOptions = Apollo.BaseMutationOptions<RefetchHubspotMutation, RefetchHubspotMutationVariables>;
export const RemoveFunderUserDocument = gql`
    mutation removeFunderUser($removeFunderUserInfo: RemoveFunderUserInput!, $funderId: Int!) {
  removeFunderUser(
    removeFunderUserInfo: $removeFunderUserInfo
    funderId: $funderId
  ) {
    funderOrgId
  }
}
    `;
export type RemoveFunderUserMutationFn = Apollo.MutationFunction<RemoveFunderUserMutation, RemoveFunderUserMutationVariables>;

/**
 * __useRemoveFunderUserMutation__
 *
 * To run a mutation, you first call `useRemoveFunderUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFunderUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFunderUserMutation, { data, loading, error }] = useRemoveFunderUserMutation({
 *   variables: {
 *      removeFunderUserInfo: // value for 'removeFunderUserInfo'
 *      funderId: // value for 'funderId'
 *   },
 * });
 */
export function useRemoveFunderUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFunderUserMutation, RemoveFunderUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFunderUserMutation, RemoveFunderUserMutationVariables>(RemoveFunderUserDocument, options);
      }
export type RemoveFunderUserMutationHookResult = ReturnType<typeof useRemoveFunderUserMutation>;
export type RemoveFunderUserMutationResult = Apollo.MutationResult<RemoveFunderUserMutation>;
export type RemoveFunderUserMutationOptions = Apollo.BaseMutationOptions<RemoveFunderUserMutation, RemoveFunderUserMutationVariables>;
export const RemoveNonprofitOrgUserDocument = gql`
    mutation removeNonprofitOrgUser($removeNonprofitOrgUserInfo: RemoveNonprofitOrgUserInput!, $nonprofitOrgId: Int!) {
  removeNonprofitOrgUser(
    removeNonprofitOrgUserInfo: $removeNonprofitOrgUserInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    nonprofitOrgId
  }
}
    `;
export type RemoveNonprofitOrgUserMutationFn = Apollo.MutationFunction<RemoveNonprofitOrgUserMutation, RemoveNonprofitOrgUserMutationVariables>;

/**
 * __useRemoveNonprofitOrgUserMutation__
 *
 * To run a mutation, you first call `useRemoveNonprofitOrgUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveNonprofitOrgUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeNonprofitOrgUserMutation, { data, loading, error }] = useRemoveNonprofitOrgUserMutation({
 *   variables: {
 *      removeNonprofitOrgUserInfo: // value for 'removeNonprofitOrgUserInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useRemoveNonprofitOrgUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveNonprofitOrgUserMutation, RemoveNonprofitOrgUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveNonprofitOrgUserMutation, RemoveNonprofitOrgUserMutationVariables>(RemoveNonprofitOrgUserDocument, options);
      }
export type RemoveNonprofitOrgUserMutationHookResult = ReturnType<typeof useRemoveNonprofitOrgUserMutation>;
export type RemoveNonprofitOrgUserMutationResult = Apollo.MutationResult<RemoveNonprofitOrgUserMutation>;
export type RemoveNonprofitOrgUserMutationOptions = Apollo.BaseMutationOptions<RemoveNonprofitOrgUserMutation, RemoveNonprofitOrgUserMutationVariables>;
export const RemoveSavedFunderForNonprofitDocument = gql`
    mutation removeSavedFunderForNonprofit($funderEin: Int!, $nonprofitOrgId: Int!) {
  removeSavedFunderForNonprofit(
    funderEin: $funderEin
    nonprofitOrgId: $nonprofitOrgId
  ) {
    nonprofitOrgId
    fundingOrg990Id
  }
}
    `;
export type RemoveSavedFunderForNonprofitMutationFn = Apollo.MutationFunction<RemoveSavedFunderForNonprofitMutation, RemoveSavedFunderForNonprofitMutationVariables>;

/**
 * __useRemoveSavedFunderForNonprofitMutation__
 *
 * To run a mutation, you first call `useRemoveSavedFunderForNonprofitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedFunderForNonprofitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedFunderForNonprofitMutation, { data, loading, error }] = useRemoveSavedFunderForNonprofitMutation({
 *   variables: {
 *      funderEin: // value for 'funderEin'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useRemoveSavedFunderForNonprofitMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedFunderForNonprofitMutation, RemoveSavedFunderForNonprofitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedFunderForNonprofitMutation, RemoveSavedFunderForNonprofitMutationVariables>(RemoveSavedFunderForNonprofitDocument, options);
      }
export type RemoveSavedFunderForNonprofitMutationHookResult = ReturnType<typeof useRemoveSavedFunderForNonprofitMutation>;
export type RemoveSavedFunderForNonprofitMutationResult = Apollo.MutationResult<RemoveSavedFunderForNonprofitMutation>;
export type RemoveSavedFunderForNonprofitMutationOptions = Apollo.BaseMutationOptions<RemoveSavedFunderForNonprofitMutation, RemoveSavedFunderForNonprofitMutationVariables>;
export const ResendFunderInviteDocument = gql`
    mutation resendFunderInvite($userId: Int!, $funderOrgId: Int!) {
  resendFunderInvite(userId: $userId, funderOrgId: $funderOrgId) {
    success
  }
}
    `;
export type ResendFunderInviteMutationFn = Apollo.MutationFunction<ResendFunderInviteMutation, ResendFunderInviteMutationVariables>;

/**
 * __useResendFunderInviteMutation__
 *
 * To run a mutation, you first call `useResendFunderInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendFunderInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendFunderInviteMutation, { data, loading, error }] = useResendFunderInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useResendFunderInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendFunderInviteMutation, ResendFunderInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendFunderInviteMutation, ResendFunderInviteMutationVariables>(ResendFunderInviteDocument, options);
      }
export type ResendFunderInviteMutationHookResult = ReturnType<typeof useResendFunderInviteMutation>;
export type ResendFunderInviteMutationResult = Apollo.MutationResult<ResendFunderInviteMutation>;
export type ResendFunderInviteMutationOptions = Apollo.BaseMutationOptions<ResendFunderInviteMutation, ResendFunderInviteMutationVariables>;
export const ResendInviteDocument = gql`
    mutation resendInvite($userId: Int!, $nonprofitOrgId: Int) {
  resendInvite(userId: $userId, nonprofitOrgId: $nonprofitOrgId) {
    success
  }
}
    `;
export type ResendInviteMutationFn = Apollo.MutationFunction<ResendInviteMutation, ResendInviteMutationVariables>;

/**
 * __useResendInviteMutation__
 *
 * To run a mutation, you first call `useResendInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInviteMutation, { data, loading, error }] = useResendInviteMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useResendInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendInviteMutation, ResendInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInviteMutation, ResendInviteMutationVariables>(ResendInviteDocument, options);
      }
export type ResendInviteMutationHookResult = ReturnType<typeof useResendInviteMutation>;
export type ResendInviteMutationResult = Apollo.MutationResult<ResendInviteMutation>;
export type ResendInviteMutationOptions = Apollo.BaseMutationOptions<ResendInviteMutation, ResendInviteMutationVariables>;
export const RetriggerGoalsWizardDocument = gql`
    mutation RetriggerGoalsWizard($nonprofitOrgId: Int!) {
  retriggerGoalsWizard(nonprofitOrgId: $nonprofitOrgId) {
    id
    nonprofitOrgId
    confirmedOrgSummary
    confirmedAreasOfImpact
    confirmedOrgSummaryUpdatedAt
  }
}
    `;
export type RetriggerGoalsWizardMutationFn = Apollo.MutationFunction<RetriggerGoalsWizardMutation, RetriggerGoalsWizardMutationVariables>;

/**
 * __useRetriggerGoalsWizardMutation__
 *
 * To run a mutation, you first call `useRetriggerGoalsWizardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerGoalsWizardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerGoalsWizardMutation, { data, loading, error }] = useRetriggerGoalsWizardMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useRetriggerGoalsWizardMutation(baseOptions?: Apollo.MutationHookOptions<RetriggerGoalsWizardMutation, RetriggerGoalsWizardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetriggerGoalsWizardMutation, RetriggerGoalsWizardMutationVariables>(RetriggerGoalsWizardDocument, options);
      }
export type RetriggerGoalsWizardMutationHookResult = ReturnType<typeof useRetriggerGoalsWizardMutation>;
export type RetriggerGoalsWizardMutationResult = Apollo.MutationResult<RetriggerGoalsWizardMutation>;
export type RetriggerGoalsWizardMutationOptions = Apollo.BaseMutationOptions<RetriggerGoalsWizardMutation, RetriggerGoalsWizardMutationVariables>;
export const RetriggerProfilerDocument = gql`
    mutation RetriggerProfiler($nonprofitOrgId: Int!) {
  retriggerProfiler(nonprofitOrgId: $nonprofitOrgId) {
    success
  }
}
    `;
export type RetriggerProfilerMutationFn = Apollo.MutationFunction<RetriggerProfilerMutation, RetriggerProfilerMutationVariables>;

/**
 * __useRetriggerProfilerMutation__
 *
 * To run a mutation, you first call `useRetriggerProfilerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetriggerProfilerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retriggerProfilerMutation, { data, loading, error }] = useRetriggerProfilerMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useRetriggerProfilerMutation(baseOptions?: Apollo.MutationHookOptions<RetriggerProfilerMutation, RetriggerProfilerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetriggerProfilerMutation, RetriggerProfilerMutationVariables>(RetriggerProfilerDocument, options);
      }
export type RetriggerProfilerMutationHookResult = ReturnType<typeof useRetriggerProfilerMutation>;
export type RetriggerProfilerMutationResult = Apollo.MutationResult<RetriggerProfilerMutation>;
export type RetriggerProfilerMutationOptions = Apollo.BaseMutationOptions<RetriggerProfilerMutation, RetriggerProfilerMutationVariables>;
export const RetryJobDocument = gql`
    mutation RetryJob($jobId: String!) {
  retryJob(jobId: $jobId) {
    success
    newJobId
    error
  }
}
    `;
export type RetryJobMutationFn = Apollo.MutationFunction<RetryJobMutation, RetryJobMutationVariables>;

/**
 * __useRetryJobMutation__
 *
 * To run a mutation, you first call `useRetryJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryJobMutation, { data, loading, error }] = useRetryJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useRetryJobMutation(baseOptions?: Apollo.MutationHookOptions<RetryJobMutation, RetryJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryJobMutation, RetryJobMutationVariables>(RetryJobDocument, options);
      }
export type RetryJobMutationHookResult = ReturnType<typeof useRetryJobMutation>;
export type RetryJobMutationResult = Apollo.MutationResult<RetryJobMutation>;
export type RetryJobMutationOptions = Apollo.BaseMutationOptions<RetryJobMutation, RetryJobMutationVariables>;
export const RevokeMcpApiKeyDocument = gql`
    mutation revokeMcpApiKey($id: ID!) {
  revokeMcpApiKey(id: $id)
}
    `;
export type RevokeMcpApiKeyMutationFn = Apollo.MutationFunction<RevokeMcpApiKeyMutation, RevokeMcpApiKeyMutationVariables>;

/**
 * __useRevokeMcpApiKeyMutation__
 *
 * To run a mutation, you first call `useRevokeMcpApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMcpApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMcpApiKeyMutation, { data, loading, error }] = useRevokeMcpApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeMcpApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<RevokeMcpApiKeyMutation, RevokeMcpApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeMcpApiKeyMutation, RevokeMcpApiKeyMutationVariables>(RevokeMcpApiKeyDocument, options);
      }
export type RevokeMcpApiKeyMutationHookResult = ReturnType<typeof useRevokeMcpApiKeyMutation>;
export type RevokeMcpApiKeyMutationResult = Apollo.MutationResult<RevokeMcpApiKeyMutation>;
export type RevokeMcpApiKeyMutationOptions = Apollo.BaseMutationOptions<RevokeMcpApiKeyMutation, RevokeMcpApiKeyMutationVariables>;
export const RsvpToGroupCoachingEventDocument = gql`
    mutation RsvpToGroupCoachingEvent($input: GroupCoachingEventRsvpInput!) {
  rsvpToGroupCoachingEvent(input: $input) {
    id
    groupCoachingEventId
    userId
    rsvpStatus
    attendedEvent
    createdAt
    updatedAt
    notes
  }
}
    `;
export type RsvpToGroupCoachingEventMutationFn = Apollo.MutationFunction<RsvpToGroupCoachingEventMutation, RsvpToGroupCoachingEventMutationVariables>;

/**
 * __useRsvpToGroupCoachingEventMutation__
 *
 * To run a mutation, you first call `useRsvpToGroupCoachingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRsvpToGroupCoachingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rsvpToGroupCoachingEventMutation, { data, loading, error }] = useRsvpToGroupCoachingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRsvpToGroupCoachingEventMutation(baseOptions?: Apollo.MutationHookOptions<RsvpToGroupCoachingEventMutation, RsvpToGroupCoachingEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RsvpToGroupCoachingEventMutation, RsvpToGroupCoachingEventMutationVariables>(RsvpToGroupCoachingEventDocument, options);
      }
export type RsvpToGroupCoachingEventMutationHookResult = ReturnType<typeof useRsvpToGroupCoachingEventMutation>;
export type RsvpToGroupCoachingEventMutationResult = Apollo.MutationResult<RsvpToGroupCoachingEventMutation>;
export type RsvpToGroupCoachingEventMutationOptions = Apollo.BaseMutationOptions<RsvpToGroupCoachingEventMutation, RsvpToGroupCoachingEventMutationVariables>;
export const SaveFunderForNonprofitDocument = gql`
    mutation saveFunderForNonprofit($funderEin: Int!, $nonprofitOrgId: Int!) {
  saveFunderForNonprofit(funderEin: $funderEin, nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    fundingOrg990Id
  }
}
    `;
export type SaveFunderForNonprofitMutationFn = Apollo.MutationFunction<SaveFunderForNonprofitMutation, SaveFunderForNonprofitMutationVariables>;

/**
 * __useSaveFunderForNonprofitMutation__
 *
 * To run a mutation, you first call `useSaveFunderForNonprofitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFunderForNonprofitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFunderForNonprofitMutation, { data, loading, error }] = useSaveFunderForNonprofitMutation({
 *   variables: {
 *      funderEin: // value for 'funderEin'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useSaveFunderForNonprofitMutation(baseOptions?: Apollo.MutationHookOptions<SaveFunderForNonprofitMutation, SaveFunderForNonprofitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFunderForNonprofitMutation, SaveFunderForNonprofitMutationVariables>(SaveFunderForNonprofitDocument, options);
      }
export type SaveFunderForNonprofitMutationHookResult = ReturnType<typeof useSaveFunderForNonprofitMutation>;
export type SaveFunderForNonprofitMutationResult = Apollo.MutationResult<SaveFunderForNonprofitMutation>;
export type SaveFunderForNonprofitMutationOptions = Apollo.BaseMutationOptions<SaveFunderForNonprofitMutation, SaveFunderForNonprofitMutationVariables>;
export const SelfCheckoutDocument = gql`
    mutation SelfCheckout($selfCheckoutInput: CheckoutInput!) {
  SelfCheckout(selfCheckoutInput: $selfCheckoutInput) {
    email
    userId
    orgId
    setpasswordURL
  }
}
    `;
export type SelfCheckoutMutationFn = Apollo.MutationFunction<SelfCheckoutMutation, SelfCheckoutMutationVariables>;

/**
 * __useSelfCheckoutMutation__
 *
 * To run a mutation, you first call `useSelfCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfCheckoutMutation, { data, loading, error }] = useSelfCheckoutMutation({
 *   variables: {
 *      selfCheckoutInput: // value for 'selfCheckoutInput'
 *   },
 * });
 */
export function useSelfCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<SelfCheckoutMutation, SelfCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfCheckoutMutation, SelfCheckoutMutationVariables>(SelfCheckoutDocument, options);
      }
export type SelfCheckoutMutationHookResult = ReturnType<typeof useSelfCheckoutMutation>;
export type SelfCheckoutMutationResult = Apollo.MutationResult<SelfCheckoutMutation>;
export type SelfCheckoutMutationOptions = Apollo.BaseMutationOptions<SelfCheckoutMutation, SelfCheckoutMutationVariables>;
export const ShareStoryWithFunderDocument = gql`
    mutation shareStoryWithFunder($funderOrgId: Int!, $storyId: Int!) {
  shareStoryWithFunder(funderOrgId: $funderOrgId, storyId: $storyId) {
    storyId
    sharedAt
  }
}
    `;
export type ShareStoryWithFunderMutationFn = Apollo.MutationFunction<ShareStoryWithFunderMutation, ShareStoryWithFunderMutationVariables>;

/**
 * __useShareStoryWithFunderMutation__
 *
 * To run a mutation, you first call `useShareStoryWithFunderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareStoryWithFunderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareStoryWithFunderMutation, { data, loading, error }] = useShareStoryWithFunderMutation({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useShareStoryWithFunderMutation(baseOptions?: Apollo.MutationHookOptions<ShareStoryWithFunderMutation, ShareStoryWithFunderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareStoryWithFunderMutation, ShareStoryWithFunderMutationVariables>(ShareStoryWithFunderDocument, options);
      }
export type ShareStoryWithFunderMutationHookResult = ReturnType<typeof useShareStoryWithFunderMutation>;
export type ShareStoryWithFunderMutationResult = Apollo.MutationResult<ShareStoryWithFunderMutation>;
export type ShareStoryWithFunderMutationOptions = Apollo.BaseMutationOptions<ShareStoryWithFunderMutation, ShareStoryWithFunderMutationVariables>;
export const TrackAdblockerDetectedDocument = gql`
    mutation trackAdblockerDetected {
  trackAdblockerDetected {
    success
  }
}
    `;
export type TrackAdblockerDetectedMutationFn = Apollo.MutationFunction<TrackAdblockerDetectedMutation, TrackAdblockerDetectedMutationVariables>;

/**
 * __useTrackAdblockerDetectedMutation__
 *
 * To run a mutation, you first call `useTrackAdblockerDetectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackAdblockerDetectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackAdblockerDetectedMutation, { data, loading, error }] = useTrackAdblockerDetectedMutation({
 *   variables: {
 *   },
 * });
 */
export function useTrackAdblockerDetectedMutation(baseOptions?: Apollo.MutationHookOptions<TrackAdblockerDetectedMutation, TrackAdblockerDetectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackAdblockerDetectedMutation, TrackAdblockerDetectedMutationVariables>(TrackAdblockerDetectedDocument, options);
      }
export type TrackAdblockerDetectedMutationHookResult = ReturnType<typeof useTrackAdblockerDetectedMutation>;
export type TrackAdblockerDetectedMutationResult = Apollo.MutationResult<TrackAdblockerDetectedMutation>;
export type TrackAdblockerDetectedMutationOptions = Apollo.BaseMutationOptions<TrackAdblockerDetectedMutation, TrackAdblockerDetectedMutationVariables>;
export const UnshareStoryWithFunderDocument = gql`
    mutation UnshareStoryWithFunder($funderOrgId: Int!, $storyId: Int!) {
  unshareStoryWithFunder(funderOrgId: $funderOrgId, storyId: $storyId) {
    storyId
  }
}
    `;
export type UnshareStoryWithFunderMutationFn = Apollo.MutationFunction<UnshareStoryWithFunderMutation, UnshareStoryWithFunderMutationVariables>;

/**
 * __useUnshareStoryWithFunderMutation__
 *
 * To run a mutation, you first call `useUnshareStoryWithFunderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareStoryWithFunderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareStoryWithFunderMutation, { data, loading, error }] = useUnshareStoryWithFunderMutation({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useUnshareStoryWithFunderMutation(baseOptions?: Apollo.MutationHookOptions<UnshareStoryWithFunderMutation, UnshareStoryWithFunderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnshareStoryWithFunderMutation, UnshareStoryWithFunderMutationVariables>(UnshareStoryWithFunderDocument, options);
      }
export type UnshareStoryWithFunderMutationHookResult = ReturnType<typeof useUnshareStoryWithFunderMutation>;
export type UnshareStoryWithFunderMutationResult = Apollo.MutationResult<UnshareStoryWithFunderMutation>;
export type UnshareStoryWithFunderMutationOptions = Apollo.BaseMutationOptions<UnshareStoryWithFunderMutation, UnshareStoryWithFunderMutationVariables>;
export const UpdateAutoStoriesSettingsDocument = gql`
    mutation updateAutoStoriesSettings($nonprofitOrgId: Int!, $settings: AutoStoriesSettingsInput!) {
  updateAutoStoriesSettings(nonprofitOrgId: $nonprofitOrgId, settings: $settings) {
    nonprofitOrgId
    autoStoriesEnabled
    socialUrls {
      platform
      url
    }
    notifyEmails
    lastScan
  }
}
    `;
export type UpdateAutoStoriesSettingsMutationFn = Apollo.MutationFunction<UpdateAutoStoriesSettingsMutation, UpdateAutoStoriesSettingsMutationVariables>;

/**
 * __useUpdateAutoStoriesSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAutoStoriesSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoStoriesSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoStoriesSettingsMutation, { data, loading, error }] = useUpdateAutoStoriesSettingsMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateAutoStoriesSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutoStoriesSettingsMutation, UpdateAutoStoriesSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutoStoriesSettingsMutation, UpdateAutoStoriesSettingsMutationVariables>(UpdateAutoStoriesSettingsDocument, options);
      }
export type UpdateAutoStoriesSettingsMutationHookResult = ReturnType<typeof useUpdateAutoStoriesSettingsMutation>;
export type UpdateAutoStoriesSettingsMutationResult = Apollo.MutationResult<UpdateAutoStoriesSettingsMutation>;
export type UpdateAutoStoriesSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateAutoStoriesSettingsMutation, UpdateAutoStoriesSettingsMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($campaignId: String!, $campaignInput: CampaignInput!, $nonprofitOrgId: Int) {
  updateCampaign(
    campaignId: $campaignId
    campaignInput: $campaignInput
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
    initiativeGoalId
    draftGoalName
    draftObjectiveName
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      campaignInput: // value for 'campaignInput'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpdateChartDocument = gql`
    mutation updateChart($data: UpdateChartInput!) {
  updateChart(data: $data) {
    id
  }
}
    `;
export type UpdateChartMutationFn = Apollo.MutationFunction<UpdateChartMutation, UpdateChartMutationVariables>;

/**
 * __useUpdateChartMutation__
 *
 * To run a mutation, you first call `useUpdateChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartMutation, { data, loading, error }] = useUpdateChartMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChartMutation, UpdateChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChartMutation, UpdateChartMutationVariables>(UpdateChartDocument, options);
      }
export type UpdateChartMutationHookResult = ReturnType<typeof useUpdateChartMutation>;
export type UpdateChartMutationResult = Apollo.MutationResult<UpdateChartMutation>;
export type UpdateChartMutationOptions = Apollo.BaseMutationOptions<UpdateChartMutation, UpdateChartMutationVariables>;
export const UpdateChartDataPointsDocument = gql`
    mutation UpdateChartDataPoints($data: [UpdateChartDataPointInput!]!) {
  updateChartDataPoints(data: $data) {
    count
  }
}
    `;
export type UpdateChartDataPointsMutationFn = Apollo.MutationFunction<UpdateChartDataPointsMutation, UpdateChartDataPointsMutationVariables>;

/**
 * __useUpdateChartDataPointsMutation__
 *
 * To run a mutation, you first call `useUpdateChartDataPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChartDataPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChartDataPointsMutation, { data, loading, error }] = useUpdateChartDataPointsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChartDataPointsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChartDataPointsMutation, UpdateChartDataPointsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChartDataPointsMutation, UpdateChartDataPointsMutationVariables>(UpdateChartDataPointsDocument, options);
      }
export type UpdateChartDataPointsMutationHookResult = ReturnType<typeof useUpdateChartDataPointsMutation>;
export type UpdateChartDataPointsMutationResult = Apollo.MutationResult<UpdateChartDataPointsMutation>;
export type UpdateChartDataPointsMutationOptions = Apollo.BaseMutationOptions<UpdateChartDataPointsMutation, UpdateChartDataPointsMutationVariables>;
export const UpdateDonationPortalDocument = gql`
    mutation updateDonationPortal($portalId: Int!, $updatedUserId: Int!, $archivedAt: DateTime, $publishedAt: DateTime) {
  updateDonationPortal(
    portalId: $portalId
    updatedUserId: $updatedUserId
    archivedAt: $archivedAt
    publishedAt: $publishedAt
  ) {
    id
    nonprofitOrgId
    createdUserId
    updatedUserId
    createdAt
    name
    updatedAt
  }
}
    `;
export type UpdateDonationPortalMutationFn = Apollo.MutationFunction<UpdateDonationPortalMutation, UpdateDonationPortalMutationVariables>;

/**
 * __useUpdateDonationPortalMutation__
 *
 * To run a mutation, you first call `useUpdateDonationPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDonationPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDonationPortalMutation, { data, loading, error }] = useUpdateDonationPortalMutation({
 *   variables: {
 *      portalId: // value for 'portalId'
 *      updatedUserId: // value for 'updatedUserId'
 *      archivedAt: // value for 'archivedAt'
 *      publishedAt: // value for 'publishedAt'
 *   },
 * });
 */
export function useUpdateDonationPortalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDonationPortalMutation, UpdateDonationPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDonationPortalMutation, UpdateDonationPortalMutationVariables>(UpdateDonationPortalDocument, options);
      }
export type UpdateDonationPortalMutationHookResult = ReturnType<typeof useUpdateDonationPortalMutation>;
export type UpdateDonationPortalMutationResult = Apollo.MutationResult<UpdateDonationPortalMutation>;
export type UpdateDonationPortalMutationOptions = Apollo.BaseMutationOptions<UpdateDonationPortalMutation, UpdateDonationPortalMutationVariables>;
export const UpdateEntryGroupDocument = gql`
    mutation updateEntryGroup($entryGroupInfo: UpdateEntryGroupInput!, $entryInfo: [UpdateEntryInput!]!, $nonprofitOrgId: Int!) {
  updateEntryGroup(
    entryGroupInfo: $entryGroupInfo
    entryInfo: $entryInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
  }
}
    `;
export type UpdateEntryGroupMutationFn = Apollo.MutationFunction<UpdateEntryGroupMutation, UpdateEntryGroupMutationVariables>;

/**
 * __useUpdateEntryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateEntryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntryGroupMutation, { data, loading, error }] = useUpdateEntryGroupMutation({
 *   variables: {
 *      entryGroupInfo: // value for 'entryGroupInfo'
 *      entryInfo: // value for 'entryInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useUpdateEntryGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntryGroupMutation, UpdateEntryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntryGroupMutation, UpdateEntryGroupMutationVariables>(UpdateEntryGroupDocument, options);
      }
export type UpdateEntryGroupMutationHookResult = ReturnType<typeof useUpdateEntryGroupMutation>;
export type UpdateEntryGroupMutationResult = Apollo.MutationResult<UpdateEntryGroupMutation>;
export type UpdateEntryGroupMutationOptions = Apollo.BaseMutationOptions<UpdateEntryGroupMutation, UpdateEntryGroupMutationVariables>;
export const UpdateFunderUserSettingsDocument = gql`
    mutation updateFunderUserSettings($funderId: Int!, $userIdToUpdate: Int, $userSettingsInfo: FunderUserSettingsUpdateInput!) {
  updateFunderUserSettings(
    funderId: $funderId
    userIdToUpdate: $userIdToUpdate
    userSettingsInfo: $userSettingsInfo
  ) {
    id
  }
}
    `;
export type UpdateFunderUserSettingsMutationFn = Apollo.MutationFunction<UpdateFunderUserSettingsMutation, UpdateFunderUserSettingsMutationVariables>;

/**
 * __useUpdateFunderUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateFunderUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFunderUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFunderUserSettingsMutation, { data, loading, error }] = useUpdateFunderUserSettingsMutation({
 *   variables: {
 *      funderId: // value for 'funderId'
 *      userIdToUpdate: // value for 'userIdToUpdate'
 *      userSettingsInfo: // value for 'userSettingsInfo'
 *   },
 * });
 */
export function useUpdateFunderUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFunderUserSettingsMutation, UpdateFunderUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFunderUserSettingsMutation, UpdateFunderUserSettingsMutationVariables>(UpdateFunderUserSettingsDocument, options);
      }
export type UpdateFunderUserSettingsMutationHookResult = ReturnType<typeof useUpdateFunderUserSettingsMutation>;
export type UpdateFunderUserSettingsMutationResult = Apollo.MutationResult<UpdateFunderUserSettingsMutation>;
export type UpdateFunderUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateFunderUserSettingsMutation, UpdateFunderUserSettingsMutationVariables>;
export const UpdateGoalDocument = gql`
    mutation updateGoal($goalUpdateInfo: GoalUpdateInput!) {
  updateGoal(goalUpdateInfo: $goalUpdateInfo) {
    id
    title
    category
    owner {
      id
      firstName
      lastName
    }
    unitOfMeasurement
    target
    archivedAt
  }
}
    `;
export type UpdateGoalMutationFn = Apollo.MutationFunction<UpdateGoalMutation, UpdateGoalMutationVariables>;

/**
 * __useUpdateGoalMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMutation, { data, loading, error }] = useUpdateGoalMutation({
 *   variables: {
 *      goalUpdateInfo: // value for 'goalUpdateInfo'
 *   },
 * });
 */
export function useUpdateGoalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoalMutation, UpdateGoalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoalMutation, UpdateGoalMutationVariables>(UpdateGoalDocument, options);
      }
export type UpdateGoalMutationHookResult = ReturnType<typeof useUpdateGoalMutation>;
export type UpdateGoalMutationResult = Apollo.MutationResult<UpdateGoalMutation>;
export type UpdateGoalMutationOptions = Apollo.BaseMutationOptions<UpdateGoalMutation, UpdateGoalMutationVariables>;
export const NonprofitBoardDocument = gql`
    mutation nonprofitBoard($nonprofitOrgId: Int!, $developmentStrategy: String, $developmentInitiatives: String) {
  nonprofitBoard(
    nonprofitOrgId: $nonprofitOrgId
    developmentStrategy: $developmentStrategy
    developmentInitiatives: $developmentInitiatives
  ) {
    developmentStrategy
    developmentInitiatives
  }
}
    `;
export type NonprofitBoardMutationFn = Apollo.MutationFunction<NonprofitBoardMutation, NonprofitBoardMutationVariables>;

/**
 * __useNonprofitBoardMutation__
 *
 * To run a mutation, you first call `useNonprofitBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNonprofitBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nonprofitBoardMutation, { data, loading, error }] = useNonprofitBoardMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      developmentStrategy: // value for 'developmentStrategy'
 *      developmentInitiatives: // value for 'developmentInitiatives'
 *   },
 * });
 */
export function useNonprofitBoardMutation(baseOptions?: Apollo.MutationHookOptions<NonprofitBoardMutation, NonprofitBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NonprofitBoardMutation, NonprofitBoardMutationVariables>(NonprofitBoardDocument, options);
      }
export type NonprofitBoardMutationHookResult = ReturnType<typeof useNonprofitBoardMutation>;
export type NonprofitBoardMutationResult = Apollo.MutationResult<NonprofitBoardMutation>;
export type NonprofitBoardMutationOptions = Apollo.BaseMutationOptions<NonprofitBoardMutation, NonprofitBoardMutationVariables>;
export const UpdateNonprofitOrgMissionDocument = gql`
    mutation updateNonprofitOrgMission($orgInfo: UpdateNonprofitOrgInput!) {
  updateNonprofitOrgMission(orgInfo: $orgInfo) {
    id
    missionStatement
  }
}
    `;
export type UpdateNonprofitOrgMissionMutationFn = Apollo.MutationFunction<UpdateNonprofitOrgMissionMutation, UpdateNonprofitOrgMissionMutationVariables>;

/**
 * __useUpdateNonprofitOrgMissionMutation__
 *
 * To run a mutation, you first call `useUpdateNonprofitOrgMissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNonprofitOrgMissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNonprofitOrgMissionMutation, { data, loading, error }] = useUpdateNonprofitOrgMissionMutation({
 *   variables: {
 *      orgInfo: // value for 'orgInfo'
 *   },
 * });
 */
export function useUpdateNonprofitOrgMissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNonprofitOrgMissionMutation, UpdateNonprofitOrgMissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNonprofitOrgMissionMutation, UpdateNonprofitOrgMissionMutationVariables>(UpdateNonprofitOrgMissionDocument, options);
      }
export type UpdateNonprofitOrgMissionMutationHookResult = ReturnType<typeof useUpdateNonprofitOrgMissionMutation>;
export type UpdateNonprofitOrgMissionMutationResult = Apollo.MutationResult<UpdateNonprofitOrgMissionMutation>;
export type UpdateNonprofitOrgMissionMutationOptions = Apollo.BaseMutationOptions<UpdateNonprofitOrgMissionMutation, UpdateNonprofitOrgMissionMutationVariables>;
export const UpdateNonprofitOrgProfileDocument = gql`
    mutation UpdateNonprofitOrgProfile($updateNonprofitOrgProfileInput: UpdateNonprofitOrgProfileInput) {
  updateNonprofitOrgProfile(
    updateNonprofitOrgProfileInput: $updateNonprofitOrgProfileInput
  ) {
    confirmedAreasOfImpact
    confirmedOrgSummary
    nonprofitOrgId
  }
}
    `;
export type UpdateNonprofitOrgProfileMutationFn = Apollo.MutationFunction<UpdateNonprofitOrgProfileMutation, UpdateNonprofitOrgProfileMutationVariables>;

/**
 * __useUpdateNonprofitOrgProfileMutation__
 *
 * To run a mutation, you first call `useUpdateNonprofitOrgProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNonprofitOrgProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNonprofitOrgProfileMutation, { data, loading, error }] = useUpdateNonprofitOrgProfileMutation({
 *   variables: {
 *      updateNonprofitOrgProfileInput: // value for 'updateNonprofitOrgProfileInput'
 *   },
 * });
 */
export function useUpdateNonprofitOrgProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNonprofitOrgProfileMutation, UpdateNonprofitOrgProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNonprofitOrgProfileMutation, UpdateNonprofitOrgProfileMutationVariables>(UpdateNonprofitOrgProfileDocument, options);
      }
export type UpdateNonprofitOrgProfileMutationHookResult = ReturnType<typeof useUpdateNonprofitOrgProfileMutation>;
export type UpdateNonprofitOrgProfileMutationResult = Apollo.MutationResult<UpdateNonprofitOrgProfileMutation>;
export type UpdateNonprofitOrgProfileMutationOptions = Apollo.BaseMutationOptions<UpdateNonprofitOrgProfileMutation, UpdateNonprofitOrgProfileMutationVariables>;
export const UpdateReportedMetricGroupDocument = gql`
    mutation updateReportedMetricGroup($reportedMetricGroupInfo: ReportedMetricGroupUpdateInput!) {
  updateReportedMetricGroup(reportedMetricGroupInfo: $reportedMetricGroupInfo) {
    id
    title
    NonprofitOrg {
      id
    }
  }
}
    `;
export type UpdateReportedMetricGroupMutationFn = Apollo.MutationFunction<UpdateReportedMetricGroupMutation, UpdateReportedMetricGroupMutationVariables>;

/**
 * __useUpdateReportedMetricGroupMutation__
 *
 * To run a mutation, you first call `useUpdateReportedMetricGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportedMetricGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportedMetricGroupMutation, { data, loading, error }] = useUpdateReportedMetricGroupMutation({
 *   variables: {
 *      reportedMetricGroupInfo: // value for 'reportedMetricGroupInfo'
 *   },
 * });
 */
export function useUpdateReportedMetricGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportedMetricGroupMutation, UpdateReportedMetricGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportedMetricGroupMutation, UpdateReportedMetricGroupMutationVariables>(UpdateReportedMetricGroupDocument, options);
      }
export type UpdateReportedMetricGroupMutationHookResult = ReturnType<typeof useUpdateReportedMetricGroupMutation>;
export type UpdateReportedMetricGroupMutationResult = Apollo.MutationResult<UpdateReportedMetricGroupMutation>;
export type UpdateReportedMetricGroupMutationOptions = Apollo.BaseMutationOptions<UpdateReportedMetricGroupMutation, UpdateReportedMetricGroupMutationVariables>;
export const UpdateStoryDocument = gql`
    mutation updateStory($storyUpdateInput: StoryUpdateInput!) {
  updateStory(storyUpdateInput: $storyUpdateInput) {
    id
  }
}
    `;
export type UpdateStoryMutationFn = Apollo.MutationFunction<UpdateStoryMutation, UpdateStoryMutationVariables>;

/**
 * __useUpdateStoryMutation__
 *
 * To run a mutation, you first call `useUpdateStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryMutation, { data, loading, error }] = useUpdateStoryMutation({
 *   variables: {
 *      storyUpdateInput: // value for 'storyUpdateInput'
 *   },
 * });
 */
export function useUpdateStoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoryMutation, UpdateStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStoryMutation, UpdateStoryMutationVariables>(UpdateStoryDocument, options);
      }
export type UpdateStoryMutationHookResult = ReturnType<typeof useUpdateStoryMutation>;
export type UpdateStoryMutationResult = Apollo.MutationResult<UpdateStoryMutation>;
export type UpdateStoryMutationOptions = Apollo.BaseMutationOptions<UpdateStoryMutation, UpdateStoryMutationVariables>;
export const UpdateTaxExemptionStatusDocument = gql`
    mutation updateTaxExemptionStatus($nonprofitOrgId: Int!, $dealStageId: String!, $questionnaireLink: String) {
  updateTaxExemptionStatus(
    nonprofitOrgId: $nonprofitOrgId
    dealStageId: $dealStageId
    questionnaireLink: $questionnaireLink
  ) {
    id
  }
}
    `;
export type UpdateTaxExemptionStatusMutationFn = Apollo.MutationFunction<UpdateTaxExemptionStatusMutation, UpdateTaxExemptionStatusMutationVariables>;

/**
 * __useUpdateTaxExemptionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTaxExemptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxExemptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxExemptionStatusMutation, { data, loading, error }] = useUpdateTaxExemptionStatusMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      dealStageId: // value for 'dealStageId'
 *      questionnaireLink: // value for 'questionnaireLink'
 *   },
 * });
 */
export function useUpdateTaxExemptionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxExemptionStatusMutation, UpdateTaxExemptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxExemptionStatusMutation, UpdateTaxExemptionStatusMutationVariables>(UpdateTaxExemptionStatusDocument, options);
      }
export type UpdateTaxExemptionStatusMutationHookResult = ReturnType<typeof useUpdateTaxExemptionStatusMutation>;
export type UpdateTaxExemptionStatusMutationResult = Apollo.MutationResult<UpdateTaxExemptionStatusMutation>;
export type UpdateTaxExemptionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTaxExemptionStatusMutation, UpdateTaxExemptionStatusMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($nonprofitOrgId: Int!, $userIdToUpdate: Int, $userSettingsInfo: UserSettingsUpdateInput!, $responsibility: ResponsibilityInput) {
  updateUserSettings(
    nonprofitOrgId: $nonprofitOrgId
    userIdToUpdate: $userIdToUpdate
    userSettingsInfo: $userSettingsInfo
    responsibility: $responsibility
  ) {
    id
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      userIdToUpdate: // value for 'userIdToUpdate'
 *      userSettingsInfo: // value for 'userSettingsInfo'
 *      responsibility: // value for 'responsibility'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpsertDonationPortalDocument = gql`
    mutation upsertDonationPortal($nonprofitOrgId: Int!, $hashedId: String, $content: PortalContentInput!) {
  upsertDonationPortal(
    nonprofitOrgId: $nonprofitOrgId
    content: $content
    hashedId: $hashedId
  ) {
    id
    hashedId
    publishedAt
    nonprofitOrgId
    createdUserId
    updatedUserId
    createdAt
    name
    updatedAt
    colorTheme {
      id
    }
    customAmounts {
      amountInCents
    }
    customAmountsOn
    socialDescription
    socialTitle
    DonationPortalBlock {
      id
      assetId
      assetType
      createdAt
      updatedAt
      asset {
        id
        assetType
        assetDetails
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type UpsertDonationPortalMutationFn = Apollo.MutationFunction<UpsertDonationPortalMutation, UpsertDonationPortalMutationVariables>;

/**
 * __useUpsertDonationPortalMutation__
 *
 * To run a mutation, you first call `useUpsertDonationPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDonationPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDonationPortalMutation, { data, loading, error }] = useUpsertDonationPortalMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      hashedId: // value for 'hashedId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpsertDonationPortalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDonationPortalMutation, UpsertDonationPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDonationPortalMutation, UpsertDonationPortalMutationVariables>(UpsertDonationPortalDocument, options);
      }
export type UpsertDonationPortalMutationHookResult = ReturnType<typeof useUpsertDonationPortalMutation>;
export type UpsertDonationPortalMutationResult = Apollo.MutationResult<UpsertDonationPortalMutation>;
export type UpsertDonationPortalMutationOptions = Apollo.BaseMutationOptions<UpsertDonationPortalMutation, UpsertDonationPortalMutationVariables>;
export const UpsertChecklistItemDocument = gql`
    mutation upsertChecklistItem($itemInfo: ChecklistItemInput!, $nonprofitOrgId: Int!) {
  upsertChecklistItem(itemInfo: $itemInfo, nonprofitOrgId: $nonprofitOrgId) {
    id
    title
    isCompleted
    updatedAt
    owner {
      id
      firstName
      lastName
    }
    lastUpdatedUser {
      id
      firstName
      lastName
    }
    resourceId
    dueDate
    linkText
    linkUrl
  }
}
    `;
export type UpsertChecklistItemMutationFn = Apollo.MutationFunction<UpsertChecklistItemMutation, UpsertChecklistItemMutationVariables>;

/**
 * __useUpsertChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpsertChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertChecklistItemMutation, { data, loading, error }] = useUpsertChecklistItemMutation({
 *   variables: {
 *      itemInfo: // value for 'itemInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useUpsertChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertChecklistItemMutation, UpsertChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertChecklistItemMutation, UpsertChecklistItemMutationVariables>(UpsertChecklistItemDocument, options);
      }
export type UpsertChecklistItemMutationHookResult = ReturnType<typeof useUpsertChecklistItemMutation>;
export type UpsertChecklistItemMutationResult = Apollo.MutationResult<UpsertChecklistItemMutation>;
export type UpsertChecklistItemMutationOptions = Apollo.BaseMutationOptions<UpsertChecklistItemMutation, UpsertChecklistItemMutationVariables>;
export const UpsertGoalUpdateDocument = gql`
    mutation upsertGoalUpdate($goalUpdateInfo: GoalTextUpdateInput!, $nonprofitOrgId: Int!) {
  upsertGoalUpdate(
    goalUpdateInfo: $goalUpdateInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
    goalId
    taskId
    taskTitle
    description
    reportedAt
    updatedAt
    lastUpdatedUser {
      id
      firstName
      lastName
    }
  }
}
    `;
export type UpsertGoalUpdateMutationFn = Apollo.MutationFunction<UpsertGoalUpdateMutation, UpsertGoalUpdateMutationVariables>;

/**
 * __useUpsertGoalUpdateMutation__
 *
 * To run a mutation, you first call `useUpsertGoalUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGoalUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGoalUpdateMutation, { data, loading, error }] = useUpsertGoalUpdateMutation({
 *   variables: {
 *      goalUpdateInfo: // value for 'goalUpdateInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useUpsertGoalUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertGoalUpdateMutation, UpsertGoalUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertGoalUpdateMutation, UpsertGoalUpdateMutationVariables>(UpsertGoalUpdateDocument, options);
      }
export type UpsertGoalUpdateMutationHookResult = ReturnType<typeof useUpsertGoalUpdateMutation>;
export type UpsertGoalUpdateMutationResult = Apollo.MutationResult<UpsertGoalUpdateMutation>;
export type UpsertGoalUpdateMutationOptions = Apollo.BaseMutationOptions<UpsertGoalUpdateMutation, UpsertGoalUpdateMutationVariables>;
export const NonprofitOrgDeiInitiativesDocument = gql`
    mutation nonprofitOrgDeiInitiatives($nonprofitOrgId: Int!, $description: String!) {
  nonprofitDeiInitiatives(
    nonprofitOrgId: $nonprofitOrgId
    description: $description
  ) {
    orgId
    description
  }
}
    `;
export type NonprofitOrgDeiInitiativesMutationFn = Apollo.MutationFunction<NonprofitOrgDeiInitiativesMutation, NonprofitOrgDeiInitiativesMutationVariables>;

/**
 * __useNonprofitOrgDeiInitiativesMutation__
 *
 * To run a mutation, you first call `useNonprofitOrgDeiInitiativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgDeiInitiativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nonprofitOrgDeiInitiativesMutation, { data, loading, error }] = useNonprofitOrgDeiInitiativesMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useNonprofitOrgDeiInitiativesMutation(baseOptions?: Apollo.MutationHookOptions<NonprofitOrgDeiInitiativesMutation, NonprofitOrgDeiInitiativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NonprofitOrgDeiInitiativesMutation, NonprofitOrgDeiInitiativesMutationVariables>(NonprofitOrgDeiInitiativesDocument, options);
      }
export type NonprofitOrgDeiInitiativesMutationHookResult = ReturnType<typeof useNonprofitOrgDeiInitiativesMutation>;
export type NonprofitOrgDeiInitiativesMutationResult = Apollo.MutationResult<NonprofitOrgDeiInitiativesMutation>;
export type NonprofitOrgDeiInitiativesMutationOptions = Apollo.BaseMutationOptions<NonprofitOrgDeiInitiativesMutation, NonprofitOrgDeiInitiativesMutationVariables>;
export const UpsertNonprofitOrgSettingsDocument = gql`
    mutation upsertNonprofitOrgSettings($nonprofitOrgId: Int!, $orgSettings: OrgSettingsInput!, $nonprofitOrgRelations: NonprofitOrgRelationsInput, $orgFinancialSettings: OrgFinancialSettingsInput) {
  upsertNonprofitOrgSettings(
    nonprofitOrgId: $nonprofitOrgId
    orgSettings: $orgSettings
    nonprofitOrgRelations: $nonprofitOrgRelations
    orgFinancialSettings: $orgFinancialSettings
  ) {
    id
    name
  }
}
    `;
export type UpsertNonprofitOrgSettingsMutationFn = Apollo.MutationFunction<UpsertNonprofitOrgSettingsMutation, UpsertNonprofitOrgSettingsMutationVariables>;

/**
 * __useUpsertNonprofitOrgSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertNonprofitOrgSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNonprofitOrgSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNonprofitOrgSettingsMutation, { data, loading, error }] = useUpsertNonprofitOrgSettingsMutation({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      orgSettings: // value for 'orgSettings'
 *      nonprofitOrgRelations: // value for 'nonprofitOrgRelations'
 *      orgFinancialSettings: // value for 'orgFinancialSettings'
 *   },
 * });
 */
export function useUpsertNonprofitOrgSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNonprofitOrgSettingsMutation, UpsertNonprofitOrgSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNonprofitOrgSettingsMutation, UpsertNonprofitOrgSettingsMutationVariables>(UpsertNonprofitOrgSettingsDocument, options);
      }
export type UpsertNonprofitOrgSettingsMutationHookResult = ReturnType<typeof useUpsertNonprofitOrgSettingsMutation>;
export type UpsertNonprofitOrgSettingsMutationResult = Apollo.MutationResult<UpsertNonprofitOrgSettingsMutation>;
export type UpsertNonprofitOrgSettingsMutationOptions = Apollo.BaseMutationOptions<UpsertNonprofitOrgSettingsMutation, UpsertNonprofitOrgSettingsMutationVariables>;
export const UpsertRecurringChecklistItemDocument = gql`
    mutation upsertRecurringChecklistItem($recurringItemInfo: RecurringChecklistItemInput!, $nonprofitOrgId: Int!) {
  upsertRecurringChecklistItem(
    recurringItemInfo: $recurringItemInfo
    nonprofitOrgId: $nonprofitOrgId
  ) {
    id
    dueDate
    owner {
      id
    }
    updatedAt
  }
}
    `;
export type UpsertRecurringChecklistItemMutationFn = Apollo.MutationFunction<UpsertRecurringChecklistItemMutation, UpsertRecurringChecklistItemMutationVariables>;

/**
 * __useUpsertRecurringChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpsertRecurringChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRecurringChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRecurringChecklistItemMutation, { data, loading, error }] = useUpsertRecurringChecklistItemMutation({
 *   variables: {
 *      recurringItemInfo: // value for 'recurringItemInfo'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useUpsertRecurringChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRecurringChecklistItemMutation, UpsertRecurringChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRecurringChecklistItemMutation, UpsertRecurringChecklistItemMutationVariables>(UpsertRecurringChecklistItemDocument, options);
      }
export type UpsertRecurringChecklistItemMutationHookResult = ReturnType<typeof useUpsertRecurringChecklistItemMutation>;
export type UpsertRecurringChecklistItemMutationResult = Apollo.MutationResult<UpsertRecurringChecklistItemMutation>;
export type UpsertRecurringChecklistItemMutationOptions = Apollo.BaseMutationOptions<UpsertRecurringChecklistItemMutation, UpsertRecurringChecklistItemMutationVariables>;
export const UpsertStoryDocument = gql`
    mutation upsertStory($storyUpsertInput: StoryUpsertInput!) {
  upsertStory(storyUpsertInput: $storyUpsertInput) {
    id
    nonprofitOrgId
    title
    updatedAt
    publishedAt
    urlTitle
    previewTitle
    previewDescription
    previewImageId
    previewImageCloudinaryFileId
    hashedId
    blocks {
      id
      assetId
      backgroundColor
      assetType
      createdAt
      updatedAt
      asset {
        id
        assetType
        assetDetails
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export type UpsertStoryMutationFn = Apollo.MutationFunction<UpsertStoryMutation, UpsertStoryMutationVariables>;

/**
 * __useUpsertStoryMutation__
 *
 * To run a mutation, you first call `useUpsertStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStoryMutation, { data, loading, error }] = useUpsertStoryMutation({
 *   variables: {
 *      storyUpsertInput: // value for 'storyUpsertInput'
 *   },
 * });
 */
export function useUpsertStoryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStoryMutation, UpsertStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStoryMutation, UpsertStoryMutationVariables>(UpsertStoryDocument, options);
      }
export type UpsertStoryMutationHookResult = ReturnType<typeof useUpsertStoryMutation>;
export type UpsertStoryMutationResult = Apollo.MutationResult<UpsertStoryMutation>;
export type UpsertStoryMutationOptions = Apollo.BaseMutationOptions<UpsertStoryMutation, UpsertStoryMutationVariables>;
export const UpsertUserSurveyDocument = gql`
    mutation upsertUserSurvey($userSurveyData: UserSurveyUpsertInput!) {
  upsertUserSurvey(userSurveyData: $userSurveyData) {
    id
    nonprofitOrgId
    response
    role
    type
  }
}
    `;
export type UpsertUserSurveyMutationFn = Apollo.MutationFunction<UpsertUserSurveyMutation, UpsertUserSurveyMutationVariables>;

/**
 * __useUpsertUserSurveyMutation__
 *
 * To run a mutation, you first call `useUpsertUserSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSurveyMutation, { data, loading, error }] = useUpsertUserSurveyMutation({
 *   variables: {
 *      userSurveyData: // value for 'userSurveyData'
 *   },
 * });
 */
export function useUpsertUserSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSurveyMutation, UpsertUserSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSurveyMutation, UpsertUserSurveyMutationVariables>(UpsertUserSurveyDocument, options);
      }
export type UpsertUserSurveyMutationHookResult = ReturnType<typeof useUpsertUserSurveyMutation>;
export type UpsertUserSurveyMutationResult = Apollo.MutationResult<UpsertUserSurveyMutation>;
export type UpsertUserSurveyMutationOptions = Apollo.BaseMutationOptions<UpsertUserSurveyMutation, UpsertUserSurveyMutationVariables>;
export const CreateOneOnOneCoachingEventDocument = gql`
    mutation createOneOnOneCoachingEvent($input: OneOnOneCoachingEventInput!) {
  createOneOnOneCoachingEvent(input: $input) {
    id
    createdAt
    updatedAt
    startsAt
    endsAt
    contactEmail
    contactName
    bookingUrl
    userSlug
    organizerEmail
    organizerName
    duration
    formGuid
  }
}
    `;
export type CreateOneOnOneCoachingEventMutationFn = Apollo.MutationFunction<CreateOneOnOneCoachingEventMutation, CreateOneOnOneCoachingEventMutationVariables>;

/**
 * __useCreateOneOnOneCoachingEventMutation__
 *
 * To run a mutation, you first call `useCreateOneOnOneCoachingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneOnOneCoachingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneOnOneCoachingEventMutation, { data, loading, error }] = useCreateOneOnOneCoachingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneOnOneCoachingEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateOneOnOneCoachingEventMutation, CreateOneOnOneCoachingEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOneOnOneCoachingEventMutation, CreateOneOnOneCoachingEventMutationVariables>(CreateOneOnOneCoachingEventDocument, options);
      }
export type CreateOneOnOneCoachingEventMutationHookResult = ReturnType<typeof useCreateOneOnOneCoachingEventMutation>;
export type CreateOneOnOneCoachingEventMutationResult = Apollo.MutationResult<CreateOneOnOneCoachingEventMutation>;
export type CreateOneOnOneCoachingEventMutationOptions = Apollo.BaseMutationOptions<CreateOneOnOneCoachingEventMutation, CreateOneOnOneCoachingEventMutationVariables>;
export const UpdateAttachmentDocument = gql`
    mutation UpdateAttachment($filename: String!, $id: Int!) {
  updateAttachment(id: $id, filename: $filename) {
    id
    createdAt
    filename
    format
    secureUrl
    publicId
    resourceType
  }
}
    `;
export type UpdateAttachmentMutationFn = Apollo.MutationFunction<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>;

/**
 * __useUpdateAttachmentMutation__
 *
 * To run a mutation, you first call `useUpdateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachmentMutation, { data, loading, error }] = useUpdateAttachmentMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>(UpdateAttachmentDocument, options);
      }
export type UpdateAttachmentMutationHookResult = ReturnType<typeof useUpdateAttachmentMutation>;
export type UpdateAttachmentMutationResult = Apollo.MutationResult<UpdateAttachmentMutation>;
export type UpdateAttachmentMutationOptions = Apollo.BaseMutationOptions<UpdateAttachmentMutation, UpdateAttachmentMutationVariables>;
export const GetAdminOneOnOneCoachingEventsDocument = gql`
    query GetAdminOneOnOneCoachingEvents($id: Int, $startDate: DateTime, $endDate: DateTime, $limit: Int, $offset: Int, $excludeDeleted: Boolean) {
  adminOneOnOneCoachingEvents(
    id: $id
    startDate: $startDate
    endDate: $endDate
    limit: $limit
    offset: $offset
    excludeDeleted: $excludeDeleted
  ) {
    total
    events {
      id
      startsAt
      endsAt
      contactEmail
      contactName
      bookingUrl
      userSlug
      organizerEmail
      organizerName
      duration
      formGuid
      hubspotId
      meetingBody
      meetingType
      meetingTitle
      videoConferenceUrl
      transcript
      summary
      status
      createdAt
      updatedAt
      deletedAt
      userId
    }
  }
}
    `;

/**
 * __useGetAdminOneOnOneCoachingEventsQuery__
 *
 * To run a query within a React component, call `useGetAdminOneOnOneCoachingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminOneOnOneCoachingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminOneOnOneCoachingEventsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      excludeDeleted: // value for 'excludeDeleted'
 *   },
 * });
 */
export function useGetAdminOneOnOneCoachingEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminOneOnOneCoachingEventsQuery, GetAdminOneOnOneCoachingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminOneOnOneCoachingEventsQuery, GetAdminOneOnOneCoachingEventsQueryVariables>(GetAdminOneOnOneCoachingEventsDocument, options);
      }
export function useGetAdminOneOnOneCoachingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminOneOnOneCoachingEventsQuery, GetAdminOneOnOneCoachingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminOneOnOneCoachingEventsQuery, GetAdminOneOnOneCoachingEventsQueryVariables>(GetAdminOneOnOneCoachingEventsDocument, options);
        }
export type GetAdminOneOnOneCoachingEventsQueryHookResult = ReturnType<typeof useGetAdminOneOnOneCoachingEventsQuery>;
export type GetAdminOneOnOneCoachingEventsLazyQueryHookResult = ReturnType<typeof useGetAdminOneOnOneCoachingEventsLazyQuery>;
export type GetAdminOneOnOneCoachingEventsQueryResult = Apollo.QueryResult<GetAdminOneOnOneCoachingEventsQuery, GetAdminOneOnOneCoachingEventsQueryVariables>;
export const GetAiCoachingInterventionsDocument = gql`
    query GetAiCoachingInterventions($userId: Int, $userEmail: String, $identifier: String, $shouldIntervene: Boolean, $status: [AiCoachingInterventionStatus!], $claimedByMe: Boolean, $unclaimed: Boolean, $userSearch: String, $organizationId: Int, $cohortId: Int, $funderOrgId: Int, $limit: Int, $offset: Int) {
  aiCoachingInterventions(
    userId: $userId
    userEmail: $userEmail
    identifier: $identifier
    shouldIntervene: $shouldIntervene
    status: $status
    claimedByMe: $claimedByMe
    unclaimed: $unclaimed
    userSearch: $userSearch
    organizationId: $organizationId
    cohortId: $cohortId
    funderOrgId: $funderOrgId
    limit: $limit
    offset: $offset
  ) {
    total
    interventions {
      id
      identifier
      version
      trigger
      shouldIntervene
      createdAt
      updatedAt
      message
      editedMessage
      status
      claimedAt
      claimedBy {
        id
        firstName
        lastName
        email
      }
      coachFeedback
      coachRating
      emailedAt
      postedToFeedAt
      declinedAt
      declineReason
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useGetAiCoachingInterventionsQuery__
 *
 * To run a query within a React component, call `useGetAiCoachingInterventionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiCoachingInterventionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiCoachingInterventionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      userEmail: // value for 'userEmail'
 *      identifier: // value for 'identifier'
 *      shouldIntervene: // value for 'shouldIntervene'
 *      status: // value for 'status'
 *      claimedByMe: // value for 'claimedByMe'
 *      unclaimed: // value for 'unclaimed'
 *      userSearch: // value for 'userSearch'
 *      organizationId: // value for 'organizationId'
 *      cohortId: // value for 'cohortId'
 *      funderOrgId: // value for 'funderOrgId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAiCoachingInterventionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiCoachingInterventionsQuery, GetAiCoachingInterventionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiCoachingInterventionsQuery, GetAiCoachingInterventionsQueryVariables>(GetAiCoachingInterventionsDocument, options);
      }
export function useGetAiCoachingInterventionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiCoachingInterventionsQuery, GetAiCoachingInterventionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiCoachingInterventionsQuery, GetAiCoachingInterventionsQueryVariables>(GetAiCoachingInterventionsDocument, options);
        }
export type GetAiCoachingInterventionsQueryHookResult = ReturnType<typeof useGetAiCoachingInterventionsQuery>;
export type GetAiCoachingInterventionsLazyQueryHookResult = ReturnType<typeof useGetAiCoachingInterventionsLazyQuery>;
export type GetAiCoachingInterventionsQueryResult = Apollo.QueryResult<GetAiCoachingInterventionsQuery, GetAiCoachingInterventionsQueryVariables>;
export const GetAiCoachingInterventionDocument = gql`
    query GetAiCoachingIntervention($id: Int!) {
  aiCoachingIntervention(id: $id) {
    id
    identifier
    version
    trigger
    shouldIntervene
    createdAt
    updatedAt
    message
    editedMessage
    status
    claimedAt
    claimedBy {
      id
      firstName
      lastName
      email
    }
    coachFeedback
    coachRating
    emailedAt
    postedToFeedAt
    declinedAt
    declineReason
    user {
      id
      firstName
      lastName
      email
      platformPlan
      funderOrgs {
        id
        name
        disabled
      }
      nonprofitOrgs {
        id
        name
        disabled
        cohortMemberships {
          id
          startDate
          endDate
          cohort {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAiCoachingInterventionQuery__
 *
 * To run a query within a React component, call `useGetAiCoachingInterventionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiCoachingInterventionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiCoachingInterventionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiCoachingInterventionQuery(baseOptions: Apollo.QueryHookOptions<GetAiCoachingInterventionQuery, GetAiCoachingInterventionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiCoachingInterventionQuery, GetAiCoachingInterventionQueryVariables>(GetAiCoachingInterventionDocument, options);
      }
export function useGetAiCoachingInterventionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiCoachingInterventionQuery, GetAiCoachingInterventionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiCoachingInterventionQuery, GetAiCoachingInterventionQueryVariables>(GetAiCoachingInterventionDocument, options);
        }
export type GetAiCoachingInterventionQueryHookResult = ReturnType<typeof useGetAiCoachingInterventionQuery>;
export type GetAiCoachingInterventionLazyQueryHookResult = ReturnType<typeof useGetAiCoachingInterventionLazyQuery>;
export type GetAiCoachingInterventionQueryResult = Apollo.QueryResult<GetAiCoachingInterventionQuery, GetAiCoachingInterventionQueryVariables>;
export const TriggerInterventionDocument = gql`
    mutation TriggerIntervention($identifier: String!, $userId: Int!, $force: Boolean) {
  triggerAiCoachingIntervention(
    identifier: $identifier
    userId: $userId
    force: $force
  ) {
    success
    message
    interventionId
  }
}
    `;
export type TriggerInterventionMutationFn = Apollo.MutationFunction<TriggerInterventionMutation, TriggerInterventionMutationVariables>;

/**
 * __useTriggerInterventionMutation__
 *
 * To run a mutation, you first call `useTriggerInterventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerInterventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerInterventionMutation, { data, loading, error }] = useTriggerInterventionMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      userId: // value for 'userId'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useTriggerInterventionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerInterventionMutation, TriggerInterventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerInterventionMutation, TriggerInterventionMutationVariables>(TriggerInterventionDocument, options);
      }
export type TriggerInterventionMutationHookResult = ReturnType<typeof useTriggerInterventionMutation>;
export type TriggerInterventionMutationResult = Apollo.MutationResult<TriggerInterventionMutation>;
export type TriggerInterventionMutationOptions = Apollo.BaseMutationOptions<TriggerInterventionMutation, TriggerInterventionMutationVariables>;
export const ClaimAiCoachingInterventionDocument = gql`
    mutation ClaimAiCoachingIntervention($interventionId: Int!) {
  claimAiCoachingIntervention(interventionId: $interventionId) {
    success
    message
    interventionId
  }
}
    `;
export type ClaimAiCoachingInterventionMutationFn = Apollo.MutationFunction<ClaimAiCoachingInterventionMutation, ClaimAiCoachingInterventionMutationVariables>;

/**
 * __useClaimAiCoachingInterventionMutation__
 *
 * To run a mutation, you first call `useClaimAiCoachingInterventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimAiCoachingInterventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimAiCoachingInterventionMutation, { data, loading, error }] = useClaimAiCoachingInterventionMutation({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *   },
 * });
 */
export function useClaimAiCoachingInterventionMutation(baseOptions?: Apollo.MutationHookOptions<ClaimAiCoachingInterventionMutation, ClaimAiCoachingInterventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimAiCoachingInterventionMutation, ClaimAiCoachingInterventionMutationVariables>(ClaimAiCoachingInterventionDocument, options);
      }
export type ClaimAiCoachingInterventionMutationHookResult = ReturnType<typeof useClaimAiCoachingInterventionMutation>;
export type ClaimAiCoachingInterventionMutationResult = Apollo.MutationResult<ClaimAiCoachingInterventionMutation>;
export type ClaimAiCoachingInterventionMutationOptions = Apollo.BaseMutationOptions<ClaimAiCoachingInterventionMutation, ClaimAiCoachingInterventionMutationVariables>;
export const UpdateAiCoachingInterventionDocument = gql`
    mutation UpdateAiCoachingIntervention($interventionId: Int!, $editedMessage: String, $coachFeedback: String, $coachRating: String) {
  updateAiCoachingIntervention(
    interventionId: $interventionId
    editedMessage: $editedMessage
    coachFeedback: $coachFeedback
    coachRating: $coachRating
  ) {
    success
    message
    interventionId
  }
}
    `;
export type UpdateAiCoachingInterventionMutationFn = Apollo.MutationFunction<UpdateAiCoachingInterventionMutation, UpdateAiCoachingInterventionMutationVariables>;

/**
 * __useUpdateAiCoachingInterventionMutation__
 *
 * To run a mutation, you first call `useUpdateAiCoachingInterventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiCoachingInterventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiCoachingInterventionMutation, { data, loading, error }] = useUpdateAiCoachingInterventionMutation({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      editedMessage: // value for 'editedMessage'
 *      coachFeedback: // value for 'coachFeedback'
 *      coachRating: // value for 'coachRating'
 *   },
 * });
 */
export function useUpdateAiCoachingInterventionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiCoachingInterventionMutation, UpdateAiCoachingInterventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiCoachingInterventionMutation, UpdateAiCoachingInterventionMutationVariables>(UpdateAiCoachingInterventionDocument, options);
      }
export type UpdateAiCoachingInterventionMutationHookResult = ReturnType<typeof useUpdateAiCoachingInterventionMutation>;
export type UpdateAiCoachingInterventionMutationResult = Apollo.MutationResult<UpdateAiCoachingInterventionMutation>;
export type UpdateAiCoachingInterventionMutationOptions = Apollo.BaseMutationOptions<UpdateAiCoachingInterventionMutation, UpdateAiCoachingInterventionMutationVariables>;
export const SendAiCoachingEmailDocument = gql`
    mutation SendAiCoachingEmail($interventionId: Int!, $message: String!) {
  sendAiCoachingEmail(interventionId: $interventionId, message: $message) {
    success
    message
    interventionId
  }
}
    `;
export type SendAiCoachingEmailMutationFn = Apollo.MutationFunction<SendAiCoachingEmailMutation, SendAiCoachingEmailMutationVariables>;

/**
 * __useSendAiCoachingEmailMutation__
 *
 * To run a mutation, you first call `useSendAiCoachingEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAiCoachingEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAiCoachingEmailMutation, { data, loading, error }] = useSendAiCoachingEmailMutation({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendAiCoachingEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendAiCoachingEmailMutation, SendAiCoachingEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAiCoachingEmailMutation, SendAiCoachingEmailMutationVariables>(SendAiCoachingEmailDocument, options);
      }
export type SendAiCoachingEmailMutationHookResult = ReturnType<typeof useSendAiCoachingEmailMutation>;
export type SendAiCoachingEmailMutationResult = Apollo.MutationResult<SendAiCoachingEmailMutation>;
export type SendAiCoachingEmailMutationOptions = Apollo.BaseMutationOptions<SendAiCoachingEmailMutation, SendAiCoachingEmailMutationVariables>;
export const PostAiCoachingToFeedDocument = gql`
    mutation PostAiCoachingToFeed($interventionId: Int!, $message: String!) {
  postAiCoachingToFeed(interventionId: $interventionId, message: $message) {
    success
    message
    interventionId
  }
}
    `;
export type PostAiCoachingToFeedMutationFn = Apollo.MutationFunction<PostAiCoachingToFeedMutation, PostAiCoachingToFeedMutationVariables>;

/**
 * __usePostAiCoachingToFeedMutation__
 *
 * To run a mutation, you first call `usePostAiCoachingToFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostAiCoachingToFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postAiCoachingToFeedMutation, { data, loading, error }] = usePostAiCoachingToFeedMutation({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function usePostAiCoachingToFeedMutation(baseOptions?: Apollo.MutationHookOptions<PostAiCoachingToFeedMutation, PostAiCoachingToFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostAiCoachingToFeedMutation, PostAiCoachingToFeedMutationVariables>(PostAiCoachingToFeedDocument, options);
      }
export type PostAiCoachingToFeedMutationHookResult = ReturnType<typeof usePostAiCoachingToFeedMutation>;
export type PostAiCoachingToFeedMutationResult = Apollo.MutationResult<PostAiCoachingToFeedMutation>;
export type PostAiCoachingToFeedMutationOptions = Apollo.BaseMutationOptions<PostAiCoachingToFeedMutation, PostAiCoachingToFeedMutationVariables>;
export const DeclineAiCoachingInterventionDocument = gql`
    mutation DeclineAiCoachingIntervention($interventionId: Int!, $reason: String) {
  declineAiCoachingIntervention(interventionId: $interventionId, reason: $reason) {
    success
    message
    interventionId
  }
}
    `;
export type DeclineAiCoachingInterventionMutationFn = Apollo.MutationFunction<DeclineAiCoachingInterventionMutation, DeclineAiCoachingInterventionMutationVariables>;

/**
 * __useDeclineAiCoachingInterventionMutation__
 *
 * To run a mutation, you first call `useDeclineAiCoachingInterventionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAiCoachingInterventionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAiCoachingInterventionMutation, { data, loading, error }] = useDeclineAiCoachingInterventionMutation({
 *   variables: {
 *      interventionId: // value for 'interventionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeclineAiCoachingInterventionMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAiCoachingInterventionMutation, DeclineAiCoachingInterventionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAiCoachingInterventionMutation, DeclineAiCoachingInterventionMutationVariables>(DeclineAiCoachingInterventionDocument, options);
      }
export type DeclineAiCoachingInterventionMutationHookResult = ReturnType<typeof useDeclineAiCoachingInterventionMutation>;
export type DeclineAiCoachingInterventionMutationResult = Apollo.MutationResult<DeclineAiCoachingInterventionMutation>;
export type DeclineAiCoachingInterventionMutationOptions = Apollo.BaseMutationOptions<DeclineAiCoachingInterventionMutation, DeclineAiCoachingInterventionMutationVariables>;
export const GetUserInterventionHistoryDocument = gql`
    query GetUserInterventionHistory($userId: Int!, $limit: Int, $offset: Int) {
  aiCoachingInterventions(userId: $userId, limit: $limit, offset: $offset) {
    total
    interventions {
      id
      identifier
      version
      shouldIntervene
      createdAt
      status
      claimedAt
      claimedBy {
        id
        firstName
        lastName
        email
      }
      emailedAt
      postedToFeedAt
      declinedAt
      declineReason
    }
  }
}
    `;

/**
 * __useGetUserInterventionHistoryQuery__
 *
 * To run a query within a React component, call `useGetUserInterventionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInterventionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInterventionHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUserInterventionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetUserInterventionHistoryQuery, GetUserInterventionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInterventionHistoryQuery, GetUserInterventionHistoryQueryVariables>(GetUserInterventionHistoryDocument, options);
      }
export function useGetUserInterventionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInterventionHistoryQuery, GetUserInterventionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInterventionHistoryQuery, GetUserInterventionHistoryQueryVariables>(GetUserInterventionHistoryDocument, options);
        }
export type GetUserInterventionHistoryQueryHookResult = ReturnType<typeof useGetUserInterventionHistoryQuery>;
export type GetUserInterventionHistoryLazyQueryHookResult = ReturnType<typeof useGetUserInterventionHistoryLazyQuery>;
export type GetUserInterventionHistoryQueryResult = Apollo.QueryResult<GetUserInterventionHistoryQuery, GetUserInterventionHistoryQueryVariables>;
export const GetFilterOptionsDocument = gql`
    query GetFilterOptions {
  nonprofitOrgs: getFilterNonprofitOrgs {
    id
    name
  }
  funderOrgs: funders {
    id
    name
    disabled
  }
  cohorts: searchCohorts(limit: 1000) {
    cohorts {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
      }
export function useGetFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
export type GetFilterOptionsQueryHookResult = ReturnType<typeof useGetFilterOptionsQuery>;
export type GetFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetFilterOptionsLazyQuery>;
export type GetFilterOptionsQueryResult = Apollo.QueryResult<GetFilterOptionsQuery, GetFilterOptionsQueryVariables>;
export const AiImpactDashboardSummaryDocument = gql`
    query AiImpactDashboardSummary($funderOrgId: Int!, $nonprofitOrgIds: [Int!], $summaryType: GoalImpactCategory!) {
  aiImpactDashboardSummary(
    funderOrgId: $funderOrgId
    nonprofitOrgIds: $nonprofitOrgIds
    summaryType: $summaryType
  ) {
    copy
    bulletpoints
    hasError
  }
}
    `;

/**
 * __useAiImpactDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useAiImpactDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiImpactDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiImpactDashboardSummaryQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *      summaryType: // value for 'summaryType'
 *   },
 * });
 */
export function useAiImpactDashboardSummaryQuery(baseOptions: Apollo.QueryHookOptions<AiImpactDashboardSummaryQuery, AiImpactDashboardSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiImpactDashboardSummaryQuery, AiImpactDashboardSummaryQueryVariables>(AiImpactDashboardSummaryDocument, options);
      }
export function useAiImpactDashboardSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiImpactDashboardSummaryQuery, AiImpactDashboardSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiImpactDashboardSummaryQuery, AiImpactDashboardSummaryQueryVariables>(AiImpactDashboardSummaryDocument, options);
        }
export type AiImpactDashboardSummaryQueryHookResult = ReturnType<typeof useAiImpactDashboardSummaryQuery>;
export type AiImpactDashboardSummaryLazyQueryHookResult = ReturnType<typeof useAiImpactDashboardSummaryLazyQuery>;
export type AiImpactDashboardSummaryQueryResult = Apollo.QueryResult<AiImpactDashboardSummaryQuery, AiImpactDashboardSummaryQueryVariables>;
export const AllChartCategoriesDocument = gql`
    query AllChartCategories($chartId: Int!) {
  allChartCategories(chartId: $chartId) {
    chartId
    id
    title
    archivedAt
    ChartDataPoint {
      archivedAt
      chartCategoryId
      id
      date
      value
    }
  }
}
    `;

/**
 * __useAllChartCategoriesQuery__
 *
 * To run a query within a React component, call `useAllChartCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChartCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChartCategoriesQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useAllChartCategoriesQuery(baseOptions: Apollo.QueryHookOptions<AllChartCategoriesQuery, AllChartCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllChartCategoriesQuery, AllChartCategoriesQueryVariables>(AllChartCategoriesDocument, options);
      }
export function useAllChartCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllChartCategoriesQuery, AllChartCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllChartCategoriesQuery, AllChartCategoriesQueryVariables>(AllChartCategoriesDocument, options);
        }
export type AllChartCategoriesQueryHookResult = ReturnType<typeof useAllChartCategoriesQuery>;
export type AllChartCategoriesLazyQueryHookResult = ReturnType<typeof useAllChartCategoriesLazyQuery>;
export type AllChartCategoriesQueryResult = Apollo.QueryResult<AllChartCategoriesQuery, AllChartCategoriesQueryVariables>;
export const AllDonationPortalsDocument = gql`
    query allDonationPortals($nonprofitOrgId: Int!) {
  allDonationPortals(nonprofitOrgId: $nonprofitOrgId) {
    id
    hashedId
    name
    publishedAt
    archivedAt
  }
}
    `;

/**
 * __useAllDonationPortalsQuery__
 *
 * To run a query within a React component, call `useAllDonationPortalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDonationPortalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDonationPortalsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useAllDonationPortalsQuery(baseOptions: Apollo.QueryHookOptions<AllDonationPortalsQuery, AllDonationPortalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDonationPortalsQuery, AllDonationPortalsQueryVariables>(AllDonationPortalsDocument, options);
      }
export function useAllDonationPortalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDonationPortalsQuery, AllDonationPortalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDonationPortalsQuery, AllDonationPortalsQueryVariables>(AllDonationPortalsDocument, options);
        }
export type AllDonationPortalsQueryHookResult = ReturnType<typeof useAllDonationPortalsQuery>;
export type AllDonationPortalsLazyQueryHookResult = ReturnType<typeof useAllDonationPortalsLazyQuery>;
export type AllDonationPortalsQueryResult = Apollo.QueryResult<AllDonationPortalsQuery, AllDonationPortalsQueryVariables>;
export const ChartDocument = gql`
    query Chart($goalId: Int) {
  chart(goalId: $goalId) {
    calculationType
    id
    target
    title
    unitOfMeasurement
    goalId
    seriesData {
      data {
        x
        y
      }
      title
    }
  }
}
    `;

/**
 * __useChartQuery__
 *
 * To run a query within a React component, call `useChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartQuery({
 *   variables: {
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useChartQuery(baseOptions?: Apollo.QueryHookOptions<ChartQuery, ChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartQuery, ChartQueryVariables>(ChartDocument, options);
      }
export function useChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartQuery, ChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartQuery, ChartQueryVariables>(ChartDocument, options);
        }
export type ChartQueryHookResult = ReturnType<typeof useChartQuery>;
export type ChartLazyQueryHookResult = ReturnType<typeof useChartLazyQuery>;
export type ChartQueryResult = Apollo.QueryResult<ChartQuery, ChartQueryVariables>;
export const ChartCategoryDocument = gql`
    query ChartCategory($chartId: Int!) {
  chartCategory(chartId: $chartId) {
    chartId
    id
    title
    archivedAt
    ChartDataPoint {
      archivedAt
      chartCategoryId
      id
      date
      value
    }
  }
}
    `;

/**
 * __useChartCategoryQuery__
 *
 * To run a query within a React component, call `useChartCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartCategoryQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *   },
 * });
 */
export function useChartCategoryQuery(baseOptions: Apollo.QueryHookOptions<ChartCategoryQuery, ChartCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartCategoryQuery, ChartCategoryQueryVariables>(ChartCategoryDocument, options);
      }
export function useChartCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartCategoryQuery, ChartCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartCategoryQuery, ChartCategoryQueryVariables>(ChartCategoryDocument, options);
        }
export type ChartCategoryQueryHookResult = ReturnType<typeof useChartCategoryQuery>;
export type ChartCategoryLazyQueryHookResult = ReturnType<typeof useChartCategoryLazyQuery>;
export type ChartCategoryQueryResult = Apollo.QueryResult<ChartCategoryQuery, ChartCategoryQueryVariables>;
export const CheckStripePromoDocument = gql`
    query checkStripePromo($code: String!) {
  checkStripePromo(code: $code) {
    promoId
    name
    percentOff
    amountOff
    couponId
  }
}
    `;

/**
 * __useCheckStripePromoQuery__
 *
 * To run a query within a React component, call `useCheckStripePromoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStripePromoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckStripePromoQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckStripePromoQuery(baseOptions: Apollo.QueryHookOptions<CheckStripePromoQuery, CheckStripePromoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckStripePromoQuery, CheckStripePromoQueryVariables>(CheckStripePromoDocument, options);
      }
export function useCheckStripePromoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckStripePromoQuery, CheckStripePromoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckStripePromoQuery, CheckStripePromoQueryVariables>(CheckStripePromoDocument, options);
        }
export type CheckStripePromoQueryHookResult = ReturnType<typeof useCheckStripePromoQuery>;
export type CheckStripePromoLazyQueryHookResult = ReturnType<typeof useCheckStripePromoLazyQuery>;
export type CheckStripePromoQueryResult = Apollo.QueryResult<CheckStripePromoQuery, CheckStripePromoQueryVariables>;
export const CommunityGuidelinesDocument = gql`
    query communityGuidelines {
  communityGuidelines {
    isAgreed
  }
}
    `;

/**
 * __useCommunityGuidelinesQuery__
 *
 * To run a query within a React component, call `useCommunityGuidelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGuidelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGuidelinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityGuidelinesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityGuidelinesQuery, CommunityGuidelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGuidelinesQuery, CommunityGuidelinesQueryVariables>(CommunityGuidelinesDocument, options);
      }
export function useCommunityGuidelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGuidelinesQuery, CommunityGuidelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGuidelinesQuery, CommunityGuidelinesQueryVariables>(CommunityGuidelinesDocument, options);
        }
export type CommunityGuidelinesQueryHookResult = ReturnType<typeof useCommunityGuidelinesQuery>;
export type CommunityGuidelinesLazyQueryHookResult = ReturnType<typeof useCommunityGuidelinesLazyQuery>;
export type CommunityGuidelinesQueryResult = Apollo.QueryResult<CommunityGuidelinesQuery, CommunityGuidelinesQueryVariables>;
export const CommunityTopPostsDocument = gql`
    query CommunityTopPosts($limit: Int) {
  communityTopPosts(limit: $limit) {
    posts {
      id
      name
      body
      poster {
        name
        avatarUrl
      }
      postDate
      likesCount
      commentsCount
      commenters {
        name
        avatarUrl
      }
      postLink
      totalEngagement
    }
  }
}
    `;

/**
 * __useCommunityTopPostsQuery__
 *
 * To run a query within a React component, call `useCommunityTopPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTopPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTopPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCommunityTopPostsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityTopPostsQuery, CommunityTopPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTopPostsQuery, CommunityTopPostsQueryVariables>(CommunityTopPostsDocument, options);
      }
export function useCommunityTopPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTopPostsQuery, CommunityTopPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTopPostsQuery, CommunityTopPostsQueryVariables>(CommunityTopPostsDocument, options);
        }
export type CommunityTopPostsQueryHookResult = ReturnType<typeof useCommunityTopPostsQuery>;
export type CommunityTopPostsLazyQueryHookResult = ReturnType<typeof useCommunityTopPostsLazyQuery>;
export type CommunityTopPostsQueryResult = Apollo.QueryResult<CommunityTopPostsQuery, CommunityTopPostsQueryVariables>;
export const CommunityTrendingEventsDocument = gql`
    query communityTrendingEvents($limit: Int) {
  communityTrendingEvents(limit: $limit) {
    id
    circleEventId
    name
    eventType
    startsAt
    endsAt
    rsvpCount
    summary
    virtualLocationUrl
    body
  }
}
    `;

/**
 * __useCommunityTrendingEventsQuery__
 *
 * To run a query within a React component, call `useCommunityTrendingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTrendingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTrendingEventsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCommunityTrendingEventsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityTrendingEventsQuery, CommunityTrendingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTrendingEventsQuery, CommunityTrendingEventsQueryVariables>(CommunityTrendingEventsDocument, options);
      }
export function useCommunityTrendingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTrendingEventsQuery, CommunityTrendingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTrendingEventsQuery, CommunityTrendingEventsQueryVariables>(CommunityTrendingEventsDocument, options);
        }
export type CommunityTrendingEventsQueryHookResult = ReturnType<typeof useCommunityTrendingEventsQuery>;
export type CommunityTrendingEventsLazyQueryHookResult = ReturnType<typeof useCommunityTrendingEventsLazyQuery>;
export type CommunityTrendingEventsQueryResult = Apollo.QueryResult<CommunityTrendingEventsQuery, CommunityTrendingEventsQueryVariables>;
export const CreateConnectAccountLinkDocument = gql`
    query createConnectAccountLink($stripeAccountId: String!, $returnUrl: String!) {
  createConnectAccountLink(
    stripeAccountId: $stripeAccountId
    returnUrl: $returnUrl
  ) {
    url
  }
}
    `;

/**
 * __useCreateConnectAccountLinkQuery__
 *
 * To run a query within a React component, call `useCreateConnectAccountLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectAccountLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateConnectAccountLinkQuery({
 *   variables: {
 *      stripeAccountId: // value for 'stripeAccountId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useCreateConnectAccountLinkQuery(baseOptions: Apollo.QueryHookOptions<CreateConnectAccountLinkQuery, CreateConnectAccountLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateConnectAccountLinkQuery, CreateConnectAccountLinkQueryVariables>(CreateConnectAccountLinkDocument, options);
      }
export function useCreateConnectAccountLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateConnectAccountLinkQuery, CreateConnectAccountLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateConnectAccountLinkQuery, CreateConnectAccountLinkQueryVariables>(CreateConnectAccountLinkDocument, options);
        }
export type CreateConnectAccountLinkQueryHookResult = ReturnType<typeof useCreateConnectAccountLinkQuery>;
export type CreateConnectAccountLinkLazyQueryHookResult = ReturnType<typeof useCreateConnectAccountLinkLazyQuery>;
export type CreateConnectAccountLinkQueryResult = Apollo.QueryResult<CreateConnectAccountLinkQuery, CreateConnectAccountLinkQueryVariables>;
export const DashboardImpactReportDocument = gql`
    query dashboardImpactReport($nonprofitOrgId: Int!) {
  dashboardImpactReport(nonprofitOrgId: $nonprofitOrgId) {
    reportEndDate
    reportStartDate
    impactGoalsUrl
    showEmptyState
    goalsPrioritizedByTaskCreateDate {
      goalId
      goalTitle
      numTasks
      numTasksCompleted
      goalLink
    }
    funderCollaboratedGoals {
      goalId
      goalTitle
      goalLink
      updatedAt
    }
    tasksSummary {
      totalTasksAssigned
      totalTasksUnassigned
      totalTasks
      totalTasksCompletedOverall
      totalTasksCompletedThisReportPeriod
    }
    pastReportPeriodActivity {
      academyResourcesViewed
      goalCategory
      goalsCreated
      tasksCompleted
    }
  }
}
    `;

/**
 * __useDashboardImpactReportQuery__
 *
 * To run a query within a React component, call `useDashboardImpactReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardImpactReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardImpactReportQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useDashboardImpactReportQuery(baseOptions: Apollo.QueryHookOptions<DashboardImpactReportQuery, DashboardImpactReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardImpactReportQuery, DashboardImpactReportQueryVariables>(DashboardImpactReportDocument, options);
      }
export function useDashboardImpactReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardImpactReportQuery, DashboardImpactReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardImpactReportQuery, DashboardImpactReportQueryVariables>(DashboardImpactReportDocument, options);
        }
export type DashboardImpactReportQueryHookResult = ReturnType<typeof useDashboardImpactReportQuery>;
export type DashboardImpactReportLazyQueryHookResult = ReturnType<typeof useDashboardImpactReportLazyQuery>;
export type DashboardImpactReportQueryResult = Apollo.QueryResult<DashboardImpactReportQuery, DashboardImpactReportQueryVariables>;
export const DonationPortalAndBlocksDocument = gql`
    query donationPortalAndBlocks($nonprofitOrgId: Int!, $hashedId: String) {
  donationPortalAndBlocks(nonprofitOrgId: $nonprofitOrgId, hashedId: $hashedId) {
    id
    nonprofitOrgId
    createdUserId
    updatedUserId
    createdAt
    updatedAt
    publishedAt
    hashedId
    name
    availableFrequencies
    colorTheme {
      id
      color
    }
    customAmounts {
      amountInCents
    }
    campaignId
    customAmountsOn
    socialTitle
    socialDescription
    DonationPortalBlock {
      id
      assetId
      assetType
      asset {
        id
        assetType
        createdAt
        updatedAt
        reusable
        createdUserId
        nonprofitOrgId
        updatedUserId
        assetDetails
      }
      createdAt
      updatedAt
      donationPortalId
    }
  }
}
    `;

/**
 * __useDonationPortalAndBlocksQuery__
 *
 * To run a query within a React component, call `useDonationPortalAndBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonationPortalAndBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonationPortalAndBlocksQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useDonationPortalAndBlocksQuery(baseOptions: Apollo.QueryHookOptions<DonationPortalAndBlocksQuery, DonationPortalAndBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonationPortalAndBlocksQuery, DonationPortalAndBlocksQueryVariables>(DonationPortalAndBlocksDocument, options);
      }
export function useDonationPortalAndBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonationPortalAndBlocksQuery, DonationPortalAndBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonationPortalAndBlocksQuery, DonationPortalAndBlocksQueryVariables>(DonationPortalAndBlocksDocument, options);
        }
export type DonationPortalAndBlocksQueryHookResult = ReturnType<typeof useDonationPortalAndBlocksQuery>;
export type DonationPortalAndBlocksLazyQueryHookResult = ReturnType<typeof useDonationPortalAndBlocksLazyQuery>;
export type DonationPortalAndBlocksQueryResult = Apollo.QueryResult<DonationPortalAndBlocksQuery, DonationPortalAndBlocksQueryVariables>;
export const EngagementDashboardDocument = gql`
    query EngagementDashboard($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    yourCohort {
      totalCount
      activeOrgsByMonth {
        activeMonth
        n
      }
      engagementData {
        orgName
        n30Days
        n90Days
      }
    }
    goalsData {
      totalOrgsWithGoals
      goalsCreatedByMonth {
        activeMonthStart
        n
      }
      goalsUpdatedByMonth {
        activeMonthStart
        n
      }
    }
    coachingData {
      totalOneOnOneSessions
      oneOnOneSessionsByMonth {
        activeWeek
        n
      }
      groupSessionsByMonth {
        activeWeek
        n
      }
    }
    academyData {
      topResources {
        resourceName
        resourceType
        totalInteractions
      }
      resourcesViewed
      templatesDownloaded
      coursesCompleted
      learningTracksCompleted
    }
    storiesData {
      orgsWithStories
      totalStories
      topStoriesByViews {
        title
        url
        n
      }
    }
    donationsData {
      orgsWithCampaigns
    }
    priorityNeedsData {
      priorityNeedTopics {
        category
        totalbaselineusers
        totalcurrentusers
        baselineconfidence
        currentconfidence
        confidencechangepercent
      }
      topPriorities {
        category
        userCount
        avgConfidence
      }
    }
    whatTheyDoingData {
      maosByMonth {
        activeMonthStart
        n
      }
      impactCFUF
      coachingCFUF
      academyCFUF
      communityCFUF
      funderFinderCFUF
      donationsCFUF
    }
  }
}
    `;

/**
 * __useEngagementDashboardQuery__
 *
 * To run a query within a React component, call `useEngagementDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngagementDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngagementDashboardQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useEngagementDashboardQuery(baseOptions?: Apollo.QueryHookOptions<EngagementDashboardQuery, EngagementDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EngagementDashboardQuery, EngagementDashboardQueryVariables>(EngagementDashboardDocument, options);
      }
export function useEngagementDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EngagementDashboardQuery, EngagementDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EngagementDashboardQuery, EngagementDashboardQueryVariables>(EngagementDashboardDocument, options);
        }
export type EngagementDashboardQueryHookResult = ReturnType<typeof useEngagementDashboardQuery>;
export type EngagementDashboardLazyQueryHookResult = ReturnType<typeof useEngagementDashboardLazyQuery>;
export type EngagementDashboardQueryResult = Apollo.QueryResult<EngagementDashboardQuery, EngagementDashboardQueryVariables>;
export const CohortSectionDocument = gql`
    query CohortSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    yourCohort {
      totalCount
      activeOrgsByMonth {
        activeMonth
        n
      }
      engagementData {
        orgName
        n30Days
        n90Days
      }
    }
  }
}
    `;

/**
 * __useCohortSectionQuery__
 *
 * To run a query within a React component, call `useCohortSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCohortSectionQuery(baseOptions?: Apollo.QueryHookOptions<CohortSectionQuery, CohortSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CohortSectionQuery, CohortSectionQueryVariables>(CohortSectionDocument, options);
      }
export function useCohortSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CohortSectionQuery, CohortSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CohortSectionQuery, CohortSectionQueryVariables>(CohortSectionDocument, options);
        }
export type CohortSectionQueryHookResult = ReturnType<typeof useCohortSectionQuery>;
export type CohortSectionLazyQueryHookResult = ReturnType<typeof useCohortSectionLazyQuery>;
export type CohortSectionQueryResult = Apollo.QueryResult<CohortSectionQuery, CohortSectionQueryVariables>;
export const GoalsSectionDocument = gql`
    query GoalsSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    goalsData {
      totalOrgsWithGoals
      goalsCreatedByMonth {
        activeMonthStart
        n
      }
      goalsUpdatedByMonth {
        activeMonthStart
        n
      }
    }
  }
}
    `;

/**
 * __useGoalsSectionQuery__
 *
 * To run a query within a React component, call `useGoalsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGoalsSectionQuery(baseOptions?: Apollo.QueryHookOptions<GoalsSectionQuery, GoalsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsSectionQuery, GoalsSectionQueryVariables>(GoalsSectionDocument, options);
      }
export function useGoalsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsSectionQuery, GoalsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsSectionQuery, GoalsSectionQueryVariables>(GoalsSectionDocument, options);
        }
export type GoalsSectionQueryHookResult = ReturnType<typeof useGoalsSectionQuery>;
export type GoalsSectionLazyQueryHookResult = ReturnType<typeof useGoalsSectionLazyQuery>;
export type GoalsSectionQueryResult = Apollo.QueryResult<GoalsSectionQuery, GoalsSectionQueryVariables>;
export const CoachingSectionDocument = gql`
    query CoachingSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    coachingData {
      totalOneOnOneSessions
      oneOnOneSessionsByMonth {
        activeWeek
        n
      }
      groupSessionsByMonth {
        activeWeek
        n
      }
      topCoachingTopics {
        topic
        sessionCount
      }
    }
  }
}
    `;

/**
 * __useCoachingSectionQuery__
 *
 * To run a query within a React component, call `useCoachingSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachingSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCoachingSectionQuery(baseOptions?: Apollo.QueryHookOptions<CoachingSectionQuery, CoachingSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachingSectionQuery, CoachingSectionQueryVariables>(CoachingSectionDocument, options);
      }
export function useCoachingSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachingSectionQuery, CoachingSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachingSectionQuery, CoachingSectionQueryVariables>(CoachingSectionDocument, options);
        }
export type CoachingSectionQueryHookResult = ReturnType<typeof useCoachingSectionQuery>;
export type CoachingSectionLazyQueryHookResult = ReturnType<typeof useCoachingSectionLazyQuery>;
export type CoachingSectionQueryResult = Apollo.QueryResult<CoachingSectionQuery, CoachingSectionQueryVariables>;
export const AcademySectionDocument = gql`
    query AcademySection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    academyData {
      topResources {
        resourceName
        resourceType
        totalInteractions
      }
      resourcesViewed
      templatesDownloaded
      coursesCompleted
      learningTracksCompleted
    }
  }
}
    `;

/**
 * __useAcademySectionQuery__
 *
 * To run a query within a React component, call `useAcademySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademySectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAcademySectionQuery(baseOptions?: Apollo.QueryHookOptions<AcademySectionQuery, AcademySectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AcademySectionQuery, AcademySectionQueryVariables>(AcademySectionDocument, options);
      }
export function useAcademySectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AcademySectionQuery, AcademySectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AcademySectionQuery, AcademySectionQueryVariables>(AcademySectionDocument, options);
        }
export type AcademySectionQueryHookResult = ReturnType<typeof useAcademySectionQuery>;
export type AcademySectionLazyQueryHookResult = ReturnType<typeof useAcademySectionLazyQuery>;
export type AcademySectionQueryResult = Apollo.QueryResult<AcademySectionQuery, AcademySectionQueryVariables>;
export const StoriesSectionDocument = gql`
    query StoriesSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    storiesData {
      orgsWithStories
      totalStories
      topStoriesByViews {
        title
        url
        n
      }
    }
  }
}
    `;

/**
 * __useStoriesSectionQuery__
 *
 * To run a query within a React component, call `useStoriesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useStoriesSectionQuery(baseOptions?: Apollo.QueryHookOptions<StoriesSectionQuery, StoriesSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesSectionQuery, StoriesSectionQueryVariables>(StoriesSectionDocument, options);
      }
export function useStoriesSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesSectionQuery, StoriesSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesSectionQuery, StoriesSectionQueryVariables>(StoriesSectionDocument, options);
        }
export type StoriesSectionQueryHookResult = ReturnType<typeof useStoriesSectionQuery>;
export type StoriesSectionLazyQueryHookResult = ReturnType<typeof useStoriesSectionLazyQuery>;
export type StoriesSectionQueryResult = Apollo.QueryResult<StoriesSectionQuery, StoriesSectionQueryVariables>;
export const DonationsSectionDocument = gql`
    query DonationsSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    donationsData {
      orgsWithCampaigns
    }
  }
}
    `;

/**
 * __useDonationsSectionQuery__
 *
 * To run a query within a React component, call `useDonationsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDonationsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDonationsSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useDonationsSectionQuery(baseOptions?: Apollo.QueryHookOptions<DonationsSectionQuery, DonationsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DonationsSectionQuery, DonationsSectionQueryVariables>(DonationsSectionDocument, options);
      }
export function useDonationsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DonationsSectionQuery, DonationsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DonationsSectionQuery, DonationsSectionQueryVariables>(DonationsSectionDocument, options);
        }
export type DonationsSectionQueryHookResult = ReturnType<typeof useDonationsSectionQuery>;
export type DonationsSectionLazyQueryHookResult = ReturnType<typeof useDonationsSectionLazyQuery>;
export type DonationsSectionQueryResult = Apollo.QueryResult<DonationsSectionQuery, DonationsSectionQueryVariables>;
export const TopPrioritiesSectionDocument = gql`
    query TopPrioritiesSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    priorityNeedsData {
      topPriorities {
        category
        userCount
        avgConfidence
      }
    }
  }
}
    `;

/**
 * __useTopPrioritiesSectionQuery__
 *
 * To run a query within a React component, call `useTopPrioritiesSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopPrioritiesSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopPrioritiesSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useTopPrioritiesSectionQuery(baseOptions?: Apollo.QueryHookOptions<TopPrioritiesSectionQuery, TopPrioritiesSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopPrioritiesSectionQuery, TopPrioritiesSectionQueryVariables>(TopPrioritiesSectionDocument, options);
      }
export function useTopPrioritiesSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopPrioritiesSectionQuery, TopPrioritiesSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopPrioritiesSectionQuery, TopPrioritiesSectionQueryVariables>(TopPrioritiesSectionDocument, options);
        }
export type TopPrioritiesSectionQueryHookResult = ReturnType<typeof useTopPrioritiesSectionQuery>;
export type TopPrioritiesSectionLazyQueryHookResult = ReturnType<typeof useTopPrioritiesSectionLazyQuery>;
export type TopPrioritiesSectionQueryResult = Apollo.QueryResult<TopPrioritiesSectionQuery, TopPrioritiesSectionQueryVariables>;
export const WhatTheyDoingSectionDocument = gql`
    query WhatTheyDoingSection($cohortId: Int, $timePeriod: TimePeriod, $startDate: DateTime, $endDate: DateTime) {
  engagementDashboard(
    cohortId: $cohortId
    timePeriod: $timePeriod
    startDate: $startDate
    endDate: $endDate
  ) {
    whatTheyDoingData {
      maosByMonth {
        activeMonthStart
        n
      }
      impactCFUF
      coachingCFUF
      academyCFUF
      communityCFUF
      funderFinderCFUF
      donationsCFUF
    }
  }
}
    `;

/**
 * __useWhatTheyDoingSectionQuery__
 *
 * To run a query within a React component, call `useWhatTheyDoingSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhatTheyDoingSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhatTheyDoingSectionQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      timePeriod: // value for 'timePeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWhatTheyDoingSectionQuery(baseOptions?: Apollo.QueryHookOptions<WhatTheyDoingSectionQuery, WhatTheyDoingSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhatTheyDoingSectionQuery, WhatTheyDoingSectionQueryVariables>(WhatTheyDoingSectionDocument, options);
      }
export function useWhatTheyDoingSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhatTheyDoingSectionQuery, WhatTheyDoingSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhatTheyDoingSectionQuery, WhatTheyDoingSectionQueryVariables>(WhatTheyDoingSectionDocument, options);
        }
export type WhatTheyDoingSectionQueryHookResult = ReturnType<typeof useWhatTheyDoingSectionQuery>;
export type WhatTheyDoingSectionLazyQueryHookResult = ReturnType<typeof useWhatTheyDoingSectionLazyQuery>;
export type WhatTheyDoingSectionQueryResult = Apollo.QueryResult<WhatTheyDoingSectionQuery, WhatTheyDoingSectionQueryVariables>;
export const GetFeedItemsDocument = gql`
    query GetFeedItems($input: GetFeedItemsInput!) {
  getFeedItems(input: $input) {
    items {
      id
      userId
      type
      activityEntityType
      activityType
      title
      category
      body
      callToActionLink
      callToActionText
      createdAt
      eventAt
      updatedAt
      seenOnDate
      interactedAt
      dismissedAt
      parameters
      user {
        id
        firstName
        lastName
      }
    }
    totalCount
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetFeedItemsQuery__
 *
 * To run a query within a React component, call `useGetFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedItemsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedItemsQuery, GetFeedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedItemsQuery, GetFeedItemsQueryVariables>(GetFeedItemsDocument, options);
      }
export function useGetFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedItemsQuery, GetFeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedItemsQuery, GetFeedItemsQueryVariables>(GetFeedItemsDocument, options);
        }
export type GetFeedItemsQueryHookResult = ReturnType<typeof useGetFeedItemsQuery>;
export type GetFeedItemsLazyQueryHookResult = ReturnType<typeof useGetFeedItemsLazyQuery>;
export type GetFeedItemsQueryResult = Apollo.QueryResult<GetFeedItemsQuery, GetFeedItemsQueryVariables>;
export const GetFeedItemsByTypeDocument = gql`
    query GetFeedItemsByType($type: FeedItemType!, $first: Int, $after: String) {
  getFeedItemsByType(type: $type, first: $first, after: $after) {
    items {
      id
      userId
      type
      activityEntityType
      activityType
      title
      category
      body
      callToActionLink
      callToActionText
      createdAt
      eventAt
      updatedAt
      seenOnDate
      interactedAt
      dismissedAt
      parameters
      user {
        id
        firstName
        lastName
      }
    }
    totalCount
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetFeedItemsByTypeQuery__
 *
 * To run a query within a React component, call `useGetFeedItemsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedItemsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedItemsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFeedItemsByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetFeedItemsByTypeQuery, GetFeedItemsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedItemsByTypeQuery, GetFeedItemsByTypeQueryVariables>(GetFeedItemsByTypeDocument, options);
      }
export function useGetFeedItemsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedItemsByTypeQuery, GetFeedItemsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedItemsByTypeQuery, GetFeedItemsByTypeQueryVariables>(GetFeedItemsByTypeDocument, options);
        }
export type GetFeedItemsByTypeQueryHookResult = ReturnType<typeof useGetFeedItemsByTypeQuery>;
export type GetFeedItemsByTypeLazyQueryHookResult = ReturnType<typeof useGetFeedItemsByTypeLazyQuery>;
export type GetFeedItemsByTypeQueryResult = Apollo.QueryResult<GetFeedItemsByTypeQuery, GetFeedItemsByTypeQueryVariables>;
export const GetFeedItemsByCategoryDocument = gql`
    query GetFeedItemsByCategory($category: FeedItemCategory!, $first: Int, $after: String) {
  getFeedItemsByCategory(category: $category, first: $first, after: $after) {
    items {
      id
      userId
      type
      activityEntityType
      activityType
      title
      category
      body
      callToActionLink
      callToActionText
      createdAt
      eventAt
      updatedAt
      seenOnDate
      interactedAt
      dismissedAt
      parameters
      user {
        id
        firstName
        lastName
      }
    }
    totalCount
    hasMore
    nextCursor
  }
}
    `;

/**
 * __useGetFeedItemsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetFeedItemsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedItemsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedItemsByCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFeedItemsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetFeedItemsByCategoryQuery, GetFeedItemsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedItemsByCategoryQuery, GetFeedItemsByCategoryQueryVariables>(GetFeedItemsByCategoryDocument, options);
      }
export function useGetFeedItemsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedItemsByCategoryQuery, GetFeedItemsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedItemsByCategoryQuery, GetFeedItemsByCategoryQueryVariables>(GetFeedItemsByCategoryDocument, options);
        }
export type GetFeedItemsByCategoryQueryHookResult = ReturnType<typeof useGetFeedItemsByCategoryQuery>;
export type GetFeedItemsByCategoryLazyQueryHookResult = ReturnType<typeof useGetFeedItemsByCategoryLazyQuery>;
export type GetFeedItemsByCategoryQueryResult = Apollo.QueryResult<GetFeedItemsByCategoryQuery, GetFeedItemsByCategoryQueryVariables>;
export const GetUnreadFeedItemsCountDocument = gql`
    query GetUnreadFeedItemsCount {
  getUnreadFeedItemsCount
}
    `;

/**
 * __useGetUnreadFeedItemsCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadFeedItemsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadFeedItemsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadFeedItemsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadFeedItemsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadFeedItemsCountQuery, GetUnreadFeedItemsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadFeedItemsCountQuery, GetUnreadFeedItemsCountQueryVariables>(GetUnreadFeedItemsCountDocument, options);
      }
export function useGetUnreadFeedItemsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadFeedItemsCountQuery, GetUnreadFeedItemsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadFeedItemsCountQuery, GetUnreadFeedItemsCountQueryVariables>(GetUnreadFeedItemsCountDocument, options);
        }
export type GetUnreadFeedItemsCountQueryHookResult = ReturnType<typeof useGetUnreadFeedItemsCountQuery>;
export type GetUnreadFeedItemsCountLazyQueryHookResult = ReturnType<typeof useGetUnreadFeedItemsCountLazyQuery>;
export type GetUnreadFeedItemsCountQueryResult = Apollo.QueryResult<GetUnreadFeedItemsCountQuery, GetUnreadFeedItemsCountQueryVariables>;
export const MarkFeedItemSeenDocument = gql`
    mutation MarkFeedItemSeen($feedItemId: Int!) {
  markFeedItemSeen(feedItemId: $feedItemId) {
    id
    seenOnDate
    updatedAt
  }
}
    `;
export type MarkFeedItemSeenMutationFn = Apollo.MutationFunction<MarkFeedItemSeenMutation, MarkFeedItemSeenMutationVariables>;

/**
 * __useMarkFeedItemSeenMutation__
 *
 * To run a mutation, you first call `useMarkFeedItemSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFeedItemSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFeedItemSeenMutation, { data, loading, error }] = useMarkFeedItemSeenMutation({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useMarkFeedItemSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkFeedItemSeenMutation, MarkFeedItemSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFeedItemSeenMutation, MarkFeedItemSeenMutationVariables>(MarkFeedItemSeenDocument, options);
      }
export type MarkFeedItemSeenMutationHookResult = ReturnType<typeof useMarkFeedItemSeenMutation>;
export type MarkFeedItemSeenMutationResult = Apollo.MutationResult<MarkFeedItemSeenMutation>;
export type MarkFeedItemSeenMutationOptions = Apollo.BaseMutationOptions<MarkFeedItemSeenMutation, MarkFeedItemSeenMutationVariables>;
export const MarkFeedItemInteractedDocument = gql`
    mutation MarkFeedItemInteracted($feedItemId: Int!) {
  markFeedItemInteracted(feedItemId: $feedItemId) {
    id
    interactedAt
    updatedAt
  }
}
    `;
export type MarkFeedItemInteractedMutationFn = Apollo.MutationFunction<MarkFeedItemInteractedMutation, MarkFeedItemInteractedMutationVariables>;

/**
 * __useMarkFeedItemInteractedMutation__
 *
 * To run a mutation, you first call `useMarkFeedItemInteractedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkFeedItemInteractedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markFeedItemInteractedMutation, { data, loading, error }] = useMarkFeedItemInteractedMutation({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useMarkFeedItemInteractedMutation(baseOptions?: Apollo.MutationHookOptions<MarkFeedItemInteractedMutation, MarkFeedItemInteractedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkFeedItemInteractedMutation, MarkFeedItemInteractedMutationVariables>(MarkFeedItemInteractedDocument, options);
      }
export type MarkFeedItemInteractedMutationHookResult = ReturnType<typeof useMarkFeedItemInteractedMutation>;
export type MarkFeedItemInteractedMutationResult = Apollo.MutationResult<MarkFeedItemInteractedMutation>;
export type MarkFeedItemInteractedMutationOptions = Apollo.BaseMutationOptions<MarkFeedItemInteractedMutation, MarkFeedItemInteractedMutationVariables>;
export const DismissFeedItemDocument = gql`
    mutation DismissFeedItem($feedItemId: Int!) {
  dismissFeedItem(feedItemId: $feedItemId) {
    id
    dismissedAt
    updatedAt
  }
}
    `;
export type DismissFeedItemMutationFn = Apollo.MutationFunction<DismissFeedItemMutation, DismissFeedItemMutationVariables>;

/**
 * __useDismissFeedItemMutation__
 *
 * To run a mutation, you first call `useDismissFeedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissFeedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissFeedItemMutation, { data, loading, error }] = useDismissFeedItemMutation({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useDismissFeedItemMutation(baseOptions?: Apollo.MutationHookOptions<DismissFeedItemMutation, DismissFeedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissFeedItemMutation, DismissFeedItemMutationVariables>(DismissFeedItemDocument, options);
      }
export type DismissFeedItemMutationHookResult = ReturnType<typeof useDismissFeedItemMutation>;
export type DismissFeedItemMutationResult = Apollo.MutationResult<DismissFeedItemMutation>;
export type DismissFeedItemMutationOptions = Apollo.BaseMutationOptions<DismissFeedItemMutation, DismissFeedItemMutationVariables>;
export const CreateFeedItemDocument = gql`
    mutation CreateFeedItem($input: CreateFeedItemInput!) {
  createFeedItem(input: $input) {
    id
    userId
    type
    activityEntityType
    activityType
    title
    category
    body
    callToActionLink
    callToActionText
    createdAt
    eventAt
    parameters
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export type CreateFeedItemMutationFn = Apollo.MutationFunction<CreateFeedItemMutation, CreateFeedItemMutationVariables>;

/**
 * __useCreateFeedItemMutation__
 *
 * To run a mutation, you first call `useCreateFeedItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedItemMutation, { data, loading, error }] = useCreateFeedItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeedItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedItemMutation, CreateFeedItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedItemMutation, CreateFeedItemMutationVariables>(CreateFeedItemDocument, options);
      }
export type CreateFeedItemMutationHookResult = ReturnType<typeof useCreateFeedItemMutation>;
export type CreateFeedItemMutationResult = Apollo.MutationResult<CreateFeedItemMutation>;
export type CreateFeedItemMutationOptions = Apollo.BaseMutationOptions<CreateFeedItemMutation, CreateFeedItemMutationVariables>;
export const FunderDashboardFiltersDocument = gql`
    query funderDashboardFilters($funderOrgId: Int!) {
  funderDashboardFilters(funderOrgId: $funderOrgId) {
    cohorts {
      type
      label
      nonprofitOrgIds
      value
    }
    missionAreas {
      type
      label
      nonprofitOrgIds
      value
    }
  }
}
    `;

/**
 * __useFunderDashboardFiltersQuery__
 *
 * To run a query within a React component, call `useFunderDashboardFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunderDashboardFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunderDashboardFiltersQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useFunderDashboardFiltersQuery(baseOptions: Apollo.QueryHookOptions<FunderDashboardFiltersQuery, FunderDashboardFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunderDashboardFiltersQuery, FunderDashboardFiltersQueryVariables>(FunderDashboardFiltersDocument, options);
      }
export function useFunderDashboardFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunderDashboardFiltersQuery, FunderDashboardFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunderDashboardFiltersQuery, FunderDashboardFiltersQueryVariables>(FunderDashboardFiltersDocument, options);
        }
export type FunderDashboardFiltersQueryHookResult = ReturnType<typeof useFunderDashboardFiltersQuery>;
export type FunderDashboardFiltersLazyQueryHookResult = ReturnType<typeof useFunderDashboardFiltersLazyQuery>;
export type FunderDashboardFiltersQueryResult = Apollo.QueryResult<FunderDashboardFiltersQuery, FunderDashboardFiltersQueryVariables>;
export const FundersDocument = gql`
    query funders {
  funders {
    id
    name
  }
}
    `;

/**
 * __useFundersQuery__
 *
 * To run a query within a React component, call `useFundersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundersQuery(baseOptions?: Apollo.QueryHookOptions<FundersQuery, FundersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundersQuery, FundersQueryVariables>(FundersDocument, options);
      }
export function useFundersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundersQuery, FundersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundersQuery, FundersQueryVariables>(FundersDocument, options);
        }
export type FundersQueryHookResult = ReturnType<typeof useFundersQuery>;
export type FundersLazyQueryHookResult = ReturnType<typeof useFundersLazyQuery>;
export type FundersQueryResult = Apollo.QueryResult<FundersQuery, FundersQueryVariables>;
export const GenerateInternalFunderReportDocument = gql`
    query generateInternalFunderReport($funderOrgId: Int!, $dateOverride: String, $skipEmail: Boolean) {
  generateInternalFunderReport(
    funderOrgId: $funderOrgId
    dateOverride: $dateOverride
    skipEmail: $skipEmail
  ) {
    generated
  }
}
    `;

/**
 * __useGenerateInternalFunderReportQuery__
 *
 * To run a query within a React component, call `useGenerateInternalFunderReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateInternalFunderReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateInternalFunderReportQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      dateOverride: // value for 'dateOverride'
 *      skipEmail: // value for 'skipEmail'
 *   },
 * });
 */
export function useGenerateInternalFunderReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateInternalFunderReportQuery, GenerateInternalFunderReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateInternalFunderReportQuery, GenerateInternalFunderReportQueryVariables>(GenerateInternalFunderReportDocument, options);
      }
export function useGenerateInternalFunderReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateInternalFunderReportQuery, GenerateInternalFunderReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateInternalFunderReportQuery, GenerateInternalFunderReportQueryVariables>(GenerateInternalFunderReportDocument, options);
        }
export type GenerateInternalFunderReportQueryHookResult = ReturnType<typeof useGenerateInternalFunderReportQuery>;
export type GenerateInternalFunderReportLazyQueryHookResult = ReturnType<typeof useGenerateInternalFunderReportLazyQuery>;
export type GenerateInternalFunderReportQueryResult = Apollo.QueryResult<GenerateInternalFunderReportQuery, GenerateInternalFunderReportQueryVariables>;
export const GenerateGoalsQueryDocument = gql`
    query generateGoalsQuery($nonprofitOrgId: Int!) {
  generateGoals(nonprofitOrgId: $nonprofitOrgId) {
    title
    description
    unit
    target
  }
}
    `;

/**
 * __useGenerateGoalsQueryQuery__
 *
 * To run a query within a React component, call `useGenerateGoalsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateGoalsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateGoalsQueryQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGenerateGoalsQueryQuery(baseOptions: Apollo.QueryHookOptions<GenerateGoalsQueryQuery, GenerateGoalsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateGoalsQueryQuery, GenerateGoalsQueryQueryVariables>(GenerateGoalsQueryDocument, options);
      }
export function useGenerateGoalsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateGoalsQueryQuery, GenerateGoalsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateGoalsQueryQuery, GenerateGoalsQueryQueryVariables>(GenerateGoalsQueryDocument, options);
        }
export type GenerateGoalsQueryQueryHookResult = ReturnType<typeof useGenerateGoalsQueryQuery>;
export type GenerateGoalsQueryLazyQueryHookResult = ReturnType<typeof useGenerateGoalsQueryLazyQuery>;
export type GenerateGoalsQueryQueryResult = Apollo.QueryResult<GenerateGoalsQueryQuery, GenerateGoalsQueryQueryVariables>;
export const GetAiOptimizedCopyDocument = gql`
    query getAiOptimizedCopy($prompt: PromptInput!, $optimizationType: OptimizationType!, $orgId: Int!) {
  getAiOptimizedCopy(
    orgId: $orgId
    prompt: $prompt
    optimizationType: $optimizationType
  ) {
    headline
    description
    hasError
  }
}
    `;

/**
 * __useGetAiOptimizedCopyQuery__
 *
 * To run a query within a React component, call `useGetAiOptimizedCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiOptimizedCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiOptimizedCopyQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      optimizationType: // value for 'optimizationType'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAiOptimizedCopyQuery(baseOptions: Apollo.QueryHookOptions<GetAiOptimizedCopyQuery, GetAiOptimizedCopyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiOptimizedCopyQuery, GetAiOptimizedCopyQueryVariables>(GetAiOptimizedCopyDocument, options);
      }
export function useGetAiOptimizedCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiOptimizedCopyQuery, GetAiOptimizedCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiOptimizedCopyQuery, GetAiOptimizedCopyQueryVariables>(GetAiOptimizedCopyDocument, options);
        }
export type GetAiOptimizedCopyQueryHookResult = ReturnType<typeof useGetAiOptimizedCopyQuery>;
export type GetAiOptimizedCopyLazyQueryHookResult = ReturnType<typeof useGetAiOptimizedCopyLazyQuery>;
export type GetAiOptimizedCopyQueryResult = Apollo.QueryResult<GetAiOptimizedCopyQuery, GetAiOptimizedCopyQueryVariables>;
export const GetAiOptimizedStoryDocument = gql`
    query getAiOptimizedStory($prompt: StoryPromptInput!, $orgId: Int!, $goalId: Int) {
  getAiOptimizedStory(orgId: $orgId, goalId: $goalId, prompt: $prompt) {
    blocks {
      ... on AiTextBlockType {
        blocks {
          key
          data
          text
          type
          depth
          entityRanges
          inlineStyleRanges
        }
        entityMap
        type
      }
      ... on AiImageBlockType {
        cloudinaryFileId
        type
      }
      ... on AiCtaBlockType {
        buttonText
        note
        url
        type
      }
    }
    template
    hasError
  }
}
    `;

/**
 * __useGetAiOptimizedStoryQuery__
 *
 * To run a query within a React component, call `useGetAiOptimizedStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiOptimizedStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiOptimizedStoryQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *      orgId: // value for 'orgId'
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useGetAiOptimizedStoryQuery(baseOptions: Apollo.QueryHookOptions<GetAiOptimizedStoryQuery, GetAiOptimizedStoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiOptimizedStoryQuery, GetAiOptimizedStoryQueryVariables>(GetAiOptimizedStoryDocument, options);
      }
export function useGetAiOptimizedStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiOptimizedStoryQuery, GetAiOptimizedStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiOptimizedStoryQuery, GetAiOptimizedStoryQueryVariables>(GetAiOptimizedStoryDocument, options);
        }
export type GetAiOptimizedStoryQueryHookResult = ReturnType<typeof useGetAiOptimizedStoryQuery>;
export type GetAiOptimizedStoryLazyQueryHookResult = ReturnType<typeof useGetAiOptimizedStoryLazyQuery>;
export type GetAiOptimizedStoryQueryResult = Apollo.QueryResult<GetAiOptimizedStoryQuery, GetAiOptimizedStoryQueryVariables>;
export const AssetDocument = gql`
    query Asset($nonprofitOrgId: Int!) {
  Asset(nonprofitOrgId: $nonprofitOrgId) {
    id
    assetType
    assetDetails
    createdUserId
    updatedUserId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAssetQuery__
 *
 * To run a query within a React component, call `useAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useAssetQuery(baseOptions: Apollo.QueryHookOptions<AssetQuery, AssetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
      }
export function useAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetQuery, AssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetQuery, AssetQueryVariables>(AssetDocument, options);
        }
export type AssetQueryHookResult = ReturnType<typeof useAssetQuery>;
export type AssetLazyQueryHookResult = ReturnType<typeof useAssetLazyQuery>;
export type AssetQueryResult = Apollo.QueryResult<AssetQuery, AssetQueryVariables>;
export const GetAutoStoriesSettingsDocument = gql`
    query getAutoStoriesSettings($nonprofitOrgId: Int!) {
  autoStoriesSettings(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    autoStoriesEnabled
    socialUrls {
      platform
      url
    }
    notifyEmails
    lastScan
  }
}
    `;

/**
 * __useGetAutoStoriesSettingsQuery__
 *
 * To run a query within a React component, call `useGetAutoStoriesSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoStoriesSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoStoriesSettingsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetAutoStoriesSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetAutoStoriesSettingsQuery, GetAutoStoriesSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutoStoriesSettingsQuery, GetAutoStoriesSettingsQueryVariables>(GetAutoStoriesSettingsDocument, options);
      }
export function useGetAutoStoriesSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutoStoriesSettingsQuery, GetAutoStoriesSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutoStoriesSettingsQuery, GetAutoStoriesSettingsQueryVariables>(GetAutoStoriesSettingsDocument, options);
        }
export type GetAutoStoriesSettingsQueryHookResult = ReturnType<typeof useGetAutoStoriesSettingsQuery>;
export type GetAutoStoriesSettingsLazyQueryHookResult = ReturnType<typeof useGetAutoStoriesSettingsLazyQuery>;
export type GetAutoStoriesSettingsQueryResult = Apollo.QueryResult<GetAutoStoriesSettingsQuery, GetAutoStoriesSettingsQueryVariables>;
export const GetBoxConfigDocument = gql`
    query getBoxConfig($userId: Int!, $orgId: Int!) {
  getBoxConfig(userId: $userId, orgId: $orgId) {
    tokenData {
      accessToken
      expiresIn
      acquiredAt
    }
    boxId
  }
}
    `;

/**
 * __useGetBoxConfigQuery__
 *
 * To run a query within a React component, call `useGetBoxConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoxConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoxConfigQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetBoxConfigQuery(baseOptions: Apollo.QueryHookOptions<GetBoxConfigQuery, GetBoxConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBoxConfigQuery, GetBoxConfigQueryVariables>(GetBoxConfigDocument, options);
      }
export function useGetBoxConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoxConfigQuery, GetBoxConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBoxConfigQuery, GetBoxConfigQueryVariables>(GetBoxConfigDocument, options);
        }
export type GetBoxConfigQueryHookResult = ReturnType<typeof useGetBoxConfigQuery>;
export type GetBoxConfigLazyQueryHookResult = ReturnType<typeof useGetBoxConfigLazyQuery>;
export type GetBoxConfigQueryResult = Apollo.QueryResult<GetBoxConfigQuery, GetBoxConfigQueryVariables>;
export const CampaignGatingDocument = gql`
    query campaignGating($nonprofitOrgId: Int!) {
  campaignGating(nonprofitOrgId: $nonprofitOrgId) {
    limit
    limitCycle
    numberOfCampaignsUsed
  }
}
    `;

/**
 * __useCampaignGatingQuery__
 *
 * To run a query within a React component, call `useCampaignGatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignGatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignGatingQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useCampaignGatingQuery(baseOptions: Apollo.QueryHookOptions<CampaignGatingQuery, CampaignGatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignGatingQuery, CampaignGatingQueryVariables>(CampaignGatingDocument, options);
      }
export function useCampaignGatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignGatingQuery, CampaignGatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignGatingQuery, CampaignGatingQueryVariables>(CampaignGatingDocument, options);
        }
export type CampaignGatingQueryHookResult = ReturnType<typeof useCampaignGatingQuery>;
export type CampaignGatingLazyQueryHookResult = ReturnType<typeof useCampaignGatingLazyQuery>;
export type CampaignGatingQueryResult = Apollo.QueryResult<CampaignGatingQuery, CampaignGatingQueryVariables>;
export const CampaignsDocument = gql`
    query campaigns($nonprofitOrgId: Int!, $createdAfter: Int) {
  campaigns(nonprofitOrgId: $nonprofitOrgId, createdAfter: $createdAfter) {
    id
    nonprofitOrgId
    name
    createdAt
    updatedAt
    archivedAt
    createdUserId
    updatedUserId
    publishedAt
    fundraisingTarget
    portalId
    hashedPortalId
    initiativeGoalId
    draftGoalName
    draftObjectiveName
    firstPublishedAt
    initiativeGoalId
    donations {
      id
      donorStripeAccountId
      createdAt
      amount
      netAmount
      refunded
      disputed
    }
  }
}
    `;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const GetCategoryByTitleDocument = gql`
    query GetCategoryByTitle($chartId: Int!, $title: String!) {
  categoryByTitle(chartId: $chartId, title: $title) {
    id
    chartId
    title
    archivedAt
  }
}
    `;

/**
 * __useGetCategoryByTitleQuery__
 *
 * To run a query within a React component, call `useGetCategoryByTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryByTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryByTitleQuery({
 *   variables: {
 *      chartId: // value for 'chartId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useGetCategoryByTitleQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryByTitleQuery, GetCategoryByTitleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryByTitleQuery, GetCategoryByTitleQueryVariables>(GetCategoryByTitleDocument, options);
      }
export function useGetCategoryByTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryByTitleQuery, GetCategoryByTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryByTitleQuery, GetCategoryByTitleQueryVariables>(GetCategoryByTitleDocument, options);
        }
export type GetCategoryByTitleQueryHookResult = ReturnType<typeof useGetCategoryByTitleQuery>;
export type GetCategoryByTitleLazyQueryHookResult = ReturnType<typeof useGetCategoryByTitleLazyQuery>;
export type GetCategoryByTitleQueryResult = Apollo.QueryResult<GetCategoryByTitleQuery, GetCategoryByTitleQueryVariables>;
export const CheckoutSessionDataDocument = gql`
    query checkoutSessionData($sessionId: String!, $portalId: String!) {
  checkoutSessionData(sessionId: $sessionId, portalId: $portalId) {
    email
    chargedAmount
    donationAmount
    feeAmount
    feeCovered
    date
    expiresAt
    redirectUrl
    orgLegalName
    ein
    orgAddress
    billingPortalUrl
    nextBillingDate
    statementDescriptor
  }
}
    `;

/**
 * __useCheckoutSessionDataQuery__
 *
 * To run a query within a React component, call `useCheckoutSessionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSessionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutSessionDataQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      portalId: // value for 'portalId'
 *   },
 * });
 */
export function useCheckoutSessionDataQuery(baseOptions: Apollo.QueryHookOptions<CheckoutSessionDataQuery, CheckoutSessionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutSessionDataQuery, CheckoutSessionDataQueryVariables>(CheckoutSessionDataDocument, options);
      }
export function useCheckoutSessionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutSessionDataQuery, CheckoutSessionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutSessionDataQuery, CheckoutSessionDataQueryVariables>(CheckoutSessionDataDocument, options);
        }
export type CheckoutSessionDataQueryHookResult = ReturnType<typeof useCheckoutSessionDataQuery>;
export type CheckoutSessionDataLazyQueryHookResult = ReturnType<typeof useCheckoutSessionDataLazyQuery>;
export type CheckoutSessionDataQueryResult = Apollo.QueryResult<CheckoutSessionDataQuery, CheckoutSessionDataQueryVariables>;
export const GetCloudinaryAssetsDocument = gql`
    query getCloudinaryAssets($orgId: Int!) {
  getCloudinaryAssets(orgId: $orgId) {
    cloudinary_public_file_id
  }
}
    `;

/**
 * __useGetCloudinaryAssetsQuery__
 *
 * To run a query within a React component, call `useGetCloudinaryAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCloudinaryAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCloudinaryAssetsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetCloudinaryAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetCloudinaryAssetsQuery, GetCloudinaryAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCloudinaryAssetsQuery, GetCloudinaryAssetsQueryVariables>(GetCloudinaryAssetsDocument, options);
      }
export function useGetCloudinaryAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCloudinaryAssetsQuery, GetCloudinaryAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCloudinaryAssetsQuery, GetCloudinaryAssetsQueryVariables>(GetCloudinaryAssetsDocument, options);
        }
export type GetCloudinaryAssetsQueryHookResult = ReturnType<typeof useGetCloudinaryAssetsQuery>;
export type GetCloudinaryAssetsLazyQueryHookResult = ReturnType<typeof useGetCloudinaryAssetsLazyQuery>;
export type GetCloudinaryAssetsQueryResult = Apollo.QueryResult<GetCloudinaryAssetsQuery, GetCloudinaryAssetsQueryVariables>;
export const CohortDocument = gql`
    query Cohort($id: Int!) {
  cohort(id: $id) {
    id
    name
    startDate
    endDate
    createdAt
    updatedAt
    memberRoles
    cohortOwnerships {
      id
      funderOrg {
        id
        name
        disabled
      }
    }
    cohortMemberships {
      id
      startDate
      endDate
      nonprofitOrg {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCohortQuery__
 *
 * To run a query within a React component, call `useCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCohortQuery(baseOptions: Apollo.QueryHookOptions<CohortQuery, CohortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CohortQuery, CohortQueryVariables>(CohortDocument, options);
      }
export function useCohortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CohortQuery, CohortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CohortQuery, CohortQueryVariables>(CohortDocument, options);
        }
export type CohortQueryHookResult = ReturnType<typeof useCohortQuery>;
export type CohortLazyQueryHookResult = ReturnType<typeof useCohortLazyQuery>;
export type CohortQueryResult = Apollo.QueryResult<CohortQuery, CohortQueryVariables>;
export const ColorThemeDocument = gql`
    query colorTheme {
  colorTheme {
    id
    color
  }
}
    `;

/**
 * __useColorThemeQuery__
 *
 * To run a query within a React component, call `useColorThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useColorThemeQuery(baseOptions?: Apollo.QueryHookOptions<ColorThemeQuery, ColorThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorThemeQuery, ColorThemeQueryVariables>(ColorThemeDocument, options);
      }
export function useColorThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorThemeQuery, ColorThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorThemeQuery, ColorThemeQueryVariables>(ColorThemeDocument, options);
        }
export type ColorThemeQueryHookResult = ReturnType<typeof useColorThemeQuery>;
export type ColorThemeLazyQueryHookResult = ReturnType<typeof useColorThemeLazyQuery>;
export type ColorThemeQueryResult = Apollo.QueryResult<ColorThemeQuery, ColorThemeQueryVariables>;
export const CommunityEventsDocument = gql`
    query communityEvents($limit: Int, $filter: CommunityEventsFilterOption) {
  communityEvents(limit: $limit, filter: $filter) {
    name
    url
    startsAt
    endsAt
  }
}
    `;

/**
 * __useCommunityEventsQuery__
 *
 * To run a query within a React component, call `useCommunityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityEventsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCommunityEventsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
      }
export function useCommunityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
        }
export type CommunityEventsQueryHookResult = ReturnType<typeof useCommunityEventsQuery>;
export type CommunityEventsLazyQueryHookResult = ReturnType<typeof useCommunityEventsLazyQuery>;
export type CommunityEventsQueryResult = Apollo.QueryResult<CommunityEventsQuery, CommunityEventsQueryVariables>;
export const ComplianceDocumentsDocument = gql`
    query complianceDocuments($nonprofitOrgId: Int!, $folderId: String) {
  complianceDocuments(nonprofitOrgId: $nonprofitOrgId, folderId: $folderId) {
    files {
      id
      etag
      created_at
      downloadUrl
      complianceDocType
    }
    folderId
  }
}
    `;

/**
 * __useComplianceDocumentsQuery__
 *
 * To run a query within a React component, call `useComplianceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceDocumentsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useComplianceDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ComplianceDocumentsQuery, ComplianceDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceDocumentsQuery, ComplianceDocumentsQueryVariables>(ComplianceDocumentsDocument, options);
      }
export function useComplianceDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceDocumentsQuery, ComplianceDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceDocumentsQuery, ComplianceDocumentsQueryVariables>(ComplianceDocumentsDocument, options);
        }
export type ComplianceDocumentsQueryHookResult = ReturnType<typeof useComplianceDocumentsQuery>;
export type ComplianceDocumentsLazyQueryHookResult = ReturnType<typeof useComplianceDocumentsLazyQuery>;
export type ComplianceDocumentsQueryResult = Apollo.QueryResult<ComplianceDocumentsQuery, ComplianceDocumentsQueryVariables>;
export const GetDimensionsDocument = gql`
    query getDimensions($nonprofitOrgId: Int!) {
  getDimensions(nonprofitOrgId: $nonprofitOrgId) {
    id
    title
    isHidden
  }
}
    `;

/**
 * __useGetDimensionsQuery__
 *
 * To run a query within a React component, call `useGetDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDimensionsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetDimensionsQuery(baseOptions: Apollo.QueryHookOptions<GetDimensionsQuery, GetDimensionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDimensionsQuery, GetDimensionsQueryVariables>(GetDimensionsDocument, options);
      }
export function useGetDimensionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDimensionsQuery, GetDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDimensionsQuery, GetDimensionsQueryVariables>(GetDimensionsDocument, options);
        }
export type GetDimensionsQueryHookResult = ReturnType<typeof useGetDimensionsQuery>;
export type GetDimensionsLazyQueryHookResult = ReturnType<typeof useGetDimensionsLazyQuery>;
export type GetDimensionsQueryResult = Apollo.QueryResult<GetDimensionsQuery, GetDimensionsQueryVariables>;
export const GetFeatureFlagsDocument = gql`
    query getFeatureFlags {
  getFeatureFlags {
    featureFlags
  }
}
    `;

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const FeatureGatingLimitDocument = gql`
    query featureGatingLimit($planName: String!) {
  featureGatingLimit(planName: $planName) {
    featureName
    visible
    lowestPlanTier
    limit
  }
}
    `;

/**
 * __useFeatureGatingLimitQuery__
 *
 * To run a query within a React component, call `useFeatureGatingLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureGatingLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureGatingLimitQuery({
 *   variables: {
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useFeatureGatingLimitQuery(baseOptions: Apollo.QueryHookOptions<FeatureGatingLimitQuery, FeatureGatingLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureGatingLimitQuery, FeatureGatingLimitQueryVariables>(FeatureGatingLimitDocument, options);
      }
export function useFeatureGatingLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureGatingLimitQuery, FeatureGatingLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureGatingLimitQuery, FeatureGatingLimitQueryVariables>(FeatureGatingLimitDocument, options);
        }
export type FeatureGatingLimitQueryHookResult = ReturnType<typeof useFeatureGatingLimitQuery>;
export type FeatureGatingLimitLazyQueryHookResult = ReturnType<typeof useFeatureGatingLimitLazyQuery>;
export type FeatureGatingLimitQueryResult = Apollo.QueryResult<FeatureGatingLimitQuery, FeatureGatingLimitQueryVariables>;
export const FunderOrgDocument = gql`
    query FunderOrg($id: Int!) {
  funderOrg(id: $id) {
    id
    name
    disabled
    isTest
    createdAt
    updatedAt
    disabledAt
    nonprofitOrgs {
      id
      name
    }
    cohorts {
      id
      name
    }
    users {
      id
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useFunderOrgQuery__
 *
 * To run a query within a React component, call `useFunderOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunderOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunderOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFunderOrgQuery(baseOptions: Apollo.QueryHookOptions<FunderOrgQuery, FunderOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunderOrgQuery, FunderOrgQueryVariables>(FunderOrgDocument, options);
      }
export function useFunderOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunderOrgQuery, FunderOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunderOrgQuery, FunderOrgQueryVariables>(FunderOrgDocument, options);
        }
export type FunderOrgQueryHookResult = ReturnType<typeof useFunderOrgQuery>;
export type FunderOrgLazyQueryHookResult = ReturnType<typeof useFunderOrgLazyQuery>;
export type FunderOrgQueryResult = Apollo.QueryResult<FunderOrgQuery, FunderOrgQueryVariables>;
export const FunderOrgCohortQueryDocument = gql`
    query funderOrgCohortQuery($funderEmail: String, $funderOrgId: Int, $nonprofitOrgIds: [Int!]!, $returnAllNonprofitsInCohort: Boolean) {
  funderOrgCohortQuery(
    funderEmail: $funderEmail
    funderOrgId: $funderOrgId
    nonprofitOrgIds: $nonprofitOrgIds
    returnAllNonprofitsInCohort: $returnAllNonprofitsInCohort
  ) {
    funderOrgId
    nonprofitOrgs {
      id
      name
    }
  }
}
    `;

/**
 * __useFunderOrgCohortQueryQuery__
 *
 * To run a query within a React component, call `useFunderOrgCohortQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunderOrgCohortQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunderOrgCohortQueryQuery({
 *   variables: {
 *      funderEmail: // value for 'funderEmail'
 *      funderOrgId: // value for 'funderOrgId'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *      returnAllNonprofitsInCohort: // value for 'returnAllNonprofitsInCohort'
 *   },
 * });
 */
export function useFunderOrgCohortQueryQuery(baseOptions: Apollo.QueryHookOptions<FunderOrgCohortQueryQuery, FunderOrgCohortQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunderOrgCohortQueryQuery, FunderOrgCohortQueryQueryVariables>(FunderOrgCohortQueryDocument, options);
      }
export function useFunderOrgCohortQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunderOrgCohortQueryQuery, FunderOrgCohortQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunderOrgCohortQueryQuery, FunderOrgCohortQueryQueryVariables>(FunderOrgCohortQueryDocument, options);
        }
export type FunderOrgCohortQueryQueryHookResult = ReturnType<typeof useFunderOrgCohortQueryQuery>;
export type FunderOrgCohortQueryLazyQueryHookResult = ReturnType<typeof useFunderOrgCohortQueryLazyQuery>;
export type FunderOrgCohortQueryQueryResult = Apollo.QueryResult<FunderOrgCohortQueryQuery, FunderOrgCohortQueryQueryVariables>;
export const GetFunderOrgConfigDocument = gql`
    query getFunderOrgConfig($email: String!) {
  funderOrgConfig(email: $email) {
    sponsoredNonprofits {
      nonprofitOrgId
      name
    }
    orgName
    orgId
    shellAppRedirectEnabled
    user {
      ... on FunderUserConfig {
        id
        firstName
        lastName
        email
        phone
        role
        funderOrgRole
      }
    }
  }
}
    `;

/**
 * __useGetFunderOrgConfigQuery__
 *
 * To run a query within a React component, call `useGetFunderOrgConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderOrgConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderOrgConfigQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetFunderOrgConfigQuery(baseOptions: Apollo.QueryHookOptions<GetFunderOrgConfigQuery, GetFunderOrgConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderOrgConfigQuery, GetFunderOrgConfigQueryVariables>(GetFunderOrgConfigDocument, options);
      }
export function useGetFunderOrgConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderOrgConfigQuery, GetFunderOrgConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderOrgConfigQuery, GetFunderOrgConfigQueryVariables>(GetFunderOrgConfigDocument, options);
        }
export type GetFunderOrgConfigQueryHookResult = ReturnType<typeof useGetFunderOrgConfigQuery>;
export type GetFunderOrgConfigLazyQueryHookResult = ReturnType<typeof useGetFunderOrgConfigLazyQuery>;
export type GetFunderOrgConfigQueryResult = Apollo.QueryResult<GetFunderOrgConfigQuery, GetFunderOrgConfigQueryVariables>;
export const GetFunderOrgDetailsDocument = gql`
    query getFunderOrgDetails($funderOrgId: Int!) {
  funderOrgDetails(funderOrgId: $funderOrgId) {
    orgName
  }
}
    `;

/**
 * __useGetFunderOrgDetailsQuery__
 *
 * To run a query within a React component, call `useGetFunderOrgDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderOrgDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderOrgDetailsQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useGetFunderOrgDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFunderOrgDetailsQuery, GetFunderOrgDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderOrgDetailsQuery, GetFunderOrgDetailsQueryVariables>(GetFunderOrgDetailsDocument, options);
      }
export function useGetFunderOrgDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderOrgDetailsQuery, GetFunderOrgDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderOrgDetailsQuery, GetFunderOrgDetailsQueryVariables>(GetFunderOrgDetailsDocument, options);
        }
export type GetFunderOrgDetailsQueryHookResult = ReturnType<typeof useGetFunderOrgDetailsQuery>;
export type GetFunderOrgDetailsLazyQueryHookResult = ReturnType<typeof useGetFunderOrgDetailsLazyQuery>;
export type GetFunderOrgDetailsQueryResult = Apollo.QueryResult<GetFunderOrgDetailsQuery, GetFunderOrgDetailsQueryVariables>;
export const GetFunderOrgToNonprofitDocument = gql`
    query getFunderOrgToNonprofit($nonprofitOrgId: Int!) {
  funderOrgToNonprofit(nonprofitOrgId: $nonprofitOrgId) {
    id
    name
    createdAt
    updatedAt
    disabledAt
  }
}
    `;

/**
 * __useGetFunderOrgToNonprofitQuery__
 *
 * To run a query within a React component, call `useGetFunderOrgToNonprofitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderOrgToNonprofitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderOrgToNonprofitQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetFunderOrgToNonprofitQuery(baseOptions: Apollo.QueryHookOptions<GetFunderOrgToNonprofitQuery, GetFunderOrgToNonprofitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderOrgToNonprofitQuery, GetFunderOrgToNonprofitQueryVariables>(GetFunderOrgToNonprofitDocument, options);
      }
export function useGetFunderOrgToNonprofitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderOrgToNonprofitQuery, GetFunderOrgToNonprofitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderOrgToNonprofitQuery, GetFunderOrgToNonprofitQueryVariables>(GetFunderOrgToNonprofitDocument, options);
        }
export type GetFunderOrgToNonprofitQueryHookResult = ReturnType<typeof useGetFunderOrgToNonprofitQuery>;
export type GetFunderOrgToNonprofitLazyQueryHookResult = ReturnType<typeof useGetFunderOrgToNonprofitLazyQuery>;
export type GetFunderOrgToNonprofitQueryResult = Apollo.QueryResult<GetFunderOrgToNonprofitQuery, GetFunderOrgToNonprofitQueryVariables>;
export const GetFunderOrgToNonprofitOrgDocument = gql`
    query getFunderOrgToNonprofitOrg($nonprofitOrgId: Int!) {
  funderOrgToNonprofitOrg(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    funderOrgId
  }
}
    `;

/**
 * __useGetFunderOrgToNonprofitOrgQuery__
 *
 * To run a query within a React component, call `useGetFunderOrgToNonprofitOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderOrgToNonprofitOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderOrgToNonprofitOrgQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetFunderOrgToNonprofitOrgQuery(baseOptions: Apollo.QueryHookOptions<GetFunderOrgToNonprofitOrgQuery, GetFunderOrgToNonprofitOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderOrgToNonprofitOrgQuery, GetFunderOrgToNonprofitOrgQueryVariables>(GetFunderOrgToNonprofitOrgDocument, options);
      }
export function useGetFunderOrgToNonprofitOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderOrgToNonprofitOrgQuery, GetFunderOrgToNonprofitOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderOrgToNonprofitOrgQuery, GetFunderOrgToNonprofitOrgQueryVariables>(GetFunderOrgToNonprofitOrgDocument, options);
        }
export type GetFunderOrgToNonprofitOrgQueryHookResult = ReturnType<typeof useGetFunderOrgToNonprofitOrgQuery>;
export type GetFunderOrgToNonprofitOrgLazyQueryHookResult = ReturnType<typeof useGetFunderOrgToNonprofitOrgLazyQuery>;
export type GetFunderOrgToNonprofitOrgQueryResult = Apollo.QueryResult<GetFunderOrgToNonprofitOrgQuery, GetFunderOrgToNonprofitOrgQueryVariables>;
export const GetNonprofitPreonboardingDocument = gql`
    query getNonprofitPreonboarding($funderOrgId: Int, $id: Int) {
  getNonprofitPreonboarding(funderOrgId: $funderOrgId, id: $id) {
    createdAt
    funderOrgId
    id
    orgName
    status
    impactIntelligenceStatus
    updatedAt
  }
}
    `;

/**
 * __useGetNonprofitPreonboardingQuery__
 *
 * To run a query within a React component, call `useGetNonprofitPreonboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitPreonboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitPreonboardingQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNonprofitPreonboardingQuery(baseOptions?: Apollo.QueryHookOptions<GetNonprofitPreonboardingQuery, GetNonprofitPreonboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitPreonboardingQuery, GetNonprofitPreonboardingQueryVariables>(GetNonprofitPreonboardingDocument, options);
      }
export function useGetNonprofitPreonboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitPreonboardingQuery, GetNonprofitPreonboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitPreonboardingQuery, GetNonprofitPreonboardingQueryVariables>(GetNonprofitPreonboardingDocument, options);
        }
export type GetNonprofitPreonboardingQueryHookResult = ReturnType<typeof useGetNonprofitPreonboardingQuery>;
export type GetNonprofitPreonboardingLazyQueryHookResult = ReturnType<typeof useGetNonprofitPreonboardingLazyQuery>;
export type GetNonprofitPreonboardingQueryResult = Apollo.QueryResult<GetNonprofitPreonboardingQuery, GetNonprofitPreonboardingQueryVariables>;
export const FundingOrg990Document = gql`
    query fundingOrg990($fundingOrg990Id: Int!) {
  fundingOrg990(fundingOrg990Id: $fundingOrg990Id) {
    id
    ein
    organizationName
    address
    city
    state
    website
    assets
    incomeAmount
    nteeCode
    nteeDescription
    locationsOfImpact
    grantCount
    grantMax
    grantMin
    grantAverage
    grantTotalAmount
    grants
    grantsToPreselectedOnly
    people
    taxYear
    createdDate
    active
  }
}
    `;

/**
 * __useFundingOrg990Query__
 *
 * To run a query within a React component, call `useFundingOrg990Query` and pass it any options that fit your needs.
 * When your component renders, `useFundingOrg990Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingOrg990Query({
 *   variables: {
 *      fundingOrg990Id: // value for 'fundingOrg990Id'
 *   },
 * });
 */
export function useFundingOrg990Query(baseOptions: Apollo.QueryHookOptions<FundingOrg990Query, FundingOrg990QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundingOrg990Query, FundingOrg990QueryVariables>(FundingOrg990Document, options);
      }
export function useFundingOrg990LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundingOrg990Query, FundingOrg990QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundingOrg990Query, FundingOrg990QueryVariables>(FundingOrg990Document, options);
        }
export type FundingOrg990QueryHookResult = ReturnType<typeof useFundingOrg990Query>;
export type FundingOrg990LazyQueryHookResult = ReturnType<typeof useFundingOrg990LazyQuery>;
export type FundingOrg990QueryResult = Apollo.QueryResult<FundingOrg990Query, FundingOrg990QueryVariables>;
export const FunderProfileViewLimitsDocument = gql`
    query funderProfileViewLimits($nonprofitOrgId: Int!) {
  funderProfileViewLimits(nonprofitOrgId: $nonprofitOrgId) {
    visible
    limitExpiryDate
    limit
    used
    available
    viewedFunderEins
  }
}
    `;

/**
 * __useFunderProfileViewLimitsQuery__
 *
 * To run a query within a React component, call `useFunderProfileViewLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunderProfileViewLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunderProfileViewLimitsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useFunderProfileViewLimitsQuery(baseOptions: Apollo.QueryHookOptions<FunderProfileViewLimitsQuery, FunderProfileViewLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FunderProfileViewLimitsQuery, FunderProfileViewLimitsQueryVariables>(FunderProfileViewLimitsDocument, options);
      }
export function useFunderProfileViewLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FunderProfileViewLimitsQuery, FunderProfileViewLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FunderProfileViewLimitsQuery, FunderProfileViewLimitsQueryVariables>(FunderProfileViewLimitsDocument, options);
        }
export type FunderProfileViewLimitsQueryHookResult = ReturnType<typeof useFunderProfileViewLimitsQuery>;
export type FunderProfileViewLimitsLazyQueryHookResult = ReturnType<typeof useFunderProfileViewLimitsLazyQuery>;
export type FunderProfileViewLimitsQueryResult = Apollo.QueryResult<FunderProfileViewLimitsQuery, FunderProfileViewLimitsQueryVariables>;
export const GetFunderUsersDocument = gql`
    query getFunderUsers($funderOrgId: Int!) {
  getFunderUsers(funderOrgId: $funderOrgId) {
    user {
      id
      email
      firstName
      lastName
    }
    role
    funderOrgRole
    lastInviteSentAt
    funderOrgId
  }
}
    `;

/**
 * __useGetFunderUsersQuery__
 *
 * To run a query within a React component, call `useGetFunderUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunderUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunderUsersQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useGetFunderUsersQuery(baseOptions: Apollo.QueryHookOptions<GetFunderUsersQuery, GetFunderUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunderUsersQuery, GetFunderUsersQueryVariables>(GetFunderUsersDocument, options);
      }
export function useGetFunderUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunderUsersQuery, GetFunderUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunderUsersQuery, GetFunderUsersQueryVariables>(GetFunderUsersDocument, options);
        }
export type GetFunderUsersQueryHookResult = ReturnType<typeof useGetFunderUsersQuery>;
export type GetFunderUsersLazyQueryHookResult = ReturnType<typeof useGetFunderUsersLazyQuery>;
export type GetFunderUsersQueryResult = Apollo.QueryResult<GetFunderUsersQuery, GetFunderUsersQueryVariables>;
export const GetGroupCoachingEventsDocument = gql`
    query GetGroupCoachingEvents($startDate: DateTime, $endDate: DateTime, $limit: Int) {
  groupCoachingEvents(startDate: $startDate, endDate: $endDate, limit: $limit) {
    id
    name
    userId
    createdAt
    updatedAt
    startsAt
    endsAt
    duration
    bookingUrl
    slug
    hideAttendees
    body
    googleCalendarId
    googleCalendarLink
    focusArea
    coachName
    recordingLink
    meetingBody
    meetingTitle
    activityType
    videoConferenceUrl
    transcript
    summary
    status
    userRsvpStatus
    userRsvpNotes
    circleEventId
    circleEventUrl
    user {
      id
    }
    attendees {
      id
    }
  }
}
    `;

/**
 * __useGetGroupCoachingEventsQuery__
 *
 * To run a query within a React component, call `useGetGroupCoachingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCoachingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCoachingEventsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGroupCoachingEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupCoachingEventsQuery, GetGroupCoachingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupCoachingEventsQuery, GetGroupCoachingEventsQueryVariables>(GetGroupCoachingEventsDocument, options);
      }
export function useGetGroupCoachingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupCoachingEventsQuery, GetGroupCoachingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupCoachingEventsQuery, GetGroupCoachingEventsQueryVariables>(GetGroupCoachingEventsDocument, options);
        }
export type GetGroupCoachingEventsQueryHookResult = ReturnType<typeof useGetGroupCoachingEventsQuery>;
export type GetGroupCoachingEventsLazyQueryHookResult = ReturnType<typeof useGetGroupCoachingEventsLazyQuery>;
export type GetGroupCoachingEventsQueryResult = Apollo.QueryResult<GetGroupCoachingEventsQuery, GetGroupCoachingEventsQueryVariables>;
export const GetOneOnOneCoachingEventsDocument = gql`
    query GetOneOnOneCoachingEvents($startDate: DateTime, $endDate: DateTime, $limit: Int) {
  oneOnOneCoachingEvents(startDate: $startDate, endDate: $endDate, limit: $limit) {
    id
    startsAt
    endsAt
    contactEmail
    contactName
    userSlug
    meetingBody
    activityType
    meetingTitle
    organizerName
    duration
    videoConferenceUrl
    transcript
    summary
    status
    goals {
      id
      title
    }
  }
}
    `;

/**
 * __useGetOneOnOneCoachingEventsQuery__
 *
 * To run a query within a React component, call `useGetOneOnOneCoachingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneOnOneCoachingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneOnOneCoachingEventsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetOneOnOneCoachingEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetOneOnOneCoachingEventsQuery, GetOneOnOneCoachingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneOnOneCoachingEventsQuery, GetOneOnOneCoachingEventsQueryVariables>(GetOneOnOneCoachingEventsDocument, options);
      }
export function useGetOneOnOneCoachingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneOnOneCoachingEventsQuery, GetOneOnOneCoachingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneOnOneCoachingEventsQuery, GetOneOnOneCoachingEventsQueryVariables>(GetOneOnOneCoachingEventsDocument, options);
        }
export type GetOneOnOneCoachingEventsQueryHookResult = ReturnType<typeof useGetOneOnOneCoachingEventsQuery>;
export type GetOneOnOneCoachingEventsLazyQueryHookResult = ReturnType<typeof useGetOneOnOneCoachingEventsLazyQuery>;
export type GetOneOnOneCoachingEventsQueryResult = Apollo.QueryResult<GetOneOnOneCoachingEventsQuery, GetOneOnOneCoachingEventsQueryVariables>;
export const GetInitiativesDocument = gql`
    query getInitiatives($nonprofitOrgId: Int!, $planName: String!) {
  getInitiatives(nonprofitOrgId: $nonprofitOrgId, planName: $planName) {
    reportedMetricGroups {
      id
      title
      createdAt
      archivedAt
      Goal {
        GoalToDimension {
          id
          displayOrder
          dimension {
            title
            lastUpdatedUser {
              firstName
              lastName
            }
            updatedAt
          }
        }
        lastUpdatedUser {
          firstName
          lastName
        }
        owner {
          id
          firstName
          lastName
        }
        updatedAt
        id
        type
        title
        category
        metric
        unitOfMeasurement
        target
        templateLibraryId
        createdAt
        archivedAt
        GoalUpdate {
          id
          description
          updatedAt
          lastUpdatedUser {
            firstName
            lastName
          }
          reportedAt
          goalId
        }
        EntryGroup {
          id
          details
          reportedAt
          archivedAt
          lastUpdatedUser {
            firstName
            lastName
          }
          updatedAt
          Entry {
            id
            value
            goalToDimension {
              dimension {
                id
                title
                lastUpdatedUser {
                  firstName
                  lastName
                }
                updatedAt
              }
            }
            lastUpdatedUser {
              firstName
              lastName
            }
            updatedAt
          }
        }
        ChecklistItem {
          id
          title
          isCompleted
          lastUpdatedUser {
            id
            firstName
            lastName
          }
          owner {
            id
            firstName
            lastName
          }
          updatedAt
          resourceId
          linkText
          linkUrl
          dueDate
        }
      }
    }
    reportedMetricGatingLimit {
      selfReportingInitiatives {
        available
        limit
        used
        visible
      }
      selfReportingGoals {
        available
        limit
        used
        visible
      }
    }
  }
}
    `;

/**
 * __useGetInitiativesQuery__
 *
 * To run a query within a React component, call `useGetInitiativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitiativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitiativesQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useGetInitiativesQuery(baseOptions: Apollo.QueryHookOptions<GetInitiativesQuery, GetInitiativesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitiativesQuery, GetInitiativesQueryVariables>(GetInitiativesDocument, options);
      }
export function useGetInitiativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitiativesQuery, GetInitiativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitiativesQuery, GetInitiativesQueryVariables>(GetInitiativesDocument, options);
        }
export type GetInitiativesQueryHookResult = ReturnType<typeof useGetInitiativesQuery>;
export type GetInitiativesLazyQueryHookResult = ReturnType<typeof useGetInitiativesLazyQuery>;
export type GetInitiativesQueryResult = Apollo.QueryResult<GetInitiativesQuery, GetInitiativesQueryVariables>;
export const GetInternalFunderReportDocument = gql`
    query getInternalFunderReport($funderOrgId: Int!) {
  getInternalFunderReport(funderOrgId: $funderOrgId) {
    aggregateData
    summaryData
    reportData
  }
}
    `;

/**
 * __useGetInternalFunderReportQuery__
 *
 * To run a query within a React component, call `useGetInternalFunderReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalFunderReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalFunderReportQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useGetInternalFunderReportQuery(baseOptions: Apollo.QueryHookOptions<GetInternalFunderReportQuery, GetInternalFunderReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalFunderReportQuery, GetInternalFunderReportQueryVariables>(GetInternalFunderReportDocument, options);
      }
export function useGetInternalFunderReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalFunderReportQuery, GetInternalFunderReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalFunderReportQuery, GetInternalFunderReportQueryVariables>(GetInternalFunderReportDocument, options);
        }
export type GetInternalFunderReportQueryHookResult = ReturnType<typeof useGetInternalFunderReportQuery>;
export type GetInternalFunderReportLazyQueryHookResult = ReturnType<typeof useGetInternalFunderReportLazyQuery>;
export type GetInternalFunderReportQueryResult = Apollo.QueryResult<GetInternalFunderReportQuery, GetInternalFunderReportQueryVariables>;
export const GetJobExecutionDocument = gql`
    query GetJobExecution($id: String!) {
  jobExecution(id: $id) {
    id
    jobName
    status
    payload
    result
    errorMessage
    errorStack
    createdAt
    startedAt
    completedAt
    duration
    createdByUserId
    organizationId
    createdByUser {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetJobExecutionQuery__
 *
 * To run a query within a React component, call `useGetJobExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobExecutionQuery(baseOptions: Apollo.QueryHookOptions<GetJobExecutionQuery, GetJobExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobExecutionQuery, GetJobExecutionQueryVariables>(GetJobExecutionDocument, options);
      }
export function useGetJobExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobExecutionQuery, GetJobExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobExecutionQuery, GetJobExecutionQueryVariables>(GetJobExecutionDocument, options);
        }
export type GetJobExecutionQueryHookResult = ReturnType<typeof useGetJobExecutionQuery>;
export type GetJobExecutionLazyQueryHookResult = ReturnType<typeof useGetJobExecutionLazyQuery>;
export type GetJobExecutionQueryResult = Apollo.QueryResult<GetJobExecutionQuery, GetJobExecutionQueryVariables>;
export const GetJobStatsDocument = gql`
    query GetJobStats($hoursBack: Int) {
  jobStats(hoursBack: $hoursBack) {
    jobStats {
      jobName
      total
      pending
      running
      completed
      failed
      successRate
    }
  }
}
    `;

/**
 * __useGetJobStatsQuery__
 *
 * To run a query within a React component, call `useGetJobStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobStatsQuery({
 *   variables: {
 *      hoursBack: // value for 'hoursBack'
 *   },
 * });
 */
export function useGetJobStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobStatsQuery, GetJobStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobStatsQuery, GetJobStatsQueryVariables>(GetJobStatsDocument, options);
      }
export function useGetJobStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobStatsQuery, GetJobStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobStatsQuery, GetJobStatsQueryVariables>(GetJobStatsDocument, options);
        }
export type GetJobStatsQueryHookResult = ReturnType<typeof useGetJobStatsQuery>;
export type GetJobStatsLazyQueryHookResult = ReturnType<typeof useGetJobStatsLazyQuery>;
export type GetJobStatsQueryResult = Apollo.QueryResult<GetJobStatsQuery, GetJobStatsQueryVariables>;
export const GetLatestFinancialHealthAssessmentReportDocument = gql`
    query GetLatestFinancialHealthAssessmentReport($nonprofitOrgId: Int!) {
  getLatestFinancialHealthAssessmentReport(nonprofitOrgId: $nonprofitOrgId) {
    runId
    status
    reportSlug
    progressUrl
    userId
    reportData
  }
}
    `;

/**
 * __useGetLatestFinancialHealthAssessmentReportQuery__
 *
 * To run a query within a React component, call `useGetLatestFinancialHealthAssessmentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestFinancialHealthAssessmentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestFinancialHealthAssessmentReportQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetLatestFinancialHealthAssessmentReportQuery(baseOptions: Apollo.QueryHookOptions<GetLatestFinancialHealthAssessmentReportQuery, GetLatestFinancialHealthAssessmentReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestFinancialHealthAssessmentReportQuery, GetLatestFinancialHealthAssessmentReportQueryVariables>(GetLatestFinancialHealthAssessmentReportDocument, options);
      }
export function useGetLatestFinancialHealthAssessmentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestFinancialHealthAssessmentReportQuery, GetLatestFinancialHealthAssessmentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestFinancialHealthAssessmentReportQuery, GetLatestFinancialHealthAssessmentReportQueryVariables>(GetLatestFinancialHealthAssessmentReportDocument, options);
        }
export type GetLatestFinancialHealthAssessmentReportQueryHookResult = ReturnType<typeof useGetLatestFinancialHealthAssessmentReportQuery>;
export type GetLatestFinancialHealthAssessmentReportLazyQueryHookResult = ReturnType<typeof useGetLatestFinancialHealthAssessmentReportLazyQuery>;
export type GetLatestFinancialHealthAssessmentReportQueryResult = Apollo.QueryResult<GetLatestFinancialHealthAssessmentReportQuery, GetLatestFinancialHealthAssessmentReportQueryVariables>;
export const GetMurdocReportDocument = gql`
    query GetMurdocReport($runId: String!) {
  getMurdocReport(runId: $runId) {
    runId
    markdown
    visualizations
    citations
    metadata
    downloadUrl
    downloadFormat
    downloadExpiresAt
    status
  }
}
    `;

/**
 * __useGetMurdocReportQuery__
 *
 * To run a query within a React component, call `useGetMurdocReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMurdocReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMurdocReportQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetMurdocReportQuery(baseOptions: Apollo.QueryHookOptions<GetMurdocReportQuery, GetMurdocReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMurdocReportQuery, GetMurdocReportQueryVariables>(GetMurdocReportDocument, options);
      }
export function useGetMurdocReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMurdocReportQuery, GetMurdocReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMurdocReportQuery, GetMurdocReportQueryVariables>(GetMurdocReportDocument, options);
        }
export type GetMurdocReportQueryHookResult = ReturnType<typeof useGetMurdocReportQuery>;
export type GetMurdocReportLazyQueryHookResult = ReturnType<typeof useGetMurdocReportLazyQuery>;
export type GetMurdocReportQueryResult = Apollo.QueryResult<GetMurdocReportQuery, GetMurdocReportQueryVariables>;
export const GetMurdocReportRunStatusDocument = gql`
    query GetMurdocReportRunStatus($runId: String!) {
  getMurdocReportRunStatus(runId: $runId) {
    runId
    status
    reportSlug
    userId
  }
}
    `;

/**
 * __useGetMurdocReportRunStatusQuery__
 *
 * To run a query within a React component, call `useGetMurdocReportRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMurdocReportRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMurdocReportRunStatusQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetMurdocReportRunStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMurdocReportRunStatusQuery, GetMurdocReportRunStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMurdocReportRunStatusQuery, GetMurdocReportRunStatusQueryVariables>(GetMurdocReportRunStatusDocument, options);
      }
export function useGetMurdocReportRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMurdocReportRunStatusQuery, GetMurdocReportRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMurdocReportRunStatusQuery, GetMurdocReportRunStatusQueryVariables>(GetMurdocReportRunStatusDocument, options);
        }
export type GetMurdocReportRunStatusQueryHookResult = ReturnType<typeof useGetMurdocReportRunStatusQuery>;
export type GetMurdocReportRunStatusLazyQueryHookResult = ReturnType<typeof useGetMurdocReportRunStatusLazyQuery>;
export type GetMurdocReportRunStatusQueryResult = Apollo.QueryResult<GetMurdocReportRunStatusQuery, GetMurdocReportRunStatusQueryVariables>;
export const GetMurdocStoryOpportunitiesDocument = gql`
    query getMurdocStoryOpportunities($nonprofitOrgId: Int!, $limit: Int, $socialUrls: [String!]) {
  getMurdocStoryOpportunities(
    nonprofitOrgId: $nonprofitOrgId
    limit: $limit
    socialUrls: $socialUrls
  ) {
    opportunities {
      title
      category
      relevanceScore
      sourcePlatform
      sourceUrl
      contentExcerpt
      suggestedAngle
    }
    generatedAt
    summary
    warnings
    orgContext {
      name
      mission
      state
      focusAreas
    }
  }
}
    `;

/**
 * __useGetMurdocStoryOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetMurdocStoryOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMurdocStoryOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMurdocStoryOpportunitiesQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      limit: // value for 'limit'
 *      socialUrls: // value for 'socialUrls'
 *   },
 * });
 */
export function useGetMurdocStoryOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMurdocStoryOpportunitiesQuery, GetMurdocStoryOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMurdocStoryOpportunitiesQuery, GetMurdocStoryOpportunitiesQueryVariables>(GetMurdocStoryOpportunitiesDocument, options);
      }
export function useGetMurdocStoryOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMurdocStoryOpportunitiesQuery, GetMurdocStoryOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMurdocStoryOpportunitiesQuery, GetMurdocStoryOpportunitiesQueryVariables>(GetMurdocStoryOpportunitiesDocument, options);
        }
export type GetMurdocStoryOpportunitiesQueryHookResult = ReturnType<typeof useGetMurdocStoryOpportunitiesQuery>;
export type GetMurdocStoryOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetMurdocStoryOpportunitiesLazyQuery>;
export type GetMurdocStoryOpportunitiesQueryResult = Apollo.QueryResult<GetMurdocStoryOpportunitiesQuery, GetMurdocStoryOpportunitiesQueryVariables>;
export const GetMyMcpApiKeysDocument = gql`
    query getMyMcpApiKeys {
  getMyMcpApiKeys {
    id
    name
    key
    createdAt
    expiresAt
    revokedAt
    lastUsedAt
  }
}
    `;

/**
 * __useGetMyMcpApiKeysQuery__
 *
 * To run a query within a React component, call `useGetMyMcpApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMcpApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMcpApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMcpApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMcpApiKeysQuery, GetMyMcpApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMcpApiKeysQuery, GetMyMcpApiKeysQueryVariables>(GetMyMcpApiKeysDocument, options);
      }
export function useGetMyMcpApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMcpApiKeysQuery, GetMyMcpApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMcpApiKeysQuery, GetMyMcpApiKeysQueryVariables>(GetMyMcpApiKeysDocument, options);
        }
export type GetMyMcpApiKeysQueryHookResult = ReturnType<typeof useGetMyMcpApiKeysQuery>;
export type GetMyMcpApiKeysLazyQueryHookResult = ReturnType<typeof useGetMyMcpApiKeysLazyQuery>;
export type GetMyMcpApiKeysQueryResult = Apollo.QueryResult<GetMyMcpApiKeysQuery, GetMyMcpApiKeysQueryVariables>;
export const GetNonprofitByIdDocument = gql`
    query GetNonprofitById($id: Int!) {
  getNonprofitOrg(id: $id) {
    id
    name
    missionStatement
    disabled
    formationPlan
    platformPlan
    ein
    legalName
    websiteUrl
    isFiscallySponsored
    isTest
    state
    yearEstablished
    createdAt
    updatedAt
    disabledAt
    hasProfile
    funders {
      id
      name
    }
    cohorts {
      id
      name
    }
    users {
      id
      email
      firstName
      lastName
      role
    }
  }
}
    `;

/**
 * __useGetNonprofitByIdQuery__
 *
 * To run a query within a React component, call `useGetNonprofitByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNonprofitByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitByIdQuery, GetNonprofitByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitByIdQuery, GetNonprofitByIdQueryVariables>(GetNonprofitByIdDocument, options);
      }
export function useGetNonprofitByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitByIdQuery, GetNonprofitByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitByIdQuery, GetNonprofitByIdQueryVariables>(GetNonprofitByIdDocument, options);
        }
export type GetNonprofitByIdQueryHookResult = ReturnType<typeof useGetNonprofitByIdQuery>;
export type GetNonprofitByIdLazyQueryHookResult = ReturnType<typeof useGetNonprofitByIdLazyQuery>;
export type GetNonprofitByIdQueryResult = Apollo.QueryResult<GetNonprofitByIdQuery, GetNonprofitByIdQueryVariables>;
export const NonprofitDeiInitiativesDocument = gql`
    query nonprofitDeiInitiatives($nonprofitOrgId: Int!) {
  nonprofitDeiInitiatives(nonprofitOrgId: $nonprofitOrgId) {
    id
    description
    category
  }
}
    `;

/**
 * __useNonprofitDeiInitiativesQuery__
 *
 * To run a query within a React component, call `useNonprofitDeiInitiativesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitDeiInitiativesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitDeiInitiativesQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitDeiInitiativesQuery(baseOptions: Apollo.QueryHookOptions<NonprofitDeiInitiativesQuery, NonprofitDeiInitiativesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitDeiInitiativesQuery, NonprofitDeiInitiativesQueryVariables>(NonprofitDeiInitiativesDocument, options);
      }
export function useNonprofitDeiInitiativesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitDeiInitiativesQuery, NonprofitDeiInitiativesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitDeiInitiativesQuery, NonprofitDeiInitiativesQueryVariables>(NonprofitDeiInitiativesDocument, options);
        }
export type NonprofitDeiInitiativesQueryHookResult = ReturnType<typeof useNonprofitDeiInitiativesQuery>;
export type NonprofitDeiInitiativesLazyQueryHookResult = ReturnType<typeof useNonprofitDeiInitiativesLazyQuery>;
export type NonprofitDeiInitiativesQueryResult = Apollo.QueryResult<NonprofitDeiInitiativesQuery, NonprofitDeiInitiativesQueryVariables>;
export const GetNonprofitOrgBillingDetailsDocument = gql`
    query getNonprofitOrgBillingDetails($customerId: String!, $platformPlan: PlatformPlan, $formationPlan: FormationPlan) {
  getNonprofitOrgBillingDetails(
    customerId: $customerId
    formationPlan: $formationPlan
    platformPlan: $platformPlan
  ) {
    platformCost
    formationCost
    trialEnd
    nextBillingDate
    isTrialing
    isLegacyPricing
  }
}
    `;

/**
 * __useGetNonprofitOrgBillingDetailsQuery__
 *
 * To run a query within a React component, call `useGetNonprofitOrgBillingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitOrgBillingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitOrgBillingDetailsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      platformPlan: // value for 'platformPlan'
 *      formationPlan: // value for 'formationPlan'
 *   },
 * });
 */
export function useGetNonprofitOrgBillingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitOrgBillingDetailsQuery, GetNonprofitOrgBillingDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitOrgBillingDetailsQuery, GetNonprofitOrgBillingDetailsQueryVariables>(GetNonprofitOrgBillingDetailsDocument, options);
      }
export function useGetNonprofitOrgBillingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitOrgBillingDetailsQuery, GetNonprofitOrgBillingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitOrgBillingDetailsQuery, GetNonprofitOrgBillingDetailsQueryVariables>(GetNonprofitOrgBillingDetailsDocument, options);
        }
export type GetNonprofitOrgBillingDetailsQueryHookResult = ReturnType<typeof useGetNonprofitOrgBillingDetailsQuery>;
export type GetNonprofitOrgBillingDetailsLazyQueryHookResult = ReturnType<typeof useGetNonprofitOrgBillingDetailsLazyQuery>;
export type GetNonprofitOrgBillingDetailsQueryResult = Apollo.QueryResult<GetNonprofitOrgBillingDetailsQuery, GetNonprofitOrgBillingDetailsQueryVariables>;
export const NonprofitBoardDevelopmentDocument = gql`
    query nonprofitBoardDevelopment($nonprofitOrgId: Int!) {
  nonprofitBoard(nonprofitOrgId: $nonprofitOrgId) {
    id
    developmentStrategy
    developmentInitiatives
  }
}
    `;

/**
 * __useNonprofitBoardDevelopmentQuery__
 *
 * To run a query within a React component, call `useNonprofitBoardDevelopmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitBoardDevelopmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitBoardDevelopmentQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitBoardDevelopmentQuery(baseOptions: Apollo.QueryHookOptions<NonprofitBoardDevelopmentQuery, NonprofitBoardDevelopmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitBoardDevelopmentQuery, NonprofitBoardDevelopmentQueryVariables>(NonprofitBoardDevelopmentDocument, options);
      }
export function useNonprofitBoardDevelopmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitBoardDevelopmentQuery, NonprofitBoardDevelopmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitBoardDevelopmentQuery, NonprofitBoardDevelopmentQueryVariables>(NonprofitBoardDevelopmentDocument, options);
        }
export type NonprofitBoardDevelopmentQueryHookResult = ReturnType<typeof useNonprofitBoardDevelopmentQuery>;
export type NonprofitBoardDevelopmentLazyQueryHookResult = ReturnType<typeof useNonprofitBoardDevelopmentLazyQuery>;
export type NonprofitBoardDevelopmentQueryResult = Apollo.QueryResult<NonprofitBoardDevelopmentQuery, NonprofitBoardDevelopmentQueryVariables>;
export const NonprofitBoardRepresentationDocument = gql`
    query nonprofitBoardRepresentation($nonprofitOrgId: Int!) {
  nonprofitBoard(nonprofitOrgId: $nonprofitOrgId) {
    id
    representation
  }
}
    `;

/**
 * __useNonprofitBoardRepresentationQuery__
 *
 * To run a query within a React component, call `useNonprofitBoardRepresentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitBoardRepresentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitBoardRepresentationQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitBoardRepresentationQuery(baseOptions: Apollo.QueryHookOptions<NonprofitBoardRepresentationQuery, NonprofitBoardRepresentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitBoardRepresentationQuery, NonprofitBoardRepresentationQueryVariables>(NonprofitBoardRepresentationDocument, options);
      }
export function useNonprofitBoardRepresentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitBoardRepresentationQuery, NonprofitBoardRepresentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitBoardRepresentationQuery, NonprofitBoardRepresentationQueryVariables>(NonprofitBoardRepresentationDocument, options);
        }
export type NonprofitBoardRepresentationQueryHookResult = ReturnType<typeof useNonprofitBoardRepresentationQuery>;
export type NonprofitBoardRepresentationLazyQueryHookResult = ReturnType<typeof useNonprofitBoardRepresentationLazyQuery>;
export type NonprofitBoardRepresentationQueryResult = Apollo.QueryResult<NonprofitBoardRepresentationQuery, NonprofitBoardRepresentationQueryVariables>;
export const GetNonprofitOrgConfigDocument = gql`
    query getNonprofitOrgConfig($nonprofitOrgId: Int) {
  nonprofitOrg(nonprofitOrgId: $nonprofitOrgId) {
    orgName
    orgId
    legalName
    user {
      id
      firstName
      lastName
      email
      phone
      nonprofitExperienceRange
      updatedAt
    }
    role
    formationPlan
    platformPlan
    stripeConnectId
    isStripeConnectActive
    stripeConnectIssues {
      errors
      resumeKYCUrl
      pendingVerification
      missingBusinessUrl
    }
    permissions
    logoBoxId
    websiteUrl
    nonprofitOrgRole
    hasTaxExemptStatusAtSignup
    ein
    isFiscallySponsored
    is501c3Verified
    isBipocLed
    isBipocServing
    yearEstablished
    address
    featureFlags
    logoCloudinaryFileId
    paidStaffSizeRange
    volunteerSizeRange
    numBoardMembers
    numTeamMembers
    donationPortalId
    donationPortalHashedId
    isFounder
    donationFeePercent
    missionStatement
    taxExemptionStatus
    platformPlanAddOns
    funderOrgId
    activeFunders
    shellAppRedirectEnabled
  }
}
    `;

/**
 * __useGetNonprofitOrgConfigQuery__
 *
 * To run a query within a React component, call `useGetNonprofitOrgConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitOrgConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitOrgConfigQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetNonprofitOrgConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetNonprofitOrgConfigQuery, GetNonprofitOrgConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitOrgConfigQuery, GetNonprofitOrgConfigQueryVariables>(GetNonprofitOrgConfigDocument, options);
      }
export function useGetNonprofitOrgConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitOrgConfigQuery, GetNonprofitOrgConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitOrgConfigQuery, GetNonprofitOrgConfigQueryVariables>(GetNonprofitOrgConfigDocument, options);
        }
export type GetNonprofitOrgConfigQueryHookResult = ReturnType<typeof useGetNonprofitOrgConfigQuery>;
export type GetNonprofitOrgConfigLazyQueryHookResult = ReturnType<typeof useGetNonprofitOrgConfigLazyQuery>;
export type GetNonprofitOrgConfigQueryResult = Apollo.QueryResult<GetNonprofitOrgConfigQuery, GetNonprofitOrgConfigQueryVariables>;
export const NonprofitOrgDonationsDetailsDocument = gql`
    query nonprofitOrgDonationsDetails($nonprofitOrgId: Int) {
  nonprofitOrgDonationsDetails(nonprofitOrgId: $nonprofitOrgId) {
    state
    onboardingUrl
    errors {
      code
    }
  }
}
    `;

/**
 * __useNonprofitOrgDonationsDetailsQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgDonationsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgDonationsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgDonationsDetailsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgDonationsDetailsQuery(baseOptions?: Apollo.QueryHookOptions<NonprofitOrgDonationsDetailsQuery, NonprofitOrgDonationsDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgDonationsDetailsQuery, NonprofitOrgDonationsDetailsQueryVariables>(NonprofitOrgDonationsDetailsDocument, options);
      }
export function useNonprofitOrgDonationsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgDonationsDetailsQuery, NonprofitOrgDonationsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgDonationsDetailsQuery, NonprofitOrgDonationsDetailsQueryVariables>(NonprofitOrgDonationsDetailsDocument, options);
        }
export type NonprofitOrgDonationsDetailsQueryHookResult = ReturnType<typeof useNonprofitOrgDonationsDetailsQuery>;
export type NonprofitOrgDonationsDetailsLazyQueryHookResult = ReturnType<typeof useNonprofitOrgDonationsDetailsLazyQuery>;
export type NonprofitOrgDonationsDetailsQueryResult = Apollo.QueryResult<NonprofitOrgDonationsDetailsQuery, NonprofitOrgDonationsDetailsQueryVariables>;
export const NonprofitOrgFinancialDetailsDocument = gql`
    query nonprofitOrgFinancialDetails($nonprofitOrgId: Int!) {
  nonprofitOrgFinancialDetails(nonprofitOrgId: $nonprofitOrgId) {
    id
    nonprofitOrgId
    isFundingDiverse
    isFundingRecurring
    budgetRange
  }
}
    `;

/**
 * __useNonprofitOrgFinancialDetailsQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgFinancialDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgFinancialDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgFinancialDetailsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgFinancialDetailsQuery(baseOptions: Apollo.QueryHookOptions<NonprofitOrgFinancialDetailsQuery, NonprofitOrgFinancialDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgFinancialDetailsQuery, NonprofitOrgFinancialDetailsQueryVariables>(NonprofitOrgFinancialDetailsDocument, options);
      }
export function useNonprofitOrgFinancialDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgFinancialDetailsQuery, NonprofitOrgFinancialDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgFinancialDetailsQuery, NonprofitOrgFinancialDetailsQueryVariables>(NonprofitOrgFinancialDetailsDocument, options);
        }
export type NonprofitOrgFinancialDetailsQueryHookResult = ReturnType<typeof useNonprofitOrgFinancialDetailsQuery>;
export type NonprofitOrgFinancialDetailsLazyQueryHookResult = ReturnType<typeof useNonprofitOrgFinancialDetailsLazyQuery>;
export type NonprofitOrgFinancialDetailsQueryResult = Apollo.QueryResult<NonprofitOrgFinancialDetailsQuery, NonprofitOrgFinancialDetailsQueryVariables>;
export const NonprofitOrgTeamDocument = gql`
    query NonprofitOrgTeam($nonprofitOrgId: Int!, $planName: String!) {
  nonprofitOrgTeam(nonprofitOrgId: $nonprofitOrgId, planName: $planName) {
    users {
      nonprofitOrgId
      lastInviteSentAt
      role
      nonprofitOrgRole
      userId
      user {
        firstName
        lastName
        id
        email
        createdAt
        updatedAt
      }
    }
    limits {
      visible
      limit
      used
      available
      lowestPlanTier
    }
  }
}
    `;

/**
 * __useNonprofitOrgTeamQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgTeamQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      planName: // value for 'planName'
 *   },
 * });
 */
export function useNonprofitOrgTeamQuery(baseOptions: Apollo.QueryHookOptions<NonprofitOrgTeamQuery, NonprofitOrgTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgTeamQuery, NonprofitOrgTeamQueryVariables>(NonprofitOrgTeamDocument, options);
      }
export function useNonprofitOrgTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgTeamQuery, NonprofitOrgTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgTeamQuery, NonprofitOrgTeamQueryVariables>(NonprofitOrgTeamDocument, options);
        }
export type NonprofitOrgTeamQueryHookResult = ReturnType<typeof useNonprofitOrgTeamQuery>;
export type NonprofitOrgTeamLazyQueryHookResult = ReturnType<typeof useNonprofitOrgTeamLazyQuery>;
export type NonprofitOrgTeamQueryResult = Apollo.QueryResult<NonprofitOrgTeamQuery, NonprofitOrgTeamQueryVariables>;
export const NonprofitOrgToNteeCodeDocument = gql`
    query nonprofitOrgToNteeCode($nonprofitOrgId: Int!) {
  nonprofitOrgToNteeCode(nonprofitOrgId: $nonprofitOrgId) {
    id
    nteeCodeId
  }
}
    `;

/**
 * __useNonprofitOrgToNteeCodeQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgToNteeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgToNteeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgToNteeCodeQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgToNteeCodeQuery(baseOptions: Apollo.QueryHookOptions<NonprofitOrgToNteeCodeQuery, NonprofitOrgToNteeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgToNteeCodeQuery, NonprofitOrgToNteeCodeQueryVariables>(NonprofitOrgToNteeCodeDocument, options);
      }
export function useNonprofitOrgToNteeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgToNteeCodeQuery, NonprofitOrgToNteeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgToNteeCodeQuery, NonprofitOrgToNteeCodeQueryVariables>(NonprofitOrgToNteeCodeDocument, options);
        }
export type NonprofitOrgToNteeCodeQueryHookResult = ReturnType<typeof useNonprofitOrgToNteeCodeQuery>;
export type NonprofitOrgToNteeCodeLazyQueryHookResult = ReturnType<typeof useNonprofitOrgToNteeCodeLazyQuery>;
export type NonprofitOrgToNteeCodeQueryResult = Apollo.QueryResult<NonprofitOrgToNteeCodeQuery, NonprofitOrgToNteeCodeQueryVariables>;
export const NonprofitOrgToStaffCalssificationTypeDocument = gql`
    query nonprofitOrgToStaffCalssificationType($nonprofitOrgId: Int!) {
  nonprofitOrgToStaffClassificationType(nonprofitOrgId: $nonprofitOrgId) {
    id
    staffClassificationTypeId
  }
}
    `;

/**
 * __useNonprofitOrgToStaffCalssificationTypeQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgToStaffCalssificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgToStaffCalssificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgToStaffCalssificationTypeQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgToStaffCalssificationTypeQuery(baseOptions: Apollo.QueryHookOptions<NonprofitOrgToStaffCalssificationTypeQuery, NonprofitOrgToStaffCalssificationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgToStaffCalssificationTypeQuery, NonprofitOrgToStaffCalssificationTypeQueryVariables>(NonprofitOrgToStaffCalssificationTypeDocument, options);
      }
export function useNonprofitOrgToStaffCalssificationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgToStaffCalssificationTypeQuery, NonprofitOrgToStaffCalssificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgToStaffCalssificationTypeQuery, NonprofitOrgToStaffCalssificationTypeQueryVariables>(NonprofitOrgToStaffCalssificationTypeDocument, options);
        }
export type NonprofitOrgToStaffCalssificationTypeQueryHookResult = ReturnType<typeof useNonprofitOrgToStaffCalssificationTypeQuery>;
export type NonprofitOrgToStaffCalssificationTypeLazyQueryHookResult = ReturnType<typeof useNonprofitOrgToStaffCalssificationTypeLazyQuery>;
export type NonprofitOrgToStaffCalssificationTypeQueryResult = Apollo.QueryResult<NonprofitOrgToStaffCalssificationTypeQuery, NonprofitOrgToStaffCalssificationTypeQueryVariables>;
export const GetNonprofitOrgToUserToResponsibilityDocument = gql`
    query getNonprofitOrgToUserToResponsibility($nonprofitOrgId: Int!) {
  getNonprofitOrgToUserToResponsibility(nonprofitOrgId: $nonprofitOrgId) {
    responsibilityId
    responsibility {
      description
    }
  }
}
    `;

/**
 * __useGetNonprofitOrgToUserToResponsibilityQuery__
 *
 * To run a query within a React component, call `useGetNonprofitOrgToUserToResponsibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitOrgToUserToResponsibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitOrgToUserToResponsibilityQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetNonprofitOrgToUserToResponsibilityQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitOrgToUserToResponsibilityQuery, GetNonprofitOrgToUserToResponsibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitOrgToUserToResponsibilityQuery, GetNonprofitOrgToUserToResponsibilityQueryVariables>(GetNonprofitOrgToUserToResponsibilityDocument, options);
      }
export function useGetNonprofitOrgToUserToResponsibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitOrgToUserToResponsibilityQuery, GetNonprofitOrgToUserToResponsibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitOrgToUserToResponsibilityQuery, GetNonprofitOrgToUserToResponsibilityQueryVariables>(GetNonprofitOrgToUserToResponsibilityDocument, options);
        }
export type GetNonprofitOrgToUserToResponsibilityQueryHookResult = ReturnType<typeof useGetNonprofitOrgToUserToResponsibilityQuery>;
export type GetNonprofitOrgToUserToResponsibilityLazyQueryHookResult = ReturnType<typeof useGetNonprofitOrgToUserToResponsibilityLazyQuery>;
export type GetNonprofitOrgToUserToResponsibilityQueryResult = Apollo.QueryResult<GetNonprofitOrgToUserToResponsibilityQuery, GetNonprofitOrgToUserToResponsibilityQueryVariables>;
export const NonprofitOrgToUserDocument = gql`
    query nonprofitOrgToUser($nonprofitOrgId: Int!) {
  nonprofitOrgToUser(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    role
    userId
    user {
      firstName
      lastName
      id
      email
      createdAt
    }
  }
}
    `;

/**
 * __useNonprofitOrgToUserQuery__
 *
 * To run a query within a React component, call `useNonprofitOrgToUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgToUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgToUserQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgToUserQuery(baseOptions: Apollo.QueryHookOptions<NonprofitOrgToUserQuery, NonprofitOrgToUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgToUserQuery, NonprofitOrgToUserQueryVariables>(NonprofitOrgToUserDocument, options);
      }
export function useNonprofitOrgToUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgToUserQuery, NonprofitOrgToUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgToUserQuery, NonprofitOrgToUserQueryVariables>(NonprofitOrgToUserDocument, options);
        }
export type NonprofitOrgToUserQueryHookResult = ReturnType<typeof useNonprofitOrgToUserQuery>;
export type NonprofitOrgToUserLazyQueryHookResult = ReturnType<typeof useNonprofitOrgToUserLazyQuery>;
export type NonprofitOrgToUserQueryResult = Apollo.QueryResult<NonprofitOrgToUserQuery, NonprofitOrgToUserQueryVariables>;
export const GetNonprofitOrgsDocument = gql`
    query getNonprofitOrgs {
  getNonprofitOrgs {
    id
    name
  }
}
    `;

/**
 * __useGetNonprofitOrgsQuery__
 *
 * To run a query within a React component, call `useGetNonprofitOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNonprofitOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonprofitOrgsQuery, GetNonprofitOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitOrgsQuery, GetNonprofitOrgsQueryVariables>(GetNonprofitOrgsDocument, options);
      }
export function useGetNonprofitOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitOrgsQuery, GetNonprofitOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitOrgsQuery, GetNonprofitOrgsQueryVariables>(GetNonprofitOrgsDocument, options);
        }
export type GetNonprofitOrgsQueryHookResult = ReturnType<typeof useGetNonprofitOrgsQuery>;
export type GetNonprofitOrgsLazyQueryHookResult = ReturnType<typeof useGetNonprofitOrgsLazyQuery>;
export type GetNonprofitOrgsQueryResult = Apollo.QueryResult<GetNonprofitOrgsQuery, GetNonprofitOrgsQueryVariables>;
export const NonprofitUserEventDocument = gql`
    query nonprofitUserEvent($eventNames: [String!]!) {
  nonprofitUserEvent(eventNames: $eventNames) {
    id
    userId
    eventName
    eventTimeStamp
    eventProperties
  }
}
    `;

/**
 * __useNonprofitUserEventQuery__
 *
 * To run a query within a React component, call `useNonprofitUserEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitUserEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitUserEventQuery({
 *   variables: {
 *      eventNames: // value for 'eventNames'
 *   },
 * });
 */
export function useNonprofitUserEventQuery(baseOptions: Apollo.QueryHookOptions<NonprofitUserEventQuery, NonprofitUserEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitUserEventQuery, NonprofitUserEventQueryVariables>(NonprofitUserEventDocument, options);
      }
export function useNonprofitUserEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitUserEventQuery, NonprofitUserEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitUserEventQuery, NonprofitUserEventQueryVariables>(NonprofitUserEventDocument, options);
        }
export type NonprofitUserEventQueryHookResult = ReturnType<typeof useNonprofitUserEventQuery>;
export type NonprofitUserEventLazyQueryHookResult = ReturnType<typeof useNonprofitUserEventLazyQuery>;
export type NonprofitUserEventQueryResult = Apollo.QueryResult<NonprofitUserEventQuery, NonprofitUserEventQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($stripeConnectId: String!) {
  getNotifications(stripeConnectId: $stripeConnectId) {
    type
    details {
      last4
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const NteeCodeMajorGroupDocument = gql`
    query nteeCodeMajorGroup {
  nteeCodeMajorGroup {
    id
    description
  }
}
    `;

/**
 * __useNteeCodeMajorGroupQuery__
 *
 * To run a query within a React component, call `useNteeCodeMajorGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useNteeCodeMajorGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNteeCodeMajorGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useNteeCodeMajorGroupQuery(baseOptions?: Apollo.QueryHookOptions<NteeCodeMajorGroupQuery, NteeCodeMajorGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NteeCodeMajorGroupQuery, NteeCodeMajorGroupQueryVariables>(NteeCodeMajorGroupDocument, options);
      }
export function useNteeCodeMajorGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NteeCodeMajorGroupQuery, NteeCodeMajorGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NteeCodeMajorGroupQuery, NteeCodeMajorGroupQueryVariables>(NteeCodeMajorGroupDocument, options);
        }
export type NteeCodeMajorGroupQueryHookResult = ReturnType<typeof useNteeCodeMajorGroupQuery>;
export type NteeCodeMajorGroupLazyQueryHookResult = ReturnType<typeof useNteeCodeMajorGroupLazyQuery>;
export type NteeCodeMajorGroupQueryResult = Apollo.QueryResult<NteeCodeMajorGroupQuery, NteeCodeMajorGroupQueryVariables>;
export const GetPresetGuestTokenDocument = gql`
    query getPresetGuestToken($funderOrgId: Int!, $firstName: String!, $lastName: String!, $presetDashboardId: String!) {
  getPresetGuestToken(
    funderOrgId: $funderOrgId
    firstName: $firstName
    lastName: $lastName
    presetDashboardId: $presetDashboardId
  )
}
    `;

/**
 * __useGetPresetGuestTokenQuery__
 *
 * To run a query within a React component, call `useGetPresetGuestTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresetGuestTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresetGuestTokenQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      presetDashboardId: // value for 'presetDashboardId'
 *   },
 * });
 */
export function useGetPresetGuestTokenQuery(baseOptions: Apollo.QueryHookOptions<GetPresetGuestTokenQuery, GetPresetGuestTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPresetGuestTokenQuery, GetPresetGuestTokenQueryVariables>(GetPresetGuestTokenDocument, options);
      }
export function useGetPresetGuestTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPresetGuestTokenQuery, GetPresetGuestTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPresetGuestTokenQuery, GetPresetGuestTokenQueryVariables>(GetPresetGuestTokenDocument, options);
        }
export type GetPresetGuestTokenQueryHookResult = ReturnType<typeof useGetPresetGuestTokenQuery>;
export type GetPresetGuestTokenLazyQueryHookResult = ReturnType<typeof useGetPresetGuestTokenLazyQuery>;
export type GetPresetGuestTokenQueryResult = Apollo.QueryResult<GetPresetGuestTokenQuery, GetPresetGuestTokenQueryVariables>;
export const GetQuickBooksConnectionDocument = gql`
    query getQuickBooksConnection($orgId: Int!) {
  quickBooksConnection(orgId: $orgId) {
    id
    nonprofitOrgId
    companyName
    status
    connectedAt
    lastDataFetch
    needsReauth
  }
}
    `;

/**
 * __useGetQuickBooksConnectionQuery__
 *
 * To run a query within a React component, call `useGetQuickBooksConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickBooksConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickBooksConnectionQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetQuickBooksConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetQuickBooksConnectionQuery, GetQuickBooksConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickBooksConnectionQuery, GetQuickBooksConnectionQueryVariables>(GetQuickBooksConnectionDocument, options);
      }
export function useGetQuickBooksConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickBooksConnectionQuery, GetQuickBooksConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickBooksConnectionQuery, GetQuickBooksConnectionQueryVariables>(GetQuickBooksConnectionDocument, options);
        }
export type GetQuickBooksConnectionQueryHookResult = ReturnType<typeof useGetQuickBooksConnectionQuery>;
export type GetQuickBooksConnectionLazyQueryHookResult = ReturnType<typeof useGetQuickBooksConnectionLazyQuery>;
export type GetQuickBooksConnectionQueryResult = Apollo.QueryResult<GetQuickBooksConnectionQuery, GetQuickBooksConnectionQueryVariables>;
export const GetRecentFunderReportsDocument = gql`
    query getRecentFunderReports {
  getRecentFunderReports {
    funderOrgId
    createdAt
    targetDate
  }
}
    `;

/**
 * __useGetRecentFunderReportsQuery__
 *
 * To run a query within a React component, call `useGetRecentFunderReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentFunderReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentFunderReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecentFunderReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetRecentFunderReportsQuery, GetRecentFunderReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentFunderReportsQuery, GetRecentFunderReportsQueryVariables>(GetRecentFunderReportsDocument, options);
      }
export function useGetRecentFunderReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentFunderReportsQuery, GetRecentFunderReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentFunderReportsQuery, GetRecentFunderReportsQueryVariables>(GetRecentFunderReportsDocument, options);
        }
export type GetRecentFunderReportsQueryHookResult = ReturnType<typeof useGetRecentFunderReportsQuery>;
export type GetRecentFunderReportsLazyQueryHookResult = ReturnType<typeof useGetRecentFunderReportsLazyQuery>;
export type GetRecentFunderReportsQueryResult = Apollo.QueryResult<GetRecentFunderReportsQuery, GetRecentFunderReportsQueryVariables>;
export const RecommendedFundersForNonprofitDocument = gql`
    query recommendedFundersForNonprofit($nonprofitOrgId: Int!) {
  recommendedFundersForNonprofit(nonprofitOrgId: $nonprofitOrgId) {
    ein
    organizationName
    locationsOfImpact
    nteeDescription
    grantCount
    grantTotalAmount
    grantAverage
    state
    matchPercentage
  }
}
    `;

/**
 * __useRecommendedFundersForNonprofitQuery__
 *
 * To run a query within a React component, call `useRecommendedFundersForNonprofitQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedFundersForNonprofitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedFundersForNonprofitQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useRecommendedFundersForNonprofitQuery(baseOptions: Apollo.QueryHookOptions<RecommendedFundersForNonprofitQuery, RecommendedFundersForNonprofitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedFundersForNonprofitQuery, RecommendedFundersForNonprofitQueryVariables>(RecommendedFundersForNonprofitDocument, options);
      }
export function useRecommendedFundersForNonprofitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedFundersForNonprofitQuery, RecommendedFundersForNonprofitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedFundersForNonprofitQuery, RecommendedFundersForNonprofitQueryVariables>(RecommendedFundersForNonprofitDocument, options);
        }
export type RecommendedFundersForNonprofitQueryHookResult = ReturnType<typeof useRecommendedFundersForNonprofitQuery>;
export type RecommendedFundersForNonprofitLazyQueryHookResult = ReturnType<typeof useRecommendedFundersForNonprofitLazyQuery>;
export type RecommendedFundersForNonprofitQueryResult = Apollo.QueryResult<RecommendedFundersForNonprofitQuery, RecommendedFundersForNonprofitQueryVariables>;
export const ReportedMetricGroupDocument = gql`
    query reportedMetricGroup($nonprofitOrgId: Int!) {
  reportedMetricGroup(nonprofitOrgId: $nonprofitOrgId) {
    id
    title
    start
    end
  }
}
    `;

/**
 * __useReportedMetricGroupQuery__
 *
 * To run a query within a React component, call `useReportedMetricGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportedMetricGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportedMetricGroupQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useReportedMetricGroupQuery(baseOptions: Apollo.QueryHookOptions<ReportedMetricGroupQuery, ReportedMetricGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportedMetricGroupQuery, ReportedMetricGroupQueryVariables>(ReportedMetricGroupDocument, options);
      }
export function useReportedMetricGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportedMetricGroupQuery, ReportedMetricGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportedMetricGroupQuery, ReportedMetricGroupQueryVariables>(ReportedMetricGroupDocument, options);
        }
export type ReportedMetricGroupQueryHookResult = ReturnType<typeof useReportedMetricGroupQuery>;
export type ReportedMetricGroupLazyQueryHookResult = ReturnType<typeof useReportedMetricGroupLazyQuery>;
export type ReportedMetricGroupQueryResult = Apollo.QueryResult<ReportedMetricGroupQuery, ReportedMetricGroupQueryVariables>;
export const GetResponsibilityDocument = gql`
    query getResponsibility {
  getResponsibility {
    id
    description
    displayOrder
  }
}
    `;

/**
 * __useGetResponsibilityQuery__
 *
 * To run a query within a React component, call `useGetResponsibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResponsibilityQuery(baseOptions?: Apollo.QueryHookOptions<GetResponsibilityQuery, GetResponsibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsibilityQuery, GetResponsibilityQueryVariables>(GetResponsibilityDocument, options);
      }
export function useGetResponsibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsibilityQuery, GetResponsibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsibilityQuery, GetResponsibilityQueryVariables>(GetResponsibilityDocument, options);
        }
export type GetResponsibilityQueryHookResult = ReturnType<typeof useGetResponsibilityQuery>;
export type GetResponsibilityLazyQueryHookResult = ReturnType<typeof useGetResponsibilityLazyQuery>;
export type GetResponsibilityQueryResult = Apollo.QueryResult<GetResponsibilityQuery, GetResponsibilityQueryVariables>;
export const SavedFunderLimitsDocument = gql`
    query savedFunderLimits($nonprofitOrgId: Int!) {
  savedFunderLimits(nonprofitOrgId: $nonprofitOrgId) {
    visible
    limit
    used
    available
  }
}
    `;

/**
 * __useSavedFunderLimitsQuery__
 *
 * To run a query within a React component, call `useSavedFunderLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedFunderLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedFunderLimitsQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useSavedFunderLimitsQuery(baseOptions: Apollo.QueryHookOptions<SavedFunderLimitsQuery, SavedFunderLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedFunderLimitsQuery, SavedFunderLimitsQueryVariables>(SavedFunderLimitsDocument, options);
      }
export function useSavedFunderLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedFunderLimitsQuery, SavedFunderLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedFunderLimitsQuery, SavedFunderLimitsQueryVariables>(SavedFunderLimitsDocument, options);
        }
export type SavedFunderLimitsQueryHookResult = ReturnType<typeof useSavedFunderLimitsQuery>;
export type SavedFunderLimitsLazyQueryHookResult = ReturnType<typeof useSavedFunderLimitsLazyQuery>;
export type SavedFunderLimitsQueryResult = Apollo.QueryResult<SavedFunderLimitsQuery, SavedFunderLimitsQueryVariables>;
export const NonprofitOrgToSavedFundingOrg990Document = gql`
    query nonprofitOrgToSavedFundingOrg990($nonprofitOrgId: Int!) {
  nonprofitOrgToSavedFundingOrg990(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    fundingOrg990Id
    fundingOrg990 {
      ein
      organizationName
      grantsToPreselectedOnly
      nteeDescription
      city
      state
      locationsOfImpact
      grantAverage
    }
  }
}
    `;

/**
 * __useNonprofitOrgToSavedFundingOrg990Query__
 *
 * To run a query within a React component, call `useNonprofitOrgToSavedFundingOrg990Query` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgToSavedFundingOrg990Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgToSavedFundingOrg990Query({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgToSavedFundingOrg990Query(baseOptions: Apollo.QueryHookOptions<NonprofitOrgToSavedFundingOrg990Query, NonprofitOrgToSavedFundingOrg990QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgToSavedFundingOrg990Query, NonprofitOrgToSavedFundingOrg990QueryVariables>(NonprofitOrgToSavedFundingOrg990Document, options);
      }
export function useNonprofitOrgToSavedFundingOrg990LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgToSavedFundingOrg990Query, NonprofitOrgToSavedFundingOrg990QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgToSavedFundingOrg990Query, NonprofitOrgToSavedFundingOrg990QueryVariables>(NonprofitOrgToSavedFundingOrg990Document, options);
        }
export type NonprofitOrgToSavedFundingOrg990QueryHookResult = ReturnType<typeof useNonprofitOrgToSavedFundingOrg990Query>;
export type NonprofitOrgToSavedFundingOrg990LazyQueryHookResult = ReturnType<typeof useNonprofitOrgToSavedFundingOrg990LazyQuery>;
export type NonprofitOrgToSavedFundingOrg990QueryResult = Apollo.QueryResult<NonprofitOrgToSavedFundingOrg990Query, NonprofitOrgToSavedFundingOrg990QueryVariables>;
export const GetShellAppRedirectDocument = gql`
    query getShellAppRedirect {
  shellAppRedirectEnabled
}
    `;

/**
 * __useGetShellAppRedirectQuery__
 *
 * To run a query within a React component, call `useGetShellAppRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShellAppRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShellAppRedirectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShellAppRedirectQuery(baseOptions?: Apollo.QueryHookOptions<GetShellAppRedirectQuery, GetShellAppRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShellAppRedirectQuery, GetShellAppRedirectQueryVariables>(GetShellAppRedirectDocument, options);
      }
export function useGetShellAppRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShellAppRedirectQuery, GetShellAppRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShellAppRedirectQuery, GetShellAppRedirectQueryVariables>(GetShellAppRedirectDocument, options);
        }
export type GetShellAppRedirectQueryHookResult = ReturnType<typeof useGetShellAppRedirectQuery>;
export type GetShellAppRedirectLazyQueryHookResult = ReturnType<typeof useGetShellAppRedirectLazyQuery>;
export type GetShellAppRedirectQueryResult = Apollo.QueryResult<GetShellAppRedirectQuery, GetShellAppRedirectQueryVariables>;
export const StaffClassificationTypeDocument = gql`
    query staffClassificationType {
  staffClassificationType {
    id
    description
  }
}
    `;

/**
 * __useStaffClassificationTypeQuery__
 *
 * To run a query within a React component, call `useStaffClassificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffClassificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffClassificationTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffClassificationTypeQuery(baseOptions?: Apollo.QueryHookOptions<StaffClassificationTypeQuery, StaffClassificationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaffClassificationTypeQuery, StaffClassificationTypeQueryVariables>(StaffClassificationTypeDocument, options);
      }
export function useStaffClassificationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffClassificationTypeQuery, StaffClassificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaffClassificationTypeQuery, StaffClassificationTypeQueryVariables>(StaffClassificationTypeDocument, options);
        }
export type StaffClassificationTypeQueryHookResult = ReturnType<typeof useStaffClassificationTypeQuery>;
export type StaffClassificationTypeLazyQueryHookResult = ReturnType<typeof useStaffClassificationTypeLazyQuery>;
export type StaffClassificationTypeQueryResult = Apollo.QueryResult<StaffClassificationTypeQuery, StaffClassificationTypeQueryVariables>;
export const StoryDocument = gql`
    query Story($userId: Int, $nonprofitOrgId: Int, $storyId: Int, $hashedId: String, $includeBlocks: Boolean! = true) {
  Story(
    userId: $userId
    nonprofitOrgId: $nonprofitOrgId
    storyId: $storyId
    hashedId: $hashedId
  ) {
    id
    nonprofitOrgId
    userId
    templateUsed
    title
    urlTitle
    hashedId
    colorTheme {
      id
      color
    }
    publishedAt
    createdAt
    updatedAt
    archivedAt
    showHeader
    showTableOfContents
    headerLogoImgUrl
    headerWebsiteUrl
    previewTitle
    previewDescription
    previewImageId
    previewImageCloudinaryFileId
    goalId
    donationPortalId
    blocks @include(if: $includeBlocks) {
      id
      storyId
      assetId
      assetType
      order
      createdAt
      updatedAt
      backgroundColor
      asset {
        id
        assetType
        reusable
        assetDetails
        nonprofitOrgId
        createdUserId
        updatedUserId
        createdAt
        updatedAt
      }
    }
    viewCount
    ctaClickCount
    nonprofitOrgName
    cloudinaryLogoId
  }
}
    `;

/**
 * __useStoryQuery__
 *
 * To run a query within a React component, call `useStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      storyId: // value for 'storyId'
 *      hashedId: // value for 'hashedId'
 *      includeBlocks: // value for 'includeBlocks'
 *   },
 * });
 */
export function useStoryQuery(baseOptions?: Apollo.QueryHookOptions<StoryQuery, StoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoryQuery, StoryQueryVariables>(StoryDocument, options);
      }
export function useStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryQuery, StoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoryQuery, StoryQueryVariables>(StoryDocument, options);
        }
export type StoryQueryHookResult = ReturnType<typeof useStoryQuery>;
export type StoryLazyQueryHookResult = ReturnType<typeof useStoryLazyQuery>;
export type StoryQueryResult = Apollo.QueryResult<StoryQuery, StoryQueryVariables>;
export const GetStoriesDocument = gql`
    query getStories($userId: Int, $nonprofitOrgId: Int) {
  getStories(userId: $userId, nonprofitOrgId: $nonprofitOrgId) {
    id
    templateUsed
    title
    hashedId
    publishedAt
    createdAt
    updatedAt
    archivedAt
    viewCount
    ctaClickCount
    hasClickTrackableBlock
    FunderOrgs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStoriesQuery__
 *
 * To run a query within a React component, call `useGetStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoriesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetStoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetStoriesQuery, GetStoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoriesQuery, GetStoriesQueryVariables>(GetStoriesDocument, options);
      }
export function useGetStoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoriesQuery, GetStoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoriesQuery, GetStoriesQueryVariables>(GetStoriesDocument, options);
        }
export type GetStoriesQueryHookResult = ReturnType<typeof useGetStoriesQuery>;
export type GetStoriesLazyQueryHookResult = ReturnType<typeof useGetStoriesLazyQuery>;
export type GetStoriesQueryResult = Apollo.QueryResult<GetStoriesQuery, GetStoriesQueryVariables>;
export const StoriesSharedWithFunderOrgDocument = gql`
    query StoriesSharedWithFunderOrg($funderOrgId: Int!, $cohortId: Int) {
  StoriesSharedWithFunderOrg(funderOrgId: $funderOrgId, cohortId: $cohortId) {
    id
    nonprofitOrgId
    nonprofitOrgName
    userId
    templateUsed
    title
    hashedId
    colorTheme {
      id
      color
    }
    publishedAt
    createdAt
    updatedAt
    archivedAt
    showHeader
    sharedAt
    headerLogoImgUrl
    headerWebsiteUrl
    previewTitle
    previewDescription
    previewImageId
    previewImageCloudinaryFileId
    goalId
    donationPortalId
    blocks {
      id
      storyId
      assetId
      assetType
      order
      createdAt
      updatedAt
      asset {
        id
        assetType
        reusable
        assetDetails
        nonprofitOrgId
        createdUserId
        updatedUserId
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useStoriesSharedWithFunderOrgQuery__
 *
 * To run a query within a React component, call `useStoriesSharedWithFunderOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoriesSharedWithFunderOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoriesSharedWithFunderOrgQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useStoriesSharedWithFunderOrgQuery(baseOptions: Apollo.QueryHookOptions<StoriesSharedWithFunderOrgQuery, StoriesSharedWithFunderOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoriesSharedWithFunderOrgQuery, StoriesSharedWithFunderOrgQueryVariables>(StoriesSharedWithFunderOrgDocument, options);
      }
export function useStoriesSharedWithFunderOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoriesSharedWithFunderOrgQuery, StoriesSharedWithFunderOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoriesSharedWithFunderOrgQuery, StoriesSharedWithFunderOrgQueryVariables>(StoriesSharedWithFunderOrgDocument, options);
        }
export type StoriesSharedWithFunderOrgQueryHookResult = ReturnType<typeof useStoriesSharedWithFunderOrgQuery>;
export type StoriesSharedWithFunderOrgLazyQueryHookResult = ReturnType<typeof useStoriesSharedWithFunderOrgLazyQuery>;
export type StoriesSharedWithFunderOrgQueryResult = Apollo.QueryResult<StoriesSharedWithFunderOrgQuery, StoriesSharedWithFunderOrgQueryVariables>;
export const StoryGatingDocument = gql`
    query storyGating($nonprofitOrgId: Int!) {
  storyGating(nonprofitOrgId: $nonprofitOrgId) {
    limit
    limitCycle
    numberOfStoriesUsed
  }
}
    `;

/**
 * __useStoryGatingQuery__
 *
 * To run a query within a React component, call `useStoryGatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoryGatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoryGatingQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useStoryGatingQuery(baseOptions: Apollo.QueryHookOptions<StoryGatingQuery, StoryGatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoryGatingQuery, StoryGatingQueryVariables>(StoryGatingDocument, options);
      }
export function useStoryGatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoryGatingQuery, StoryGatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoryGatingQuery, StoryGatingQueryVariables>(StoryGatingDocument, options);
        }
export type StoryGatingQueryHookResult = ReturnType<typeof useStoryGatingQuery>;
export type StoryGatingLazyQueryHookResult = ReturnType<typeof useStoryGatingLazyQuery>;
export type StoryGatingQueryResult = Apollo.QueryResult<StoryGatingQuery, StoryGatingQueryVariables>;
export const GetChangePlanPortalLinksDocument = gql`
    query getChangePlanPortalLinks($stripeCustomerId: String!, $returnUrl: String!) {
  getChangePlanPortalLinks(
    stripeCustomerId: $stripeCustomerId
    returnUrl: $returnUrl
  ) {
    starter
    performance
    isTrialing
    trialEnd
  }
}
    `;

/**
 * __useGetChangePlanPortalLinksQuery__
 *
 * To run a query within a React component, call `useGetChangePlanPortalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangePlanPortalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangePlanPortalLinksQuery({
 *   variables: {
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useGetChangePlanPortalLinksQuery(baseOptions: Apollo.QueryHookOptions<GetChangePlanPortalLinksQuery, GetChangePlanPortalLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangePlanPortalLinksQuery, GetChangePlanPortalLinksQueryVariables>(GetChangePlanPortalLinksDocument, options);
      }
export function useGetChangePlanPortalLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangePlanPortalLinksQuery, GetChangePlanPortalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangePlanPortalLinksQuery, GetChangePlanPortalLinksQueryVariables>(GetChangePlanPortalLinksDocument, options);
        }
export type GetChangePlanPortalLinksQueryHookResult = ReturnType<typeof useGetChangePlanPortalLinksQuery>;
export type GetChangePlanPortalLinksLazyQueryHookResult = ReturnType<typeof useGetChangePlanPortalLinksLazyQuery>;
export type GetChangePlanPortalLinksQueryResult = Apollo.QueryResult<GetChangePlanPortalLinksQuery, GetChangePlanPortalLinksQueryVariables>;
export const GetStripeConnectAccountDocument = gql`
    query getStripeConnectAccount($stripeAccountId: String!) {
  getStripeConnectAccount(stripeAccountId: $stripeAccountId) {
    id
    payouts_enabled
    bankAccount {
      routingNumber
      last4
    }
    capabilities {
      transfers
      card_payments
    }
  }
}
    `;

/**
 * __useGetStripeConnectAccountQuery__
 *
 * To run a query within a React component, call `useGetStripeConnectAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeConnectAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeConnectAccountQuery({
 *   variables: {
 *      stripeAccountId: // value for 'stripeAccountId'
 *   },
 * });
 */
export function useGetStripeConnectAccountQuery(baseOptions: Apollo.QueryHookOptions<GetStripeConnectAccountQuery, GetStripeConnectAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeConnectAccountQuery, GetStripeConnectAccountQueryVariables>(GetStripeConnectAccountDocument, options);
      }
export function useGetStripeConnectAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeConnectAccountQuery, GetStripeConnectAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeConnectAccountQuery, GetStripeConnectAccountQueryVariables>(GetStripeConnectAccountDocument, options);
        }
export type GetStripeConnectAccountQueryHookResult = ReturnType<typeof useGetStripeConnectAccountQuery>;
export type GetStripeConnectAccountLazyQueryHookResult = ReturnType<typeof useGetStripeConnectAccountLazyQuery>;
export type GetStripeConnectAccountQueryResult = Apollo.QueryResult<GetStripeConnectAccountQuery, GetStripeConnectAccountQueryVariables>;
export const GetFilteredNonprofitTransactionsDocument = gql`
    query getFilteredNonprofitTransactions($stripeConnectId: String!, $page: String, $filters: Filters) {
  getFilteredNonprofitTransactions(
    stripeConnectId: $stripeConnectId
    filters: $filters
    page: $page
  ) {
    nextPage
    transactions {
      id
      amount
      balanceTransactionId
      fee
      net
      created
      status
      card {
        last4
        brand
        fundingType
      }
      paymentMethod
      donor
      donorEmail
      donorAddress {
        city
        country
        line1
        line2
        postal_code
        state
      }
      honoree
      honoreeEmail
      feeCovered
      story {
        id
        title
        imageId
      }
      isRecurring
      recurrenceDetails {
        interval
        status
      }
      type
      ... on NonprofitCharge {
        refundIds
        disputeId
      }
      ... on NonprofitRefund {
        chargeId
      }
      ... on NonprofitDispute {
        chargeId
      }
    }
  }
}
    `;

/**
 * __useGetFilteredNonprofitTransactionsQuery__
 *
 * To run a query within a React component, call `useGetFilteredNonprofitTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredNonprofitTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredNonprofitTransactionsQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      page: // value for 'page'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetFilteredNonprofitTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredNonprofitTransactionsQuery, GetFilteredNonprofitTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredNonprofitTransactionsQuery, GetFilteredNonprofitTransactionsQueryVariables>(GetFilteredNonprofitTransactionsDocument, options);
      }
export function useGetFilteredNonprofitTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredNonprofitTransactionsQuery, GetFilteredNonprofitTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredNonprofitTransactionsQuery, GetFilteredNonprofitTransactionsQueryVariables>(GetFilteredNonprofitTransactionsDocument, options);
        }
export type GetFilteredNonprofitTransactionsQueryHookResult = ReturnType<typeof useGetFilteredNonprofitTransactionsQuery>;
export type GetFilteredNonprofitTransactionsLazyQueryHookResult = ReturnType<typeof useGetFilteredNonprofitTransactionsLazyQuery>;
export type GetFilteredNonprofitTransactionsQueryResult = Apollo.QueryResult<GetFilteredNonprofitTransactionsQuery, GetFilteredNonprofitTransactionsQueryVariables>;
export const GetNonprofitDonationSummaryDocument = gql`
    query getNonprofitDonationSummary($stripeConnectId: String!, $createdAfter: Int) {
  getNonprofitDonationSummary(
    stripeConnectId: $stripeConnectId
    createdAfter: $createdAfter
  ) {
    netRaised
    donationCount
    average
    transactionCount
  }
}
    `;

/**
 * __useGetNonprofitDonationSummaryQuery__
 *
 * To run a query within a React component, call `useGetNonprofitDonationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitDonationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitDonationSummaryQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useGetNonprofitDonationSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitDonationSummaryQuery, GetNonprofitDonationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitDonationSummaryQuery, GetNonprofitDonationSummaryQueryVariables>(GetNonprofitDonationSummaryDocument, options);
      }
export function useGetNonprofitDonationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitDonationSummaryQuery, GetNonprofitDonationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitDonationSummaryQuery, GetNonprofitDonationSummaryQueryVariables>(GetNonprofitDonationSummaryDocument, options);
        }
export type GetNonprofitDonationSummaryQueryHookResult = ReturnType<typeof useGetNonprofitDonationSummaryQuery>;
export type GetNonprofitDonationSummaryLazyQueryHookResult = ReturnType<typeof useGetNonprofitDonationSummaryLazyQuery>;
export type GetNonprofitDonationSummaryQueryResult = Apollo.QueryResult<GetNonprofitDonationSummaryQuery, GetNonprofitDonationSummaryQueryVariables>;
export const GetNonprofitDonationsDocument = gql`
    query getNonprofitDonations($stripeConnectId: String!, $createdAfter: Int) {
  getNonprofitDonations(
    stripeConnectId: $stripeConnectId
    createdAfter: $createdAfter
  ) {
    id
    amount
    fee
    net
    application_fee_amount
    created
    currency
    description
    object
    status
    last4
    funding
    paymentMethod
    brand
    refundDetails
    disputeDetails
    metadata {
      donor
      donorEmail
      storyId
      storyTitle
      honoree
      honoreeEmail
      imageId
    }
    type
  }
}
    `;

/**
 * __useGetNonprofitDonationsQuery__
 *
 * To run a query within a React component, call `useGetNonprofitDonationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitDonationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitDonationsQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useGetNonprofitDonationsQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitDonationsQuery, GetNonprofitDonationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitDonationsQuery, GetNonprofitDonationsQueryVariables>(GetNonprofitDonationsDocument, options);
      }
export function useGetNonprofitDonationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitDonationsQuery, GetNonprofitDonationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitDonationsQuery, GetNonprofitDonationsQueryVariables>(GetNonprofitDonationsDocument, options);
        }
export type GetNonprofitDonationsQueryHookResult = ReturnType<typeof useGetNonprofitDonationsQuery>;
export type GetNonprofitDonationsLazyQueryHookResult = ReturnType<typeof useGetNonprofitDonationsLazyQuery>;
export type GetNonprofitDonationsQueryResult = Apollo.QueryResult<GetNonprofitDonationsQuery, GetNonprofitDonationsQueryVariables>;
export const GetNonprofitTransactionDocument = gql`
    query getNonprofitTransaction($stripeConnectId: String!, $transactionId: String!) {
  getNonprofitTransaction(
    stripeConnectId: $stripeConnectId
    transactionId: $transactionId
  ) {
    id
    amount
    balanceTransactionId
    fee
    net
    created
    status
    card {
      last4
      brand
      fundingType
    }
    paymentMethod
    donor
    donorEmail
    donorAddress {
      city
      country
      line1
      line2
      postal_code
      state
    }
    honoree
    honoreeEmail
    feeCovered
    story {
      id
      title
      imageId
    }
    campaignId
    isRecurring
    recurrenceDetails {
      interval
      status
    }
    type
    ... on NonprofitCharge {
      refundIds
      disputeId
    }
    ... on NonprofitRefund {
      chargeId
    }
    ... on NonprofitDispute {
      chargeId
    }
  }
}
    `;

/**
 * __useGetNonprofitTransactionQuery__
 *
 * To run a query within a React component, call `useGetNonprofitTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitTransactionQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetNonprofitTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitTransactionQuery, GetNonprofitTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitTransactionQuery, GetNonprofitTransactionQueryVariables>(GetNonprofitTransactionDocument, options);
      }
export function useGetNonprofitTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitTransactionQuery, GetNonprofitTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitTransactionQuery, GetNonprofitTransactionQueryVariables>(GetNonprofitTransactionDocument, options);
        }
export type GetNonprofitTransactionQueryHookResult = ReturnType<typeof useGetNonprofitTransactionQuery>;
export type GetNonprofitTransactionLazyQueryHookResult = ReturnType<typeof useGetNonprofitTransactionLazyQuery>;
export type GetNonprofitTransactionQueryResult = Apollo.QueryResult<GetNonprofitTransactionQuery, GetNonprofitTransactionQueryVariables>;
export const GetNonprofitTransactionsDocument = gql`
    query getNonprofitTransactions($stripeConnectId: String!, $createdAfter: Int, $startingAfter: String) {
  getNonprofitTransactions(
    stripeConnectId: $stripeConnectId
    createdAfter: $createdAfter
    startingAfter: $startingAfter
  ) {
    hasMore
    transactions {
      id
      amount
      balanceTransactionId
      fee
      net
      created
      status
      card {
        last4
        brand
        fundingType
      }
      paymentMethod
      isAnonymousDonation
      donor
      donorEmail
      donorAddress {
        city
        country
        line1
        line2
        postal_code
        state
      }
      disputeStatus
      honoree
      honoreeEmail
      feeCovered
      story {
        id
        title
        imageId
      }
      campaignId
      isRecurring
      recurrenceDetails {
        interval
        status
      }
      type
      ... on NonprofitCharge {
        refundIds
        disputeId
        disputeFeeId
        disputeReversalId
        disputeFeeReversalId
      }
      ... on NonprofitRefund {
        chargeId
      }
      ... on NonprofitDispute {
        chargeId
        disputeFeeId
        disputeReversalId
        disputeFeeReversalId
      }
      ... on NonprofitDisputeFee {
        chargeId
        disputeId
        disputeReversalId
        disputeFeeReversalId
      }
      ... on NonprofitDisputeReversal {
        chargeId
        disputeId
        disputeFeeId
        disputeFeeReversalId
      }
      ... on NonprofitDisputeFeeReversal {
        chargeId
        disputeId
        disputeFeeId
        disputeReversalId
      }
    }
  }
}
    `;

/**
 * __useGetNonprofitTransactionsQuery__
 *
 * To run a query within a React component, call `useGetNonprofitTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitTransactionsQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      createdAfter: // value for 'createdAfter'
 *      startingAfter: // value for 'startingAfter'
 *   },
 * });
 */
export function useGetNonprofitTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitTransactionsQuery, GetNonprofitTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitTransactionsQuery, GetNonprofitTransactionsQueryVariables>(GetNonprofitTransactionsDocument, options);
      }
export function useGetNonprofitTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitTransactionsQuery, GetNonprofitTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitTransactionsQuery, GetNonprofitTransactionsQueryVariables>(GetNonprofitTransactionsDocument, options);
        }
export type GetNonprofitTransactionsQueryHookResult = ReturnType<typeof useGetNonprofitTransactionsQuery>;
export type GetNonprofitTransactionsLazyQueryHookResult = ReturnType<typeof useGetNonprofitTransactionsLazyQuery>;
export type GetNonprofitTransactionsQueryResult = Apollo.QueryResult<GetNonprofitTransactionsQuery, GetNonprofitTransactionsQueryVariables>;
export const GetStripePriceDocument = gql`
    query getStripePrice($platformPlan: PlatformPlan!, $formationPlan: FormationPlan) {
  getStripePrice(platformPlan: $platformPlan, formationPlan: $formationPlan) {
    platformPrice
    formationPrice
  }
}
    `;

/**
 * __useGetStripePriceQuery__
 *
 * To run a query within a React component, call `useGetStripePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripePriceQuery({
 *   variables: {
 *      platformPlan: // value for 'platformPlan'
 *      formationPlan: // value for 'formationPlan'
 *   },
 * });
 */
export function useGetStripePriceQuery(baseOptions: Apollo.QueryHookOptions<GetStripePriceQuery, GetStripePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripePriceQuery, GetStripePriceQueryVariables>(GetStripePriceDocument, options);
      }
export function useGetStripePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripePriceQuery, GetStripePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripePriceQuery, GetStripePriceQueryVariables>(GetStripePriceDocument, options);
        }
export type GetStripePriceQueryHookResult = ReturnType<typeof useGetStripePriceQuery>;
export type GetStripePriceLazyQueryHookResult = ReturnType<typeof useGetStripePriceLazyQuery>;
export type GetStripePriceQueryResult = Apollo.QueryResult<GetStripePriceQuery, GetStripePriceQueryVariables>;
export const GetTasksDocument = gql`
    query getTasks($isCompleted: Boolean) {
  getTasks(isCompleted: $isCompleted) {
    id
    goalId
    title
    isCompleted
    updatedAt
    resourceId
    linkUrl
    linkText
  }
}
    `;

/**
 * __useGetTasksQuery__
 *
 * To run a query within a React component, call `useGetTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksQuery({
 *   variables: {
 *      isCompleted: // value for 'isCompleted'
 *   },
 * });
 */
export function useGetTasksQuery(baseOptions?: Apollo.QueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksQuery, GetTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksQuery, GetTasksQueryVariables>(GetTasksDocument, options);
        }
export type GetTasksQueryHookResult = ReturnType<typeof useGetTasksQuery>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<GetTasksQuery, GetTasksQueryVariables>;
export const GetTaxExemptionStatusDocument = gql`
    query getTaxExemptionStatus($nonprofitOrgId: Int!) {
  getTaxExemptionStatus(nonprofitOrgId: $nonprofitOrgId) {
    status
  }
}
    `;

/**
 * __useGetTaxExemptionStatusQuery__
 *
 * To run a query within a React component, call `useGetTaxExemptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxExemptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxExemptionStatusQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetTaxExemptionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetTaxExemptionStatusQuery, GetTaxExemptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxExemptionStatusQuery, GetTaxExemptionStatusQueryVariables>(GetTaxExemptionStatusDocument, options);
      }
export function useGetTaxExemptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxExemptionStatusQuery, GetTaxExemptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxExemptionStatusQuery, GetTaxExemptionStatusQueryVariables>(GetTaxExemptionStatusDocument, options);
        }
export type GetTaxExemptionStatusQueryHookResult = ReturnType<typeof useGetTaxExemptionStatusQuery>;
export type GetTaxExemptionStatusLazyQueryHookResult = ReturnType<typeof useGetTaxExemptionStatusLazyQuery>;
export type GetTaxExemptionStatusQueryResult = Apollo.QueryResult<GetTaxExemptionStatusQuery, GetTaxExemptionStatusQueryVariables>;
export const GetTemplateLibraryDocument = gql`
    query getTemplateLibrary {
  getTemplateLibrary {
    id
    appcuesFlowId
    createdAt
    updatedAt
    archivedAt
    showInListing
    description
    checklistItemTemplate {
      id
      title
      resourceId
      displayOrder
      linkText
      linkUrl
      templateLibraryId
      createdAt
      updatedAt
    }
    goalTemplate {
      id
      title
      category
    }
  }
}
    `;

/**
 * __useGetTemplateLibraryQuery__
 *
 * To run a query within a React component, call `useGetTemplateLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTemplateLibraryQuery(baseOptions?: Apollo.QueryHookOptions<GetTemplateLibraryQuery, GetTemplateLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateLibraryQuery, GetTemplateLibraryQueryVariables>(GetTemplateLibraryDocument, options);
      }
export function useGetTemplateLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateLibraryQuery, GetTemplateLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateLibraryQuery, GetTemplateLibraryQueryVariables>(GetTemplateLibraryDocument, options);
        }
export type GetTemplateLibraryQueryHookResult = ReturnType<typeof useGetTemplateLibraryQuery>;
export type GetTemplateLibraryLazyQueryHookResult = ReturnType<typeof useGetTemplateLibraryLazyQuery>;
export type GetTemplateLibraryQueryResult = Apollo.QueryResult<GetTemplateLibraryQuery, GetTemplateLibraryQueryVariables>;
export const GetThirdPartyNonprofitOrgConfigDocument = gql`
    query getThirdPartyNonprofitOrgConfig($nonprofitOrgId: Int!) {
  getThirdPartyNonprofitOrgConfig(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    stripeCustomerId
  }
}
    `;

/**
 * __useGetThirdPartyNonprofitOrgConfigQuery__
 *
 * To run a query within a React component, call `useGetThirdPartyNonprofitOrgConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThirdPartyNonprofitOrgConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThirdPartyNonprofitOrgConfigQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetThirdPartyNonprofitOrgConfigQuery(baseOptions: Apollo.QueryHookOptions<GetThirdPartyNonprofitOrgConfigQuery, GetThirdPartyNonprofitOrgConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThirdPartyNonprofitOrgConfigQuery, GetThirdPartyNonprofitOrgConfigQueryVariables>(GetThirdPartyNonprofitOrgConfigDocument, options);
      }
export function useGetThirdPartyNonprofitOrgConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThirdPartyNonprofitOrgConfigQuery, GetThirdPartyNonprofitOrgConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThirdPartyNonprofitOrgConfigQuery, GetThirdPartyNonprofitOrgConfigQueryVariables>(GetThirdPartyNonprofitOrgConfigDocument, options);
        }
export type GetThirdPartyNonprofitOrgConfigQueryHookResult = ReturnType<typeof useGetThirdPartyNonprofitOrgConfigQuery>;
export type GetThirdPartyNonprofitOrgConfigLazyQueryHookResult = ReturnType<typeof useGetThirdPartyNonprofitOrgConfigLazyQuery>;
export type GetThirdPartyNonprofitOrgConfigQueryResult = Apollo.QueryResult<GetThirdPartyNonprofitOrgConfigQuery, GetThirdPartyNonprofitOrgConfigQueryVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: Int!) {
  getUserById(id: $id) {
    id
    email
    firstName
    lastName
    phone
    disabled
    isTest
    createdAt
    updatedAt
    disabledAt
    lastLoggedInAt
    nonprofitExperienceRange
    nonprofitOrgs {
      id
      name
      disabled
      isTest
    }
    funderOrgs {
      id
      name
      disabled
      isTest
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const UserDocument = gql`
    query user {
  user {
    createdAt
    id
    firstName
    lastName
    email
    phone
    nonprofitExperienceRange
    permissions
    lastLoggedInAt
    spaces
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserEventDocument = gql`
    query userEvent($eventNames: [String!]!, $eventPropertiesFilter: EventPropertiesFilter) {
  userEvent(
    eventNames: $eventNames
    eventPropertiesFilter: $eventPropertiesFilter
  ) {
    id
    userId
    eventName
    eventTimeStamp
    eventProperties
  }
}
    `;

/**
 * __useUserEventQuery__
 *
 * To run a query within a React component, call `useUserEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEventQuery({
 *   variables: {
 *      eventNames: // value for 'eventNames'
 *      eventPropertiesFilter: // value for 'eventPropertiesFilter'
 *   },
 * });
 */
export function useUserEventQuery(baseOptions: Apollo.QueryHookOptions<UserEventQuery, UserEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEventQuery, UserEventQueryVariables>(UserEventDocument, options);
      }
export function useUserEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEventQuery, UserEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEventQuery, UserEventQueryVariables>(UserEventDocument, options);
        }
export type UserEventQueryHookResult = ReturnType<typeof useUserEventQuery>;
export type UserEventLazyQueryHookResult = ReturnType<typeof useUserEventLazyQuery>;
export type UserEventQueryResult = Apollo.QueryResult<UserEventQuery, UserEventQueryVariables>;
export const GetUserRsvpGroupCoachingEventsDocument = gql`
    query GetUserRsvpGroupCoachingEvents($status: [RsvpStatus], $startDate: DateTime, $endDate: DateTime, $limit: Int) {
  userRsvpGroupCoachingEvents(
    status: $status
    startDate: $startDate
    endDate: $endDate
    limit: $limit
  ) {
    id
    name
    userId
    createdAt
    updatedAt
    startsAt
    endsAt
    duration
    bookingUrl
    slug
    hideAttendees
    body
    googleCalendarId
    googleCalendarLink
    focusArea
    coachName
    recordingLink
    meetingBody
    meetingTitle
    activityType
    videoConferenceUrl
    transcript
    summary
    status
    userRsvpStatus
    userRsvpNotes
    circleEventId
    circleEventUrl
  }
}
    `;

/**
 * __useGetUserRsvpGroupCoachingEventsQuery__
 *
 * To run a query within a React component, call `useGetUserRsvpGroupCoachingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRsvpGroupCoachingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRsvpGroupCoachingEventsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserRsvpGroupCoachingEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRsvpGroupCoachingEventsQuery, GetUserRsvpGroupCoachingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRsvpGroupCoachingEventsQuery, GetUserRsvpGroupCoachingEventsQueryVariables>(GetUserRsvpGroupCoachingEventsDocument, options);
      }
export function useGetUserRsvpGroupCoachingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRsvpGroupCoachingEventsQuery, GetUserRsvpGroupCoachingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRsvpGroupCoachingEventsQuery, GetUserRsvpGroupCoachingEventsQueryVariables>(GetUserRsvpGroupCoachingEventsDocument, options);
        }
export type GetUserRsvpGroupCoachingEventsQueryHookResult = ReturnType<typeof useGetUserRsvpGroupCoachingEventsQuery>;
export type GetUserRsvpGroupCoachingEventsLazyQueryHookResult = ReturnType<typeof useGetUserRsvpGroupCoachingEventsLazyQuery>;
export type GetUserRsvpGroupCoachingEventsQueryResult = Apollo.QueryResult<GetUserRsvpGroupCoachingEventsQuery, GetUserRsvpGroupCoachingEventsQueryVariables>;
export const NonprofitOrgToViewedFundingOrg990Document = gql`
    query NonprofitOrgToViewedFundingOrg990($nonprofitOrgId: Int!) {
  NonprofitOrgToViewedFundingOrg990(nonprofitOrgId: $nonprofitOrgId) {
    nonprofitOrgId
    fundingOrg990Id
    fundingOrg990 {
      ein
      organizationName
      grantsToPreselectedOnly
      nteeDescription
      city
      state
      locationsOfImpact
      grantAverage
    }
  }
}
    `;

/**
 * __useNonprofitOrgToViewedFundingOrg990Query__
 *
 * To run a query within a React component, call `useNonprofitOrgToViewedFundingOrg990Query` and pass it any options that fit your needs.
 * When your component renders, `useNonprofitOrgToViewedFundingOrg990Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonprofitOrgToViewedFundingOrg990Query({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useNonprofitOrgToViewedFundingOrg990Query(baseOptions: Apollo.QueryHookOptions<NonprofitOrgToViewedFundingOrg990Query, NonprofitOrgToViewedFundingOrg990QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonprofitOrgToViewedFundingOrg990Query, NonprofitOrgToViewedFundingOrg990QueryVariables>(NonprofitOrgToViewedFundingOrg990Document, options);
      }
export function useNonprofitOrgToViewedFundingOrg990LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonprofitOrgToViewedFundingOrg990Query, NonprofitOrgToViewedFundingOrg990QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonprofitOrgToViewedFundingOrg990Query, NonprofitOrgToViewedFundingOrg990QueryVariables>(NonprofitOrgToViewedFundingOrg990Document, options);
        }
export type NonprofitOrgToViewedFundingOrg990QueryHookResult = ReturnType<typeof useNonprofitOrgToViewedFundingOrg990Query>;
export type NonprofitOrgToViewedFundingOrg990LazyQueryHookResult = ReturnType<typeof useNonprofitOrgToViewedFundingOrg990LazyQuery>;
export type NonprofitOrgToViewedFundingOrg990QueryResult = Apollo.QueryResult<NonprofitOrgToViewedFundingOrg990Query, NonprofitOrgToViewedFundingOrg990QueryVariables>;
export const GoalGroupCardsInfoDocument = gql`
    query goalGroupCardsInfo($funderOrgId: Int!, $goalGroupId: Int, $cohortId: Int) {
  goalGroupCards(
    funderOrgId: $funderOrgId
    goalGroupId: $goalGroupId
    cohortId: $cohortId
  ) {
    category
    completedTasks
    description
    endDate
    goalGroupId
    numGrantees
    startDate
    target
    targetDescription
    targetProgress
    totalTasks
    title
    isFunderAssigned
  }
}
    `;

/**
 * __useGoalGroupCardsInfoQuery__
 *
 * To run a query within a React component, call `useGoalGroupCardsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalGroupCardsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalGroupCardsInfoQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      goalGroupId: // value for 'goalGroupId'
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useGoalGroupCardsInfoQuery(baseOptions: Apollo.QueryHookOptions<GoalGroupCardsInfoQuery, GoalGroupCardsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalGroupCardsInfoQuery, GoalGroupCardsInfoQueryVariables>(GoalGroupCardsInfoDocument, options);
      }
export function useGoalGroupCardsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalGroupCardsInfoQuery, GoalGroupCardsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalGroupCardsInfoQuery, GoalGroupCardsInfoQueryVariables>(GoalGroupCardsInfoDocument, options);
        }
export type GoalGroupCardsInfoQueryHookResult = ReturnType<typeof useGoalGroupCardsInfoQuery>;
export type GoalGroupCardsInfoLazyQueryHookResult = ReturnType<typeof useGoalGroupCardsInfoLazyQuery>;
export type GoalGroupCardsInfoQueryResult = Apollo.QueryResult<GoalGroupCardsInfoQuery, GoalGroupCardsInfoQueryVariables>;
export const GoalGroupChartDocument = gql`
    query goalGroupChart($goalGroupId: Int!, $type: GoalGroupChartType!, $funderOrgId: Int!) {
  goalGroupChart(
    goalGroupId: $goalGroupId
    type: $type
    funderOrgId: $funderOrgId
  ) {
    id
    title
    target
    unitOfMeasurement
    goalId
    seriesData {
      goalName
      nonprofitOrgName
      data {
        x
        y
      }
    }
    totalValue
  }
}
    `;

/**
 * __useGoalGroupChartQuery__
 *
 * To run a query within a React component, call `useGoalGroupChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalGroupChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalGroupChartQuery({
 *   variables: {
 *      goalGroupId: // value for 'goalGroupId'
 *      type: // value for 'type'
 *      funderOrgId: // value for 'funderOrgId'
 *   },
 * });
 */
export function useGoalGroupChartQuery(baseOptions: Apollo.QueryHookOptions<GoalGroupChartQuery, GoalGroupChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalGroupChartQuery, GoalGroupChartQueryVariables>(GoalGroupChartDocument, options);
      }
export function useGoalGroupChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalGroupChartQuery, GoalGroupChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalGroupChartQuery, GoalGroupChartQueryVariables>(GoalGroupChartDocument, options);
        }
export type GoalGroupChartQueryHookResult = ReturnType<typeof useGoalGroupChartQuery>;
export type GoalGroupChartLazyQueryHookResult = ReturnType<typeof useGoalGroupChartLazyQuery>;
export type GoalGroupChartQueryResult = Apollo.QueryResult<GoalGroupChartQuery, GoalGroupChartQueryVariables>;
export const GoalGroupGranteesInfoDocument = gql`
    query goalGroupGranteesInfo($funderOrgId: Int!, $goalGroupId: Int!) {
  goalGroupGranteesInfo(funderOrgId: $funderOrgId, goalGroupId: $goalGroupId) {
    completedTasks
    goalName
    goalProgress
    goalTarget
    nonprofitOrgId
    totalTasks
  }
}
    `;

/**
 * __useGoalGroupGranteesInfoQuery__
 *
 * To run a query within a React component, call `useGoalGroupGranteesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalGroupGranteesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalGroupGranteesInfoQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      goalGroupId: // value for 'goalGroupId'
 *   },
 * });
 */
export function useGoalGroupGranteesInfoQuery(baseOptions: Apollo.QueryHookOptions<GoalGroupGranteesInfoQuery, GoalGroupGranteesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalGroupGranteesInfoQuery, GoalGroupGranteesInfoQueryVariables>(GoalGroupGranteesInfoDocument, options);
      }
export function useGoalGroupGranteesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalGroupGranteesInfoQuery, GoalGroupGranteesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalGroupGranteesInfoQuery, GoalGroupGranteesInfoQueryVariables>(GoalGroupGranteesInfoDocument, options);
        }
export type GoalGroupGranteesInfoQueryHookResult = ReturnType<typeof useGoalGroupGranteesInfoQuery>;
export type GoalGroupGranteesInfoLazyQueryHookResult = ReturnType<typeof useGoalGroupGranteesInfoLazyQuery>;
export type GoalGroupGranteesInfoQueryResult = Apollo.QueryResult<GoalGroupGranteesInfoQuery, GoalGroupGranteesInfoQueryVariables>;
export const GoalSharedToFunderCardDocument = gql`
    query goalSharedToFunderCard($activeOnly: Boolean, $goalId: Int, $funderOrgId: Int!, $cohortId: Int) {
  goalSharedToFunderCard(
    activeOnly: $activeOnly
    goalId: $goalId
    funderOrgId: $funderOrgId
    cohortId: $cohortId
  ) {
    nonprofitOrgId
    category
    isComplete
    ChecklistItem {
      createdAt
      goalId
      dueDate
      id
      isCompleted
      linkText
      linkUrl
      resourceId
      title
      updatedAt
    }
    EntryGroup {
      id
    }
    description
    endDate
    id
    title
    startDate
    target
    targetProgress
    impactCategory
  }
}
    `;

/**
 * __useGoalSharedToFunderCardQuery__
 *
 * To run a query within a React component, call `useGoalSharedToFunderCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalSharedToFunderCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalSharedToFunderCardQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      goalId: // value for 'goalId'
 *      funderOrgId: // value for 'funderOrgId'
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useGoalSharedToFunderCardQuery(baseOptions: Apollo.QueryHookOptions<GoalSharedToFunderCardQuery, GoalSharedToFunderCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalSharedToFunderCardQuery, GoalSharedToFunderCardQueryVariables>(GoalSharedToFunderCardDocument, options);
      }
export function useGoalSharedToFunderCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalSharedToFunderCardQuery, GoalSharedToFunderCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalSharedToFunderCardQuery, GoalSharedToFunderCardQueryVariables>(GoalSharedToFunderCardDocument, options);
        }
export type GoalSharedToFunderCardQueryHookResult = ReturnType<typeof useGoalSharedToFunderCardQuery>;
export type GoalSharedToFunderCardLazyQueryHookResult = ReturnType<typeof useGoalSharedToFunderCardLazyQuery>;
export type GoalSharedToFunderCardQueryResult = Apollo.QueryResult<GoalSharedToFunderCardQuery, GoalSharedToFunderCardQueryVariables>;
export const GoalUpdatesDocument = gql`
    query GoalUpdates($goalId: Int, $nonprofitOrgId: Int, $sort: GoalUpdateSortOptions) {
  goalUpdates(goalId: $goalId, nonprofitOrgId: $nonprofitOrgId, sort: $sort) {
    nodes {
      id
      goalId
      goalTitle
      description
      lastUpdatedUserId
      lastUpdatedUserFirstname
      lastUpdatedUserLastname
      taskId
      taskTitle
      reportedAt
    }
  }
}
    `;

/**
 * __useGoalUpdatesQuery__
 *
 * To run a query within a React component, call `useGoalUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalUpdatesQuery({
 *   variables: {
 *      goalId: // value for 'goalId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGoalUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<GoalUpdatesQuery, GoalUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalUpdatesQuery, GoalUpdatesQueryVariables>(GoalUpdatesDocument, options);
      }
export function useGoalUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalUpdatesQuery, GoalUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalUpdatesQuery, GoalUpdatesQueryVariables>(GoalUpdatesDocument, options);
        }
export type GoalUpdatesQueryHookResult = ReturnType<typeof useGoalUpdatesQuery>;
export type GoalUpdatesLazyQueryHookResult = ReturnType<typeof useGoalUpdatesLazyQuery>;
export type GoalUpdatesQueryResult = Apollo.QueryResult<GoalUpdatesQuery, GoalUpdatesQueryVariables>;
export const GoalsDocument = gql`
    query Goals($activeOnly: Boolean, $includeOnboarding: Boolean, $goalId: String, $nonprofitOrgId: Int!, $type: GoalType) {
  goals(
    activeOnly: $activeOnly
    includeOnboarding: $includeOnboarding
    goalId: $goalId
    nonprofitOrgId: $nonprofitOrgId
    type: $type
  ) {
    archivedAt
    category
    impactCategory
    isComplete
    numProgressUpdates
    numAttachments
    hasChart
    hasUpdates
    chartId
    ChecklistItem {
      createdAt
      goalId
      dueDate
      id
      isCompleted
      linkText
      linkUrl
      owner {
        id
        firstName
        lastName
      }
      resourceId
      title
      updatedAt
      checklistItemGroupId
    }
    createdAt
    description
    endDate
    id
    GoalUpdate {
      createdAt
      description
      id
      goalId
      lastUpdatedUser {
        id
        firstName
        lastName
      }
    }
    nonprofitOrgId
    metric
    owner {
      id
      firstName
      lastName
    }
    FunderOrgToSharedGoal {
      funderOrgId
      sharedAt
      goalId
      funderOrg {
        id
        name
      }
      isGoalSharedByFunder
      isGoalSharedByNonprofit
      archivedAt
    }
    startDate
    target
    templateLibraryId
    title
    type
    unitOfMeasurement
    updatedAt
    attachments {
      id
      createdAt
      filename
      format
      secureUrl
      publicId
      resourceType
      owner {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGoalsQuery__
 *
 * To run a query within a React component, call `useGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoalsQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      includeOnboarding: // value for 'includeOnboarding'
 *      goalId: // value for 'goalId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGoalsQuery(baseOptions: Apollo.QueryHookOptions<GoalsQuery, GoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoalsQuery, GoalsQueryVariables>(GoalsDocument, options);
      }
export function useGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoalsQuery, GoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoalsQuery, GoalsQueryVariables>(GoalsDocument, options);
        }
export type GoalsQueryHookResult = ReturnType<typeof useGoalsQuery>;
export type GoalsLazyQueryHookResult = ReturnType<typeof useGoalsLazyQuery>;
export type GoalsQueryResult = Apollo.QueryResult<GoalsQuery, GoalsQueryVariables>;
export const LatestGrantResearchReportDocument = gql`
    query latestGrantResearchReport($nonprofitOrgId: Int!) {
  latestGrantResearchReport(nonprofitOrgId: $nonprofitOrgId) {
    id
    status
    grantsFoundCount
    grantsOpenCount
    grantsUpcomingCount
    grantsRollingCount
    createdAt
    completedAt
    grants {
      id
      grantName
      funderName
      funderEin
      externalUrl
      deadlineCategory
      deadline
      matchScore
      matchReasons
      grantAmount {
        min
        max
        typical
      }
      eligibility
      focusAreas
      geographicRequirements
      applicationUrl
      status
      savedAt
      dismissedAt
    }
  }
}
    `;

/**
 * __useLatestGrantResearchReportQuery__
 *
 * To run a query within a React component, call `useLatestGrantResearchReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestGrantResearchReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestGrantResearchReportQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useLatestGrantResearchReportQuery(baseOptions: Apollo.QueryHookOptions<LatestGrantResearchReportQuery, LatestGrantResearchReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestGrantResearchReportQuery, LatestGrantResearchReportQueryVariables>(LatestGrantResearchReportDocument, options);
      }
export function useLatestGrantResearchReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestGrantResearchReportQuery, LatestGrantResearchReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestGrantResearchReportQuery, LatestGrantResearchReportQueryVariables>(LatestGrantResearchReportDocument, options);
        }
export type LatestGrantResearchReportQueryHookResult = ReturnType<typeof useLatestGrantResearchReportQuery>;
export type LatestGrantResearchReportLazyQueryHookResult = ReturnType<typeof useLatestGrantResearchReportLazyQuery>;
export type LatestGrantResearchReportQueryResult = Apollo.QueryResult<LatestGrantResearchReportQuery, LatestGrantResearchReportQueryVariables>;
export const GrantResearchRateLimitDocument = gql`
    query grantResearchRateLimit($nonprofitOrgId: Int!) {
  grantResearchRateLimit(nonprofitOrgId: $nonprofitOrgId) {
    canGenerateReport
    nextAvailableAt
    lastReportId
  }
}
    `;

/**
 * __useGrantResearchRateLimitQuery__
 *
 * To run a query within a React component, call `useGrantResearchRateLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrantResearchRateLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrantResearchRateLimitQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGrantResearchRateLimitQuery(baseOptions: Apollo.QueryHookOptions<GrantResearchRateLimitQuery, GrantResearchRateLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrantResearchRateLimitQuery, GrantResearchRateLimitQueryVariables>(GrantResearchRateLimitDocument, options);
      }
export function useGrantResearchRateLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrantResearchRateLimitQuery, GrantResearchRateLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrantResearchRateLimitQuery, GrantResearchRateLimitQueryVariables>(GrantResearchRateLimitDocument, options);
        }
export type GrantResearchRateLimitQueryHookResult = ReturnType<typeof useGrantResearchRateLimitQuery>;
export type GrantResearchRateLimitLazyQueryHookResult = ReturnType<typeof useGrantResearchRateLimitLazyQuery>;
export type GrantResearchRateLimitQueryResult = Apollo.QueryResult<GrantResearchRateLimitQuery, GrantResearchRateLimitQueryVariables>;
export const ImpactDashboardAcademyActivityDocument = gql`
    query ImpactDashboardAcademyActivity($nonprofitOrgId: Int!) {
  impactDashboardAcademyActivity(nonprofitOrgId: $nonprofitOrgId) {
    userFullName
    userId
    userStatus
    resource {
      courseId
      id
      nonprofitTopic
      title
      type
    }
  }
}
    `;

/**
 * __useImpactDashboardAcademyActivityQuery__
 *
 * To run a query within a React component, call `useImpactDashboardAcademyActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactDashboardAcademyActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactDashboardAcademyActivityQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useImpactDashboardAcademyActivityQuery(baseOptions: Apollo.QueryHookOptions<ImpactDashboardAcademyActivityQuery, ImpactDashboardAcademyActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactDashboardAcademyActivityQuery, ImpactDashboardAcademyActivityQueryVariables>(ImpactDashboardAcademyActivityDocument, options);
      }
export function useImpactDashboardAcademyActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactDashboardAcademyActivityQuery, ImpactDashboardAcademyActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactDashboardAcademyActivityQuery, ImpactDashboardAcademyActivityQueryVariables>(ImpactDashboardAcademyActivityDocument, options);
        }
export type ImpactDashboardAcademyActivityQueryHookResult = ReturnType<typeof useImpactDashboardAcademyActivityQuery>;
export type ImpactDashboardAcademyActivityLazyQueryHookResult = ReturnType<typeof useImpactDashboardAcademyActivityLazyQuery>;
export type ImpactDashboardAcademyActivityQueryResult = Apollo.QueryResult<ImpactDashboardAcademyActivityQuery, ImpactDashboardAcademyActivityQueryVariables>;
export const ImpactDashboardGoalsDocument = gql`
    query ImpactDashboardGoals($activeOnly: Boolean, $createdAtStart: DateTime, $createdAtEnd: DateTime, $goalId: String, $nonprofitOrgId: Int!) {
  goals(
    activeOnly: $activeOnly
    createdAtStart: $createdAtStart
    createdAtEnd: $createdAtEnd
    goalId: $goalId
    nonprofitOrgId: $nonprofitOrgId
  ) {
    archivedAt
    category
    ChecklistItem {
      createdAt
      goalId
      dueDate
      id
      isCompleted
      linkText
      linkUrl
      owner {
        id
        firstName
        lastName
      }
      resourceId
      title
      updatedAt
    }
    createdAt
    description
    endDate
    id
    GoalUpdate {
      createdAt
      description
      id
      goalId
      lastUpdatedUser {
        id
        firstName
        lastName
      }
    }
    nonprofitOrgId
    metric
    owner {
      id
      firstName
      lastName
    }
    FunderOrgToSharedGoal {
      funderOrgId
      sharedAt
      goalId
      funderOrg {
        id
        name
      }
      isGoalSharedByFunder
      isGoalSharedByNonprofit
      archivedAt
    }
    startDate
    target
    templateLibraryId
    title
    type
    unitOfMeasurement
    updatedAt
  }
}
    `;

/**
 * __useImpactDashboardGoalsQuery__
 *
 * To run a query within a React component, call `useImpactDashboardGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactDashboardGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactDashboardGoalsQuery({
 *   variables: {
 *      activeOnly: // value for 'activeOnly'
 *      createdAtStart: // value for 'createdAtStart'
 *      createdAtEnd: // value for 'createdAtEnd'
 *      goalId: // value for 'goalId'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useImpactDashboardGoalsQuery(baseOptions: Apollo.QueryHookOptions<ImpactDashboardGoalsQuery, ImpactDashboardGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactDashboardGoalsQuery, ImpactDashboardGoalsQueryVariables>(ImpactDashboardGoalsDocument, options);
      }
export function useImpactDashboardGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactDashboardGoalsQuery, ImpactDashboardGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactDashboardGoalsQuery, ImpactDashboardGoalsQueryVariables>(ImpactDashboardGoalsDocument, options);
        }
export type ImpactDashboardGoalsQueryHookResult = ReturnType<typeof useImpactDashboardGoalsQuery>;
export type ImpactDashboardGoalsLazyQueryHookResult = ReturnType<typeof useImpactDashboardGoalsLazyQuery>;
export type ImpactDashboardGoalsQueryResult = Apollo.QueryResult<ImpactDashboardGoalsQuery, ImpactDashboardGoalsQueryVariables>;
export const MissionGoalsProgressStatsDocument = gql`
    query MissionGoalsProgressStats($funderOrgId: Int!, $lookBackPeriod: Int!, $nonprofitOrgIds: [Int!]) {
  missionGoalsProgressStats(
    funderOrgId: $funderOrgId
    lookBackPeriod: $lookBackPeriod
    nonprofitOrgIds: $nonprofitOrgIds
  ) {
    orgsWithMissionGoals {
      currentValue
      previousValue
    }
    missionGoalsWithTargets {
      currentValue
      totalValue
    }
    missionGoalChartUpdates {
      currentValue
      previousValue
    }
    missionGoalChartProgress {
      currentValue
      previousValue
    }
  }
}
    `;

/**
 * __useMissionGoalsProgressStatsQuery__
 *
 * To run a query within a React component, call `useMissionGoalsProgressStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissionGoalsProgressStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissionGoalsProgressStatsQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      lookBackPeriod: // value for 'lookBackPeriod'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *   },
 * });
 */
export function useMissionGoalsProgressStatsQuery(baseOptions: Apollo.QueryHookOptions<MissionGoalsProgressStatsQuery, MissionGoalsProgressStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MissionGoalsProgressStatsQuery, MissionGoalsProgressStatsQueryVariables>(MissionGoalsProgressStatsDocument, options);
      }
export function useMissionGoalsProgressStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MissionGoalsProgressStatsQuery, MissionGoalsProgressStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MissionGoalsProgressStatsQuery, MissionGoalsProgressStatsQueryVariables>(MissionGoalsProgressStatsDocument, options);
        }
export type MissionGoalsProgressStatsQueryHookResult = ReturnType<typeof useMissionGoalsProgressStatsQuery>;
export type MissionGoalsProgressStatsLazyQueryHookResult = ReturnType<typeof useMissionGoalsProgressStatsLazyQuery>;
export type MissionGoalsProgressStatsQueryResult = Apollo.QueryResult<MissionGoalsProgressStatsQuery, MissionGoalsProgressStatsQueryVariables>;
export const MissionGoalsTargetProgressDocument = gql`
    query MissionGoalsTargetProgress($funderOrgId: Int!, $lookBackPeriod: Int!, $nonprofitOrgIds: [Int!]) {
  missionGoalsTargetProgress(
    funderOrgId: $funderOrgId
    lookBackPeriod: $lookBackPeriod
    nonprofitOrgIds: $nonprofitOrgIds
  ) {
    x
    y
  }
}
    `;

/**
 * __useMissionGoalsTargetProgressQuery__
 *
 * To run a query within a React component, call `useMissionGoalsTargetProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissionGoalsTargetProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissionGoalsTargetProgressQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      lookBackPeriod: // value for 'lookBackPeriod'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *   },
 * });
 */
export function useMissionGoalsTargetProgressQuery(baseOptions: Apollo.QueryHookOptions<MissionGoalsTargetProgressQuery, MissionGoalsTargetProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MissionGoalsTargetProgressQuery, MissionGoalsTargetProgressQueryVariables>(MissionGoalsTargetProgressDocument, options);
      }
export function useMissionGoalsTargetProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MissionGoalsTargetProgressQuery, MissionGoalsTargetProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MissionGoalsTargetProgressQuery, MissionGoalsTargetProgressQueryVariables>(MissionGoalsTargetProgressDocument, options);
        }
export type MissionGoalsTargetProgressQueryHookResult = ReturnType<typeof useMissionGoalsTargetProgressQuery>;
export type MissionGoalsTargetProgressLazyQueryHookResult = ReturnType<typeof useMissionGoalsTargetProgressLazyQuery>;
export type MissionGoalsTargetProgressQueryResult = Apollo.QueryResult<MissionGoalsTargetProgressQuery, MissionGoalsTargetProgressQueryVariables>;
export const NeedsProgressUpdateDocument = gql`
    query NeedsProgressUpdate {
  needsProgressUpdate {
    needsProgressUpdate
  }
}
    `;

/**
 * __useNeedsProgressUpdateQuery__
 *
 * To run a query within a React component, call `useNeedsProgressUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedsProgressUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedsProgressUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useNeedsProgressUpdateQuery(baseOptions?: Apollo.QueryHookOptions<NeedsProgressUpdateQuery, NeedsProgressUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeedsProgressUpdateQuery, NeedsProgressUpdateQueryVariables>(NeedsProgressUpdateDocument, options);
      }
export function useNeedsProgressUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeedsProgressUpdateQuery, NeedsProgressUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeedsProgressUpdateQuery, NeedsProgressUpdateQueryVariables>(NeedsProgressUpdateDocument, options);
        }
export type NeedsProgressUpdateQueryHookResult = ReturnType<typeof useNeedsProgressUpdateQuery>;
export type NeedsProgressUpdateLazyQueryHookResult = ReturnType<typeof useNeedsProgressUpdateLazyQuery>;
export type NeedsProgressUpdateQueryResult = Apollo.QueryResult<NeedsProgressUpdateQuery, NeedsProgressUpdateQueryVariables>;
export const NeedsUserSurveyUpdateDocument = gql`
    query NeedsUserSurveyUpdate {
  needsUserSurveyUpdate
}
    `;

/**
 * __useNeedsUserSurveyUpdateQuery__
 *
 * To run a query within a React component, call `useNeedsUserSurveyUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedsUserSurveyUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedsUserSurveyUpdateQuery({
 *   variables: {
 *   },
 * });
 */
export function useNeedsUserSurveyUpdateQuery(baseOptions?: Apollo.QueryHookOptions<NeedsUserSurveyUpdateQuery, NeedsUserSurveyUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeedsUserSurveyUpdateQuery, NeedsUserSurveyUpdateQueryVariables>(NeedsUserSurveyUpdateDocument, options);
      }
export function useNeedsUserSurveyUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeedsUserSurveyUpdateQuery, NeedsUserSurveyUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeedsUserSurveyUpdateQuery, NeedsUserSurveyUpdateQueryVariables>(NeedsUserSurveyUpdateDocument, options);
        }
export type NeedsUserSurveyUpdateQueryHookResult = ReturnType<typeof useNeedsUserSurveyUpdateQuery>;
export type NeedsUserSurveyUpdateLazyQueryHookResult = ReturnType<typeof useNeedsUserSurveyUpdateLazyQuery>;
export type NeedsUserSurveyUpdateQueryResult = Apollo.QueryResult<NeedsUserSurveyUpdateQuery, NeedsUserSurveyUpdateQueryVariables>;
export const GetNonprofitOrgProfileDocument = gql`
    query GetNonprofitOrgProfile($nonprofitOrgId: Int!) {
  nonprofitOrgProfile(nonprofitOrgId: $nonprofitOrgId) {
    id
    nonprofitOrgId
    candidData
    websiteData
    instagramData
    twitterData
    confirmedOrgSummary
    confirmedOrgSummaryUpdatedAt
    confirmedAreasOfImpact
    suggestedOrgSummary
    suggestedAreasOfImpact
  }
}
    `;

/**
 * __useGetNonprofitOrgProfileQuery__
 *
 * To run a query within a React component, call `useGetNonprofitOrgProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonprofitOrgProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonprofitOrgProfileQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *   },
 * });
 */
export function useGetNonprofitOrgProfileQuery(baseOptions: Apollo.QueryHookOptions<GetNonprofitOrgProfileQuery, GetNonprofitOrgProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonprofitOrgProfileQuery, GetNonprofitOrgProfileQueryVariables>(GetNonprofitOrgProfileDocument, options);
      }
export function useGetNonprofitOrgProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonprofitOrgProfileQuery, GetNonprofitOrgProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonprofitOrgProfileQuery, GetNonprofitOrgProfileQueryVariables>(GetNonprofitOrgProfileDocument, options);
        }
export type GetNonprofitOrgProfileQueryHookResult = ReturnType<typeof useGetNonprofitOrgProfileQuery>;
export type GetNonprofitOrgProfileLazyQueryHookResult = ReturnType<typeof useGetNonprofitOrgProfileLazyQuery>;
export type GetNonprofitOrgProfileQueryResult = Apollo.QueryResult<GetNonprofitOrgProfileQuery, GetNonprofitOrgProfileQueryVariables>;
export const GetOrg990AttributesDocument = gql`
    query getOrg990Attributes($orgId: Int!) {
  getOrg990Attributes(orgId: $orgId) {
    orgId
    missionDesc
  }
}
    `;

/**
 * __useGetOrg990AttributesQuery__
 *
 * To run a query within a React component, call `useGetOrg990AttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrg990AttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrg990AttributesQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrg990AttributesQuery(baseOptions: Apollo.QueryHookOptions<GetOrg990AttributesQuery, GetOrg990AttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrg990AttributesQuery, GetOrg990AttributesQueryVariables>(GetOrg990AttributesDocument, options);
      }
export function useGetOrg990AttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrg990AttributesQuery, GetOrg990AttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrg990AttributesQuery, GetOrg990AttributesQueryVariables>(GetOrg990AttributesDocument, options);
        }
export type GetOrg990AttributesQueryHookResult = ReturnType<typeof useGetOrg990AttributesQuery>;
export type GetOrg990AttributesLazyQueryHookResult = ReturnType<typeof useGetOrg990AttributesLazyQuery>;
export type GetOrg990AttributesQueryResult = Apollo.QueryResult<GetOrg990AttributesQuery, GetOrg990AttributesQueryVariables>;
export const OrgGoalsTaskProgressChartDocument = gql`
    query OrgGoalsTaskProgressChart($funderOrgId: Int!, $lookBackPeriod: Int!, $nonprofitOrgIds: [Int!]!) {
  orgGoalsTaskProgressChart(
    funderOrgId: $funderOrgId
    lookBackPeriod: $lookBackPeriod
    nonprofitOrgIds: $nonprofitOrgIds
  ) {
    createdItems {
      x
      y
    }
    completedItems {
      x
      y
    }
    progress {
      x
      y
    }
  }
}
    `;

/**
 * __useOrgGoalsTaskProgressChartQuery__
 *
 * To run a query within a React component, call `useOrgGoalsTaskProgressChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGoalsTaskProgressChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGoalsTaskProgressChartQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      lookBackPeriod: // value for 'lookBackPeriod'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *   },
 * });
 */
export function useOrgGoalsTaskProgressChartQuery(baseOptions: Apollo.QueryHookOptions<OrgGoalsTaskProgressChartQuery, OrgGoalsTaskProgressChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGoalsTaskProgressChartQuery, OrgGoalsTaskProgressChartQueryVariables>(OrgGoalsTaskProgressChartDocument, options);
      }
export function useOrgGoalsTaskProgressChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGoalsTaskProgressChartQuery, OrgGoalsTaskProgressChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGoalsTaskProgressChartQuery, OrgGoalsTaskProgressChartQueryVariables>(OrgGoalsTaskProgressChartDocument, options);
        }
export type OrgGoalsTaskProgressChartQueryHookResult = ReturnType<typeof useOrgGoalsTaskProgressChartQuery>;
export type OrgGoalsTaskProgressChartLazyQueryHookResult = ReturnType<typeof useOrgGoalsTaskProgressChartLazyQuery>;
export type OrgGoalsTaskProgressChartQueryResult = Apollo.QueryResult<OrgGoalsTaskProgressChartQuery, OrgGoalsTaskProgressChartQueryVariables>;
export const OrgGoalsTaskProgressStatsDocument = gql`
    query OrgGoalsTaskProgressStats($funderOrgId: Int!, $nonprofitOrgIds: [Int!], $lookBackPeriod: Int!) {
  orgGoalsTaskProgressStats(
    funderOrgId: $funderOrgId
    nonprofitOrgIds: $nonprofitOrgIds
    lookBackPeriod: $lookBackPeriod
  ) {
    totalGoalsAdded {
      currentValue
      previousValue
    }
    goalsWithTasks {
      currentValue
      previousValue
    }
    goalTemplatesUsed {
      currentValue
      previousValue
    }
    totalTasksAdded {
      currentValue
      previousValue
    }
    totalTasksCompleted {
      currentValue
      previousValue
    }
  }
}
    `;

/**
 * __useOrgGoalsTaskProgressStatsQuery__
 *
 * To run a query within a React component, call `useOrgGoalsTaskProgressStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGoalsTaskProgressStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGoalsTaskProgressStatsQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *      lookBackPeriod: // value for 'lookBackPeriod'
 *   },
 * });
 */
export function useOrgGoalsTaskProgressStatsQuery(baseOptions: Apollo.QueryHookOptions<OrgGoalsTaskProgressStatsQuery, OrgGoalsTaskProgressStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGoalsTaskProgressStatsQuery, OrgGoalsTaskProgressStatsQueryVariables>(OrgGoalsTaskProgressStatsDocument, options);
      }
export function useOrgGoalsTaskProgressStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGoalsTaskProgressStatsQuery, OrgGoalsTaskProgressStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGoalsTaskProgressStatsQuery, OrgGoalsTaskProgressStatsQueryVariables>(OrgGoalsTaskProgressStatsDocument, options);
        }
export type OrgGoalsTaskProgressStatsQueryHookResult = ReturnType<typeof useOrgGoalsTaskProgressStatsQuery>;
export type OrgGoalsTaskProgressStatsLazyQueryHookResult = ReturnType<typeof useOrgGoalsTaskProgressStatsLazyQuery>;
export type OrgGoalsTaskProgressStatsQueryResult = Apollo.QueryResult<OrgGoalsTaskProgressStatsQuery, OrgGoalsTaskProgressStatsQueryVariables>;
export const PrioritiesProgressStatsDocument = gql`
    query PrioritiesProgressStats($funderOrgId: Int!, $lookBackPeriod: Int!) {
  prioritiesProgressStats(
    funderOrgId: $funderOrgId
    lookBackPeriod: $lookBackPeriod
  ) {
    totalOrgsCount {
      currentValue
      previousValue
    }
    orgsWithLeaders {
      currentValue
      previousValue
    }
    orgsWithPriorities {
      currentValue
      previousValue
    }
  }
}
    `;

/**
 * __usePrioritiesProgressStatsQuery__
 *
 * To run a query within a React component, call `usePrioritiesProgressStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrioritiesProgressStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrioritiesProgressStatsQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      lookBackPeriod: // value for 'lookBackPeriod'
 *   },
 * });
 */
export function usePrioritiesProgressStatsQuery(baseOptions: Apollo.QueryHookOptions<PrioritiesProgressStatsQuery, PrioritiesProgressStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrioritiesProgressStatsQuery, PrioritiesProgressStatsQueryVariables>(PrioritiesProgressStatsDocument, options);
      }
export function usePrioritiesProgressStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrioritiesProgressStatsQuery, PrioritiesProgressStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrioritiesProgressStatsQuery, PrioritiesProgressStatsQueryVariables>(PrioritiesProgressStatsDocument, options);
        }
export type PrioritiesProgressStatsQueryHookResult = ReturnType<typeof usePrioritiesProgressStatsQuery>;
export type PrioritiesProgressStatsLazyQueryHookResult = ReturnType<typeof usePrioritiesProgressStatsLazyQuery>;
export type PrioritiesProgressStatsQueryResult = Apollo.QueryResult<PrioritiesProgressStatsQuery, PrioritiesProgressStatsQueryVariables>;
export const GetUserRecommendationsDocument = gql`
    query GetUserRecommendations($input: GetUserRecommendationsInput!) {
  getUserRecommendations(input: $input) {
    recommendations {
      id
      userId
      nonprofitOrgId
      score
      status
      placement
      shownAt
      clickedAt
      dismissedAt
      completedAt
      metadata
      expiresAt
      createdAt
      updatedAt
      recommendationTemplate {
        id
        key
        title
        description
        category
        priority
        placement
        targetAudience
        callToActionText
        callToActionLink
        iconName
        isActive
        createdAt
        updatedAt
      }
      user {
        id
        firstName
        lastName
      }
      nonprofitOrg {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetUserRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetUserRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>(GetUserRecommendationsDocument, options);
      }
export function useGetUserRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>(GetUserRecommendationsDocument, options);
        }
export type GetUserRecommendationsQueryHookResult = ReturnType<typeof useGetUserRecommendationsQuery>;
export type GetUserRecommendationsLazyQueryHookResult = ReturnType<typeof useGetUserRecommendationsLazyQuery>;
export type GetUserRecommendationsQueryResult = Apollo.QueryResult<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>;
export const TrackRecommendationInteractionDocument = gql`
    mutation TrackRecommendationInteraction($input: TrackRecommendationInteractionInput!) {
  trackRecommendationInteraction(input: $input) {
    id
    status
    shownAt
    clickedAt
    dismissedAt
    completedAt
  }
}
    `;
export type TrackRecommendationInteractionMutationFn = Apollo.MutationFunction<TrackRecommendationInteractionMutation, TrackRecommendationInteractionMutationVariables>;

/**
 * __useTrackRecommendationInteractionMutation__
 *
 * To run a mutation, you first call `useTrackRecommendationInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackRecommendationInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackRecommendationInteractionMutation, { data, loading, error }] = useTrackRecommendationInteractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackRecommendationInteractionMutation(baseOptions?: Apollo.MutationHookOptions<TrackRecommendationInteractionMutation, TrackRecommendationInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackRecommendationInteractionMutation, TrackRecommendationInteractionMutationVariables>(TrackRecommendationInteractionDocument, options);
      }
export type TrackRecommendationInteractionMutationHookResult = ReturnType<typeof useTrackRecommendationInteractionMutation>;
export type TrackRecommendationInteractionMutationResult = Apollo.MutationResult<TrackRecommendationInteractionMutation>;
export type TrackRecommendationInteractionMutationOptions = Apollo.BaseMutationOptions<TrackRecommendationInteractionMutation, TrackRecommendationInteractionMutationVariables>;
export const GenerateUserRecommendationsDocument = gql`
    mutation GenerateUserRecommendations($userId: Int) {
  generateUserRecommendations(userId: $userId) {
    recommendations {
      id
      userId
      nonprofitOrgId
      score
      status
      placement
      createdAt
      recommendationTemplate {
        id
        key
        title
        description
        category
        callToActionText
        callToActionLink
      }
    }
    totalCount
  }
}
    `;
export type GenerateUserRecommendationsMutationFn = Apollo.MutationFunction<GenerateUserRecommendationsMutation, GenerateUserRecommendationsMutationVariables>;

/**
 * __useGenerateUserRecommendationsMutation__
 *
 * To run a mutation, you first call `useGenerateUserRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUserRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUserRecommendationsMutation, { data, loading, error }] = useGenerateUserRecommendationsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateUserRecommendationsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUserRecommendationsMutation, GenerateUserRecommendationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUserRecommendationsMutation, GenerateUserRecommendationsMutationVariables>(GenerateUserRecommendationsDocument, options);
      }
export type GenerateUserRecommendationsMutationHookResult = ReturnType<typeof useGenerateUserRecommendationsMutation>;
export type GenerateUserRecommendationsMutationResult = Apollo.MutationResult<GenerateUserRecommendationsMutation>;
export type GenerateUserRecommendationsMutationOptions = Apollo.BaseMutationOptions<GenerateUserRecommendationsMutation, GenerateUserRecommendationsMutationVariables>;
export const SearchCohortsDocument = gql`
    query SearchCohorts($id: Int, $name: String, $funderName: String, $nonprofitName: String, $limit: Int, $offset: Int) {
  searchCohorts(
    id: $id
    name: $name
    funderName: $funderName
    nonprofitName: $nonprofitName
    limit: $limit
    offset: $offset
  ) {
    total
    cohorts {
      id
      name
      startDate
      endDate
      createdAt
      updatedAt
      memberRoles
      cohortOwnerships {
        id
        funderOrg {
          id
          name
        }
      }
      cohortMemberships {
        id
        startDate
        endDate
        nonprofitOrg {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchCohortsQuery__
 *
 * To run a query within a React component, call `useSearchCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCohortsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      funderName: // value for 'funderName'
 *      nonprofitName: // value for 'nonprofitName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchCohortsQuery(baseOptions?: Apollo.QueryHookOptions<SearchCohortsQuery, SearchCohortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCohortsQuery, SearchCohortsQueryVariables>(SearchCohortsDocument, options);
      }
export function useSearchCohortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCohortsQuery, SearchCohortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCohortsQuery, SearchCohortsQueryVariables>(SearchCohortsDocument, options);
        }
export type SearchCohortsQueryHookResult = ReturnType<typeof useSearchCohortsQuery>;
export type SearchCohortsLazyQueryHookResult = ReturnType<typeof useSearchCohortsLazyQuery>;
export type SearchCohortsQueryResult = Apollo.QueryResult<SearchCohortsQuery, SearchCohortsQueryVariables>;
export const SearchFundersDocument = gql`
    query SearchFunders($id: Int, $name: String, $nonprofitName: String, $cohortName: String, $userEmail: String, $limit: Int, $offset: Int) {
  searchFunders(
    id: $id
    name: $name
    nonprofitName: $nonprofitName
    cohortName: $cohortName
    userEmail: $userEmail
    limit: $limit
    offset: $offset
  ) {
    total
    funders {
      id
      name
      disabled
      isTest
      createdAt
      updatedAt
      disabledAt
      nonprofitOrgs {
        id
        name
      }
      cohorts {
        id
        name
      }
      users {
        id
        email
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSearchFundersQuery__
 *
 * To run a query within a React component, call `useSearchFundersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFundersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFundersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      nonprofitName: // value for 'nonprofitName'
 *      cohortName: // value for 'cohortName'
 *      userEmail: // value for 'userEmail'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchFundersQuery(baseOptions?: Apollo.QueryHookOptions<SearchFundersQuery, SearchFundersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFundersQuery, SearchFundersQueryVariables>(SearchFundersDocument, options);
      }
export function useSearchFundersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFundersQuery, SearchFundersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFundersQuery, SearchFundersQueryVariables>(SearchFundersDocument, options);
        }
export type SearchFundersQueryHookResult = ReturnType<typeof useSearchFundersQuery>;
export type SearchFundersLazyQueryHookResult = ReturnType<typeof useSearchFundersLazyQuery>;
export type SearchFundersQueryResult = Apollo.QueryResult<SearchFundersQuery, SearchFundersQueryVariables>;
export const SearchJobExecutionsDocument = gql`
    query SearchJobExecutions($filter: JobExecutionFilter, $limit: Int, $offset: Int, $orderBy: String, $orderDirection: String) {
  searchJobExecutions(
    filter: $filter
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    orderDirection: $orderDirection
  ) {
    nodes {
      id
      jobName
      status
      payload
      result
      errorMessage
      errorStack
      createdAt
      startedAt
      completedAt
      duration
      createdByUserId
      organizationId
      createdByUser {
        id
        firstName
        lastName
      }
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useSearchJobExecutionsQuery__
 *
 * To run a query within a React component, call `useSearchJobExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchJobExecutionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useSearchJobExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchJobExecutionsQuery, SearchJobExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchJobExecutionsQuery, SearchJobExecutionsQueryVariables>(SearchJobExecutionsDocument, options);
      }
export function useSearchJobExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchJobExecutionsQuery, SearchJobExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchJobExecutionsQuery, SearchJobExecutionsQueryVariables>(SearchJobExecutionsDocument, options);
        }
export type SearchJobExecutionsQueryHookResult = ReturnType<typeof useSearchJobExecutionsQuery>;
export type SearchJobExecutionsLazyQueryHookResult = ReturnType<typeof useSearchJobExecutionsLazyQuery>;
export type SearchJobExecutionsQueryResult = Apollo.QueryResult<SearchJobExecutionsQuery, SearchJobExecutionsQueryVariables>;
export const SearchNonprofitsDocument = gql`
    query SearchNonprofits($id: Int, $name: String, $funderName: String, $cohortName: String, $userEmail: String, $profileSearchTerm: String, $limit: Int, $offset: Int) {
  searchNonprofits(
    id: $id
    name: $name
    funderName: $funderName
    cohortName: $cohortName
    userEmail: $userEmail
    profileSearchTerm: $profileSearchTerm
    limit: $limit
    offset: $offset
  ) {
    total
    nonprofits {
      id
      name
      disabled
      formationPlan
      platformPlan
      ein
      websiteUrl
      isFiscallySponsored
      isTest
      funders {
        id
        name
      }
      cohorts {
        id
        name
      }
      users {
        id
        email
        firstName
        lastName
        role
      }
    }
  }
}
    `;

/**
 * __useSearchNonprofitsQuery__
 *
 * To run a query within a React component, call `useSearchNonprofitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNonprofitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNonprofitsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      funderName: // value for 'funderName'
 *      cohortName: // value for 'cohortName'
 *      userEmail: // value for 'userEmail'
 *      profileSearchTerm: // value for 'profileSearchTerm'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchNonprofitsQuery(baseOptions?: Apollo.QueryHookOptions<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>(SearchNonprofitsDocument, options);
      }
export function useSearchNonprofitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>(SearchNonprofitsDocument, options);
        }
export type SearchNonprofitsQueryHookResult = ReturnType<typeof useSearchNonprofitsQuery>;
export type SearchNonprofitsLazyQueryHookResult = ReturnType<typeof useSearchNonprofitsLazyQuery>;
export type SearchNonprofitsQueryResult = Apollo.QueryResult<SearchNonprofitsQuery, SearchNonprofitsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($id: Int, $email: String, $name: String, $nonprofitName: String, $funderName: String, $limit: Int, $offset: Int) {
  searchUsers(
    id: $id
    email: $email
    name: $name
    nonprofitName: $nonprofitName
    funderName: $funderName
    limit: $limit
    offset: $offset
  ) {
    total
    users {
      id
      email
      firstName
      lastName
      disabled
      isTest
      createdAt
      updatedAt
      disabledAt
      lastLoggedInAt
      nonprofitOrgs {
        id
        name
      }
      funderOrgs {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      nonprofitName: // value for 'nonprofitName'
 *      funderName: // value for 'funderName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const StripePayoutsDocument = gql`
    query stripePayouts($stripeConnectId: String!, $createdAfter: Int) {
  stripePayouts(stripeConnectId: $stripeConnectId, createdAfter: $createdAfter) {
    totalPaidOutInCents
    currentBalanceInCents
    payoutFrequency
    items {
      id
      amount
      arrival_date
      created
      status
      reversed_by
    }
  }
}
    `;

/**
 * __useStripePayoutsQuery__
 *
 * To run a query within a React component, call `useStripePayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripePayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripePayoutsQuery({
 *   variables: {
 *      stripeConnectId: // value for 'stripeConnectId'
 *      createdAfter: // value for 'createdAfter'
 *   },
 * });
 */
export function useStripePayoutsQuery(baseOptions: Apollo.QueryHookOptions<StripePayoutsQuery, StripePayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripePayoutsQuery, StripePayoutsQueryVariables>(StripePayoutsDocument, options);
      }
export function useStripePayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripePayoutsQuery, StripePayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripePayoutsQuery, StripePayoutsQueryVariables>(StripePayoutsDocument, options);
        }
export type StripePayoutsQueryHookResult = ReturnType<typeof useStripePayoutsQuery>;
export type StripePayoutsLazyQueryHookResult = ReturnType<typeof useStripePayoutsLazyQuery>;
export type StripePayoutsQueryResult = Apollo.QueryResult<StripePayoutsQuery, StripePayoutsQueryVariables>;
export const TopPrioritiesDocument = gql`
    query topPriorities($funderOrgId: Int, $nonprofitOrgIds: [Int!], $daysAgo: Int) {
  topPriorities(
    funderOrgId: $funderOrgId
    nonprofitOrgIds: $nonprofitOrgIds
    daysAgo: $daysAgo
  ) {
    label
    data
    confidenceLevel
    totalResponses
    roleData
  }
}
    `;

/**
 * __useTopPrioritiesQuery__
 *
 * To run a query within a React component, call `useTopPrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopPrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopPrioritiesQuery({
 *   variables: {
 *      funderOrgId: // value for 'funderOrgId'
 *      nonprofitOrgIds: // value for 'nonprofitOrgIds'
 *      daysAgo: // value for 'daysAgo'
 *   },
 * });
 */
export function useTopPrioritiesQuery(baseOptions?: Apollo.QueryHookOptions<TopPrioritiesQuery, TopPrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopPrioritiesQuery, TopPrioritiesQueryVariables>(TopPrioritiesDocument, options);
      }
export function useTopPrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopPrioritiesQuery, TopPrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopPrioritiesQuery, TopPrioritiesQueryVariables>(TopPrioritiesDocument, options);
        }
export type TopPrioritiesQueryHookResult = ReturnType<typeof useTopPrioritiesQuery>;
export type TopPrioritiesLazyQueryHookResult = ReturnType<typeof useTopPrioritiesLazyQuery>;
export type TopPrioritiesQueryResult = Apollo.QueryResult<TopPrioritiesQuery, TopPrioritiesQueryVariables>;
export const UpdateConnectAccountLinkDocument = gql`
    query updateConnectAccountLink($stripeAccountId: String!, $returnUrl: String!) {
  updateConnectAccountLink(
    stripeAccountId: $stripeAccountId
    returnUrl: $returnUrl
  ) {
    url
  }
}
    `;

/**
 * __useUpdateConnectAccountLinkQuery__
 *
 * To run a query within a React component, call `useUpdateConnectAccountLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectAccountLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateConnectAccountLinkQuery({
 *   variables: {
 *      stripeAccountId: // value for 'stripeAccountId'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useUpdateConnectAccountLinkQuery(baseOptions: Apollo.QueryHookOptions<UpdateConnectAccountLinkQuery, UpdateConnectAccountLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateConnectAccountLinkQuery, UpdateConnectAccountLinkQueryVariables>(UpdateConnectAccountLinkDocument, options);
      }
export function useUpdateConnectAccountLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateConnectAccountLinkQuery, UpdateConnectAccountLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateConnectAccountLinkQuery, UpdateConnectAccountLinkQueryVariables>(UpdateConnectAccountLinkDocument, options);
        }
export type UpdateConnectAccountLinkQueryHookResult = ReturnType<typeof useUpdateConnectAccountLinkQuery>;
export type UpdateConnectAccountLinkLazyQueryHookResult = ReturnType<typeof useUpdateConnectAccountLinkLazyQuery>;
export type UpdateConnectAccountLinkQueryResult = Apollo.QueryResult<UpdateConnectAccountLinkQuery, UpdateConnectAccountLinkQueryVariables>;
export const UserOneOnOneCoachingEventsDocument = gql`
    query userOneOnOneCoachingEvents($userId: Int, $startDate: DateTime, $endDate: DateTime, $limit: Int) {
  userOneOnOneCoachingEvents(
    userId: $userId
    startDate: $startDate
    endDate: $endDate
    limit: $limit
  ) {
    id
    userId
    createdAt
    updatedAt
    startsAt
    endsAt
    contactEmail
    contactName
    bookingUrl
    userSlug
    organizerEmail
    organizerName
    duration
    formGuid
    hubspotId
    meetingBody
    meetingTitle
    videoConferenceUrl
    transcript
    summary
    status
    goals {
      id
      title
    }
  }
}
    `;

/**
 * __useUserOneOnOneCoachingEventsQuery__
 *
 * To run a query within a React component, call `useUserOneOnOneCoachingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOneOnOneCoachingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOneOnOneCoachingEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserOneOnOneCoachingEventsQuery(baseOptions?: Apollo.QueryHookOptions<UserOneOnOneCoachingEventsQuery, UserOneOnOneCoachingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOneOnOneCoachingEventsQuery, UserOneOnOneCoachingEventsQueryVariables>(UserOneOnOneCoachingEventsDocument, options);
      }
export function useUserOneOnOneCoachingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOneOnOneCoachingEventsQuery, UserOneOnOneCoachingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOneOnOneCoachingEventsQuery, UserOneOnOneCoachingEventsQueryVariables>(UserOneOnOneCoachingEventsDocument, options);
        }
export type UserOneOnOneCoachingEventsQueryHookResult = ReturnType<typeof useUserOneOnOneCoachingEventsQuery>;
export type UserOneOnOneCoachingEventsLazyQueryHookResult = ReturnType<typeof useUserOneOnOneCoachingEventsLazyQuery>;
export type UserOneOnOneCoachingEventsQueryResult = Apollo.QueryResult<UserOneOnOneCoachingEventsQuery, UserOneOnOneCoachingEventsQueryVariables>;
export const UserPrioritiesDocument = gql`
    query UserPriorities($userId: Int!) {
  userSurveyPriorities(userId: $userId) {
    id
    rank
    category
    confidenceLevel
    challenges
    createdAt
  }
}
    `;

/**
 * __useUserPrioritiesQuery__
 *
 * To run a query within a React component, call `useUserPrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPrioritiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPrioritiesQuery(baseOptions: Apollo.QueryHookOptions<UserPrioritiesQuery, UserPrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPrioritiesQuery, UserPrioritiesQueryVariables>(UserPrioritiesDocument, options);
      }
export function useUserPrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPrioritiesQuery, UserPrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPrioritiesQuery, UserPrioritiesQueryVariables>(UserPrioritiesDocument, options);
        }
export type UserPrioritiesQueryHookResult = ReturnType<typeof useUserPrioritiesQuery>;
export type UserPrioritiesLazyQueryHookResult = ReturnType<typeof useUserPrioritiesLazyQuery>;
export type UserPrioritiesQueryResult = Apollo.QueryResult<UserPrioritiesQuery, UserPrioritiesQueryVariables>;
export const UserSurveyDocument = gql`
    query UserSurvey($isCompleted: Boolean, $nonprofitOrgId: Int!, $type: SurveyType) {
  userSurvey(
    isCompleted: $isCompleted
    nonprofitOrgId: $nonprofitOrgId
    type: $type
  ) {
    completedAt
    id
    orgMissionChange
    orgMissionChangeExplanation
    primaryFunction
    response
    role
    type
    UserSurveyPriority {
      archivedAt
      category
      confidenceLevel
      customPriorities
      id
      rank
      UserSurveyPriorityTopic {
        id
        topic
      }
    }
  }
}
    `;

/**
 * __useUserSurveyQuery__
 *
 * To run a query within a React component, call `useUserSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSurveyQuery({
 *   variables: {
 *      isCompleted: // value for 'isCompleted'
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUserSurveyQuery(baseOptions: Apollo.QueryHookOptions<UserSurveyQuery, UserSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSurveyQuery, UserSurveyQueryVariables>(UserSurveyDocument, options);
      }
export function useUserSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSurveyQuery, UserSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSurveyQuery, UserSurveyQueryVariables>(UserSurveyDocument, options);
        }
export type UserSurveyQueryHookResult = ReturnType<typeof useUserSurveyQuery>;
export type UserSurveyLazyQueryHookResult = ReturnType<typeof useUserSurveyLazyQuery>;
export type UserSurveyQueryResult = Apollo.QueryResult<UserSurveyQuery, UserSurveyQueryVariables>;
export const UserSurveysDocument = gql`
    query UserSurveys($nonprofitOrgId: Int!, $type: SurveyType, $types: [SurveyType!]) {
  userSurveys(nonprofitOrgId: $nonprofitOrgId, type: $type, types: $types) {
    id
    isCompleted
  }
}
    `;

/**
 * __useUserSurveysQuery__
 *
 * To run a query within a React component, call `useUserSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSurveysQuery({
 *   variables: {
 *      nonprofitOrgId: // value for 'nonprofitOrgId'
 *      type: // value for 'type'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useUserSurveysQuery(baseOptions: Apollo.QueryHookOptions<UserSurveysQuery, UserSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSurveysQuery, UserSurveysQueryVariables>(UserSurveysDocument, options);
      }
export function useUserSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSurveysQuery, UserSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSurveysQuery, UserSurveysQueryVariables>(UserSurveysDocument, options);
        }
export type UserSurveysQueryHookResult = ReturnType<typeof useUserSurveysQuery>;
export type UserSurveysLazyQueryHookResult = ReturnType<typeof useUserSurveysLazyQuery>;
export type UserSurveysQueryResult = Apollo.QueryResult<UserSurveysQuery, UserSurveysQueryVariables>;